import { GraphqlError as GqlError } from '@/types/error';
export class GraphqlError extends GqlError {}
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DrTimestamp: number;
};

/** 상품 정보 */
export type AbstractProduct = {
  /** 상품 Id */
  id: Scalars['ID'];
  /** 상품 이름 */
  name: Scalars['String'];
  /** 상품 가격 */
  price: Scalars['Int'];
};

export type AccountGraph = {
  id: Scalars['ID'];
  loginType: LoginType;
  oAuthInfo?: Maybe<OAuthInfoGraph>;
  role: RoleType;
  status: AccountStatus;
};

/** 로그인 파라미터 */
export type AccountSignOutMutationRequestInput = {
  /** account ID */
  accountId: Scalars['ID'];
  /** deviceId */
  deviceId?: InputMaybe<Scalars['String']>;
  /** 플랫폼 타입 */
  platform?: InputMaybe<PlatformType>;
};

export enum AccountStatus {
  Activated = 'ACTIVATED',
  Deleted = 'DELETED',
  Inactivated = 'INACTIVATED'
}

export type AdBadgeGraph = {
  content: Scalars['String'];
};

export enum AdColorTheme {
  Dark = 'DARK',
  Light = 'LIGHT'
}

/** 광고 노출 처리 요청 */
export type AdExposureHandleMutationRequestInput = {
  /** 광고 ID */
  adId: Scalars['ID'];
  /** 광고를 본 OS 플랫폼 */
  adViewerOsPlatform?: InputMaybe<Scalars['String']>;
  /** 광고가 노출된 일시 */
  exposedAt: Scalars['DrTimestamp'];
};

export enum AdTargetPlace {
  DoctorWebSideBigLeft = 'DOCTOR_WEB_SIDE_BIG_LEFT',
  DoctorWebSideBigRight = 'DOCTOR_WEB_SIDE_BIG_RIGHT',
  DoctorWebSideSmall = 'DOCTOR_WEB_SIDE_SMALL',
  PharmacistWebSideBig = 'PHARMACIST_WEB_SIDE_BIG',
  PharmacistWebSideSmall = 'PHARMACIST_WEB_SIDE_SMALL',
  UserAppCommunityArticleBottom = 'USER_APP_COMMUNITY_ARTICLE_BOTTOM',
  UserAppCommunityMain = 'USER_APP_COMMUNITY_MAIN',
  UserAppDiagnosisHistoryInList = 'USER_APP_DIAGNOSIS_HISTORY_IN_LIST',
  UserAppDoctorListDepartmentInList = 'USER_APP_DOCTOR_LIST_DEPARTMENT_IN_LIST',
  UserAppDoctorListDepartmentTop = 'USER_APP_DOCTOR_LIST_DEPARTMENT_TOP',
  UserAppDoctorListTreatmentInList = 'USER_APP_DOCTOR_LIST_TREATMENT_IN_LIST',
  UserAppDoctorListTreatmentTop = 'USER_APP_DOCTOR_LIST_TREATMENT_TOP',
  UserAppEncyclopediaDetailBottom = 'USER_APP_ENCYCLOPEDIA_DETAIL_BOTTOM',
  UserAppExit = 'USER_APP_EXIT',
  UserAppHealthDocument = 'USER_APP_HEALTH_DOCUMENT',
  UserAppHealthMain = 'USER_APP_HEALTH_MAIN',
  UserAppHomeMain = 'USER_APP_HOME_MAIN',
  UserAppHospitalSearchDetailBottom = 'USER_APP_HOSPITAL_SEARCH_DETAIL_BOTTOM',
  UserAppHospitalSearchInList = 'USER_APP_HOSPITAL_SEARCH_IN_LIST',
  UserAppMagazineArticleBottom = 'USER_APP_MAGAZINE_ARTICLE_BOTTOM',
  UserAppMagazineArticleContentBanner = 'USER_APP_MAGAZINE_ARTICLE_CONTENT_BANNER',
  UserAppMagazineFaqBottom = 'USER_APP_MAGAZINE_FAQ_BOTTOM',
  UserAppMainRolling = 'USER_APP_MAIN_ROLLING',
  UserAppPointMarketMain = 'USER_APP_POINT_MARKET_MAIN',
  UserAppPopup = 'USER_APP_POPUP',
  UserAppQnaMain = 'USER_APP_QNA_MAIN',
  UserAppQnaQuestionBottom = 'USER_APP_QNA_QUESTION_BOTTOM',
  UserAppQnaQuestionBottomImage = 'USER_APP_QNA_QUESTION_BOTTOM_IMAGE',
  UserAppSearchMain = 'USER_APP_SEARCH_MAIN',
  UserAppSearchMainImage = 'USER_APP_SEARCH_MAIN_IMAGE',
  UserWebHomeMain = 'USER_WEB_HOME_MAIN',
  UserWebMagazineArticleContentBanner = 'USER_WEB_MAGAZINE_ARTICLE_CONTENT_BANNER',
  UserWebMenuBottom = 'USER_WEB_MENU_BOTTOM',
  UserWebMobileMagazineArticleContentBanner = 'USER_WEB_MOBILE_MAGAZINE_ARTICLE_CONTENT_BANNER',
  UserWebMobileMenuBottom = 'USER_WEB_MOBILE_MENU_BOTTOM',
  UserWebMobileNonBenefitPriceBand = 'USER_WEB_MOBILE_NON_BENEFIT_PRICE_BAND',
  UserWebMobileNonBenefitPriceMiddle = 'USER_WEB_MOBILE_NON_BENEFIT_PRICE_MIDDLE',
  UserWebMobileQnaQuestionBottom = 'USER_WEB_MOBILE_QNA_QUESTION_BOTTOM',
  UserWebMobileSearchMain = 'USER_WEB_MOBILE_SEARCH_MAIN',
  UserWebMobileTopStickyBand = 'USER_WEB_MOBILE_TOP_STICKY_BAND',
  UserWebNonBenefitPriceMiddle = 'USER_WEB_NON_BENEFIT_PRICE_MIDDLE',
  UserWebQnaQuestionBottom = 'USER_WEB_QNA_QUESTION_BOTTOM',
  UserWebSearchMain = 'USER_WEB_SEARCH_MAIN',
  UserWebSideBigRight = 'USER_WEB_SIDE_BIG_RIGHT',
  UserWebSideSmallLeft = 'USER_WEB_SIDE_SMALL_LEFT',
  UserWebSideSmallRight = 'USER_WEB_SIDE_SMALL_RIGHT'
}

export type AdditionalProductRequestInput = {
  /** 상품 Id */
  productId: Scalars['ID'];
  /** 상품 수량 */
  quantity: Scalars['Int'];
};

export type Address = {
  /** 상세주소 */
  detailAddress?: Maybe<Scalars['String']>;
  /** 지번주소 */
  jibunAddress: Scalars['String'];
  /** 도로명주소 */
  roadAddress?: Maybe<Scalars['String']>;
  /** 우편번호 */
  zipCode?: Maybe<Scalars['String']>;
};

/** 주소 및 좌표 정보 */
export type AddressLocation = {
  detailAddress: Scalars['String'];
  jibunAddress: Scalars['String'];
  location: GeoPoint;
  postCode?: Maybe<Scalars['String']>;
  roadAddress?: Maybe<Scalars['String']>;
};

export enum AddressType {
  Company = 'COMPANY',
  Home = 'HOME',
  Others = 'OTHERS'
}

/** 투여 정보 */
export type AdministrationInfo = {
  /** 투여 경로(경구, 주사 등) */
  route: Scalars['String'];
  /** 투여 단위(정, 캡슐, mL 등) */
  unit: Scalars['String'];
};

export type Affiliation = {
  address?: Maybe<Scalars['String']>;
  /** @deprecated affiliationPid 를 사용한다. */
  affiliationId: Scalars['ID'];
  affiliationPid: Scalars['ID'];
  affiliationType: AffiliationType;
  imageUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export enum AffiliationType {
  Doctornow = 'DOCTORNOW',
  Hospital = 'HOSPITAL',
  Pharmacy = 'PHARMACY'
}

/** 진료 과목 정보 */
export type Agreement = {
  /** 약관 카테고리 */
  category: AgreementCategory;
  /** 약관 내용 */
  content?: Maybe<Scalars['String']>;
  /** 삭제일시 */
  deletedAt?: Maybe<Scalars['DrTimestamp']>;
  /** 약관ID */
  id: Scalars['ID'];
  /** 약관 필수여부 */
  required: Scalars['Boolean'];
  /** 약관 타이틀 */
  title: Scalars['String'];
  /** 약관 타입 */
  type: AgreementType;
  /** 약관 URL */
  url?: Maybe<Scalars['String']>;
  /** 약관 버전 */
  version: Scalars['Int'];
};

export type AgreementApproveRequestInput = {
  agreementId: Scalars['ID'];
  isApproved: Scalars['Boolean'];
};

export enum AgreementCategory {
  AiSymptomCheckerAgreement = 'AI_SYMPTOM_CHECKER_AGREEMENT',
  DoctorTermsAgreement = 'DOCTOR_TERMS_AGREEMENT',
  F2FTermsAgreement = 'F2F_TERMS_AGREEMENT',
  Family = 'FAMILY',
  HealthInsurance = 'HEALTH_INSURANCE',
  HistoryTakingTermsAgreement = 'HISTORY_TAKING_TERMS_AGREEMENT',
  HospitalTermsAgreement = 'HOSPITAL_TERMS_AGREEMENT',
  HospitalWholesalePartnership = 'HOSPITAL_WHOLESALE_PARTNERSHIP',
  LocationBasedService = 'LOCATION_BASED_SERVICE',
  Marketing = 'MARKETING',
  NowPartnership = 'NOW_PARTNERSHIP',
  PharmacistTermsAgreement = 'PHARMACIST_TERMS_AGREEMENT',
  PharmacyWholesalePartnership = 'PHARMACY_WHOLESALE_PARTNERSHIP',
  PointCouponAgreement = 'POINT_COUPON_AGREEMENT',
  QnaAgreement = 'QNA_AGREEMENT',
  UserPayment = 'USER_PAYMENT',
  UserPaymentInisis = 'USER_PAYMENT_INISIS',
  UserPaymentTossPg = 'USER_PAYMENT_TOSS_PG'
}

export enum AgreementType {
  AiSymptomCheckerTermsAndConditions = 'AI_SYMPTOM_CHECKER_TERMS_AND_CONDITIONS',
  CollectHealthInformation = 'COLLECT_HEALTH_INFORMATION',
  CollectMaskingPersonalInformation = 'COLLECT_MASKING_PERSONAL_INFORMATION',
  CollectPersonalInformation = 'COLLECT_PERSONAL_INFORMATION',
  CollectUniqueIdentification = 'COLLECT_UNIQUE_IDENTIFICATION',
  ConsignmentContract = 'CONSIGNMENT_CONTRACT',
  ConsignmentContractConsignor = 'CONSIGNMENT_CONTRACT_CONSIGNOR',
  ConsignmentContractTrusteee = 'CONSIGNMENT_CONTRACT_TRUSTEEE',
  ElectronicFinancialTransaction = 'ELECTRONIC_FINANCIAL_TRANSACTION',
  F2FProvidePersonalInformation = 'F2F_PROVIDE_PERSONAL_INFORMATION',
  F2FSensitiveInformation = 'F2F_SENSITIVE_INFORMATION',
  FamilyRepresentativeApplication = 'FAMILY_REPRESENTATIVE_APPLICATION',
  HealthInformation = 'HEALTH_INFORMATION',
  HealthInformationMarketing = 'HEALTH_INFORMATION_MARKETING',
  HealthInformationOverseasTransfer = 'HEALTH_INFORMATION_OVERSEAS_TRANSFER',
  HospitalWholesaleServiceTerms = 'HOSPITAL_WHOLESALE_SERVICE_TERMS',
  LocationBasedServiceTermsAndConditions = 'LOCATION_BASED_SERVICE_TERMS_AND_CONDITIONS',
  Marketing = 'MARKETING',
  MarketingNight = 'MARKETING_NIGHT',
  NowPartnershipPharmaceuticalManagementTerms = 'NOW_PARTNERSHIP_PHARMACEUTICAL_MANAGEMENT_TERMS',
  NowPartnershipTermsOfService = 'NOW_PARTNERSHIP_TERMS_OF_SERVICE',
  PartnershipContract = 'PARTNERSHIP_CONTRACT',
  PartnershipPharmaceuticalManagementTerms = 'PARTNERSHIP_PHARMACEUTICAL_MANAGEMENT_TERMS',
  PersonalInformationOverseasTransfer = 'PERSONAL_INFORMATION_OVERSEAS_TRANSFER',
  PersonalInformationProcessing = 'PERSONAL_INFORMATION_PROCESSING',
  PharmacyWholesaleServiceTerms = 'PHARMACY_WHOLESALE_SERVICE_TERMS',
  ProvideHealthInformation = 'PROVIDE_HEALTH_INFORMATION',
  ProvidePersonalInformation = 'PROVIDE_PERSONAL_INFORMATION',
  ProvideSensitiveInformation = 'PROVIDE_SENSITIVE_INFORMATION',
  RegularPayment = 'REGULAR_PAYMENT',
  SensitiveInformation = 'SENSITIVE_INFORMATION',
  TermsAndConditions = 'TERMS_AND_CONDITIONS'
}

/** 약관 동의 / 비동의 요청 */
export type AgreementsApprovedApiRequestInput = {
  /** 동의할 약관 id 목록 */
  approvedAgreementIds: Array<Scalars['ID']>;
  /** 비동의할 약관 id 목록 */
  disapprovedAgreementIds: Array<Scalars['ID']>;
};

/** 약관 동의 여부 확인 요청 */
export type AgreementsApprovedCheckApiRequestInput = {
  /** 약관 카테고리 */
  agreementCategory: AgreementCategory;
  /** 약관 타입 */
  agreementType: AgreementType;
};

export enum AiAnswerButtonType {
  Horizontal = 'HORIZONTAL',
  Vertical = 'VERTICAL'
}

export enum AiAnswerCheckStatus {
  Checked = 'CHECKED',
  NoNeedToCheck = 'NO_NEED_TO_CHECK',
  Unchecked = 'UNCHECKED'
}

export type AiAnswerGraph = {
  aiAnswerStatus: AiAnswerStatus;
  checkStatus?: Maybe<AiAnswerCheckStatus>;
  content: Scalars['String'];
  questionPid: Scalars['ID'];
};

export enum AiAnswerStatus {
  Accepted = 'ACCEPTED',
  Generating = 'GENERATING',
  GenerationComplete = 'GENERATION_COMPLETE',
  GenerationFailed = 'GENERATION_FAILED',
  GenerationRequested = 'GENERATION_REQUESTED',
  None = 'NONE',
  Rejected = 'REJECTED'
}

/** 주문 결제 요청 */
export type AllOrderPayRequestInput = {
  /** 결제해야 할 추가주문 금액 */
  additionalOrderAmountToPay: Scalars['Int'];
  /** 추가주문한 상품 목록 */
  additionalProducts: Array<AdditionalProductRequestInput>;
  /** 결제해야 할 배송비 금액 */
  deliveryFeeAmountToPay: Scalars['Int'];
  /** 결제해야 할 조제비 금액 */
  dispensationAmountToPay: Scalars['Int'];
  /** 할부 개월 */
  installmentMonth?: InputMaybe<Scalars['Int']>;
  /** 주문 Id */
  orderId: Scalars['Int'];
  /** 사용할 포인트 */
  point: Scalars['Int'];
  /** 결제해야 할 총 금액 */
  totalAmountToPay: Scalars['Int'];
  /** 유저 결제수단 id */
  userPaymentId: Scalars['Int'];
};

export type AlternativeIngredientSearchRequestInput = {
  /** 작용기전 */
  actionMechanismList: Array<Scalars['String']>;
  /** 페이지 번호 */
  page: Scalars['Int'];
  /** 페이지 크기 */
  size: Scalars['Int'];
  /** 대체할 대상 성분 코드 */
  targetIngredientCode: Scalars['String'];
};

export type AlternativeMedicationInfo = {
  /** 급여타입 (급여/비급여) */
  benefitType: MedicineBenefitType;
  /** 현재 보험코드 */
  currentInsuranceCode?: Maybe<Scalars['ID']>;
  /** 대조약 여부 */
  existComparedMedication: Scalars['Boolean'];
  /** 생동성 인정 의약품 */
  isLivelinessMedication: Scalars['Boolean'];
  /** 저가 대체 가산여부 */
  isLowCostAlternative: Scalars['Boolean'];
  /** 주성분 코드 */
  mainIngredientCode?: Maybe<Scalars['String']>;
  /** 주성분 영문 이름 */
  mainIngredientEnglishName: Scalars['String'];
  /** 주성분 이름 */
  mainIngredientName: Scalars['String'];
  /** 전문/일반 의약품 */
  medicationApprovalType: MedicineApprovalType;
  /** 약 이름 */
  medicationName: Scalars['String'];
  /** 원스글로벌 코드 */
  onesglobalCode: Scalars['ID'];
};

export type AnemiaGraph = {
  /** 빈혈 수치 */
  anemiaLevel: Scalars['Float'];
  /** 빈혈 수치 상태 */
  status: AnemiaStatus;
};

/** 빈혈 기록 */
export type AnemiaRecord = {
  /** 건강기록 ID */
  healthRecordId: Scalars['ID'];
  /** 기록 타입 */
  healthRecordType: HealthRecordType;
  /** 기록 대상일자 */
  recordDateTime: Scalars['DrTimestamp'];
  /** 데이터 출처 */
  source: HealthRecordSource;
  /** 유저 ID */
  userId: Scalars['ID'];
  /** 빈혈 수치 */
  value: AnemiaGraph;
};

export enum AnemiaStatus {
  Danger = 'DANGER',
  Normal = 'NORMAL',
  Warning = 'WARNING'
}

/** 실시간 건강상담 답변 */
export type Answer = {
  /** 답변 PID */
  answerPid: Scalars['ID'];
  /** 답변자 */
  answerer: Answerer;
  /** 답변 본문 */
  content: Scalars['String'];
  /** 답변 생성시각 */
  createdAt: Scalars['DrTimestamp'];
  /** 싫어요 수 */
  dislikeCount: Scalars['Int'];
  /** 답변 꼬리말 */
  footer?: Maybe<Scalars['String']>;
  /** 답변 머리말 */
  header?: Maybe<Scalars['String']>;
  /** 내가 블록한 여부 */
  isBlockedByMe: Scalars['Boolean'];
  /** 좋아요 수 */
  likeCount: Scalars['Int'];
  /** 내가 좋아요한 여부 */
  myLikeType?: Maybe<AnswerLikeType>;
  /** 질문 아이디 */
  questionPid: Scalars['ID'];
  /** 추천 매거진 정보 */
  recommendedMagazineGraph?: Maybe<RecommendedMagazineGraph>;
  /** 답변 리뷰 목록 */
  reviews: Array<QnaAnswerReview>;
};

export type AnswerCursorPage = {
  elements: Array<Answer>;
  pivot?: Maybe<Scalars['ID']>;
};

export type AnswerLikeReasonAddRequestInput = {
  answerPid: Scalars['ID'];
  reasons: Array<AnswerLikeReasonRequestInput>;
};

export type AnswerLikeReasonRequestInput = {
  answerLikeType: AnswerLikeType;
  reason: Scalars['String'];
};

export type AnswerLikeRequestInput = {
  answerPid: Scalars['ID'];
  type: AnswerLikeType;
};

export enum AnswerLikeType {
  Dislike = 'DISLIKE',
  Like = 'LIKE'
}

export type AnswerReportRequestInput = {
  answerPid: Scalars['ID'];
  reason: Scalars['String'];
};

export type AnswerSection = {
  answerPid: Scalars['ID'];
  answerer: Answerer;
  content: Scalars['String'];
  createdAt: Scalars['DrTimestamp'];
  dislikeCount: Scalars['Int'];
  footer?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  isBlockedByUser: Scalars['Boolean'];
  likeCount: Scalars['Int'];
  myLikeType?: Maybe<AnswerLikeType>;
  questionPid: Scalars['ID'];
};

export type Answerer = {
  /** @deprecated affiliation 을 사용한다. */
  affiliatedInstitutionName: Scalars['String'];
  affiliation?: Maybe<Affiliation>;
  answererId: Scalars['ID'];
  answererPublicId?: Maybe<Scalars['ID']>;
  answererType: AnswererType;
  name: Scalars['String'];
  professionalFields: Array<ProfessionalField>;
  profileImageUrl: Scalars['String'];
};

export enum AnswererType {
  Ai = 'AI',
  Doctor = 'DOCTOR',
  Nurse = 'NURSE'
}

/** 앱 버전 체크 */
export type AppVersionCheck = {
  /** 가장 최신 버전 */
  latestStoreVersion: Scalars['String'];
  /** 강제 업데이트 필요 여부 */
  needToForceUpdate: Scalars['Boolean'];
};

export enum AttachmentBlindType {
  Blinded = 'BLINDED',
  Dimmed = 'DIMMED',
  None = 'NONE'
}

export enum AuthRole {
  Admin = 'ADMIN',
  Hospital = 'HOSPITAL',
  User = 'USER'
}

/** 로그인 토큰 */
export type AuthToken = {
  /** API access token */
  accessToken: Scalars['String'];
  /** accountId */
  accountId: Scalars['ID'];
  /** refresh token */
  refreshToken: Scalars['String'];
  /** roleId */
  roleId?: Maybe<Scalars['ID']>;
  /** roleType */
  roleType: Scalars['String'];
};

/** 건강매거진 저자 */
export type Author = {
  /** @deprecated affiliation 을 사용한다. */
  affiliatedInstitutionName: Scalars['String'];
  affiliation?: Maybe<Affiliation>;
  authorId: Scalars['ID'];
  authorPublicId?: Maybe<Scalars['ID']>;
  authorType: AuthorType;
  careers: Array<AuthorCareer>;
  externalLinkUrl?: Maybe<Scalars['String']>;
  hospitalId?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  professionalFields: Array<ProfessionalField>;
  profileDescription?: Maybe<Scalars['String']>;
  profileImageUrl: Scalars['String'];
};

/** 저자 경력 */
export type AuthorCareer = {
  careerType: DoctorCareerType;
  content: Scalars['String'];
  id: Scalars['ID'];
  isRepresentative: Scalars['Boolean'];
};

export enum AuthorType {
  Ai = 'AI',
  Doctor = 'DOCTOR',
  GeneralEditor = 'GENERAL_EDITOR',
  MedicalProfessionalEditor = 'MEDICAL_PROFESSIONAL_EDITOR',
  Nurse = 'NURSE'
}

export type AvailablePickupOnlyMethodsRequestInput = {
  /** 진료 ID */
  diagnosisId: Scalars['ID'];
};

export type BanCommunityUserRequestInput = {
  dayCount: Scalars['Int'];
  userId: Scalars['ID'];
};

/** 노출할 광고 소재 */
export type BannerAdExchange = {
  badges: Array<AdBadgeGraph>;
  /** 배너 광고 ID */
  bannerAdId: Scalars['ID'];
  /** 배너 이미지 presigned URL */
  bannerImageUrl?: Maybe<Scalars['String']>;
  /** 클릭시 발생시킬 행동 */
  clickAction: ClickAction;
  /** 광고 테마 (LIGHT | DARK) */
  colorTheme: AdColorTheme;
  content?: Maybe<Scalars['String']>;
  /** CTA 버튼에 들어갈 문구 */
  ctaButtonLabel?: Maybe<Scalars['String']>;
  /** 심의필 번호 (i.e. 제220421-중-54650) */
  deliberatedCode?: Maybe<Scalars['String']>;
  /** 갤럭시 폴드용 긴 부제목 (얇은 글씨로 나오는 광고 문구) */
  longSubTitle?: Maybe<Scalars['String']>;
  /** 갤럭시 폴드용 긴 제목 (굵은 글씨로 나오는 광고 문구) */
  longTitle?: Maybe<Scalars['String']>;
  /** 부제목 (얇은 글씨로 나오는 광고 문구) */
  subTitle?: Maybe<Scalars['String']>;
  /**
   * 구좌가 배치될 구체적 위치
   * @deprecated targetPlaceCode로 대체
   */
  targetPlace?: Maybe<AdTargetPlace>;
  /** 구좌가 배치될 구체적 위치 */
  targetPlaceCode: Scalars['String'];
  /** 제목 (굵은 글씨로 나오는 광고 문구) */
  title?: Maybe<Scalars['String']>;
};

/** 배너 광고 Ad Exchange 요청 */
export type BannerAdExchangeRequestInput = {
  /** 구좌가 배치될 구체적 위치 (targetPlaceCode로 대체) */
  targetPlace?: InputMaybe<AdTargetPlace>;
  /** 구좌가 배치될 구체적 위치 */
  targetPlaceCode?: InputMaybe<Scalars['String']>;
};

export enum BannerDisplayType {
  All = 'ALL',
  App = 'APP',
  Web = 'WEB'
}

/** 약품 기본 정보 */
export type BasicInfo = {
  /** 약품 영문명 */
  englishName: Scalars['String'];
  /** 생산 여부 */
  isOperating: Scalars['Boolean'];
  /** 약품 이미지 */
  medicineImage?: Maybe<Scalars['String']>;
  /** 약품 관련 픽토그램 이미지 */
  medicinePictogramImages: Array<Scalars['String']>;
  /** 약품명 */
  name: Scalars['String'];
  /** 약효 한줄 요약 */
  pharmaceuticalEffectLiteracy: Scalars['String'];
  /** 간소화된 약품명 */
  simplifiedName: Scalars['String'];
};

/** 실시간 상담 질문 만족 의견 표현 요청 */
export type BeDissatisfiedWithAiAnswerRequestInput = {
  /** 질문 PID */
  questionPid: Scalars['ID'];
};

/** 실시간 상담 질문 만족 의견 표현 요청 */
export type BeSatisfiedWithAiAnswerRequestInput = {
  /** 질문 PID */
  questionPid: Scalars['ID'];
};

export type BlindBoardCommentResult = {
  /** 댓글 작성자의 차단일 수 */
  userBannedDayCount: Scalars['Int'];
  /** 댓글 작성자의 차단일 수 메시지 */
  userBannedDayCountMessage: Scalars['String'];
  /** 댓글 작성자의 블라인드된 횟수 */
  userBlindedCount: Scalars['Int'];
};

export type BlindBoardPostResult = {
  /** 게시글 작성자의 차단일 수 */
  userBannedDayCount: Scalars['Int'];
  /** 게시글 작성자의 차단일 수 메시지 */
  userBannedDayCountMessage: Scalars['String'];
  /** 게시글 작성자의 블라인드된 횟수 */
  userBlindedCount: Scalars['Int'];
};

/** 대상 ID 블럭 요청 */
export type BlockingAccountMutationRequestInput = {
  /** 블럭 대상 role ID */
  blockTargetId: Scalars['String'];
  /** 블럭 대상 role type, ex: user, doctor, pharmacy 등 */
  blockTargetRoleType: Scalars['String'];
};

export type BloodPressureGraph = {
  /** 이완기 혈압 */
  diastolicBloodPressure: Scalars['Float'];
  /** 이완기 혈압 상태 */
  diastolicBloodPressureStatus: BloodPressureStatus;
  /** 수축기 혈압 */
  systolicBloodPressure: Scalars['Float'];
  /** 수축기 혈압 상태 */
  systolicBloodPressureStatus: BloodPressureStatus;
  /** 통합 상태 */
  totalStatus: BloodPressureStatus;
};

/** 혈압 */
export type BloodPressureMutationRecordInput = {
  /** 이완기 혈압 */
  diastolicBloodPressure: Scalars['Float'];
  /** 수축기 혈압 */
  systolicBloodPressure: Scalars['Float'];
};

/** 혈압 기록 */
export type BloodPressureRecord = {
  /** 건강기록 ID */
  healthRecordId: Scalars['ID'];
  /** 기록 타입 */
  healthRecordType: HealthRecordType;
  /** 기록 대상일자 */
  recordDateTime: Scalars['DrTimestamp'];
  /** 데이터 출처 */
  source: HealthRecordSource;
  /** 유저 ID */
  userId: Scalars['ID'];
  /** 혈압 */
  value: BloodPressureGraph;
};

/** 혈압 요청 */
export type BloodPressureRecordMutationRequestInput = {
  /** 혈압 */
  bloodPressureRecord: BloodPressureMutationRecordInput;
  /** 기록 대상일자 */
  recordDateTime: Scalars['DrTimestamp'];
};

export enum BloodPressureStatus {
  Hypertension = 'HYPERTENSION',
  Normal = 'NORMAL',
  PreHypertension = 'PRE_HYPERTENSION'
}

export type BloodSugarGraph = {
  /** 혈당 */
  bloodSugar: Scalars['Float'];
  /** 기록 시점 */
  recordedTimeType: RecordedTimeType;
  /** 상태 */
  status: BloodSugarStatus;
};

/** 혈당 */
export type BloodSugarMutationRecordInput = {
  /** 혈당 */
  bloodSugar: Scalars['Float'];
  /** 기록 시점 */
  recordedTimeType: RecordedTimeType;
};

/** 혈당 기록 */
export type BloodSugarRecord = {
  /** 건강기록 ID */
  healthRecordId: Scalars['ID'];
  /** 기록 타입 */
  healthRecordType: HealthRecordType;
  /** 기록 대상일자 */
  recordDateTime: Scalars['DrTimestamp'];
  /** 데이터 출처 */
  source: HealthRecordSource;
  /** 유저 ID */
  userId: Scalars['ID'];
  /** 혈당 */
  value: BloodSugarGraph;
};

/** 혈당 요청 */
export type BloodSugarRecordMutationRequestInput = {
  /** 혈당 */
  bloodSugarRecord: BloodSugarMutationRecordInput;
  /** 기록 대상일자 */
  recordDateTime: Scalars['DrTimestamp'];
};

export enum BloodSugarStatus {
  Diabetes = 'DIABETES',
  DiabetesWarning = 'DIABETES_WARNING',
  Normal = 'NORMAL'
}

export type BoardCategory = {
  /** 카테고리 아이디 */
  boardCategoryId: Scalars['ID'];
  /** 이미지 url */
  imageUrl: Scalars['String'];
  /** 카테고리 명 */
  name: Scalars['String'];
};

export type BoardCommentBelongedBoardCommentsRequestInput = {
  boardCommentPid: Scalars['ID'];
};

export type BoardCommentCursorPage = {
  elements: Array<BoardCommentGraph>;
  pivot?: Maybe<Scalars['ID']>;
};

/** BoardComment */
export type BoardCommentGraph = {
  /** 블라인드 여부 */
  blinded: Scalars['Boolean'];
  /** 댓글 아이디 */
  boardCommentPid: Scalars['ID'];
  boardPost?: Maybe<BoardPost>;
  /** 게시글 아이디 */
  boardPostPid: Scalars['ID'];
  communityUser: CommunityUser;
  /** 내용 */
  content: Scalars['String'];
  /** 댓글 생성 시간 */
  createdAt: Scalars['DrTimestamp'];
  /** 삭제 여부 */
  deleted: Scalars['Boolean'];
  isLikedByMe: Scalars['Boolean'];
  isMine: Scalars['Boolean'];
  /** 좋아요 갯수 */
  likeCount: Scalars['Int'];
  /** 상위 댓글 아이디 */
  parentBoardCommentPid: Scalars['ID'];
  /** 유저 아이디 */
  userId: Scalars['ID'];
};

export type BoardPost = {
  /** 블라인드 여부 */
  blinded: Scalars['Boolean'];
  boardCategory: BoardCategory;
  /** 카테고리 아이디 */
  boardCategoryId: Scalars['ID'];
  /** 댓글 수 */
  boardCommentCount: Scalars['Int'];
  boardComments: Array<BoardCommentGraph>;
  boardPostAttachments: Array<BoardPostAttachment>;
  /** 게시글 아이디 */
  boardPostPid: Scalars['ID'];
  communityUser: CommunityUser;
  /** 내용 */
  content: Scalars['String'];
  /** 작성시간 */
  createdAt: Scalars['DrTimestamp'];
  isLikedByMe: Scalars['Boolean'];
  isMine: Scalars['Boolean'];
  /** 인기글 여부 */
  isPopular: Scalars['Boolean'];
  /**
   * 추천글 여부
   * @deprecated 사용하지 않음
   */
  isRecommended: Scalars['Boolean'];
  /** 좋아요 갯수 */
  likeCount: Scalars['Int'];
  /** 타이틀 */
  title: Scalars['String'];
  /** 유저 아이디 */
  userId: Scalars['ID'];
};

export type BoardPostAttachment = {
  /** 블라인드 타입 */
  blindType: AttachmentBlindType;
  /** 첨부 파일 아이디 */
  boardPostAttachmentId: Scalars['ID'];
  /** 게시글 아이디 */
  boardPostPid: Scalars['ID'];
};

/** BoardPostAttachmentUploadInfo */
export type BoardPostAttachmentUploadInfoGraph = {
  path: Scalars['String'];
  preSignedUrl: Scalars['String'];
};

export type BoardPostCursorPage = {
  elements: Array<BoardPost>;
  pivot?: Maybe<Scalars['ID']>;
};

/** 신체정보 기록 */
export type BodyInfoRecord = {
  /** 건강기록 ID */
  healthRecordId: Scalars['ID'];
  /** 기록 타입 */
  healthRecordType: HealthRecordType;
  /** 기록 대상일자 */
  recordDateTime: Scalars['DrTimestamp'];
  /** 데이터 출처 */
  source: HealthRecordSource;
  /** 유저 ID */
  userId: Scalars['ID'];
  /** 신체 정보 */
  value: BodyMeasurementGraph;
};

/** 신체 정보 요청 */
export type BodyInfoRecordMutationRequestInput = {
  /** 신체 정보 */
  bodyInfoRecord: BodyMeasurementMutationRecordInput;
  /** 기록 대상일자 */
  recordDateTime: Scalars['DrTimestamp'];
};

export type BodyMeasurementGraph = {
  /** bmi */
  bmi: Scalars['Float'];
  /** 키 */
  height: Scalars['Float'];
  /** 상태 */
  status: BodyStatus;
  /** 몸무게 */
  weight: Scalars['Float'];
};

/** 신체 정보 */
export type BodyMeasurementMutationRecordInput = {
  /** 키 */
  height: Scalars['Float'];
  /** 몸무게 */
  weight: Scalars['Float'];
};

/** 신체정보 기록 */
export type BodyMeasurementRecord = {
  /** 건강기록 ID */
  healthRecordId: Scalars['ID'];
  /** 기록 타입 */
  healthRecordType: HealthRecordType;
  /** 기록 대상일자 */
  recordDateTime: Scalars['DrTimestamp'];
  /** 데이터 출처 */
  source: HealthRecordSource;
  /** 유저 ID */
  userId: Scalars['ID'];
  /** 신체 정보 */
  value: BodyMeasurementGraph;
};

/** 신체 정보 요청 */
export type BodyMeasurementRecordMutationRequestInput = {
  /** 신체 정보 */
  bodyMeasurementRecord: BodyMeasurementMutationRecordInput;
  /** 기록 대상일자 */
  recordDateTime: Scalars['DrTimestamp'];
};

export enum BodyStatus {
  LowWeight = 'LOW_WEIGHT',
  Normal = 'NORMAL',
  Obesity = 'OBESITY',
  Overweight = 'OVERWEIGHT'
}

export enum BookingAvailability {
  NotBookable = 'NOT_BOOKABLE',
  TodayBookable = 'TODAY_BOOKABLE',
  TomorrowBookable = 'TOMORROW_BOOKABLE',
  UpcomingBookable = 'UPCOMING_BOOKABLE'
}

export enum BookingScheduleType {
  Bookable = 'BOOKABLE',
  Disabled = 'DISABLED',
  FullyBooked = 'FULLY_BOOKED'
}

export enum BookingStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

/** 예약 슬롯 */
export type BookingTimeSlotGraph = {
  /** 슬롯의 시작 시간 (hh:MM) */
  displayTime: Scalars['String'];
  /** 슬롯의 시작 시간 (hh:MM) */
  fromDisplayTime: Scalars['String'];
  /** 슬롯의 끝 시간 (hh:MM) */
  toDisplayTime: Scalars['String'];
  /** 슬롯 번호 (0~143) */
  value: Scalars['Int'];
};

export type BrandDoctorSearchRequestInput = {
  /** 브랜드 ID */
  brandId: Scalars['ID'];
  /** 위치 정보 */
  geoPoint?: InputMaybe<GeoPointInput>;
  /** limit */
  limit: Scalars['Int'];
  /** page */
  page: Scalars['Int'];
  /** 정렬 타입 */
  sortType: DoctorSortType;
  /** 원격의료 타겟 타입 */
  telemedicineEligibleTargetType?: InputMaybe<TelemedicineEligibleTargetType>;
  /** 오늘 예약가능 여부 */
  todayBookableOnly?: InputMaybe<Scalars['Boolean']>;
};

export type BrandGraph = {
  /** 배너 배경색 RGB 6자리 */
  backgroundColor: Scalars['String'];
  /** 브랜드 배너 이미지 경로 */
  bannerImageUrl: Scalars['String'];
  /** 브랜드명 */
  brandName: Scalars['String'];
  /** 캐치프레이즈 */
  catchPhrase: Scalars['String'];
  /** 진료 신청서 타입 */
  diagnosisFormType: DiagnosisFormType;
  /** 브랜드 Id */
  id: Scalars['ID'];
  /** 브랜드 로고 경로 */
  logoUrl: Scalars['String'];
};

export type ButtonOnDiagnosisListAtUserApp = {
  actionType: ButtonOnDiagnosisListAtUserAppActionType;
  text: Scalars['String'];
};

export enum ButtonOnDiagnosisListAtUserAppActionType {
  GoToWriteDiagnosisReview = 'GO_TO_WRITE_DIAGNOSIS_REVIEW'
}

export type CancelOrderByUserDiagnosisMutationRequestInput = {
  diagnosisId: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
};

export type CancelPartnershipPickupOrderByUserMutationRequestInput = {
  cancelReasonType: OrderCancelReasonType;
  diagnosisId: Scalars['ID'];
  reason: Scalars['String'];
};

export type CancelPickupOrderByUserMutationRequestInput = {
  cancelReasonType: OrderCancelReasonType;
  orderId: Scalars['ID'];
  reason: Scalars['String'];
};

export enum CardType {
  Credit = 'CREDIT',
  Debit = 'DEBIT',
  Gift = 'GIFT',
  KakaopayMoney = 'KAKAOPAY_MONEY',
  Unknown = 'UNKNOWN'
}

export type CatalogRecommendationGraph = {
  catalogIds: Array<Scalars['ID']>;
  description: Scalars['String'];
  medicalCategory?: Maybe<MedicalCategoryTargetGraph>;
  name: Scalars['String'];
};

/** 카테고리 별 베스트 질문 */
export type CategoryBestSimpleQuestionsRequestInput = {
  /** 카테고리 아이디 */
  categoryId: Scalars['ID'];
};

export enum ChannelType {
  PersonalizedNutrition = 'PERSONALIZED_NUTRITION',
  /** @deprecated 구 추가주문임, 신 추가주문은 PHARMACY_MARKETPLACE 사용 */
  PharmacyAdditionalOrder = 'PHARMACY_ADDITIONAL_ORDER',
  PharmacyMarketplace = 'PHARMACY_MARKETPLACE'
}

export type CheckApprovedAgreementGraph = {
  result: Scalars['Boolean'];
};

/** 의약품 분류 정보 */
export type ClassificationInfo = {
  /** 약품 분류명 */
  classificationName: Scalars['String'];
  /** 전문/일반의약품 구분 */
  ethicalType: Scalars['String'];
};

export type ClickAction = {
  /** 클릭시 취할 행동의 종류 (OUTLINK, PHONE_CALL, ...) */
  clickActionType: ClickActionType;
  /** 클릭시 이동할 랜딩페이지의 링크 */
  outlink?: Maybe<Scalars['String']>;
  /** 클릭시 전화가 걸려야 하는 번호 */
  phoneNumber?: Maybe<Scalars['String']>;
};

export enum ClickActionType {
  Outlink = 'OUTLINK',
  PhoneCall = 'PHONE_CALL'
}

export enum CombinedEligibilityTagType {
  MedicineDeliveryAlways = 'MEDICINE_DELIVERY_ALWAYS',
  MedicinePickUpOnly = 'MEDICINE_PICK_UP_ONLY',
  TelemedicineAlways = 'TELEMEDICINE_ALWAYS',
  TelemedicineNightAndHolidayOnly = 'TELEMEDICINE_NIGHT_AND_HOLIDAY_ONLY'
}

export type CommerceCategoryGraph = {
  categoryId: Scalars['ID'];
  channelType: ChannelType;
  name: Scalars['String'];
};

/** 커머스 주문 */
export type CommerceOrder = {
  /** 판매 채널 타입 */
  channelType: ChannelType;
  /** 배송비 */
  deliveryFee: Scalars['Int'];
  /** 커머스 주문 아이디 */
  orderId: Scalars['ID'];
  /** 오더 아이템 리스트 */
  orderItems: Array<CommerceOrderItemGraph>;
  /** 커머스 주문 번호 */
  orderNumber: Scalars['String'];
  /** 결제완료 금액 */
  paidAmount: Scalars['Int'];
  /** 결제 종합 정보 */
  paymentTotal?: Maybe<PaymentTotalGraph>;
  /** 배송 정보 */
  shipment?: Maybe<Shipment>;
  /** 커머스 주문 상태 */
  status: CommerceOrderStatus;
  /** 총 상품금액 */
  totalItemPrice: Scalars['Int'];
  /** 유저 아이디 */
  userId: Scalars['ID'];
};

export type CommerceOrderItemGraph = {
  /** 상품 이름 */
  name: Scalars['String'];
  /** 주문 아이템 아이디 */
  orderItemId: Scalars['ID'];
  /** 주문 아이템 가격 */
  price: Scalars['Int'];
  /** 상품 정보 (Deprecated) */
  product: CommerceProductGraph;
  /** 상품 아이디 */
  productId: Scalars['ID'];
  /** 상품 수량 */
  quantity: Scalars['Int'];
  /** 주문 아이템 상태 */
  status: CommerceOrderItemStatus;
};

export enum CommerceOrderItemStatus {
  AwaitingShipment = 'AWAITING_SHIPMENT',
  Cancelled = 'CANCELLED',
  DeliveryCompleted = 'DELIVERY_COMPLETED',
  Paid = 'PAID',
  PendingPayment = 'PENDING_PAYMENT',
  Shipped = 'SHIPPED'
}

/** 커머스 주문 아이템 */
export type CommerceOrderItemV2 = {
  /** 주문 아이템 아이디 */
  id: Scalars['ID'];
  /** 상품 이름 */
  name: Scalars['String'];
  /** 주문 아이템 가격 */
  price: Scalars['Int'];
  /** 상품 정보 */
  product: AbstractProduct;
  /** 상품 아이디 */
  productId: Scalars['ID'];
  /** 상품 수량 */
  quantity: Scalars['Int'];
  /** 주문 아이템 상태 */
  status: CommerceOrderItemStatus;
};

export enum CommerceOrderStatus {
  AwaitingShipment = 'AWAITING_SHIPMENT',
  Cancelled = 'CANCELLED',
  DeliveryCompleted = 'DELIVERY_COMPLETED',
  Paid = 'PAID',
  PendingPayment = 'PENDING_PAYMENT',
  Shipped = 'SHIPPED'
}

/** 커머스 주문 */
export type CommerceOrderV2 = {
  /** 판매 채널 타입 */
  channelType: ChannelType;
  deliveryCompletedAt?: Maybe<Scalars['DrTimestamp']>;
  /** 배송비 */
  deliveryFee: Scalars['Int'];
  /** 할인 금액 */
  discountAmount: Scalars['Int'];
  /** 할인율 */
  discountRate: Scalars['Float'];
  /** 커머스 주문 아이디 */
  id: Scalars['ID'];
  /** 주문 아이템 리스트 */
  orderItems: Array<CommerceOrderItemV2>;
  /** 커머스 주문 번호 */
  orderNumber: Scalars['String'];
  /** 결제완료 금액 */
  paidAmount: Scalars['Int'];
  /** 결제완료 일시 */
  paidAt?: Maybe<Scalars['DrTimestamp']>;
  /** 결제 종합 정보 */
  paymentTotal?: Maybe<PaymentTotalGraph>;
  /** 수취인의 배송정보 */
  receiverDeliveryInfo: DeliveryInfo;
  /** 커머스 주문 상태 */
  status: CommerceOrderStatus;
  /** 사용된 포인트 */
  usedPoint: Scalars['Int'];
  /** 유저 아이디 */
  userId: Scalars['ID'];
};

export type CommerceProductGraph = {
  category: CommerceCategoryGraph;
  meta: Array<ProductMetadataGraph>;
  name: Scalars['String'];
  price: Scalars['Int'];
  productId: Scalars['ID'];
  productThumbnailUrl: Scalars['String'];
  sellerId: Scalars['ID'];
};

export type CommerceProductSearchRequestInput = {
  /** 약국 Id */
  channelType: ChannelType;
  /** 약국 Id */
  sellerType: SellerType;
  /** 약국 Id */
  sellerTypeKey: Scalars['String'];
};

export type CommunityUser = {
  bannedUntil?: Maybe<Scalars['DrTimestamp']>;
  isAdmin: Scalars['Boolean'];
  nickname: Scalars['String'];
  postCommentNotificationAllowed: Scalars['Boolean'];
  postLikeNotificationAllowed: Scalars['Boolean'];
  profileImageUrl: Scalars['String'];
  qnaAnswerNotificationAllowed: Scalars['Boolean'];
  tutorialCompleted: Scalars['Boolean'];
  userId: Scalars['ID'];
};

export type CommunityUserNicknameValidationGraph = {
  available: Scalars['Boolean'];
  resultType: ResultType;
};

export type CommunityUserProfileImagePreset = {
  path: Scalars['String'];
  url: Scalars['String'];
};

export type CommunityUserProfileImageUploadInfo = {
  path: Scalars['String'];
  preSignedUrl: Scalars['String'];
};

/** 회사 정보 */
export type CompanyInfo = {
  /** 판매사(제조사) 영문명 */
  companyEnglishName: Scalars['String'];
  /** 판매사(제조사) */
  companyName: Scalars['String'];
};

export enum ContractType {
  All = 'ALL',
  FaceToFace = 'FACE_TO_FACE',
  NonFaceToFace = 'NON_FACE_TO_FACE'
}

export type CoreCategoryGraph = {
  coreId: Scalars['ID'];
  coreType: CoreCategoryType;
};

export enum CoreCategoryType {
  Department = 'DEPARTMENT',
  Disease = 'DISEASE',
  Symptom = 'SYMPTOM'
}

/** 상담 정보 */
export type Counseling = {
  /** 내담자 이름 */
  applicantName: Scalars['String'];
  /** 내담자 전화번호 */
  applicantPhone: Scalars['String'];
  /** 상담자가 내담자에게 전하는 말 */
  comment?: Maybe<Scalars['String']>;
  /** 상담 완료 예정일시 */
  completeScheduledAt: Scalars['DrTimestamp'];
  /** 상담 완료 일시 */
  completedAt?: Maybe<Scalars['DrTimestamp']>;
  /** 상담자 정보 */
  counselor: Counselor;
  /** 상담 id */
  id: Scalars['ID'];
  /** 상담 아이템 정보 */
  items: Array<CounselingItemGraph>;
  /** 상담 Key */
  key: Scalars['String'];
  /** 상담 시작 예정일시 */
  startScheduledAt: Scalars['DrTimestamp'];
  /** 상담 시작 일시 */
  startedAt?: Maybe<Scalars['DrTimestamp']>;
  /** 상담 상태 */
  status: CounselingStatus;
  /** 상담 타입 */
  type: CounselingType;
};

export type CounselingBookingDayScheduleGraph = {
  /** 예약 가능한 스케쥴 리스트 */
  schedules: Array<CounselingBookingScheduleGraph>;
  /** 예약 날짜 */
  targetDate: Scalars['String'];
};

export type CounselingBookingDaySchedulesByUserRequestInput = {
  /** 상담자 Role */
  role: AuthRole;
  /** role 의 id */
  roleId: Scalars['ID'];
  /** 예약 스케줄을 가져올 날짜 리스트 (ex: 2022-05-01) */
  targetDates: Array<Scalars['String']>;
};

/** 상담 예약 스케쥴 가져오기 */
export type CounselingBookingScheduleGraph = {
  /** 해당 스케줄의 예약 상태 (DISABLED | BOOKABLE | FULLY_BOOKED) */
  bookingStatus: BookingScheduleType;
  /** 이 예약의 끝 슬롯 */
  endTimeSlot: BookingTimeSlotGraph;
  /** 해당 시간대의 남은 예약 수 */
  remainingCount: Scalars['Int'];
  /** 이 예약의 시작 슬롯 */
  startTimeSlot: BookingTimeSlotGraph;
};

/** 상담 예약 스케쥴 가져오기 */
export type CounselingBookingSchedulesByUserRequestInput = {
  /** 상담자 Role */
  role: AuthRole;
  /** role 의 id */
  roleId: Scalars['ID'];
  /** 예약 스케줄을 가져올 날짜 (ex: 2022-05-01) */
  targetDate: Scalars['String'];
};

export enum CounselingCancelReason {
  BookingNotPossible = 'BOOKING_NOT_POSSIBLE',
  CallFailed = 'CALL_FAILED',
  Other = 'OTHER',
  WaitingTimeout = 'WAITING_TIMEOUT'
}

/** 상담 roomToken 정보 */
export type CounselingChannelTokenGraph = {
  /** 채널 이름 */
  channelName: Scalars['String'];
  /** 채널 접속 토큰 */
  channelToken: Scalars['String'];
};

/** 날짜별 스케쥴 */
export type CounselingDayScheduleGraph = {
  /** 예약 가능한 스케쥴 리스트 */
  schedules: Array<CounselingScheduleGraph>;
  /** 날짜 스케쥴 상태 */
  status: DayScheduleStatus;
  /** 예약 날짜 */
  targetDate: Scalars['String'];
};

export type CounselingDaySchedulesByPolicyRequestInput = {
  /** 상담자 Role */
  role: AuthRole;
  /** 상담자 타입별 id */
  roleId: Scalars['ID'];
};

export type CounselingItemGraph = {
  /** 구독 Id */
  counselingId: Scalars['ID'];
  /** 구독 타입 */
  counselingType: CounselingType;
  /** 구독 아이템 Id */
  id: Scalars['ID'];
  /** 상품 가격 */
  price: Scalars['Int'];
  /** 상품 정보 */
  product: AbstractProduct;
  /** 상품 Id */
  productId: Scalars['ID'];
  /** 상품 이름 */
  productName: Scalars['String'];
};

/** 상담 요청 */
export type CounselingRegisterRequestInput = {
  /** 건강 분석 결과 Id */
  counselingType: CounselingType;
  /** 종료 예약 슬롯 값 */
  endTimeSlotValue: Scalars['Int'];
  /** 건강 분석 결과 Id */
  healthAnalysisReportId?: InputMaybe<Scalars['ID']>;
  /** 상담자 Role */
  role: AuthRole;
  /** role 의 id */
  roleId: Scalars['ID'];
  /** 시작 예약 슬롯 값 */
  startTimeSlotValue: Scalars['Int'];
  /** 예약날짜 (ex: 2022-05-01) */
  targetDate: Scalars['String'];
};

/** 상담 예약 스케쥴 가져오기 */
export type CounselingScheduleGraph = {
  /** 해당 스케줄의 예약 상태 (DISABLED | BOOKABLE | FULLY_BOOKED) */
  bookingStatus: BookingScheduleType;
  /** 이 예약의 끝 슬롯 */
  endTimeSlot: BookingTimeSlotGraph;
  /** 해당 시간대의 남은 예약 수 */
  remainingCount: Scalars['Int'];
  /** 이 예약의 시작 슬롯 */
  startTimeSlot: BookingTimeSlotGraph;
};

export enum CounselingStatus {
  BookingConfirmed = 'BOOKING_CONFIRMED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Progress = 'PROGRESS',
  Requested = 'REQUESTED'
}

export enum CounselingType {
  PersonalizedNutrition = 'PERSONALIZED_NUTRITION'
}

/** 상담자 정보 */
export type Counselor = {
  /** 상담자 타입 리스트 */
  counselorTypes: Array<CounselorType>;
  /** 상담자 활성 상태 */
  isActive: Scalars['Boolean'];
  /** 상담자 이름 */
  name: Scalars['String'];
  /** 상담자 프로필 url */
  profileUrl: Scalars['String'];
  /** 상담자 역할 */
  role: AuthRole;
  /** 상담자의 roleId (doctorId 등) */
  roleId: Scalars['ID'];
};

export enum CounselorType {
  PersonalizedNutrition = 'PERSONALIZED_NUTRITION'
}

/** 인증 토큰 발급 요청 */
export type CreateVerificationMutationRequestInput = {
  /** email or phone number */
  target: Scalars['String'];
  /** 인증 타입 */
  type: VerificationType;
};

/** 일일 퀴즈 */
export type DailyQuiz = {
  /**
   * 퀴즈 보너스 보상 포인트
   * @deprecated 보너스 리워드와 일반 리워드를 합친 값으로 사용
   */
  bonusRewardPoint: Scalars['Int'];
  /** 퀴즈 보너스 타입 */
  bonusType: QuizBonusType;
  /**
   * 퀴즈 보너스 보상 포함 여부
   * @deprecated 보너스 리워드와 일반 리워드를 합친 값으로 사용
   */
  includedBonusReward: Scalars['Boolean'];
  /** 퀴즈 보상 양 */
  rewardAmount: Scalars['Int'];
  /**
   * 퀴즈 보상 포인트
   * @deprecated 보너스 리워드와 일반 리워드를 합친 값으로 사용
   */
  rewardPoint: Scalars['Int'];
  /** 퀴즈 보상 타입 */
  rewardType: QuizRewardType;
  /** 퀴즈 상태 */
  status: QuizStatus;
  /** 퀴즈 일자 */
  targetDate: Scalars['String'];
  /**
   * 퀴즈 보상 총합 포인트
   * @deprecated 보너스 리워드와 일반 리워드를 합친 값으로 사용
   */
  totalRewardPoint: Scalars['Int'];
};

export enum DayOfWeekType {
  Friday = 'FRIDAY',
  Holiday = 'HOLIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export enum DayScheduleStatus {
  Bookable = 'BOOKABLE',
  FullyBooked = 'FULLY_BOOKED',
  Holiday = 'HOLIDAY'
}

export type DecideAiAnswerRequestInput = {
  aiAnswerStatus: AiAnswerStatus;
  questionPid: Scalars['ID'];
};

/** 전담의사 삭제 요청 */
export type DeleteFamilyDoctorMutationRequestInput = {
  /** 의사 ID 배열 */
  doctorIds: Array<Scalars['ID']>;
};

/** 건강기록 삭제 요청 */
export type DeleteHealthRecordMutationRequestInput = {
  /** 건강기록 ID 배열 */
  healthRecordIds: Array<Scalars['String']>;
};

export enum DeliveryCategoryType {
  Dawn = 'DAWN',
  PartnershipPickup = 'PARTNERSHIP_PICKUP',
  Pickup = 'PICKUP',
  Post = 'POST',
  Quick = 'QUICK',
  TodayDelivery = 'TODAY_DELIVERY'
}

/** 배송정보 */
export type DeliveryInfo = {
  /** 위치 정보 */
  addressLocation: AddressLocation;
  /** 배송요청사항 */
  deliveryComment?: Maybe<Scalars['String']>;
  /** 이름 */
  name: Scalars['String'];
  /** 전화번호 */
  phone: Scalars['String'];
};

export type DeliveryMethodSearchRequestInput = {
  /** 진료 ID */
  diagnosisId?: InputMaybe<Scalars['ID']>;
  /** 위도 */
  latitude: Scalars['Float'];
  /** 경도 */
  longitude: Scalars['Float'];
  /** 유저 주소 ID */
  userAddressId?: InputMaybe<Scalars['ID']>;
};

/** 진료 과목 정보 */
export type Department = {
  /** 진료 과목 Id */
  departmentId: Scalars['ID'];
  /** 진료 과목 이름 */
  departmentName: Scalars['String'];
  /** 진료 과목 아이콘 주소 */
  iconUrl: Scalars['String'];
};

/** (커스텀) 진료 과목 그룹 정보 */
export type DepartmentGroup = {
  /** 진료 과목 그룹 Id */
  departmentGroupId: Scalars['ID'];
  /** 진료 과목 그룹명 */
  departmentGroupName: Scalars['String'];
  /** 아이콘 URL */
  iconUrl: Scalars['String'];
};

/** 진료 과목 그룹 태그 정보 */
export type DepartmentGroupTag = {
  /** 진료과목 그룹ID */
  departmentGroupId: Scalars['ID'];
  /** 태그 ID */
  id: Scalars['ID'];
  /** 추천 태그 리스트 */
  recommendationTags: Array<Scalars['String']>;
  /** 추천 태그 타이틀 */
  recommendationTitle: Scalars['String'];
};

/** (커스텀) 진료 과목 그룹과 태그 정보 */
export type DepartmentGroupWithRecommendationTag = {
  /** 진료 과목 그룹 Id */
  departmentGroupId: Scalars['ID'];
  /** 진료 과목 그룹명 */
  departmentGroupName: Scalars['String'];
  /** 진료 과목 그룹 태그 */
  departmentGroupTags?: Maybe<Array<DepartmentGroupTag>>;
  /** 아이콘 URL */
  iconUrl: Scalars['String'];
};

/** 과목ID로 건강매거진 목록 조회 요청 */
export type DepartmentMappedMagazineCursorPageRequestInput = {
  /** 컨텐츠 유형(ARTICLE, FAQ) */
  contentType?: InputMaybe<Scalars['String']>;
  /** 과목ID 목록 */
  departmentIds: Array<Scalars['ID']>;
  /** 피벗 아이디 */
  pivot?: InputMaybe<Scalars['ID']>;
  /** 조회 사이즈 */
  size?: InputMaybe<Scalars['Int']>;
};

/** (심평원) 진료 과목 정보 */
export type DepartmentV2 = {
  /** 진료 과목 Id */
  departmentId: Scalars['ID'];
  /** 진료 과목 이름 */
  departmentName: Scalars['String'];
};

export type DeviceInfoSaveMutationRequestInput = {
  deviceId: Scalars['String'];
  platform?: InputMaybe<PlatformType>;
  pushToken?: InputMaybe<Scalars['String']>;
};

/** 진료 정보 */
export type Diagnosis = {
  bookingInfo: DiagnosisBookingGraph;
  canWriteReview: Scalars['Boolean'];
  /** 대면/비대면 여부 */
  contactType: DiagnosisContactType;
  /** 생성일자 */
  createdAt: Scalars['DrTimestamp'];
  /** 외부 노출 진료 ID */
  diagnosisExternalId: Scalars['String'];
  diagnosisForm: DiagnosisFormGraphV2;
  /** 진료 ID */
  diagnosisId: Scalars['ID'];
  doctor: Doctor;
  /** 의사 ID */
  doctorId: Scalars['ID'];
  doseDaysInfo?: Maybe<DiagnosisDoseDays>;
  forms: Array<DiagnosisForm>;
  /** @deprecated 프론트에서 대응 후 제거 필요. hasReview 대신 canWriteReview 사용 */
  hasReview: Scalars['Boolean'];
  hospital: Hospital;
  /** 병원 ID */
  hospitalId: Scalars['ID'];
  /** 진료 타입 빠진/일반 */
  inflowType: Scalars['String'];
  order?: Maybe<Order>;
  paymentInfo: DiagnosisPaymentGraph;
  /** 진료비 */
  price: Scalars['Int'];
  scheduleInfo: DiagnosisScheduleGraph;
  /** 진료 상태 */
  status: DiagnosisStatus;
  /** 수정일자 */
  updatedAt: Scalars['DrTimestamp'];
  /** 유저 ID */
  userId: Scalars['ID'];
};

export type DiagnosisAttachmentRequestInput = {
  path: Scalars['String'];
  type: DiagnosisAttachmentType;
};

export enum DiagnosisAttachmentType {
  Symptom = 'SYMPTOM',
  TelemedicineGroupVerification = 'TELEMEDICINE_GROUP_VERIFICATION'
}

export enum DiagnosisBenefitType {
  Benefit = 'BENEFIT',
  BenefitAndNonBenefit = 'BENEFIT_AND_NON_BENEFIT',
  NonBenefit = 'NON_BENEFIT'
}

/** 유저에 의한 진료 예약 변경 요청 */
export type DiagnosisBookingChangeMutationRequestInput = {
  /** 예약 정보 */
  bookingRequest: DiagnosisBookingRequestInput;
  /** 진료 Id */
  diagnosisId: Scalars['ID'];
};

/** 진료 예약 정보 */
export type DiagnosisBookingGraph = {
  bookingEndTimeSlotValue?: Maybe<Scalars['Int']>;
  bookingStartTimeSlotValue?: Maybe<Scalars['Int']>;
  bookingTargetAt?: Maybe<Scalars['DrTimestamp']>;
  bookingTargetDate?: Maybe<Scalars['String']>;
  isAsapRequest: Scalars['Boolean'];
};

export type DiagnosisBookingRequestInput = {
  /** 진료 예약 날짜 (YYYY-MM-DD) */
  bookingTargetDate: Scalars['String'];
  endTimeSlotValue: Scalars['Int'];
  isAsapRequest: Scalars['Boolean'];
  startTimeSlotValue: Scalars['Int'];
};

/** 진료 예약 스케쥴 가져오기 */
export type DiagnosisBookingScheduleGraph = {
  /** 해당 스케줄의 예약 상태 (DISABLED | BOOKABLE | FULLY_BOOKED) */
  bookingStatus: BookingScheduleType;
  /** 이 예약의 끝 슬롯 */
  endTimeSlot: BookingTimeSlotGraph;
  /** 해당 시간대의 남은 예약 수 */
  remainingCount: Scalars['Int'];
  /** 이 예약의 시작 슬롯 */
  startTimeSlot: BookingTimeSlotGraph;
};

/** 진료 취소 사유 */
export type DiagnosisCancelReason = {
  /** 취소 타입 */
  cancelledType: Scalars['String'];
  /** 취소 사유 아이디 */
  id: Scalars['ID'];
  /** 취소 사유 */
  reason: Scalars['String'];
};

/** 진료 취소 사유 V2 */
export type DiagnosisCancelReasonV2 = {
  /** 취소 사유 아이디 */
  id: Scalars['ID'];
  /** 취소 사유 메시지 */
  message: Scalars['String'];
  /** 취소 타입 */
  type: Scalars['String'];
};

/** 진료 전체 카테고리 */
export type DiagnosisCategory = {
  /** 과목 카테고리 리스트 */
  departmentCategories: Array<DiagnosisCategoryGraph>;
  /** 많이 찾는 과목 카테고리 리스트 */
  popularDepartmentCategories: Array<DiagnosisCategoryGraph>;
  /** 많이 찾는 증상 카테고리 리스트 */
  popularTreatmentCategories: Array<DiagnosisCategoryGraph>;
  /** 증상 카테고리 리스트 */
  treatmentCategories: Array<DiagnosisCategoryGraph>;
};

export type DiagnosisCategoryGraph = {
  /** 설명 */
  description?: Maybe<Scalars['String']>;
  /** 아이콘 url */
  iconUrl: Scalars['String'];
  /** id */
  id: Scalars['ID'];
  /** 진료 카테고리 아이템 */
  items: Array<DiagnosisCategoryItemGraph>;
  /** 이름 */
  name: Scalars['String'];
};

export type DiagnosisCategoryGraphV2 = {
  /** 진료 타입(과목/증상) */
  diagnosisType: DiagnosisType;
  /** 진료 타입(과목/증상) ID */
  diagnosisTypeId: Scalars['ID'];
  /** 아이콘 이미지 url */
  iconUrl: Scalars['String'];
  /** 이름 */
  name: Scalars['String'];
};

export type DiagnosisCategoryItemGraph = {
  /** 설명 */
  description?: Maybe<Scalars['String']>;
  /** 아이콘 url */
  iconUrl: Scalars['String'];
  /** id */
  id: Scalars['ID'];
  /** 이름 */
  name: Scalars['String'];
};

export enum DiagnosisContactType {
  F2F = 'F2F',
  NonF2F = 'NON_F2F'
}

/** 진료 날짜별 스케쥴 */
export type DiagnosisDayScheduleGraph = {
  /** 화면에 보여질 스케줄명 */
  displayName: Scalars['String'];
  /** 예약 가능한 스케쥴 리스트 */
  schedules: Array<DiagnosisBookingScheduleGraph>;
  /** 날짜 스케쥴 상태 */
  status: DayScheduleStatus;
  /** 예약 날짜 */
  targetDate: Scalars['String'];
};

/** 복약 정보 */
export type DiagnosisDoseDays = {
  /** 진료 Id */
  diagnosisId: Scalars['ID'];
  /** 하루 복약횟수 */
  doseCountPerDay?: Maybe<Scalars['Int']>;
  /** 복약중인지 여부 */
  isDoseActive: Scalars['Boolean'];
  /** 남은 복약일수 */
  remainingDoseDays?: Maybe<Scalars['Int']>;
  /** 오늘 복약기록 정보 */
  todayDoseStates: Array<DoseState>;
  /** 총 복약일수 */
  totalDoseDays?: Maybe<Scalars['Int']>;
};

/** 진료 요청서 정보 */
export type DiagnosisForm = {
  /** 급여 타입 */
  benefitType?: Maybe<DiagnosisBenefitType>;
  /** 과목 이름 */
  departmentName?: Maybe<Scalars['String']>;
  /** 과목 혹은 증상명 */
  departmentOrTreatmentName: Scalars['String'];
  /** 진료 요청서 ID */
  diagnosisFormId: Scalars['ID'];
  /** 진료 ID */
  diagnosisId: Scalars['ID'];
  /** 환자 이름(마스킹) */
  maskedPatientName: Scalars['String'];
  /** 환자 이름 */
  patientName: Scalars['String'];
  /** 환자 연락처 */
  patientPhone: Scalars['String'];
  /** 증상 */
  symptom?: Maybe<Scalars['String']>;
  /** 증상 이름 */
  treatmentItemName?: Maybe<Scalars['String']>;
};

/** 진료 요청서 V2 */
export type DiagnosisFormGraphV2 = {
  /** 급여 타입 */
  benefitType?: Maybe<DiagnosisBenefitType>;
  /** 과목 및 증상 */
  diagnosisCategory: DiagnosisCategoryGraphV2;
  /** 과목 및 증상 아이콘 */
  diagnosisCategoryIconUrl: Scalars['String'];
  /** 과목 및 증상명 */
  diagnosisCategoryType?: Maybe<Scalars['String']>;
  /** 진료 ID */
  diagnosisId: Scalars['ID'];
  /** 진료 타입(과목/증상) */
  diagnosisType: DiagnosisType;
  /** 진료 타입(과목/증상) ID */
  diagnosisTypeId: Scalars['ID'];
  /** 진료 요청서 ID */
  id: Scalars['ID'];
  /** 초진/재진 여부 */
  isVisit: Scalars['Boolean'];
  /** 브랜드 초진/재진 여부 */
  isVisitBrand?: Maybe<Scalars['Boolean']>;
  patientInfo: DiagnosisFormPatientGraph;
  /** 영상진료 여부 */
  requestForVideoCall: Scalars['Boolean'];
  /** 증상 */
  symptom?: Maybe<Scalars['String']>;
  /** 의료 대상군명 */
  telemedicineGroupDisplayName?: Maybe<Scalars['String']>;
  /** 초진 재진 여부 */
  visitType: Scalars['String'];
  /** 초진 재진 설명 */
  visitTypeDescription: Scalars['String'];
};

/** 진료 요청서 환자 정보 */
export type DiagnosisFormPatientGraph = {
  /** 환자 이름 */
  patientName: Scalars['String'];
  /** 환자 연락처 */
  patientPhone: Scalars['String'];
  /** 환자의 관계 */
  patientRelation: Scalars['String'];
  /** 환자 주민번호 */
  patientSsn?: Maybe<Scalars['String']>;
};

export enum DiagnosisFormType {
  General = 'GENERAL',
  InHospitalDelivery = 'IN_HOSPITAL_DELIVERY'
}

export enum DiagnosisInflowType {
  General = 'GENERAL',
  Quick = 'QUICK',
  WebGeneral = 'WEB_GENERAL',
  WebQuick = 'WEB_QUICK'
}

export type DiagnosisNonBenefitInfoInput = {
  allowPointUse: Scalars['Boolean'];
  treatmentMedicineId: Scalars['ID'];
  treatmentMedicineStrengthId?: InputMaybe<Scalars['ID']>;
  treatmentMedicineUnitId?: InputMaybe<Scalars['ID']>;
};

export type DiagnosisPayByUserMutationRequestInput = {
  diagnosisId: Scalars['ID'];
  installmentMonth: Scalars['Int'];
  userPaymentId: Scalars['ID'];
};

export enum DiagnosisPayStatus {
  Cancel = 'CANCEL',
  Done = 'DONE',
  Fail = 'FAIL',
  None = 'NONE',
  Ready = 'READY'
}

/** 진료 결제 정보 */
export type DiagnosisPaymentGraph = {
  paidAmount: Scalars['Int'];
  payStatus: DiagnosisPayStatus;
  price: Scalars['Int'];
  userPaymentId: Scalars['ID'];
};

export type DiagnosisPaymentRequestInput = {
  installmentMonth?: InputMaybe<Scalars['Int']>;
  userPaymentId: Scalars['ID'];
};

export enum DiagnosisPriceType {
  DiagnosisOnly = 'DIAGNOSIS_ONLY',
  WithDispensation = 'WITH_DISPENSATION'
}

export type DiagnosisRegistrationRequestV2Input = {
  bookingRequest: DiagnosisBookingRequestInput;
  contactType: DiagnosisContactType;
  diagnosisFormType: DiagnosisFormType;
  dispensationInfo?: InputMaybe<DispensationInfoInput>;
  doctorId: Scalars['ID'];
  inHospitalDeliveryInfo?: InputMaybe<InHospitalDeliveryInfoInput>;
  inflowType?: InputMaybe<DiagnosisInflowType>;
  medicalCategory: MedicalCategoryTargetInput;
  nonBenefitInfo?: InputMaybe<DiagnosisNonBenefitInfoInput>;
  patientForm: PatientFormRequestInput;
  paymentInfo: DiagnosisPaymentRequestInput;
  prescriptionDispensingType?: InputMaybe<PrescriptionDispensingType>;
  receiptLocation?: InputMaybe<LocationMutationRequestInput>;
  vaccinationInfo?: InputMaybe<VaccinationInfoMutationRequestInput>;
};

/** 진료 시간 정보 */
export type DiagnosisScheduleGraph = {
  scheduledAt?: Maybe<Scalars['DrTimestamp']>;
  startedAt?: Maybe<Scalars['DrTimestamp']>;
};

export enum DiagnosisStatus {
  BookingRequested = 'BOOKING_REQUESTED',
  Cancel = 'CANCEL',
  Done = 'DONE',
  Progress = 'PROGRESS',
  Ready = 'READY'
}

export type DiagnosisSummaryGraph = {
  buttons: Array<ButtonOnDiagnosisListAtUserApp>;
  description?: Maybe<Scalars['String']>;
  lottie?: Maybe<LottieOnDiagnosisListAtUserApp>;
  status: DiagnosisSummaryStatus;
  statusIconUrl: Scalars['String'];
  statusProgressRingUrl: Scalars['String'];
  title: Scalars['String'];
};

export enum DiagnosisSummaryStatus {
  DeliveryComplete = 'DELIVERY_COMPLETE',
  DeliveryCompletePickup = 'DELIVERY_COMPLETE_PICKUP',
  DeliveryDoing = 'DELIVERY_DOING',
  DiagnosisAutoPaymentWaiting = 'DIAGNOSIS_AUTO_PAYMENT_WAITING',
  DiagnosisBookingRequested = 'DIAGNOSIS_BOOKING_REQUESTED',
  DiagnosisCancel = 'DIAGNOSIS_CANCEL',
  DiagnosisDirectPaymentWaiting = 'DIAGNOSIS_DIRECT_PAYMENT_WAITING',
  DiagnosisDoing = 'DIAGNOSIS_DOING',
  DiagnosisNoPrescription = 'DIAGNOSIS_NO_PRESCRIPTION',
  DiagnosisPrescriptionExpired = 'DIAGNOSIS_PRESCRIPTION_EXPIRED',
  DispensationAcceptPrescriptionPickup = 'DISPENSATION_ACCEPT_PRESCRIPTION_PICKUP',
  DispensationCompleteDeliveryAccept = 'DISPENSATION_COMPLETE_DELIVERY_ACCEPT',
  DispensationDirectPaymentWaitingFail = 'DISPENSATION_DIRECT_PAYMENT_WAITING_FAIL',
  DispensationDoing = 'DISPENSATION_DOING',
  DispensationManualPaymentWaiting = 'DISPENSATION_MANUAL_PAYMENT_WAITING',
  DispensationSelectPharmacy = 'DISPENSATION_SELECT_PHARMACY',
  DispensationSelectPharmacyCancelByUser = 'DISPENSATION_SELECT_PHARMACY_CANCEL_BY_USER',
  DispensationSelectPharmacyMatching = 'DISPENSATION_SELECT_PHARMACY_MATCHING',
  DispensationSelectRetryPharmacy = 'DISPENSATION_SELECT_RETRY_PHARMACY',
  F2FDiagnosisBookingConfirmed = 'F2F_DIAGNOSIS_BOOKING_CONFIRMED',
  NonF2FDiagnosisWaiting = 'NON_F2F_DIAGNOSIS_WAITING',
  PartnershipPickupDispensationConfirmed = 'PARTNERSHIP_PICKUP_DISPENSATION_CONFIRMED',
  PartnershipPickupDispensationOnsitePaymentCompleted = 'PARTNERSHIP_PICKUP_DISPENSATION_ONSITE_PAYMENT_COMPLETED',
  PartnershipPickupDispensationPaymentCompleted = 'PARTNERSHIP_PICKUP_DISPENSATION_PAYMENT_COMPLETED',
  PartnershipPickupDispensationPaymentFailed = 'PARTNERSHIP_PICKUP_DISPENSATION_PAYMENT_FAILED',
  PartnershipPickupDispensationPaymentRequested = 'PARTNERSHIP_PICKUP_DISPENSATION_PAYMENT_REQUESTED',
  PartnershipPickupDispensationPrepared = 'PARTNERSHIP_PICKUP_DISPENSATION_PREPARED',
  PartnershipPickupDispensationRequested = 'PARTNERSHIP_PICKUP_DISPENSATION_REQUESTED',
  PartnershipPickupDispensationReserved = 'PARTNERSHIP_PICKUP_DISPENSATION_RESERVED',
  PharmacyReviewed = 'PHARMACY_REVIEWED'
}

export enum DiagnosisType {
  Department = 'DEPARTMENT',
  Treatment = 'TREATMENT',
  Vaccination = 'VACCINATION'
}

export type DiagnosisTypeCriteriaInput = {
  diagnosisType: DiagnosisType;
  diagnosisTypeId: Scalars['Int'];
};

/** 질병 */
export type Disease = {
  /** Action */
  actions: Array<DiseaseAction>;
  /** 추가 정보 */
  additionalInfoDescription?: Maybe<Scalars['String']>;
  /** 추가 검사 */
  additionalTestDescription?: Maybe<Scalars['String']>;
  /** 연령별 유행병학 -> 나이에 따라 걸릴 확률 */
  ageEpidemiologyDescription?: Maybe<Scalars['String']>;
  /** 작성자 */
  authorDescription?: Maybe<Scalars['String']>;
  /** 참고문헌 */
  bibliographyDescription?: Maybe<Scalars['String']>;
  /** 원인 */
  causeDescription?: Maybe<Scalars['String']>;
  /** 저작 */
  copyrightDescription?: Maybe<Scalars['String']>;
  /** 고유번호 */
  diseaseId: Scalars['ID'];
  /** 성별 유행병학 -> 성별에 따라 걸릴 확률 */
  genderEpidemiologyDescription?: Maybe<Scalars['String']>;
  /** 일반적인 설명 */
  generalDescription?: Maybe<Scalars['String']>;
  /** 초성 */
  initialCharacter: Scalars['String'];
  /** 키워드 */
  keywords: Array<Scalars['String']>;
  /** 미디어 파일 */
  mediaFiles: Array<DiseaseMediaFile>;
  /** 질병명 */
  name: Scalars['String'];
  /** 본문 요약(본문 맨 위) */
  summaryDescription: Scalars['String'];
  /** 증상 */
  symptomDescription?: Maybe<Scalars['String']>;
  /** 관련 증상 */
  symptoms: Array<DiseaseSymptom>;
  /** 치료 */
  treatmentDescription?: Maybe<Scalars['String']>;
};

/** 액션 */
export type DiseaseAction = {
  /** 내용 */
  name: Scalars['String'];
  /** 타입 */
  type: Array<Scalars['String']>;
};

/** 질병 */
export type DiseaseCard = {
  /** 고유번호 */
  diseaseId: Scalars['ID'];
  /** 초성 */
  initialCharacter: Scalars['String'];
  /** 질병명 */
  name: Scalars['String'];
};

/** 질병 목록 */
export type DiseaseCursorPage = {
  elements: Array<Disease>;
  pivot?: Maybe<Scalars['ID']>;
};

/** 질병백과 배너 정보 */
export type DiseaseEncyclopediaBanner = {
  /** 버튼 문구 */
  buttonPhrase: Scalars['String'];
  /** 설명 */
  description: Scalars['String'];
  /** 질병백과 고유번호 */
  diseaseEncyclopediaId: Scalars['ID'];
  /** 외부 URL */
  externalUrl: Scalars['String'];
  /** 고유번호 */
  id: Scalars['ID'];
  /** 이미지 Url */
  imageUrl: Scalars['String'];
  /** 제목 */
  title: Scalars['String'];
};

export enum DiseaseEncyclopediaBottomButtonType {
  DiagnosisReservation = 'DIAGNOSIS_RESERVATION',
  None = 'NONE',
  Qna = 'QNA'
}

/** 질병백과 커서 기반 검색 결과 */
export type DiseaseEncyclopediaByCursor = {
  /** 질병백과 목록 */
  items: Array<DiseaseEncyclopediaItem>;
  /** 피벗 ID */
  pivotId?: Maybe<Scalars['String']>;
  /** 피벗 점수 */
  pivotScore?: Maybe<Scalars['Float']>;
  /** 전체 개수 */
  totalCount: Scalars['Int'];
};

export enum DiseaseEncyclopediaContentType {
  Disease = 'DISEASE',
  Symptom = 'SYMPTOM'
}

/** 질병백과 FAQ */
export type DiseaseEncyclopediaFaq = {
  answer: Scalars['String'];
  question: Scalars['String'];
};

/** 질병백과 상세 정보 */
export type DiseaseEncyclopediaItem = {
  /** 배너 */
  banner?: Maybe<DiseaseEncyclopediaBanner>;
  /** 하단 버튼 타입 */
  bottomButtonType: DiseaseEncyclopediaBottomButtonType;
  /** 내용 */
  content: Scalars['String'];
  /** 컨텐츠 타입 */
  contentType: DiseaseEncyclopediaContentType;
  /** 생성일 */
  createdAt: Scalars['DrTimestamp'];
  /** 과목 태그 */
  departmentTags: Array<Scalars['String']>;
  /** FAQs */
  faqs: Array<DiseaseEncyclopediaFaq>;
  /** 고유번호 */
  id: Scalars['ID'];
  /** 공개 ID */
  publicId: Scalars['String'];
  /** 레퍼런스 url */
  referenceUrls: Array<Scalars['String']>;
  /** 검색 태그 */
  searchTags: Array<Scalars['String']>;
  /** 증상 태그 */
  symptomTags: Array<Scalars['String']>;
  /** 제목 */
  title: Scalars['String'];
  /** 제목 이미지 URL */
  titleImageUrl?: Maybe<Scalars['String']>;
  /** 조회수 */
  viewCount: Scalars['Int'];
};

/** 질병백과 검색 결과 */
export type DiseaseEncyclopediaSearch = {
  /** 질병백과 목록 */
  items: Array<DiseaseEncyclopediaItem>;
  /** 전체 개수 */
  totalCount: Scalars['Int'];
  /** 전체 페이지 개수 */
  totalPageCount: Scalars['Int'];
};

export type DiseaseEncyclopediaSearchByCursorRequestInput = {
  /** 검색 키워드 */
  keyword?: InputMaybe<Scalars['String']>;
  /** 사이즈 */
  limit: Scalars['Int'];
  /** 피벗 검색 아이디 */
  pivotId?: InputMaybe<Scalars['String']>;
  /** 피벗 검색 점수 */
  pivotScore?: InputMaybe<Scalars['Float']>;
  /** 정렬 기준 */
  sortType?: InputMaybe<DiseaseEncyclopediaSortType>;
};

export type DiseaseEncyclopediaSearchRequestInput = {
  /** 검색 키워드 */
  keyword?: InputMaybe<Scalars['String']>;
  /** 몇 개의 데이터를 가져올지 */
  limit: Scalars['Int'];
  /** 페이지 */
  page: Scalars['Int'];
  /** 정렬 기준 */
  sortType?: InputMaybe<DiseaseEncyclopediaSortType>;
};

export type DiseaseEncyclopediaSitemapGraph = {
  /** ID */
  id: Scalars['ID'];
  /** 사이트맵 URL */
  sitemapUrl: Scalars['String'];
};

/** 질병 백과사전 사이트맵 */
export type DiseaseEncyclopediaSitemapPage = {
  /** 사이트맵 */
  elements: Array<DiseaseEncyclopediaSitemapGraph>;
  /** 전체 데이터 수 */
  totalCount: Scalars['Int'];
  /** 전체 페이지 수 */
  totalPage: Scalars['Int'];
};

export enum DiseaseEncyclopediaSortType {
  Name = 'NAME',
  Score = 'SCORE'
}

export type DiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageRequestInput = {
  /** 위경도 */
  geoPoint: GeoPointInput;
  /** 검색 키워드 */
  keyword: Scalars['String'];
  /** pivot */
  pivot?: InputMaybe<Scalars['Float']>;
  /** pivotScore */
  pivotScore?: InputMaybe<Scalars['Float']>;
  /** 크기 */
  size: Scalars['Int'];
  /** 정렬타입 */
  sortType: HospitalSortType;
};

/** 미디어 파일 */
export type DiseaseMediaFile = {
  /** 저작권 */
  copyright?: Maybe<Scalars['String']>;
  /** 파일 유형(ex. IMAGE, VIDEO, AUDIO, DOCUMENT) */
  type: Scalars['String'];
  /** 이미지 url */
  url: Scalars['String'];
};

/** 질병 내 증상 */
export type DiseaseSymptom = {
  name: Scalars['String'];
  positiveProbability?: Maybe<Scalars['Float']>;
};

/** 조제 가능한 대응 약품 */
export type DispensableMedicine = {
  /** 약 */
  medicine: MedicineGraphV2;
  pharmacyMedicine?: Maybe<PharmacyMedicineSummary>;
  prescribedMedicineId?: Maybe<Scalars['ID']>;
};

/** 처방 내역 */
export type DispensationHistory = {
  /** 효능 및 효과 */
  drugEffect?: Maybe<Scalars['String']>;
  /** 복약지도 */
  medicationDirection?: Maybe<Scalars['String']>;
  /** 약풍명 */
  medicineName: Scalars['String'];
  /** 처방일수 */
  totalDoseDays: Scalars['Int'];
};

export type DispensationInfoInput = {
  dispensationUnit: Scalars['Int'];
  pharmacyId: Scalars['ID'];
  treatmentMedicineStrengthId?: InputMaybe<Scalars['ID']>;
};

/** 단일 조제 옵션 */
export type DispensationOption = {
  /** 메인 태그 */
  mainTags: Array<NearbyPharmacyAttribute>;
  /** 총 약값 */
  totalAmount?: Maybe<Scalars['Int']>;
};

/** 대체조제 옵션 */
export type DispensationOptions = {
  /** 같은 성분 다른 약 */
  alternativeAvailable: DispensationOption;
  /** 처방전 약 그대로 */
  asPrescribed: DispensationOption;
};

export type DispensationPharmacyFaxRequestInput = {
  /** 약국 ID */
  detailAddress: Scalars['String'];
  /** 진료 ID */
  diagnosisId: Scalars['ID'];
  /** 팩스번호 */
  faxNumber: Scalars['String'];
  /** 약국 ID */
  jibunAddress: Scalars['String'];
  /** 경도 */
  latitude: Scalars['Float'];
  /** 위도 */
  longitude: Scalars['Float'];
  /** 약국 ID */
  pharmacyId: Scalars['ID'];
  /** 약국 ID */
  postCode?: InputMaybe<Scalars['String']>;
  /** 주문 요청 당시 유저의 현 위치 */
  receiptLocation?: InputMaybe<LocationMutationRequestInput>;
  /** 약국 ID */
  roadAddress?: InputMaybe<Scalars['String']>;
};

/** 처방 단위 */
export type DispensationUnit = {
  /** 처방 규격 */
  dispensationUnit: Scalars['Int'];
  /** 처방 규격 화면에 보여지는 이름 */
  dispensationUnitDisplayName: Scalars['String'];
  /** 처방 규격 단위 */
  dispensationUnitType: MedicineStandardType;
  /** 디폴트 여부 */
  isDefault: Scalars['Boolean'];
  /** treatmentMedicineId */
  treatmentMedicineId: Scalars['ID'];
  /** treatmentMedicineUnitId */
  treatmentMedicineUnitId: Scalars['ID'];
};

/** 의사 정보 */
export type Doctor = {
  counselor?: Maybe<Counselor>;
  /** 의사 상세 정보 */
  detail?: Maybe<DoctorDetail>;
  /** 의사 ID */
  doctorId: Scalars['ID'];
  /** 전담의사 정보 */
  familyDoctorInfo?: Maybe<FamilyDoctorInfoGraph>;
  hospital: DoctorHospital;
  hospitalV2: DoctorHospitalV2;
  /** 의사 종류(의사, 한의사 등) */
  medicineType: MedicineType;
  /** 의사 이름 */
  name: Scalars['String'];
  /** 의사 개인 핸드폰 번호 */
  phone: Scalars['String'];
  /** 의사 프로필이미지 url */
  profileImage: Scalars['String'];
  treatmentCategories: Array<DoctorTreatmentCategory>;
};

/** 의사 뱃지 */
export type DoctorBadge = {
  /** 뱃지 설명 */
  description: Scalars['String'];
  /** 뱃지 아이콘 url */
  iconUrl: Scalars['String'];
  /** 뱃지 타이틀 */
  title: Scalars['String'];
  /** 뱃지 타입 */
  type: DoctorBadgeType;
};

export enum DoctorBadgeType {
  Over_1000Cases = 'OVER_1000_CASES',
  Over_1000LateNightCases = 'OVER_1000_LATE_NIGHT_CASES',
  Over_1000RevisitRequests = 'OVER_1000_REVISIT_REQUESTS',
  SpecialistInSubject = 'SPECIALIST_IN_SUBJECT'
}

/** 의사 뱃지 목록 정보 */
export type DoctorBadges = {
  /** 뱃지 목록 */
  badges: Array<DoctorBadge>;
  /** 의사 ID */
  doctorId: Scalars['ID'];
};

export type DoctorBookingGraph = {
  bookingAvailability: BookingAvailability;
  doctorId: Scalars['ID'];
  earliestBookableAt?: Maybe<Scalars['DrTimestamp']>;
  isBookable: Scalars['Boolean'];
  todayBookable: Scalars['Boolean'];
  todayCutoffTime: Scalars['String'];
  todayKickoffTime: Scalars['String'];
  todaySchedule: Scalars['String'];
  tomorrowBookable: Scalars['Boolean'];
  tomorrowCutoffTime: Scalars['String'];
  tomorrowKickoffTime: Scalars['String'];
  tomorrowSchedule: Scalars['String'];
};

/** 유저조회를 위한 의사 정보 */
export type DoctorByUser = {
  careers: Array<DoctorCareerGraph>;
  departments: Array<NonF2fDepartment>;
  /** 의사 상세 정보 */
  detail?: Maybe<DoctorDetailByUser>;
  diagnosisBookingSchedules: Array<DiagnosisDayScheduleGraph>;
  doctorBadges: Array<DoctorBadges>;
  doctorDiagnosisTypeReviewRatingStatistics: Array<DoctorDiagnosisTypeReviewStatistic>;
  /** 의사 ID */
  doctorId: Scalars['ID'];
  doctorNotice?: Maybe<DoctorNotice>;
  /** 의사 공개 ID */
  doctorPublicId: Scalars['ID'];
  doctorTreatments: Array<DoctorTreatmentGraphV2>;
  hospital: DoctorHospitalV2;
  /** 의사 종류 */
  medicineType: MedicineType;
  /** 의사 이름 */
  name: Scalars['String'];
  nonBenefitTreatmentsV2: Array<NonBenefitTreatmentGraph>;
  /** 의사 프로필이미지 url */
  profileImage: Scalars['String'];
  /** 화상진료 가능 여부 */
  readyForVideoCall: Scalars['Boolean'];
  reviewAverageRating: Scalars['Float'];
  reviewCount: Scalars['Int'];
  reviewTagGroups: Array<ReviewTagGroup>;
};


/** 유저조회를 위한 의사 정보 */
export type DoctorByUserDiagnosisBookingSchedulesArgs = {
  contactType: DiagnosisContactType;
  telemedicineTargetType: TelemedicineTargetType;
};


/** 유저조회를 위한 의사 정보 */
export type DoctorByUserNonBenefitTreatmentsV2Args = {
  contactType: DiagnosisContactType;
};

/** 유저조회를 위한 의사 정보 */
export type DoctorByUserV2 = {
  /** 예약 정보 */
  bookingInfo: DoctorBookingGraph;
  /** 예약 스케쥴 정보 */
  bookingSchedules: Array<DiagnosisDayScheduleGraph>;
  careers: Array<DoctorCareerGraph>;
  /** @deprecated use v2 */
  departments: Array<NonF2fDepartment>;
  departmentsV2: Array<NonF2fDepartment>;
  /** 의사 상세 정보 */
  detail?: Maybe<DoctorDetailByUserV2>;
  doctorBadges: Array<DoctorBadges>;
  doctorDiagnosisTypeReviewRatingStatistics: Array<DoctorDiagnosisTypeReviewStatistic>;
  doctorDuties: DoctorDuty;
  /** 의사 ID */
  doctorId: Scalars['ID'];
  doctorNotice?: Maybe<DoctorNotice>;
  doctorTreatments: Array<DoctorTreatmentGraphV2>;
  /** 의사 예방접종 정보 (유저용) */
  doctorVaccinations: Array<DoctorVaccinationGraph>;
  /** 전담의사 정보 */
  familyDoctorInfo?: Maybe<FamilyDoctorInfoGraph>;
  hospital: DoctorHospitalV2;
  hospitalId: Scalars['ID'];
  /** 의사 종류 */
  medicineType: MedicineType;
  /** 의사 이름 */
  name: Scalars['String'];
  nonBenefitTreatmentsV2: Array<NonBenefitTreatmentGraph>;
  /** public ID */
  publicId: Scalars['ID'];
  /** 화상진료 가능 여부 */
  readyForVideoCall: Scalars['Boolean'];
  reviewAverageRating: Scalars['Float'];
  reviewCount: Scalars['Int'];
  reviewTagGroups: Array<ReviewTagGroup>;
  reviewTotalCount: Scalars['Int'];
  /** @deprecated use v2 */
  treatmentCategories: Array<DoctorTreatmentCategory>;
  treatmentCategoriesV2: Array<DoctorTreatmentCategoryV2>;
};


/** 유저조회를 위한 의사 정보 */
export type DoctorByUserV2BookingInfoArgs = {
  contactType?: InputMaybe<DiagnosisContactType>;
  telemedicineEligibleTargetType: TelemedicineTargetType;
};


/** 유저조회를 위한 의사 정보 */
export type DoctorByUserV2BookingSchedulesArgs = {
  contactType?: InputMaybe<DiagnosisContactType>;
  telemedicineEligibleTargetType: TelemedicineTargetType;
};


/** 유저조회를 위한 의사 정보 */
export type DoctorByUserV2DepartmentsV2Args = {
  contactType: DiagnosisContactType;
};


/** 유저조회를 위한 의사 정보 */
export type DoctorByUserV2NonBenefitTreatmentsV2Args = {
  contactType: DiagnosisContactType;
};


/** 유저조회를 위한 의사 정보 */
export type DoctorByUserV2TreatmentCategoriesV2Args = {
  contactType: DiagnosisContactType;
};

/** 의사 경력사항 */
export type DoctorCareerGraph = {
  /** 경력 종류(전, 현, 졸업, 수료 등) */
  careerType: DoctorCareerType;
  /** 경력 내용 */
  content: Scalars['String'];
  /** 의사 ID */
  doctorId: Scalars['ID'];
  /** 의사경력 ID */
  id: Scalars['ID'];
  /** 대표 경력 여부 */
  isRepresentative: Scalars['Boolean'];
  /** 정렬순서 */
  sequence: Scalars['Int'];
};

export enum DoctorCareerType {
  Completion = 'COMPLETION',
  Current = 'CURRENT',
  Graduation = 'GRADUATION',
  Past = 'PAST'
}

/** 의사 과 정보 */
export type DoctorDepartment = {
  /** 의사 ID */
  doctorId: Scalars['ID'];
  /** 전문과 Id */
  professionalDepartmentId?: Maybe<Scalars['ID']>;
  /** 전문과 이름 */
  professionalDepartmentName?: Maybe<Scalars['String']>;
};

/** 의사 상세 정보 */
export type DoctorDetail = {
  /** 빠른 진료 가능 여부 */
  availableQuickDiagnosis: Scalars['Boolean'];
  /** 의사 부재중 여부 */
  isAbsent: Scalars['Boolean'];
};

export type DoctorDetailAnswer = {
  answerPid: Scalars['String'];
  content: Scalars['String'];
  doctorId: Scalars['ID'];
  doctorName: Scalars['String'];
  doctorProfileImageUrl: Scalars['String'];
  isBlockedByUser: Scalars['Boolean'];
};

/** 유저조회를 위한 의사 상세 정보 */
export type DoctorDetailByUser = {
  availableQuickDiagnosis: Scalars['Boolean'];
  contractType: ContractType;
  detailImages: Array<Scalars['String']>;
  doctorId: Scalars['ID'];
  introduce?: Maybe<Scalars['String']>;
  isAbsent: Scalars['Boolean'];
  isAbsentFaceToFace: Scalars['Boolean'];
  isBookable: Scalars['Boolean'];
  maxWaitingCount: Scalars['Int'];
  personalHexColor?: Maybe<Scalars['String']>;
  presentedAt?: Maybe<Scalars['DrTimestamp']>;
  professionalDepartmentId?: Maybe<Scalars['ID']>;
  profilePath?: Maybe<Scalars['String']>;
  simpleIntroduce?: Maybe<Scalars['String']>;
  simpleIntroduceFaceToFace?: Maybe<Scalars['String']>;
};

/** 유저조회를 위한 의사 상세 정보 */
export type DoctorDetailByUserV2 = {
  availableQuickDiagnosis: Scalars['Boolean'];
  contractType: ContractType;
  detailImages: Array<Scalars['String']>;
  doctorId: Scalars['ID'];
  introduce?: Maybe<Scalars['String']>;
  isAbsent: Scalars['Boolean'];
  isAbsentFaceToFace: Scalars['Boolean'];
  isBookable: Scalars['Boolean'];
  isBookableF2F: Scalars['Boolean'];
  maxWaitingCount: Scalars['Int'];
  personalHexColor?: Maybe<Scalars['String']>;
  presentedAt?: Maybe<Scalars['DrTimestamp']>;
  professionalDepartmentId?: Maybe<Scalars['ID']>;
  profileImageUrl?: Maybe<Scalars['String']>;
  simpleIntroduce?: Maybe<Scalars['String']>;
  simpleIntroduceFaceToFace?: Maybe<Scalars['String']>;
};

export type DoctorDetailQuestion = {
  answer: DoctorDetailAnswer;
  categoryName: Scalars['String'];
  content: Scalars['String'];
  createdAt: Scalars['DrTimestamp'];
  isBlockedByUser: Scalars['Boolean'];
  questionPid: Scalars['String'];
  title: Scalars['String'];
  userId: Scalars['ID'];
  userName: Scalars['String'];
};

export type DoctorDetailQuestionCursorPage = {
  elements: Array<DoctorDetailQuestion>;
  pivot?: Maybe<Scalars['ID']>;
};

/** 유저앱 의사상세페이지 무료상담 질문 목록 요청 */
export type DoctorDetailQuestionCursorPageRequestInput = {
  /** 의사 ID */
  doctorId: Scalars['ID'];
  /** 페이지 피벗 질문 ID */
  pivot?: InputMaybe<Scalars['ID']>;
  /** 페이지 사이즈(기본값: 20) */
  size?: InputMaybe<Scalars['Int']>;
};

export type DoctorDiagnosisBookingSchedulesQueryRequestInput = {
  contactType: DiagnosisContactType;
  doctorId: Scalars['ID'];
  telemedicineTargetType: TelemedicineTargetType;
};

/** 의사 대기 진료수 */
export type DoctorDiagnosisCount = {
  /** 대기 진료수 */
  count?: Maybe<Scalars['Int']>;
  /** 의사 ID */
  doctorId: Scalars['ID'];
};

/** 과목/증상별 리뷰 통계 */
export type DoctorDiagnosisTypeReviewStatistic = {
  /** 리뷰 평균 평점 */
  averageRating: Scalars['Float'];
  /** 리뷰 개수 */
  count: Scalars['Int'];
  /** 과목/증상 구분 */
  diagnosisType: DiagnosisType;
  /** 과목/증상 ID */
  diagnosisTypeId: Scalars['ID'];
  /** 과목/증상명 */
  name: Scalars['String'];
};

/** 비대면진료 의사 근무시간 */
export type DoctorDuty = {
  /** 대면진료 근무시간 */
  f2f: Array<DoctorDutyRecord>;
  /** 비대면진료 근무시간 */
  nonF2f: Array<DoctorDutyRecord>;
};

export type DoctorDutyRecord = {
  /** 휴식 종료 시간 */
  breakEndTime?: Maybe<Scalars['String']>;
  /** 휴식 시작 시간 */
  breakStartTime?: Maybe<Scalars['String']>;
  /** 대면/비대면 여부 */
  contactType: DiagnosisContactType;
  /** 요일 */
  dayOfWeek: DayOfWeekType;
  /** 의사 ID */
  doctorId: Scalars['ID'];
  /** 진료 종료 시간 */
  endTime: Scalars['String'];
  /** 휴게시간을 가지는지 여부 */
  hasBreakTime: Scalars['Boolean'];
  /** 근무시간 ID */
  id: Scalars['ID'];
  /** 휴무일 여부 */
  isClosed: Scalars['Boolean'];
  /** 진료 시작 시간 */
  startTime: Scalars['String'];
};

export enum DoctorGender {
  Female = 'FEMALE',
  Male = 'MALE',
  None = 'NONE'
}

/** 병원 정보 */
export type DoctorHospital = {
  /** 브랜드 */
  brand?: Maybe<BrandGraph>;
  /** 병원 ID (hospital.id) */
  doctorHospitalId: Scalars['ID'];
  /** 의사 ID */
  doctorId: Scalars['ID'];
  /** 병원 이름 */
  name: Scalars['String'];
};

/** 병원 주소 정보 */
export type DoctorHospitalAddress = {
  detailAddress?: Maybe<Scalars['String']>;
  jibunAddress?: Maybe<Scalars['String']>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  regionByDepth: RegionByDepthGraph;
  roadAddress: Scalars['String'];
};

/** 병원 정보 */
export type DoctorHospitalV2 = {
  /** 브랜드 정보 */
  brand?: Maybe<BrandGraph>;
  /** 병원 ID */
  doctorHospitalId: Scalars['ID'];
  /** 의사 ID */
  doctorId: Scalars['ID'];
  /** 병원 위치 */
  geoPoint: GeoPoint;
  /** 병원 주소 */
  hospitalAddress: DoctorHospitalAddress;
  /** 병원 이름 */
  hospitalName: Scalars['String'];
  /** 병원 전화번호 */
  hospitalTelNumber?: Maybe<Scalars['String']>;
};

/** 의사가 등록한 공지사항 */
export type DoctorNotice = {
  /** 공지 내용 */
  content: Scalars['String'];
  /** 공지 작성일자 */
  createdAt: Scalars['DrTimestamp'];
  /** 의사 ID */
  doctorId: Scalars['ID'];
  /** ID */
  id: Scalars['ID'];
  /** 공지 제목 */
  title: Scalars['String'];
  /** 공지 수정일자 */
  updatedAt: Scalars['DrTimestamp'];
};

export enum DoctorPartnershipStatus {
  Affiliated = 'AFFILIATED',
  Applied = 'APPLIED',
  Applying = 'APPLYING',
  Approved = 'APPROVED',
  Blocked = 'BLOCKED',
  NotAffiliated = 'NOT_AFFILIATED',
  Rejected = 'REJECTED',
  Revoked = 'REVOKED'
}

/** 의사 리뷰 */
export type DoctorReview = {
  /** 리뷰 코멘트 */
  comments: Array<ReviewCommentV2>;
  /** 리뷰 내용 */
  content: Scalars['String'];
  /** 생성일시 */
  createdAt: Scalars['DrTimestamp'];
  /** 삭제일시 */
  deletedAt?: Maybe<Scalars['DrTimestamp']>;
  /** 진료 정보 */
  diagnosis: ReviewDiagnosis;
  /** 과목 혹은 증상명 */
  diagnosisCategoryName: Scalars['String'];
  /** 진료 ID */
  diagnosisId: Scalars['ID'];
  /** 진료비 */
  diagnosisPrice: Scalars['Int'];
  doctor: Doctor;
  /** 의사 ID */
  doctorId: Scalars['ID'];
  /** 의사 Public ID */
  doctorPublicId: Scalars['ID'];
  /** 차단 여부 */
  isBlocked: Scalars['Boolean'];
  /** 유저가 리뷰 좋아요를 눌렀는지 여부 */
  isLiked: Scalars['Boolean'];
  /** 숨김 여부 */
  isPrivate: Scalars['Boolean'];
  /** 좋아요 개수 */
  likeCount: Scalars['Int'];
  /** 환자 이름(마스킹) */
  maskedPatientName: Scalars['String'];
  /** 별점 */
  rating: Scalars['Int'];
  /** 리뷰 ID */
  reviewId: Scalars['ID'];
  /** 리뷰 태그 */
  tags: Array<ReviewTagMap>;
  /** 리뷰 타이틀 */
  title: Scalars['String'];
  /** 업데이트일시 */
  updatedAt: Scalars['DrTimestamp'];
  /** 작성자 유저 ID */
  userId: Scalars['ID'];
};

/** 의사 리뷰 지표 */
export type DoctorReviewMetric = {
  /** 별점 평균 */
  averageRating: Scalars['Float'];
  /** 진료 항목별 리뷰 개수 */
  groupByDiagnosisType: Array<ReviewCount>;
  /** 별점별 리뷰 개수 */
  groupByRating: Array<NumberOfReviewsByRating>;
  /** 리뷰 개수 */
  totalCount: Scalars['Int'];
};

/** 의사 리뷰 검색 요청(pid) */
export type DoctorReviewRequestInput = {
  /** 과목/증상 검색 조건 */
  diagnosisTypeCriteria?: InputMaybe<DiagnosisTypeCriteriaInput>;
  /** 의사 PublicId */
  doctorPublicId: Scalars['ID'];
};

/** 의사 리뷰 검색 요청 */
export type DoctorReviewSearchRequestV2Input = {
  /** 과목/증상 검색 조건 */
  diagnosisTypeCriteria?: InputMaybe<DiagnosisTypeCriteriaInput>;
  /** 의사 IDs */
  doctorIds: Array<Scalars['ID']>;
};

/** 정렬 방법 */
export enum DoctorReviewSort {
  HighRating = 'HIGH_RATING',
  LowRating = 'LOW_RATING',
  Newest = 'NEWEST'
}

export type DoctorSearchByUserRequestInput = {
  /** 대면, 비대면 여부 */
  contactType: DiagnosisContactType;
  /** 검색 바운더리 */
  geoBound?: InputMaybe<DoctorSearchGeoBoundInput>;
  /** 위치 정보 */
  geoPoint?: InputMaybe<GeoPointInput>;
  /** 검색 키워드 */
  keyword?: InputMaybe<Scalars['String']>;
  /** limit */
  limit: Scalars['Int'];
  /** 과목/증상 정보 */
  medicalCategory?: InputMaybe<NonF2fMedicalCategoryRequestInput>;
  /** 의약품 용량 Id */
  medicineStrengthId?: InputMaybe<Scalars['ID']>;
  /** 의약품 단위 Id */
  medicineUnitId?: InputMaybe<Scalars['ID']>;
  /** 신규가입(10일)대상 여부 */
  newOnly?: InputMaybe<Scalars['Boolean']>;
  /** page */
  page: Scalars['Int'];
  /** 대면, 비대면 여부 */
  priceType?: InputMaybe<DiagnosisPriceType>;
  /** 정렬 타입 */
  sortType: DoctorSortType;
  /** 전문의 여부 */
  specialistOnly?: InputMaybe<Scalars['Boolean']>;
  /** 원격의료 타겟 타입 */
  telemedicineEligibleTargetType?: InputMaybe<TelemedicineEligibleTargetType>;
  /** 오늘 예약가능 여부 */
  todayBookableOnly?: InputMaybe<Scalars['Boolean']>;
  /** 예방접종 검색 필터 */
  vaccinationSearchFilterRequest?: InputMaybe<VaccinationSearchFilterRequestInput>;
};

export type DoctorSearchGeoBoundInput = {
  /** 남서쪽 위도 */
  screenBottomLeftCornerLatitude: Scalars['Float'];
  /** 남서쪽 경도 */
  screenBottomLeftCornerLongitude: Scalars['Float'];
  /** 북동쪽 위도 */
  screenTopRightCornerLatitude: Scalars['Float'];
  /** 북동쪽 경도 */
  screenTopRightCornerLongitude: Scalars['Float'];
};

export type DoctorSeoSearchRequestInput = {
  /** limit */
  limit: Scalars['Int'];
  /** page */
  page: Scalars['Int'];
  /** 과목/증상 정보 */
  regionCode: Scalars['String'];
  /** treatmentMedicineUnitId */
  treatmentMedicineUnitId: Scalars['ID'];
};

export enum DoctorSortType {
  Alphabetically = 'ALPHABETICALLY',
  Default = 'DEFAULT',
  Distance = 'DISTANCE',
  Medicine = 'MEDICINE',
  NearestBooking = 'NEAREST_BOOKING',
  Price = 'PRICE',
  Random = 'RANDOM',
  Recent = 'RECENT',
  ReviewAverageRating = 'REVIEW_AVERAGE_RATING',
  ReviewCount = 'REVIEW_COUNT'
}

/** 의사가 선택한 증상 카테고리 */
export type DoctorTreatmentCategory = {
  /** 의사 ID */
  doctorId: Scalars['ID'];
  /** 증상 카테고리 아이콘 URL */
  iconUrl: Scalars['String'];
  /** 증상 카테고리 ID */
  id: Scalars['ID'];
  /** 증상 카테고리명 */
  name: Scalars['String'];
  /** 의사가 선택한 증상 목록 */
  treatments: Array<Treatment>;
};

/** 의사가 선택한 증상 카테고리 V2 */
export type DoctorTreatmentCategoryV2 = {
  /** 의사 ID */
  doctorId: Scalars['ID'];
  doctorTreatments: Array<DoctorTreatmentGraphV2>;
  /** 증상 카테고리 아이콘 URL */
  iconUrl: Scalars['String'];
  /** 증상 카테고리 ID */
  id: Scalars['ID'];
  /** 증상 카테고리명 */
  name: Scalars['String'];
};


/** 의사가 선택한 증상 카테고리 V2 */
export type DoctorTreatmentCategoryV2DoctorTreatmentsArgs = {
  contactType: DiagnosisContactType;
};

export type DoctorTreatmentGraphV2 = {
  doctorId: Scalars['ID'];
  /** 의사가 선택한 처방약 목록 v2 */
  doctorMedicinesV2: Array<DoctorTreatmentMedicine>;
  /** 증상 */
  treatment: Treatment;
  treatmentCategoryId: Scalars['ID'];
  treatmentId: Scalars['ID'];
};


export type DoctorTreatmentGraphV2DoctorMedicinesV2Args = {
  contactType: DiagnosisContactType;
};

export type DoctorTreatmentMedicine = {
  doctorId: Scalars['ID'];
  medicineName: Scalars['String'];
  treatmentId: Scalars['ID'];
  treatmentMedicineId: Scalars['ID'];
};

/** 의사의 증상약 진료 오픈일자 */
export type DoctorTreatmentMedicineOpenDateGraph = {
  /** 진료 오픈일자 */
  date?: Maybe<Scalars['String']>;
  /** 의사 ID */
  doctorId: Scalars['ID'];
  /** 증상약 ID */
  treatmentMedicineId: Scalars['ID'];
};

export enum DoctorType {
  Counselor = 'COUNSELOR',
  Doctor = 'DOCTOR'
}

/** 의사 예방접종 정보 */
export type DoctorVaccinationGraph = {
  /** 무료 정책 정보 */
  freePolicies: Array<VaccinationFreePolicyInfoGraph>;
  /** 지원 무료 정책 ID 목록 */
  supportedFreePolicyIds: Array<Scalars['ID']>;
  /** 진료 항목 ID */
  treatmentId: Scalars['ID'];
  /** 진료 항목명 */
  treatmentName: Scalars['String'];
  /** 진료 항목 정렬 순서 */
  treatmentSortKey: Scalars['Int'];
  /** 예방접종 종류 목록 */
  vaccinationTypes: Array<DoctorVaccinationTypeGraph>;
};

/** 예방접종 종류 */
export type DoctorVaccinationTypeGraph = {
  /** 예방접종 종류명 */
  name: Scalars['String'];
  /** 백신 제품 목록 */
  products: Array<DoctorVaccineProductGraph>;
  /** 정렬 순서 */
  sortKey: Scalars['Int'];
  /** 예방접종 종류 ID */
  vaccinationTypeId: Scalars['ID'];
};

/** 의사별 백신 최저가 정보 */
export type DoctorVaccineMinPriceGraph = {
  /** 의사 ID */
  doctorId: Scalars['ID'];
  /** 최저 가격 */
  minPrice?: Maybe<Scalars['Int']>;
  /** 가격 출처 */
  priceSource?: Maybe<DoctorVaccinePriceSource>;
};

export enum DoctorVaccinePriceSource {
  Hira = 'HIRA',
  Manual = 'MANUAL'
}

/** 백신 제품 */
export type DoctorVaccineProductGraph = {
  /** 사용 가능 여부 */
  isAvailable: Scalars['Boolean'];
  /** 가격 */
  price: Scalars['Int'];
  /** 백신 제품 정보 */
  product: VaccineProductGraph;
  /** 접종 단위 */
  unit: Scalars['Int'];
  /** 예방접종 종류 단위 ID */
  vaccinationTypeUnitId: Scalars['ID'];
  /** 백신 제품 ID */
  vaccineProductId: Scalars['ID'];
};

/** 계정정보 */
export type DoctornowAuthInfo = {
  /** accountId */
  accountId: Scalars['ID'];
  /** 계정명 */
  username: Scalars['String'];
};

export enum DoctornowRole {
  Admin = 'ADMIN',
  Doctor = 'DOCTOR',
  Hospital = 'HOSPITAL',
  Pharmacy = 'PHARMACY',
  Unknown = 'UNKNOWN',
  User = 'USER'
}

/** 회원가입 파라미터 */
export type DoctornowSignUpUserRequestInput = {
  accountId?: InputMaybe<Scalars['ID']>;
  contentNotificationAllowed?: InputMaybe<Scalars['Boolean']>;
  deviceId: Scalars['String'];
  invitationCode?: InputMaybe<Scalars['String']>;
  marketingReceiptAccepted: Scalars['Boolean'];
  nightlyMarketingReceiptAccepted?: InputMaybe<Scalars['Boolean']>;
  notificationAllowed: Scalars['Boolean'];
  password: Scalars['String'];
  platform: PlatformType;
  pushToken: Scalars['String'];
  userId?: InputMaybe<Scalars['ID']>;
  userName: Scalars['String'];
};

export enum DomainName {
  Commerce = 'COMMERCE',
  Counseling = 'COUNSELING',
  Cs = 'CS',
  Healthcare = 'HEALTHCARE',
  Hospital = 'HOSPITAL',
  NonFaceToFaceDiagnosis = 'NON_FACE_TO_FACE_DIAGNOSIS',
  Payment = 'PAYMENT',
  Pharmacy = 'PHARMACY',
  Qna = 'QNA',
  Settlement = 'SETTLEMENT',
  Subscription = 'SUBSCRIPTION'
}

export type DomainRequestContextGraph = {
  domain: DomainName;
  key: Scalars['String'];
};

export type DomainRequestContextRequestInput = {
  domain: DomainName;
  key: Scalars['String'];
};

/** 복약 기록 미션 정보 */
export type DoseRecordPointMission = {
  /** 전체 미션 완료 여부 */
  isCompleted: Scalars['Boolean'];
  /** 포인트 미션 상세 정보 */
  pointMissionDetails: Array<DoseRecordPointMissionDetailGraph>;
};

export enum DoseRecordPointMissionCode {
  TodayDoseCompleteMission = 'TODAY_DOSE_COMPLETE_MISSION'
}

export type DoseRecordPointMissionDetailGraph = {
  /** 해당 미션으로 포인트를 획득했는지 여부 */
  hasEarned: Scalars['Boolean'];
  /** 포인트 미션 코드 */
  pointMissionCode: DoseRecordPointMissionCode;
};

/** 복약 기록 정보 */
export type DoseState = {
  /** 복약기록 Id */
  doseStateId: Scalars['ID'];
  /** 복약기록 했는지 여부 */
  isMarked: Scalars['Boolean'];
  /** 해당 복약기록 라벨 */
  label: Scalars['String'];
};

/** 웰컴 포인트 획득 결과 */
export type EarnWelcomePoint = {
  /** 얻은 포인트 */
  earnedPointAmount: Scalars['Int'];
  /** 총 포인트 */
  totalPointAmount: Scalars['Int'];
};

/** EMR */
export type ElectronicMedicalRecordGraph = {
  /** EMR ID */
  id: Scalars['ID'];
  /** EMR 명 */
  name: Scalars['String'];
};

/** 비대면진료 관련 자격 태그 */
export type EligibilityTag = {
  message: Scalars['String'];
  type: CombinedEligibilityTagType;
};

/** 대면진료 */
export type FaceToFaceDiagnosis = {
  /** 예약 신청 정보 */
  bookingForm?: Maybe<FaceToFaceDiagnosisBookingForm>;
  /** 예약 ID */
  bookingId?: Maybe<Scalars['ID']>;
  /** 환자호출 히스토리 */
  callUpHistories?: Maybe<Array<PatientNotificationHistory>>;
  /** 진료를 처음 확인한 시각 */
  checkedAt?: Maybe<Scalars['DrTimestamp']>;
  /** 진료 신청 일시 */
  createdAt: Scalars['DrTimestamp'];
  /** 진료과목 */
  department?: Maybe<Scalars['String']>;
  /** 커스텀 진료과목 */
  departmentGroup?: Maybe<DepartmentGroup>;
  /** 커스텀 진료과목 ID */
  departmentGroupId?: Maybe<Scalars['ID']>;
  /**
   * 진료과목 ID
   * @deprecated departmentGroupId 사용
   */
  departmentId?: Maybe<Scalars['ID']>;
  /** 의사 정보 */
  doctor: Doctor;
  /** 진료 과목 */
  doctorDepartment?: Maybe<Department>;
  /** 의사 ID */
  doctorId: Scalars['ID'];
  /** 문진표 */
  historyTaking?: Maybe<HistoryTaking>;
  /** 문진표 ID */
  historyTakingId?: Maybe<Scalars['ID']>;
  /** 대면진료 ID */
  id: Scalars['ID'];
  /** 초진, 재진 여부 */
  isVisit: Scalars['Boolean'];
  /** 환자 정보 */
  patient: Patient;
  /** 환자 ID */
  patientId: Scalars['ID'];
  /** 진료 상태 */
  status: FaceToFaceDiagnosisStatus;
  /** 상태 노출 텍스트 */
  statusDisplayText?: Maybe<Scalars['String']>;
  /** 증상 ID */
  treatmentId?: Maybe<Scalars['ID']>;
  /** 진료 증상 */
  treatments?: Maybe<FaceToFaceTreatment>;
};

/** 대면진료 예약 */
export type FaceToFaceDiagnosisBooking = {
  /** 예약 신청 정보 */
  bookingForm?: Maybe<FaceToFaceDiagnosisBookingForm>;
  /** 예약ID */
  bookingId: Scalars['ID'];
  /** 의사 정보 */
  doctor: Doctor;
  /** 의사ID */
  doctorId: Scalars['ID'];
  /** 종료 타임슬롯 */
  endTimeSlot: TimeSlotGraph;
  /** 시작 타임슬롯 */
  startTimeSlot: TimeSlotGraph;
  /** 예약상태 */
  status: BookingStatus;
  /** 예약날짜 */
  targetDate: Scalars['String'];
  /** 사용자ID */
  userId: Scalars['ID'];
};

/** 대면진료 예약 폼 */
export type FaceToFaceDiagnosisBookingForm = {
  /** 사용자 주소 */
  address: Scalars['String'];
  /** 예약 정보 */
  booking: FaceToFaceDiagnosisBooking;
  /** 예약ID */
  bookingId: Scalars['ID'];
  /** 진료과목 */
  department?: Maybe<Department>;
  /** 커스텀 진료과목 */
  departmentGroup?: Maybe<DepartmentGroup>;
  /** 커스텀 진료과목 ID */
  departmentGroupId?: Maybe<Scalars['ID']>;
  /** 진료과목 ID */
  departmentId?: Maybe<Scalars['ID']>;
  /** 사용자 상세주소 */
  detailAddress?: Maybe<Scalars['String']>;
  /** 상세증상 */
  detailSymptom?: Maybe<Scalars['String']>;
  /** 대면진료 정보 */
  diagnosis?: Maybe<FaceToFaceDiagnosis>;
  /** 의사 정보 */
  doctor: Doctor;
  /** 의사ID */
  doctorId: Scalars['ID'];
  /** 종료 타임슬롯 값 */
  endTimeSlotValue: Scalars['Int'];
  /** 병원 정보 */
  hospital: Hospital;
  /** 병원ID */
  hospitalId: Scalars['ID'];
  /** 사용자명 */
  name: Scalars['String'];
  /** 사용자 전화번호 */
  phone: Scalars['String'];
  /** 사용자 주민등록번호 */
  registrationNumber: Scalars['String'];
  /** 시작 타임슬롯 값 */
  startTimeSlotValue: Scalars['Int'];
  /** 예약날짜 */
  targetDate: Scalars['String'];
  /** 화면에 노출될 예약날짜 */
  targetDateDisplayText: Scalars['String'];
  /** 사용자ID */
  userId: Scalars['ID'];
};

/** 대면진료 예약 조회 */
export type FaceToFaceDiagnosisBookingSearchRequestInput = {
  /** 상태 (PENDING, COMPLETED, CANCELED) */
  bookingStatusList?: InputMaybe<Array<BookingStatus>>;
  /** 의사 ids */
  doctorIds?: InputMaybe<Array<Scalars['ID']>>;
  /** pivotId 부터 정렬 방향으로 탐색 */
  pivotId?: InputMaybe<Scalars['Int']>;
  /** 몇 개의 데이터를 가져올지 */
  size: Scalars['Int'];
  /** 정렬 방향 */
  sort: SortType;
  /** 일(ex: 1~31) */
  targetDay?: InputMaybe<Scalars['Int']>;
  /** 월(ex: 1~12) */
  targetMonth?: InputMaybe<Scalars['Int']>;
  /** 연(ex: 2023) */
  targetYear?: InputMaybe<Scalars['Int']>;
  /** 예약자 ID */
  userId?: InputMaybe<Scalars['ID']>;
};

/** 대면진료 접수 요청 */
export type FaceToFaceDiagnosisReceiptMutationRequestInput = {
  /** 환자 주소 */
  address: Scalars['String'];
  /** 약관 동의 리스트 */
  approvedAgreementIds: Array<Scalars['ID']>;
  /** 진료과목 ex. 산부인과 */
  department: Scalars['String'];
  /** 약관 비동의 리스트 */
  disapprovedAgreementIds: Array<Scalars['ID']>;
  /** 의사 ID */
  doctorId: Scalars['Int'];
  /** 환자명 */
  name: Scalars['String'];
  /** 환자 핸드폰 번호 */
  phone: Scalars['String'];
  /** 환자 주민등록번호 ex.95072811111111 */
  registrationNumber: Scalars['String'];
  /** 증상 */
  treatment?: InputMaybe<Scalars['String']>;
  /** 증상 ID */
  treatmentId: Scalars['Int'];
};

/** 대면진료 목록 요청 */
export type FaceToFaceDiagnosisRequestInput = {
  /** 예약날짜 탐색 종료일 */
  bookingEndDate?: InputMaybe<Scalars['String']>;
  /** 예약날짜 탐색 시작일 */
  bookingStartDate?: InputMaybe<Scalars['String']>;
  /** 의사 ID */
  doctorId?: InputMaybe<Scalars['ID']>;
  /** 탐색 종료 일자 */
  endDate?: InputMaybe<Scalars['String']>;
  /** 환자명 */
  patientName?: InputMaybe<Scalars['String']>;
  /** 환자 핸드폰번호 */
  patientPhone?: InputMaybe<Scalars['String']>;
  /** 탐색 시작 일자 */
  startDate?: InputMaybe<Scalars['String']>;
  /** 진료 상태 */
  status?: InputMaybe<FaceToFaceDiagnosisStatus>;
};

export enum FaceToFaceDiagnosisStatus {
  Booked = 'BOOKED',
  Cancel = 'CANCEL',
  Done = 'DONE',
  InProgress = 'IN_PROGRESS',
  Ready = 'READY'
}

/** 의사 휴게시간 변경 */
export type FaceToFaceDoctorBreakTimeChangeApiRequestInput = {
  /** 종료 시각 */
  breakEndTime: Scalars['String'];
  /** 시작 시각 */
  breakStartTime: Scalars['String'];
  /** 요일(월~일 + 공휴일) */
  dayOfWeek: DayOfWeekType;
  /** 휴게시간 없음 여부 */
  hasNoBreakTimes: Scalars['Boolean'];
};

/** 대면의사 커스텀 진료과목 */
export type FaceToFaceDoctorDepartmentGroup = {
  /** 커스텀 진료과목별 평균 평점 */
  averageRating: Scalars['Float'];
  /** 커스텀 진료과목 아이콘 url */
  departmentGroupIconUrl: Scalars['String'];
  /** 커스텀 진료과목 ID */
  departmentGroupId: Scalars['ID'];
  /** 커스텀 진료과목 명 */
  departmentGroupName: Scalars['String'];
  /** 대면의사 ID */
  doctorId: Scalars['ID'];
  /** ID */
  id: Scalars['ID'];
};

/** 대면의사 운영정보 */
export type FaceToFaceDoctorDuty = {
  /** 휴식 종료 시각 */
  breakEndTime: Scalars['String'];
  /** 휴식 시작 시각 */
  breakStartTime: Scalars['String'];
  /** 진료 종료 시각 */
  closeTime: Scalars['String'];
  /** 요일(월~일, 공휴일) */
  dayOfWeek: DayOfWeekType;
  /** 휴게시간을 갖지 않는지 여부 */
  hasNoBreakTimes: Scalars['Boolean'];
  /** ID */
  id: Scalars['ID'];
  /** 정기 휴무 여부 */
  isClosed: Scalars['Boolean'];
  /** 진료 시작 시각 */
  openTime: Scalars['String'];
};

/** 의사 운영시간 변경 */
export type FaceToFaceDoctorOperatingTimeChangeRequestInput = {
  /** 종료 시각 */
  closeTime: Scalars['String'];
  /** 요일(월~일 + 공휴일) */
  dayOfWeek: DayOfWeekType;
  /** 시작 시각 */
  openTime: Scalars['String'];
};

/** 대면의사 전문의 심평원 과목 */
export type FaceToFaceDoctorProfessionalDepartment = {
  /** 심평원 진료과목 코드 */
  departmentCode: Scalars['String'];
  /** 심평원 진료과목 ID */
  departmentId: Scalars['ID'];
  /** 심평원 진료과목 명 */
  departmentName: Scalars['String'];
  /** 대면의사 ID */
  doctorId: Scalars['ID'];
  /** ID */
  id: Scalars['ID'];
};

/** 대면의사 오늘 운영정보 */
export type FaceToFaceDoctorTodayDuty = {
  /** 휴식 종료 시각 */
  breakEndTime: Scalars['String'];
  /** 휴식 시작 시각 */
  breakStartTime: Scalars['String'];
  /** 진료 종료 시각 */
  closeTime: Scalars['String'];
  /** 요일(월~일, 공휴일) */
  dayOfWeek: DayOfWeekType;
  /** 대면의사 ID */
  doctorId: Scalars['ID'];
  /** 휴게시간을 갖지 않는지 여부 */
  hasNoBreakTimes: Scalars['Boolean'];
  /** ID */
  id: Scalars['ID'];
  /** 정기 휴무 여부 */
  isClosed: Scalars['Boolean'];
  /** 진료 시작 시각 */
  openTime: Scalars['String'];
  /** 현재 운영 상태 */
  operatingStatus: HospitalOperatingStatus;
};

/** 대면진료 증상 정보 */
export type FaceToFaceTreatment = {
  /** 증상 ID */
  id: Scalars['ID'];
  /** 증상명 */
  name: Scalars['String'];
};

/** 대면증상 키워드 */
export type FaceToFaceTreatmentKeyword = {
  /** 대면증상 키워드 ID */
  id: Scalars['ID'];
  /** 대면증상 키워드명 */
  name: Scalars['String'];
};

/** 전담의사 정보 */
export type FamilyDoctor = {
  /** 예약 정보 */
  bookingInfo: DoctorBookingGraph;
  /** createdAt */
  createdAt: Scalars['DrTimestamp'];
  diagnosisCount?: Maybe<DoctorDiagnosisCount>;
  /** 의사 ID */
  doctorId: Scalars['ID'];
  /** 의사 이름 */
  doctorName: Scalars['String'];
  hospital: DoctorHospital;
  /** 병원 이름 */
  hospitalName: Scalars['String'];
  /** 부재여부 */
  isAbsent: Scalars['Boolean'];
  /** 10일 이내 가입 여부 */
  isNew: Scalars['Boolean'];
  /** 최대 진료 대기수 */
  maxWaitingCount: Scalars['Int'];
  /** 의사 타입 */
  medicineType: Scalars['String'];
  professionalDepartment: DoctorDepartment;
  /** 프로필 이미지 url */
  profileUrl?: Maybe<Scalars['String']>;
  /** 의사 퍼블릭 ID */
  publicId: Scalars['ID'];
  /** 영상 진료 가능 여부 */
  readyForVideoCall: Scalars['Boolean'];
  /** 의사 평균 평점 */
  reviewAverageRating: Scalars['Float'];
  /** 의사 리뷰수 */
  reviewCount: Scalars['Int'];
};


/** 전담의사 정보 */
export type FamilyDoctorBookingInfoArgs = {
  contactType?: InputMaybe<DiagnosisContactType>;
  telemedicineEligibleTargetType?: InputMaybe<TelemedicineTargetType>;
};

export type FamilyDoctorInfoGraph = {
  createdAt: Scalars['DrTimestamp'];
  doctorId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type FamilyDoctorSearchRequestInput = {
  /** limit */
  limit: Scalars['Int'];
  /** page */
  page: Scalars['Int'];
};

export enum FamilyGender {
  Female = 'FEMALE',
  Male = 'MALE',
  None = 'NONE'
}

export type FamilyGraph = {
  birth: Scalars['String'];
  gender: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  relation: Scalars['String'];
  residentFirst: Scalars['Int'];
  userId: Scalars['ID'];
};

/** 가족구성원 수정 요청 */
export type FamilyModifyMutationRequestInput = {
  /** 생년월일 (ex. 2001-01-01) */
  birth: Scalars['String'];
  /** 가족구성원 성별 */
  gender: FamilyGender;
  /** 가족구성원 이름 */
  name: Scalars['String'];
  /** 핸드폰 번호 */
  phone?: InputMaybe<Scalars['String']>;
  /** 나와의 관계 */
  relation: FamilyRelation;
  /** 주민번호 뒷 첫자리 수 */
  residentFirst: Scalars['Int'];
  /** 진료대상자 타입 */
  telemedicineEligibleGroupType?: InputMaybe<TelemedicineEligibleGroupType>;
};

/** 가족구성원 추가 요청 */
export type FamilyRegisterMutationRequestInput = {
  /** 생년월일 (ex. 2001-01-01) */
  birth: Scalars['String'];
  /** 가족구성원 성별 */
  gender: FamilyGender;
  /** 약관 동의 여부 */
  isConfirm: Scalars['Boolean'];
  /** 가족구성원 이름 */
  name: Scalars['String'];
  /** 핸드폰 번호 */
  phone?: InputMaybe<Scalars['String']>;
  /** 나와의 관계 */
  relation: FamilyRelation;
  /** 주민번호 뒷 첫자리 수 */
  residentFirst: Scalars['Int'];
  /** 진료대상자 타입 */
  telemedicineEligibleGroupType?: InputMaybe<TelemedicineEligibleGroupType>;
};

export enum FamilyRelation {
  Children = 'CHILDREN',
  Me = 'ME',
  Parents = 'PARENTS',
  Spouse = 'SPOUSE'
}

/** 유저 가족 비대면진료 대상 그룹 등록 요청 */
export type FamilyTelemedicineEligibleGroupRegisterMutationRequestInput = {
  /** 가족 ID */
  familyId: Scalars['ID'];
  /** 비대면진료 대상 그룹 타입 */
  type: TelemedicineEligibleGroupType;
};

export type FavoritePharmaciesRequestInput = {
  userLocation?: InputMaybe<GeoPointRequestInput>;
};

/** 피드백 생성 요청 */
export type FeedbackCreateRequestInput = {
  /** 피드백 내용 */
  content: Scalars['String'];
  /** 피드백 사유 */
  feedbackReasonCode: FeedbackReasonCode;
  /** 피드백 타겟 */
  target: FeedbackTarget;
  /** 유저 이름 */
  userName: Scalars['String'];
};

/** 피드백 사유 */
export type FeedbackReason = {
  /** 사유 타입 */
  feedbackReasonCode: FeedbackReasonCode;
  /** 사유 ID */
  id: Scalars['ID'];
  /** 정렬 키 */
  sortKey: Scalars['Float'];
  /** 사유 제목 */
  title: Scalars['String'];
};

export enum FeedbackReasonCode {
  ConcernedAboutCost = 'CONCERNED_ABOUT_COST',
  DirectInput = 'DIRECT_INPUT',
  DoctorInfoLack = 'DOCTOR_INFO_LACK',
  TreatmentNotNecessaryYet = 'TREATMENT_NOT_NECESSARY_YET',
  UnsureFitForChild = 'UNSURE_FIT_FOR_CHILD'
}

export enum FeedbackTarget {
  ExitPediatricDoctorList = 'EXIT_PEDIATRIC_DOCTOR_LIST'
}

/** 아이디 찾기 요청 */
export type FindUsernameMutationRequestInput = {
  /** phone number */
  phone: Scalars['String'];
  /** Role Type */
  roleType: RoleType;
  /** token */
  token: Scalars['String'];
};

/** 아이디 찾기 */
export type FindUsernameResponse = {
  /** provider */
  provider: ProviderType;
  /** username */
  username: Scalars['String'];
};

export type Food = {
  foodName: Scalars['String'];
  imageUrl: Scalars['String'];
  imageUrlWithBackground: Scalars['String'];
};

/** 제형 정보 */
export type FormInfo = {
  /** 제형의 영문 표기 */
  englishFormType: Scalars['String'];
  /** 약품의 외형적 특징(색상, 모양, 제형 등 시각적 정보) */
  feature: Scalars['String'];
  /** 제형(정제, 캡슐, 주사제 등) */
  formType: Scalars['String'];
};

export enum FreeVaccinationSearchFilterType {
  Child = 'CHILD',
  Pregnant = 'PREGNANT',
  Senior = 'SENIOR',
  SeongnamCitizen = 'SEONGNAM_CITIZEN'
}

export type FullyBookingRemindRequestInput = {
  healthAnalysisReportId: Scalars['Int'];
};

export type GamePrizeStrategyGraph = {
  /** 게임 타입 */
  gameType: GameType;
  /** 게임 상품 정책 ID */
  id: Scalars['ID'];
  /** 상품 정보 */
  prize: PrizeGraph;
  /** 상품 수량 */
  quantity: Scalars['Int'];
};

export enum GameType {
  RandomBox = 'RANDOM_BOX',
  Roulette = 'ROULETTE'
}

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  None = 'NONE'
}

export enum GenderType {
  Female = 'FEMALE',
  Male = 'MALE',
  None = 'NONE'
}

/** 주소 정보 */
export type GeneralAddress = {
  /** 상세주소 */
  detailAddress: Scalars['String'];
  /** 동리 (쌍문동 or 항아리) */
  dongLi: Scalars['String'];
  /** 지번주소 */
  jibunAddress: Scalars['String'];
  /** 도로명주소 */
  roadAddress: Scalars['String'];
  /** 시도 (경기도 or 서울 */
  sido: Scalars['String'];
  /** 시군구 (성남시 수정구 or 강남구) */
  sigungu: Scalars['String'];
  /** 우편번호 */
  zipCode: Scalars['String'];
};

export enum GeneralSearchFeatureType {
  DietInjection = 'DIET_INJECTION',
  EmergencyContraceptive = 'EMERGENCY_CONTRACEPTIVE',
  FindPharmacy = 'FIND_PHARMACY'
}

/** 일반 검색 필터 */
export type GeneralSearchFilter = {
  /** 적용할 필터들 */
  filters: Array<HospitalFilterType>;
  /** 검색 키워드 */
  keyword: Scalars['ID'];
  /** 정렬 기준 */
  sortTypes: Array<HospitalSearchSortType>;
};

/** 통합 검색 메타 정보 */
export type GeneralSearchMeta = {
  features?: Maybe<Array<GeneralSearchFeatureType>>;
  snippet?: Maybe<GeneralSearchSnippetType>;
};

export enum GeneralSearchSnippetType {
  DeliveryGuide = 'DELIVERY_GUIDE',
  FaceToFaceDiagnosis = 'FACE_TO_FACE_DIAGNOSIS',
  FaceToFacePrescription = 'FACE_TO_FACE_PRESCRIPTION',
  NonFaceToFaceDiagnosis = 'NON_FACE_TO_FACE_DIAGNOSIS',
  NonFaceToFacePrescription = 'NON_FACE_TO_FACE_PRESCRIPTION'
}

export type GenerateAiAnswerRequestInput = {
  questionPid: Scalars['ID'];
};

/** 위치 정보 */
export type GeoLocation = {
  /** 행정동/읍/면명 */
  administrationEupMyeonDongName: Scalars['String'];
  /** 위도 */
  latitude: Scalars['Float'];
  /** 경도 */
  longitude: Scalars['Float'];
  /** 지역 코드 */
  regionCode: Scalars['String'];
  /** 시/도명 */
  siDoName: Scalars['String'];
  /** 시/군/구명 */
  siGunGuName: Scalars['String'];
};

/** 좌표 정보 */
export type GeoPoint = {
  /** 위도 */
  latitude: Scalars['Float'];
  /** 경도 */
  longitude: Scalars['Float'];
};

/** 좌표 정보 */
export type GeoPointInput = {
  /** 위도 */
  latitude: Scalars['Float'];
  /** 경도 */
  longitude: Scalars['Float'];
};

export type GeoPointMutationRequestInput = {
  /** 위도 */
  latitude: Scalars['Float'];
  /** 경도 */
  longitude: Scalars['Float'];
};

export type GeoPointRequestInput = {
  /** 위도 */
  latitude: Scalars['Float'];
  /** 경도 */
  longitude: Scalars['Float'];
};

/** 건강분석 정보 결과지 */
export type HealthAnalysisReport = {
  /** 건강검진 일자 리스트 */
  healthCheckDates: Array<Scalars['String']>;
  /** 검강검진 아이템별 결과 */
  healthCheckResultItems: Array<HealthCheckResultItem>;
  /** 상담 id */
  id: Scalars['ID'];
  /** 필요한 주타겟기능 */
  necessaryMainFunctions: Array<MainFunctionGraph>;
  /** 추천된 상품 id 리스트 */
  recommendedProductItems: Array<PersonalizedNutritionRecommendationItem>;
  /** 건강분석 점수 */
  score: Scalars['Int'];
  /** 설문 결과 */
  surveyResult: SurveyResult;
  /** 설문 결과 (의사용, '해당 없음' 등의 불필요한 데이터가 제거된 버전) */
  surveyResultForDoctor: SurveyResult;
  /** 유저 id */
  userId: Scalars['ID'];
};

/** 건강 분석 리포트(결과지) 저장 요청 */
export type HealthAnalysisReportSaveRequestInput = {
  /** 건강검진 데이터 사용할 것인지 여부 */
  useHealthCheck?: InputMaybe<Scalars['Boolean']>;
};

/** 건강 분석 리포트(결과지) 저장 요청 */
export type HealthAnalysisReportUpdateRequestInput = {
  /** 건강 분석 리포트 ID */
  healthAnalysisReportId: Scalars['ID'];
  /** 건강검진 데이터 사용할 것인지 여부 */
  useHealthCheck: Scalars['Boolean'];
};

export enum HealthCheckItemType {
  AltSgop = 'ALT_SGOP',
  AltSgpt = 'ALT_SGPT',
  Bmi = 'BMI',
  Creatinine = 'CREATININE',
  EyeLeft = 'EYE_LEFT',
  EyeRight = 'EYE_RIGHT',
  Fbs = 'FBS',
  Gfr = 'GFR',
  Gpt = 'GPT',
  HdlCholesterol = 'HDL_CHOLESTEROL',
  Hearing = 'HEARING',
  Height = 'HEIGHT',
  Hemoglobin = 'HEMOGLOBIN',
  LdlCholesterol = 'LDL_CHOLESTEROL',
  MaximumBloodPressure = 'MAXIMUM_BLOOD_PRESSURE',
  MinimumBloodPressure = 'MINIMUM_BLOOD_PRESSURE',
  Proteinuria = 'PROTEINURIA',
  TotalCholesterol = 'TOTAL_CHOLESTEROL',
  Triglyceride = 'TRIGLYCERIDE',
  Waist = 'WAIST',
  Weight = 'WEIGHT'
}

/** 건강검진 항목별 결과 */
export type HealthCheckResultItem = {
  /** 건강검진 연령대별 평균값 */
  averageValueInGroup?: Maybe<Scalars['String']>;
  /** 해당 항목 건강검진 날짜 */
  healthCheckDate: Scalars['String'];
  /** 백분위 */
  percentInGroup?: Maybe<Scalars['Int']>;
  /** 항목별 검강검진 결과 */
  status: HealthCheckResultStatus;
  /** 건강검진 아이템 타입 */
  type: HealthCheckItemType;
  /** 값의 단위 */
  unit: Scalars['String'];
  /** 검진 결과 값 */
  value: Scalars['String'];
};

export enum HealthCheckResultStatus {
  Caution = 'CAUTION',
  Danger = 'DANGER',
  Normal = 'NORMAL',
  Uncertain = 'UNCERTAIN'
}

export type HealthDashboardCount = {
  danger: Scalars['Int'];
  normal: Scalars['Int'];
  warning: Scalars['Int'];
};

/** 건강 조회 대시보드 조회 (탭홈용) */
export type HealthDashboardForTabHome = {
  /** 건강 검진 년도 리스트 */
  healthCheckedDates: Array<Scalars['DrTimestamp']>;
  /** 위험, 주의, 정상 대시보드 */
  healthDashboardCount: HealthDashboardCount;
  /** 건강 정보 기록 */
  healthInfo: HealthInfoGraph;
};

export type HealthInfoGraph = {
  /** 빈혈 */
  anemia?: Maybe<AnemiaGraph>;
  /** 혈압 */
  bloodPressure?: Maybe<BloodPressureGraph>;
  /** 혈당 */
  bloodSugar?: Maybe<BloodSugarGraph>;
  /** 비만도 */
  bodyMeasurement?: Maybe<BodyMeasurementGraph>;
  /** 간 기능 */
  liverFunction?: Maybe<LiverFunctionGraph>;
};

export enum HealthInsuranceScrapingStatus {
  Done = 'DONE',
  Fail = 'FAIL',
  ScrapingProgress = 'SCRAPING_PROGRESS',
  SimpleAuthRequested = 'SIMPLE_AUTH_REQUESTED'
}

/** 건강보험 스크래핑 간편인증 요청 */
export type HealthInsuranceSimpleAuthMutationRequestInput = {
  /** 간편인증 수단 */
  healthInsuranceSimpleAuthType: HealthInsuranceSimpleAuthType;
};

export enum HealthInsuranceSimpleAuthType {
  Kakaotalk = 'KAKAOTALK',
  KbMobile = 'KB_MOBILE',
  Naver = 'NAVER',
  Passauth = 'PASSAUTH',
  Payco = 'PAYCO',
  Samsungpass = 'SAMSUNGPASS',
  Shinhan = 'SHINHAN',
  Toss = 'TOSS'
}

export enum HealthRecordSource {
  HealthCheck = 'HEALTH_CHECK',
  Record = 'RECORD'
}

export enum HealthRecordType {
  Anemia = 'ANEMIA',
  BloodPressure = 'BLOOD_PRESSURE',
  BloodSugar = 'BLOOD_SUGAR',
  BodyInfo = 'BODY_INFO',
  LiverFunction = 'LIVER_FUNCTION'
}

/** 문진표 */
export type HistoryTaking = {
  /** 답변 */
  answer?: Maybe<Scalars['String']>;
  /** 확인일시 */
  checkedAt?: Maybe<Scalars['DrTimestamp']>;
  /** 생성일시 */
  createdAt: Scalars['DrTimestamp'];
  /** 문진표 양식 정보 */
  historyTakingForm: HistoryTakingForm;
  /** 문진표 양식 ID */
  historyTakingFormId: Scalars['ID'];
  /** 문진표 ID */
  id: Scalars['ID'];
  /** 환자 정보 */
  patient: Patient;
  /** 환자 ID */
  patientId: Scalars['ID'];
  /** 상태 */
  status: HistoryTakingStatus;
  /** 수정일시 */
  updatedAt: Scalars['DrTimestamp'];
};

/** 문진표 양식 */
export type HistoryTakingForm = {
  /** 증상 ID */
  faceToFaceTreatmentId: Scalars['ID'];
  /** 병원 정보 */
  hospital: Hospital;
  /** 병원 ID */
  hospitalId: Scalars['ID'];
  /** 문진표 양식 ID */
  id: Scalars['ID'];
  /** 환자 성별 */
  patientGender: PatientGender;
  /** 질문 */
  question?: Maybe<Scalars['String']>;
};

/** (병원) 문진표 업데이트 */
export type HistoryTakingHospitalMutationRequestInput = {
  /** 문진표 내용 */
  answer: Scalars['String'];
  /** 문진표 ID */
  historyTakingId: Scalars['ID'];
};

/** (환자) 문진표 업데이트 */
export type HistoryTakingPatientMutationRequestInput = {
  /** 문진표 내용 */
  answer: Scalars['String'];
  /** 약관 동의 리스트 */
  approvedAgreementIds: Array<Scalars['ID']>;
  /** 약관 비동의 리스트 */
  disapprovedAgreementIds: Array<Scalars['ID']>;
  /** 문진표 Public ID */
  historyTakingPublicId: Scalars['String'];
  /** 환자 상세주소 */
  patientDetailAddress?: InputMaybe<Scalars['String']>;
  /** 환자 키 */
  patientHeight?: InputMaybe<Scalars['Float']>;
  /** 환자 몸무게 */
  patientWeight?: InputMaybe<Scalars['Float']>;
};

export enum HistoryTakingStatus {
  RequestCanceled = 'REQUEST_CANCELED',
  Submitted = 'SUBMITTED',
  SubmitRequested = 'SUBMIT_REQUESTED'
}

/** 유저 홈 배너 */
export type HomeBanner = {
  actionUrls: Array<HomeBannerActionUrlGraph>;
  backgroundColor: Scalars['String'];
  content: Scalars['String'];
  id: Scalars['ID'];
  imageUrls: Array<HomeBannerImageUrlGraph>;
  textColor: Scalars['String'];
  title: Scalars['String'];
};

export type HomeBannerActionUrlGraph = {
  type: HomeBannerActionUrlType;
  url?: Maybe<Scalars['String']>;
};

export enum HomeBannerActionUrlType {
  App = 'APP',
  Web = 'WEB'
}

export type HomeBannerImageUrlGraph = {
  type: HomeBannerImageUrlType;
  url?: Maybe<Scalars['String']>;
};

export enum HomeBannerImageUrlType {
  Mobile = 'MOBILE',
  Pc = 'PC'
}

export type HomeBannerRequestInput = {
  /** 노출 타입 */
  displayType?: InputMaybe<BannerDisplayType>;
};

/** 유저 홈 배너 V2 */
export type HomeBannerV2 = {
  actionUrls: Array<HomeBannerActionUrlGraph>;
  backgroundColor: Scalars['String'];
  content: Scalars['String'];
  contentColor: Scalars['String'];
  id: Scalars['ID'];
  imageUrls: Array<HomeBannerImageUrlGraph>;
  title: Scalars['String'];
  titleColor: Scalars['String'];
};

/** 홈 환영인사 */
export type HomeGreeting = {
  /** CTA 버튼 */
  ctaButton?: Maybe<HomeGreetingCtaButton>;
  /** 홈 환영인사 ID */
  id: Scalars['ID'];
  /** 메시지 */
  message: HomeGreetingMessage;
};

/** 홈 인삿말의 CTA 버튼 */
export type HomeGreetingCtaButton = {
  /** 버튼 문구 */
  title: Scalars['String'];
  /** 버튼 누르면 이동할 딥링크 */
  url: Scalars['String'];
};

/** 홈 환영인사 메시지 */
export type HomeGreetingMessage = {
  /** 환영인사 메시지 문단 (개행 기준) */
  paragraphs: Array<HomeGreetingMessageParagraph>;
};

/** 홈 환영인사 문단 */
export type HomeGreetingMessageParagraph = {
  /** 인삿말 환영인사 절 */
  phrases: Array<HomeGreetingMessagePhrase>;
};

/** 홈 환영인사 절 */
export type HomeGreetingMessagePhrase = {
  /** 내용 */
  content: Scalars['String'];
  /** 환영인사 메시지 절 타입 (PLAIN | HIGHLIGHTED) */
  type: HomeGreetingMessagePhraseType;
};

export enum HomeGreetingMessagePhraseType {
  Highlighted = 'HIGHLIGHTED',
  Plain = 'PLAIN'
}

/** 비대면 진료 증상/과목 */
export type HomeMedicalCategory = {
  /** 카테고리 (DEPARTMENT | TREATMENT | VACCINATION) */
  category: MedicalCategoryType;
  /** 아이콘 URL */
  iconUrl?: Maybe<Scalars['String']>;
  /** 증상 ID 또는 과목 ID */
  id: Scalars['ID'];
  /** 카테고리명 */
  name?: Maybe<Scalars['String']>;
};

export type HomepageGraph = {
  homepageType: Scalars['String'];
  url: Scalars['String'];
};

/** 병원 정보 */
export type Hospital = {
  /** 계정 ID */
  accountId?: Maybe<Scalars['ID']>;
  /** 담당자 전화번호 */
  administratorTelNumber?: Maybe<Scalars['String']>;
  /** 병원 소개 뱃지들 ex. 산부인과 전문의 2명, 야간 진료, 휴일 진료 */
  badges: Array<Scalars['String']>;
  /** 커스텀 진료과목 */
  departmentGroups: Array<HospitalDepartmentGroup>;
  /** 심평원 진료과목 */
  departmentsV2: Array<HospitalDepartmentV2>;
  /** 상세주소 */
  detailAddress?: Maybe<Scalars['String']>;
  /** 길 안내 */
  directionGuidance?: Maybe<Scalars['String']>;
  /** 병원에 소속된 의사정보 */
  doctors: Array<HospitalDoctor>;
  /** 병원 운영정보 */
  duties: Array<HospitalDuty>;
  hospitalAdBanners: Array<HospitalAdBanner>;
  hospitalSurgeries: Array<HospitalSurgery>;
  /** 병원 ID */
  id: Scalars['ID'];
  /** 병원 소개글 */
  introduction?: Maybe<Scalars['String']>;
  /** 예약기능 활성화 여부 */
  isBookable: Scalars['Boolean'];
  /** 무료 주차 여부 */
  isFreeParking?: Maybe<Scalars['Boolean']>;
  /** 당일예약 기능 활성화 여부 */
  isTodayBookable: Scalars['Boolean'];
  /** 지번주소 */
  jibunAddress?: Maybe<Scalars['String']>;
  /** 위도 */
  latitude?: Maybe<Scalars['Float']>;
  /** 경도 */
  longitude?: Maybe<Scalars['Float']>;
  /** 병원명 */
  name: Scalars['String'];
  /** 네이버 플레이스 정보 */
  naverPlaceDetail: HospitalNaverPlaceDetailGraph;
  /** (심평원)비급여 진료비 가격 */
  nonBenefitDiagnosisPrices: Array<NonBenefitDiagnosisPrice>;
  /** 태그별 리뷰 개수 */
  numberOfReviewByTags: NumberOfReviewsByTag;
  /** 병원 온보딩(원터치) 단계 */
  onBoardingStatus: HospitalOnBoardingStatus;
  /** 병원 운영상태 */
  operatingStatus: HospitalOperatingStatus;
  /** 주차 정보 */
  parkingInformation?: Maybe<Scalars['String']>;
  /** 제휴 상태 */
  partnershipStatus: HospitalPartnershipStatus;
  /** 제휴/비제휴에 따른 템플릿 여부 */
  partnershipTemplate: Scalars['Boolean'];
  /** 병원 프로필 이미지 */
  profileImages: Array<HospitalProfileImage>;
  /** 병원 PublicID */
  publicId: Scalars['String'];
  /** Depth별 주소 */
  regionByDepth: HospitalRegionByDepth;
  /** 대표과목명 */
  representativeDepartmentName?: Maybe<Scalars['String']>;
  /** 리뷰 토탈 카운트 */
  reviewAverageRating: Scalars['Float'];
  /** 리뷰 평균 평점 */
  reviewTotalCount: Scalars['Int'];
  /** 도로명주소 */
  roadAddress?: Maybe<Scalars['String']>;
  /** 지하철역 정보 */
  subwayStation?: Maybe<HospitalSubwayStation>;
  /** 병원 전화번호 */
  tel?: Maybe<Scalars['String']>;
  /** 병원 임시휴일 */
  temporaryHolidays: Array<Scalars['String']>;
  /** 임시 휴무 알림 */
  temporaryHolidaysNotice?: Maybe<Scalars['String']>;
  /** 오늘의 운영정보 */
  todayDuty: HospitalTodayDuty;
  topRatedDoctorReviews: Array<Review>;
  /** 병원에서 다루는 증상정보 */
  treatments: Array<FaceToFaceTreatment>;
  /** 병원 조회수 */
  viewCount: Scalars['Int'];
};


/** 병원 정보 */
export type HospitalTopRatedDoctorReviewsArgs = {
  size: Scalars['Int'];
};

/** 병원 이벤트 배너 */
export type HospitalAdBanner = {
  /** 할인율, 할인금액 등 */
  displayDiscount: Scalars['String'];
  /** 이벤트가격 */
  displayPrice: Scalars['String'];
  /** 병원 ID */
  hospitalId: Scalars['ID'];
  /** 이벤트 배너 ID */
  id: Scalars['ID'];
  /** 썸네일 url */
  thumbnailImageUrl: Scalars['String'];
  /** 이벤트명 */
  title: Scalars['String'];
  /** 랜딩페이지 url */
  url: Scalars['String'];
};

/** 병원 인증정보 업데이트 요청 */
export type HospitalAuthorizationInfoUpdateMutationRequestInput = {
  /** 사업자 등록 번호 */
  corporateRegistrationNumber: Scalars['String'];
  /** 요양 기관 번호 */
  medicalCareNumber: Scalars['String'];
};

/** 병원 기본 정보 업데이트 요청 */
export type HospitalBasicInformationUpdateMutationRequestInput = {
  /** 병원 담당자 전화번호 */
  administratorTelNumber?: InputMaybe<Scalars['String']>;
  /** 길 안내 */
  directionGuidance?: InputMaybe<Scalars['String']>;
  /** 무료주차여부 */
  isFreeParking?: InputMaybe<Scalars['Boolean']>;
  /** 주차정보 */
  parkingInformation?: InputMaybe<Scalars['String']>;
  /** 병원 전화번호 */
  tel: Scalars['String'];
};

/** 병원 휴게시간 변경 */
export type HospitalBreakTimeChangeApiRequestInput = {
  /** 종료 시각 */
  breakEndTime: Scalars['String'];
  /** 시작 시각 */
  breakStartTime: Scalars['String'];
  /** 요일(월~일 + 공휴일) */
  dayOfWeek: DayOfWeekType;
  /** 휴게시간 없음 여부 */
  hasNoBreakTimes: Scalars['Boolean'];
};

/** 병원 진료과목그룹 */
export type HospitalDepartmentGroup = {
  /** 과목별 평균 평점 */
  averageRating: Scalars['Float'];
  /** 진료과목 아이콘 url */
  departmentGroupIconUrl: Scalars['String'];
  /** 진료 과목 */
  departmentGroupId: Scalars['ID'];
  /** 진료 과목명 */
  departmentGroupName: Scalars['String'];
  /** 병원 ID */
  hospitalId: Scalars['ID'];
  /** ID */
  id: Scalars['ID'];
  /** 대표과목 여부 */
  isRepresentative: Scalars['Boolean'];
  /** 태그 */
  tags: Array<Scalars['String']>;
};

/** 대면의사 진료과목, 태그 업데이트 요청 */
export type HospitalDepartmentGroupTagUpdateMutationRequestInput = {
  /** 커스텀 진료과목ID */
  departmentGroupId: Scalars['ID'];
  /** 태그 리스트 */
  tags: Array<Scalars['String']>;
};

/** 병원 심평원 진료과목 */
export type HospitalDepartmentV2 = {
  /** 심평원 진료과목 코드 */
  departmentCode: Scalars['String'];
  /** 진료 과목 */
  departmentId: Scalars['ID'];
  /** 진료 과목명 */
  departmentName: Scalars['String'];
  /** 병원 ID */
  hospitalId: Scalars['ID'];
  /** ID */
  id: Scalars['ID'];
};

/** 병원에 소속된 의사 정보 */
export type HospitalDoctor = {
  /** 의사 경력 */
  careers: Array<DoctorCareerGraph>;
  /** 의사 유형(대면, 비대면, 다) */
  contractType: ContractType;
  /** 의사별 커스텀 진료과목 */
  departmentGroups: Array<FaceToFaceDoctorDepartmentGroup>;
  /** 면허 유형 포함 화면에 보여지는 이름(ex. 노아 의사, 코비 한의사) */
  displayName: Scalars['String'];
  /** 의사 운영정보 */
  duties: Array<FaceToFaceDoctorDuty>;
  /** 성별 */
  gender: DoctorGender;
  /** 병원 ID */
  hospitalId: Scalars['ID'];
  /** 의사 ID */
  id: Scalars['ID'];
  /** 자리비움 ON/OFF */
  isAbsent: Scalars['Boolean'];
  /** 면허 유형(의사, 한의사, 치과의사) */
  medicineType: MedicineType;
  /** 의사명 */
  name: Scalars['String'];
  /** (심평원)비급여 진료비 가격 */
  nonBenefitDiagnosisPrices: Array<NonBenefitDiagnosisPrice>;
  /** 제휴 상태 */
  partnershipStatus: DoctorPartnershipStatus;
  /** 의사별 HEX COLOR */
  personalHexColor?: Maybe<Scalars['String']>;
  /** 전화번호 */
  phone: Scalars['String'];
  /** 출근시각 */
  presentAt?: Maybe<Scalars['DrTimestamp']>;
  /** 의사별 전문의 심평원 진료과목 */
  professionalDepartmentsV2: Array<FaceToFaceDoctorProfessionalDepartment>;
  /** 프로필 이미지 URL */
  profileImagePath?: Maybe<Scalars['String']>;
  /** 의사 PublicID */
  publicId: Scalars['String'];
  /** 리뷰 지표 */
  reviewMetric: DoctorReviewMetric;
  /** 간단한 자기소개 */
  simpleIntroduce?: Maybe<Scalars['String']>;
  /** 의사 임시휴일 */
  temporaryHolidays: Array<Scalars['String']>;
  /** 임시 휴무 알림 */
  temporaryHolidaysNotice?: Maybe<Scalars['String']>;
  /** 오늘의 운영정보 */
  todayDuty: FaceToFaceDoctorTodayDuty;
  /** 대기 환자 수 */
  waitingCount: Scalars['Int'];
};

/** 병원 요일별 운영정보 */
export type HospitalDuty = {
  /** 휴식 종료 시각 */
  breakEndTime?: Maybe<Scalars['String']>;
  /** 휴식 시작 시각 */
  breakStartTime?: Maybe<Scalars['String']>;
  /** 휴식 시간 문자열 */
  breakTimes: Scalars['String'];
  /** 진료 종료 시각 */
  closeTime?: Maybe<Scalars['String']>;
  /** 요일(월~일, 공휴일) */
  dayOfWeek: DayOfWeekType;
  /** 휴게시간을 갖지 않는지 여부 */
  hasNoBreakTimes: Scalars['Boolean'];
  /** ID */
  id: Scalars['ID'];
  /** 정기 휴무 여부 */
  isClosed?: Maybe<Scalars['Boolean']>;
  /** 진료 시작 시각 */
  openTime?: Maybe<Scalars['String']>;
  /** 진료 시간 문자열 ex. 09:00 - 확인 필요, 09:00 - 18:00 */
  operationTimes: Scalars['String'];
};

export type HospitalElasticSearchRegionByDepthRequestInput = {
  /** 법정동 이름 */
  legalEupMyeonDongName?: InputMaybe<Scalars['String']>;
  /** 시/도 이름 */
  siDoName: Scalars['String'];
  /** 시/군/구 이름 */
  siGunGuName?: InputMaybe<Scalars['String']>;
};

/** 병원 조회 요청 V2 */
export type HospitalElasticSearchV2RequestInput = {
  /** 커스텀 진료과목 그룹ID 리스트 */
  departmentGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  /** 심평원 진료과목 그룹ID 리스트 */
  departmentIds?: InputMaybe<Array<Scalars['ID']>>;
  /** 위경도 */
  geoPoint: GeoPointInput;
  /** 검색어 */
  keyword?: InputMaybe<Scalars['String']>;
  /** 페이지 사이즈 */
  limit: Scalars['Int'];
  /** 피벗 검색 아이디 (거리) */
  pivotId?: InputMaybe<Scalars['Float']>;
  /** 피벗 검색 스코어 */
  pivotScore?: InputMaybe<Scalars['Float']>;
  /** 지역 필터 조건 */
  regionByDepth?: InputMaybe<HospitalElasticSearchRegionByDepthRequestInput>;
  /** 거리 조건으로 검색(m) */
  searchDistanceInMeters?: InputMaybe<Scalars['Int']>;
  /** 정렬타입 */
  sortType: HospitalSortType;
};

/** 네이버 플레이스 블로그 리뷰 */
export type HospitalExternalPost = {
  items: Array<HospitalExternalPostItem>;
  totalCount: Scalars['Int'];
};

export type HospitalExternalPostItem = {
  authorName: Scalars['String'];
  content: Scalars['String'];
  id: Scalars['ID'];
  linkName: Scalars['String'];
  linkType: Scalars['String'];
  postedAt: Scalars['String'];
  thumbnailUrl?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  url: Scalars['String'];
};

export enum HospitalFilterType {
  Bookable = 'BOOKABLE',
  HasMedicinePrice = 'HAS_MEDICINE_PRICE',
  NightOperating = 'NIGHT_OPERATING',
  Operating = 'OPERATING',
  PrescriptionUnit = 'PRESCRIPTION_UNIT',
  RegionByDepth = 'REGION_BY_DEPTH',
  Specialist = 'SPECIALIST'
}

export type HospitalGeneralSearch = {
  doctors: Array<DoctorByUserV2>;
  hospitalAdBanners: Array<HospitalAdBanner>;
  /** 병원 주소 */
  hospitalAddress: Scalars['String'];
  /** 병원 뱃지 */
  hospitalBadges: Array<Scalars['String']>;
  /** 병원 거리 */
  hospitalDistance?: Maybe<Scalars['Int']>;
  /** 병원 Id */
  hospitalId: Scalars['ID'];
  /** 병원명 */
  hospitalName: Scalars['String'];
  /** 병원 운영상태 */
  hospitalOperationStatus: HospitalOperatingStatus;
  /** 병원 publicId */
  hospitalPublicId: Scalars['String'];
  /** 병원 대표과목명 */
  hospitalRepresentativeDepartmentName?: Maybe<Scalars['String']>;
  /** 병원 대표 이미지 URL */
  hospitalRepresentativeImageUrl?: Maybe<Scalars['String']>;
  /** 예약가능여부 */
  isBookable: Scalars['Boolean'];
  /** 운영상태 화면표시 */
  operationDisplay?: Maybe<Scalars['String']>;
  /** 병원 리뷰 평점 */
  reviewAverageRating: Scalars['Float'];
  /** 병원 리뷰 총 개수 */
  reviewTotalCount: Scalars['Int'];
};

export type HospitalGeneralSearchCursorPage = {
  elements: Array<HospitalGeneralSearch>;
  pivot?: Maybe<Scalars['String']>;
  pivotScore?: Maybe<Scalars['String']>;
  totalCount: Scalars['Int'];
};

/** 일반적인 병원 검색 요청 */
export type HospitalGeneralSearchRequestInput = {
  /** 병원찾기 필터 */
  commonFilter: HospitalSearchCommonFilterInput;
  /** 위경도 */
  geoPoint: GeoPointInput;
  /** 검색어 */
  keyword?: InputMaybe<Scalars['String']>;
  /** 페이지 사이즈 */
  limit: Scalars['Int'];
  /** 피벗 검색 아이디 (거리) */
  pivotId?: InputMaybe<Scalars['String']>;
  /** 피벗 검색 스코어 */
  pivotScore?: InputMaybe<Scalars['String']>;
  /** 지역 필터 조건 */
  regionByDepth?: InputMaybe<HospitalElasticSearchRegionByDepthRequestInput>;
  regionCode?: InputMaybe<Scalars['String']>;
  /** 정렬타입 */
  sortType: HospitalSortType;
};

/** [독감예방접종] 병원정보 */
export type HospitalInfluenza = {
  /** 병원 주소 */
  hospitalAddress: Scalars['String'];
  /** 병원 뱃지 */
  hospitalBadges: Array<Scalars['String']>;
  /** 병원 거리 */
  hospitalDistance?: Maybe<Scalars['Int']>;
  /** 병원 Id */
  hospitalId: Scalars['ID'];
  /** 병원명 */
  hospitalName: Scalars['String'];
  /** 병원 운영상태 */
  hospitalOperationStatus: HospitalOperatingStatus;
  /** 병원 제휴상태 */
  hospitalPartnershipStatus: HospitalPartnershipStatus;
  /** 병원 publicId */
  hospitalPublicId: Scalars['String'];
  /** 병원 대표과목명 */
  hospitalRepresentativeDepartmentName?: Maybe<Scalars['String']>;
  /** 병원 대표 이미지 URL */
  hospitalRepresentativeImageUrl?: Maybe<Scalars['String']>;
  /** [독감예방접종] 가격과 메타데이터 */
  influenzaPriceWithMetadata?: Maybe<HospitalInfluenzaPriceWithMetadata>;
  /** 예약가능여부 */
  isBookable: Scalars['Boolean'];
  /** 병원 리뷰 평점 */
  reviewAverageRating: Scalars['Float'];
  /** 병원 리뷰 총 개수 */
  reviewTotalCount: Scalars['Int'];
};

export type HospitalInfluenzaCursorPage = {
  elements: Array<HospitalInfluenza>;
  pivot?: Maybe<Scalars['Float']>;
  pivotScore?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};

/** [독감예방접종] 병원가격과 메타데이터 정보 */
export type HospitalInfluenzaPriceWithMetadata = {
  /** 접종가격 */
  diagnosisPrice?: Maybe<Scalars['Int']>;
  /** label 리스트 */
  labels?: Maybe<Array<Scalars['String']>>;
};

/** [독감예방접종] 병원 조회 요청 */
export type HospitalInfluenzaSearchRequestInput = {
  /** 무료접종 필터 */
  freeVaccinationFilters?: InputMaybe<Array<FreeVaccinationSearchFilterType>>;
  /** 위경도 */
  geoPoint: GeoPointInput;
  /** 페이지 사이즈 */
  limit: Scalars['Int'];
  /** 피벗 검색 아이디 (거리) */
  pivotId?: InputMaybe<Scalars['Float']>;
  /** 피벗 검색 스코어 */
  pivotScore?: InputMaybe<Scalars['Float']>;
  /** 지역 필터 조건 */
  regionByDepth?: InputMaybe<HospitalElasticSearchRegionByDepthRequestInput>;
  /** 정렬타입 */
  sortType: HospitalSortType;
};

export type HospitalInfoWithReviewSummaryCursorPageV3 = {
  elements: Array<HospitalInfoWithReviewSummaryV2Graph>;
  pivot?: Maybe<Scalars['Float']>;
  pivotScore?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};

/** 병원과 리뷰 정보 */
export type HospitalInfoWithReviewSummaryV2Graph = {
  /** 병원에 소속된 의사정보 */
  doctors: Array<HospitalDoctor>;
  /** 병원 주소 */
  hospitalAddress: Scalars['String'];
  /** 병원 뱃지 */
  hospitalBadges: Array<Scalars['String']>;
  /** 병원 거리 */
  hospitalDistance?: Maybe<Scalars['Int']>;
  /** 병원 Id */
  hospitalId: Scalars['ID'];
  /** 병원명 */
  hospitalName: Scalars['String'];
  /** 병원 운영상태 */
  hospitalOperationStatus: HospitalOperatingStatus;
  /** 병원 publicId */
  hospitalPublicId: Scalars['String'];
  /** 병원 대표과목명 */
  hospitalRepresentativeDepartmentName?: Maybe<Scalars['String']>;
  /** 병원 대표 이미지 URL */
  hospitalRepresentativeImageUrl?: Maybe<Scalars['String']>;
  /** 예약여부 */
  isBookable: Scalars['Boolean'];
  /** 병원 리뷰 평점 */
  reviewAverageRating: Scalars['Float'];
  /** 병원 리뷰 총 개수 */
  reviewTotalCount: Scalars['Int'];
};

/** 병원 소개 업데이트 요청 */
export type HospitalIntroductionUpdateMutationRequestInput = {
  /** 병원 소개글 */
  introduction?: InputMaybe<Scalars['String']>;
};

export type HospitalNaverPlaceDetailGraph = {
  description?: Maybe<Scalars['String']>;
  hashtags?: Maybe<Array<Scalars['String']>>;
  homepages: Array<HomepageGraph>;
  hospitalId: Scalars['ID'];
  treatmentMenus: Array<TreatmentMenuGraph>;
};

/** 병원 가격표 비급여 카테고리 */
export type HospitalNonBenefitCategory = {
  /** 비급여 카테고리 ID */
  categoryId: Scalars['ID'];
  /** 비급여 카테고리명 */
  categoryName: Scalars['String'];
  /** 비급여 카테고리 이미지 */
  imageUrl?: Maybe<Scalars['String']>;
  /** 비급여 아이템 그룹 */
  nonBenefitItemGroup: HospitalPriceListNonBenefitItemGroup;
};

/** 병원 비급여 카테고리 정보 */
export type HospitalNonBenefitCategoryInfo = {
  /** 비급여 카테고리 ID */
  categoryId: Scalars['ID'];
  /** 비급여 카테고리명 */
  categoryName: Scalars['String'];
  /** 비급여 카테고리 이미지 */
  imageUrl?: Maybe<Scalars['String']>;
  /** 병원 비급여 아이템 그룹 */
  nonBenefitItemGroups: Array<NonBenefitItemGroup>;
};

/** 비급여 카테고리 아이템 가격표 */
export type HospitalNonBenefitCategoryItemPriceListGraph = {
  /** 병원 ID */
  hospitalId: Scalars['ID'];
  /** 비급여 카테고리 */
  nonBenefitCategory: HospitalNonBenefitCategory;
};

/** 병원 비급여 정보 */
export type HospitalNonBenefitInfo = {
  /** 병원 ID */
  hospitalId: Scalars['ID'];
  /** 병원 비급여 카테고리 목록 */
  nonBenefitCategories: Array<HospitalNonBenefitCategoryInfo>;
};

/** 병원 비급여 아이템 업데이트 요청 */
export type HospitalNonBenefitItemUpdateMutationRequestInput = {
  /** 병원 비급여 아이템 데이터 */
  nonBenefitItemUnitPrices: Array<NonBenefitItemUpdateMutationRequestInput>;
};

export enum HospitalOnBoardingStatus {
  BreakTimes = 'BREAK_TIMES',
  Completed = 'COMPLETED',
  DepartmentGroups = 'DEPARTMENT_GROUPS',
  OperationTimes = 'OPERATION_TIMES',
  RegularHolidays = 'REGULAR_HOLIDAYS'
}

export enum HospitalOperatingStatus {
  Closed = 'CLOSED',
  DayOff = 'DAY_OFF',
  Lunch = 'LUNCH',
  Open = 'OPEN',
  Unknown = 'UNKNOWN'
}

/** 병원 운영시간 변경 */
export type HospitalOperatingTimeChangeRequestInput = {
  /** 종료 시각 */
  closeTime: Scalars['String'];
  /** 요일(월~일 + 공휴일) */
  dayOfWeek: DayOfWeekType;
  /** 시작 시각 */
  openTime: Scalars['String'];
};

export enum HospitalPartnershipStatus {
  NonPartnership = 'NON_PARTNERSHIP',
  Partnership = 'PARTNERSHIP',
  Pending = 'PENDING'
}

/** 병원 가격표 비급여 아이템 그룹 */
export type HospitalPriceListNonBenefitItemGroup = {
  /** 약제비가 포함되었는지 여부 */
  hasMedicinePrice: Scalars['Boolean'];
  /** 비급여 아이템 ID */
  itemId: Scalars['ID'];
  /** 비급여 아이템명 */
  itemName: Scalars['String'];
  /** 비급여 아이템 처방단위별 금액 */
  unitPrices: Array<HospitalPriceListNonBenefitItemUnitPrice>;
};

/** 병원 상세 가격표 비급여 아이템 처방단위별 금액 */
export type HospitalPriceListNonBenefitItemUnitPrice = {
  /** 진료비 */
  diagnosisPrice?: Maybe<Scalars['String']>;
  /** 진료비 + 약제비 포함 총 금액 정보 */
  totalPrice?: Maybe<Scalars['String']>;
  /** 처방 단위 */
  unitDisplayMessage: Scalars['String'];
};

/** 병원 소개 이미지 */
export type HospitalProfileImage = {
  /** 병원 ID */
  hospitalId: Scalars['ID'];
  /** 이미지 url */
  id: Scalars['ID'];
  /** 대표사진 여부 */
  isRepresentative: Scalars['Boolean'];
  /** 이미지 url */
  url: Scalars['String'];
};

/** 병원 프로필 이미지 업로드용 pre-signed url */
export type HospitalProfileImageUploadPreSignedUrl = {
  filePath: Scalars['String'];
  preSignedUrl: Scalars['String'];
};

export type HospitalRegionByDepth = {
  /** 읍/면/동 이름 */
  eupMyeonDongName: Scalars['String'];
  /** 시/도 이름 */
  siDoName: Scalars['String'];
  /** 시/군/구 이름 */
  siGunGuName?: Maybe<Scalars['String']>;
};

export type HospitalSearchCommonFilterInput = {
  bookable?: InputMaybe<Scalars['Boolean']>;
  nightOperation?: InputMaybe<Scalars['Boolean']>;
  /** 비대면진료를 보는 의사가 있는지 여부 */
  nonF2f?: InputMaybe<Scalars['Boolean']>;
  operating?: InputMaybe<Scalars['Boolean']>;
  specialist?: InputMaybe<Scalars['Boolean']>;
  sundayOperation?: InputMaybe<Scalars['Boolean']>;
};

export enum HospitalSearchPortalType {
  Naver = 'NAVER'
}

/** 병원 네이버 검색결과 */
export type HospitalSearchResultGraph = {
  items: Array<HospitalSearchResultItemGraph>;
  totalCount: Scalars['Int'];
};

export type HospitalSearchResultItemGraph = {
  /** 블로그/카페 글 내용 */
  content: Scalars['String'];
  /** 병원 ID */
  hospitalId: Scalars['ID'];
  /** ID */
  id: Scalars['ID'];
  /** 블로그/카페 링크 */
  link: Scalars['String'];
  /** 작성일자 */
  postDate?: Maybe<Scalars['String']>;
  /** 블로그/카페 글 제목 */
  title: Scalars['String'];
};

/** 병원 정렬기준 */
export type HospitalSearchSortType = {
  /** 기본으로 선택 여부 */
  isDefault: Scalars['Boolean'];
  /** 정렬 기준 */
  sortType: HospitalSortType;
};

export type HospitalSignUpAccountRequestInput = {
  /** 병원 비밀번호 */
  password: Scalars['String'];
  /** 병원 로그인ID */
  userName: Scalars['String'];
};

export type HospitalSignUpAddressRequestInput = {
  /** 병원 상세주소 */
  detailAddress?: InputMaybe<Scalars['String']>;
  /** 병원 지번주소 */
  jibunAddress: Scalars['String'];
  /** 병원 도로명주소 */
  roadAddress?: InputMaybe<Scalars['String']>;
};

export type HospitalSignUpAgreementRequestInput = {
  /** 약관 동의 리스트 */
  approvedAgreementIds: Array<Scalars['ID']>;
  /** 약관 비동의 리스트 */
  disapprovedAgreementIds: Array<Scalars['ID']>;
};

export type HospitalSignUpContactRequestInput = {
  /** 병원 연락처 */
  telNumber: Scalars['String'];
};

export type HospitalSignUpHospitalRequestInput = {
  /** 병원정보 (신규 병원은 NULL) */
  hospitalId?: InputMaybe<Scalars['ID']>;
  /** 병원명 */
  hospitalName: Scalars['String'];
};

/** 병원 회원가입 요청 */
export type HospitalSignUpMutationRequestInput = {
  /** 계정 정보 */
  account: HospitalSignUpAccountRequestInput;
  /** 병원 주소 */
  address: HospitalSignUpAddressRequestInput;
  /** 회원가입 약관 */
  agreement: HospitalSignUpAgreementRequestInput;
  /** 병원 연락처 */
  contact: HospitalSignUpContactRequestInput;
  /** 병원 정보 */
  hospital: HospitalSignUpHospitalRequestInput;
};

export type HospitalSitemapGraph = {
  /** ID */
  id: Scalars['ID'];
  /** 사이트맵 URL */
  sitemapUrl: Scalars['String'];
};

/** 병원 사이트맵 */
export type HospitalSitemapPage = {
  /** 사이트맵 */
  elements: Array<HospitalSitemapGraph>;
  /** 전체 데이터 수 */
  totalCount: Scalars['Int'];
  /** 전체 페이지 수 */
  totalPage: Scalars['Int'];
};

export enum HospitalSortType {
  Accuracy = 'ACCURACY',
  Distance = 'DISTANCE',
  NonBenefitPrice = 'NON_BENEFIT_PRICE',
  ReviewAverageRating = 'REVIEW_AVERAGE_RATING',
  ReviewCount = 'REVIEW_COUNT'
}

/** 병원 지하철역 */
export type HospitalSubwayStation = {
  /** ID */
  hospitalId: Scalars['ID'];
  /** 지역 */
  subwayRegion: Scalars['String'];
  /** 역까지의 거리 */
  subwayStationDistance: Scalars['Float'];
  /** 호선 */
  subwayStationLane: Scalars['String'];
  /** 역이름 */
  subwayStationName: Scalars['String'];
};

/** 병원 수술 횟수 */
export type HospitalSurgery = {
  /** 뱃지들 */
  badges: Array<Scalars['String']>;
  /** 병원 ID */
  hospitalId: Scalars['ID'];
  /** ID */
  id: Scalars['ID'];
  /** 수술횟수 */
  surgeryCount: Scalars['Int'];
  /** 수술명 */
  surgeryName: Scalars['String'];
};

/** 병원 오늘 운영정보 */
export type HospitalTodayDuty = {
  /** 휴식 종료 시각 */
  breakEndTime?: Maybe<Scalars['String']>;
  /** 휴식 시작 시각 */
  breakStartTime?: Maybe<Scalars['String']>;
  /** 휴식 시간 문자열 */
  breakTimes: Scalars['String'];
  /** 진료 종료 시각 */
  closeTime?: Maybe<Scalars['String']>;
  /** 요일(월~일, 공휴일) */
  dayOfWeek: DayOfWeekType;
  /** 휴게시간을 갖지 않는지 여부 */
  hasNoBreakTimes: Scalars['Boolean'];
  /** ID */
  id: Scalars['ID'];
  /** 정기 휴무 여부 */
  isClosed?: Maybe<Scalars['Boolean']>;
  /** 진료 시작 시각 */
  openTime?: Maybe<Scalars['String']>;
  /** 현재 운영 상태 */
  operatingStatus: HospitalOperatingStatus;
  /** 진료 시간 문자열 ex. 09:00 - 확인 필요, 09:00 - 18:00 */
  operationTimes: Scalars['String'];
};

/** 병원찾기 인기검색어 */
export type HotKeyword = {
  /** 검색어 */
  keyword: Scalars['String'];
};

export type HotKeywordRequestInput = {
  /** 정렬기준 */
  sortType: HotKeywordSortType;
};

export enum HotKeywordSortType {
  Recommendation = 'RECOMMENDATION'
}

/** 무료상담 홈 이미지 배너 */
export type ImageBanner = {
  /** 사이즈 374 이미지 */
  image360Url: Scalars['String'];
  /** 사이즈 640 이미지 */
  image640Url: Scalars['String'];
  /** 이미지 배너 고유번호 */
  imageBannerId: Scalars['ID'];
  /** 액션 링크 */
  linkUrl?: Maybe<Scalars['String']>;
};

/** 유저앱 최상단 이미지 배너 목록 조회 조건 */
export type ImageBannersRequestInput = {
  /** 셔플 여부 */
  shuffled?: InputMaybe<Scalars['Boolean']>;
};

export enum InHospitalDeliveryCategoryType {
  Pickup = 'PICKUP',
  Post = 'POST',
  Quick = 'QUICK'
}

export type InHospitalDeliveryInfoInput = {
  inHospitalDeliveryCategoryType: InHospitalDeliveryCategoryType;
  userAddressId: Scalars['ID'];
};

export enum InflowType {
  Default = 'DEFAULT',
  NonBenefit = 'NON_BENEFIT'
}

export type Ingredient = {
  /** 성분 코드 */
  code: Scalars['ID'];
  /** 성분 영문 이름 */
  englishName: Scalars['String'];
  /** 성분 이름 */
  name: Scalars['String'];
  /** 처방약 */
  prescribedMedications: Array<Medication>;
  /** 성분별 수령률 */
  receiptRate?: Maybe<Scalars['Float']>;
};

/** 성분 정보 */
export type IngredientInfo = {
  /** 정제된 주성분 한글명 */
  formattedIngredientName?: Maybe<Scalars['String']>;
  /** 주성분 영문명 */
  ingredientEnglishName?: Maybe<Scalars['String']>;
  /** 주성분 한글명 */
  ingredientName?: Maybe<Scalars['String']>;
  /** 원재료(성분)명 영문 목록 */
  materialEnglishNames: Array<Scalars['String']>;
  /** 원재료(성분)명 목록 */
  materialNames: Array<Scalars['String']>;
};

/** 보험 및 가격 정보 */
export type InsuranceInfo = {
  /** 현재 기본 적용 보험 코드 */
  currentInsuranceCode: Scalars['String'];
  /** 보험 코드 목록 */
  insuranceCodes: Array<Scalars['String']>;
  /** 보험 적용 유형 */
  insuranceType: Scalars['String'];
  /** 약품의 공식 최고가 */
  maxPrice: Scalars['String'];
};

/** 초대 코드 */
export type InvitationCode = {
  /** 코드 */
  code: Scalars['String'];
  /** 초대 코드 아이디 */
  id: Scalars['ID'];
  invitationCount: Scalars['Int'];
  /** 피초대자 리워드 */
  inviteeRewardAmount: Scalars['Int'];
  inviterReceivableTotalPoints: Scalars['Int'];
  inviterReceivedPoints: Scalars['Int'];
  /** 초대자 리워드 */
  inviterRewardAmount: Scalars['Int'];
};

export enum InvitationCodeType {
  FriendInvitation = 'FRIEND_INVITATION',
  None = 'NONE'
}

/** 초대 코드 생성 결과 */
export type IssueInvitationCode = {
  /** 코드 */
  code: Scalars['String'];
  /** id */
  id: Scalars['ID'];
  /** 피초대자 리워드 */
  inviteeRewardAmount: Scalars['Int'];
  /** 초대자 리워드 */
  inviterRewardAmount: Scalars['Int'];
};

/** 초대 코드 발급 요청 */
export type IssueInvitationCodeMutationRequestInput = {
  /** 코드 타입 */
  codeType: InvitationCodeType;
};

/** 카카오페이 등록 2차 요청 응답 */
export type KakaopayRegistrationApprovalGraph = {
  /** 성공여부 */
  isSuccess: Scalars['Boolean'];
  /** 등록된 카드 */
  registeredCard?: Maybe<RegisteredUserPaymentGraph>;
  /** 결과 메시지 */
  resultMessage: Scalars['String'];
};

/** 카카오페이 등록 1차 요청 응답 */
export type KakaopayRegistrationReady = {
  /** 카카오페이 결제화면 이동 Android 스킴 */
  androidScheme: Scalars['String'];
  /** 카카오페이 결제화면 이동 iOS 스킴 */
  iosScheme: Scalars['String'];
  /** 카카오톡 결제 페이지 앱 URL */
  nextRedirectAppUrl: Scalars['String'];
  /** 카카오톡 결제 페이지 모바일 URL */
  nextRedirectMobileUrl: Scalars['String'];
  /** 카카오톡 결제 페이지 PC URL */
  nextRedirectPcUrl: Scalars['String'];
  /** 카카오페이 트랜잭션 ID */
  transactionId: Scalars['String'];
};

/** 카카오페이 결제수단 등록 - 2차요청 */
export type KakaopayRegistrationRequestInput = {
  pgToken: Scalars['String'];
  transactionId?: InputMaybe<Scalars['String']>;
};

/** 건강매거진 키워드 검색 요청 */
export type KeywordSearchMagazineCursorPageRequestInput = {
  /** 컨텐츠 유형(ARTICLE, FAQ) */
  contentType?: InputMaybe<Scalars['String']>;
  /** 검색어 */
  keyword: Scalars['String'];
  /** 피벗 아이디 */
  pivot?: InputMaybe<Scalars['ID']>;
  /** 조회 사이즈 */
  size?: InputMaybe<Scalars['Int']>;
};

/** 키워드 기반 질문 검색 요청 */
export type KeywordSearchQuestionCardCursorPageRequestInput = {
  /** 검색어 */
  keyword: Scalars['String'];
  /** 페이지 피벗 질문 ID */
  pivot?: InputMaybe<Scalars['ID']>;
  /** 페이지 사이즈(기본값: 20) */
  size?: InputMaybe<Scalars['Int']>;
};

export type KeywordSearchedDiseaseCursorPageRequestInput = {
  keyword: Scalars['String'];
  pivot?: InputMaybe<Scalars['ID']>;
  size?: InputMaybe<Scalars['Int']>;
};

/** Depth별 주소 */
export type KoreaAddress = {
  /** 동 주소 */
  dongNames: Array<Scalars['String']>;
  /** 시/도 주소 */
  sidoNames: Array<Scalars['String']>;
  /** 시/군/구 주소 */
  sigunguNames: Array<Scalars['String']>;
};

export enum KoreaAddressDongType {
  Administration = 'ADMINISTRATION',
  Legal = 'LEGAL'
}

export type KoreaAddressGraphV3 = {
  dongCode: Scalars['String'];
  dongName: Scalars['String'];
  dongType: KoreaAddressDongType;
  id: Scalars['ID'];
  sidoCode: Scalars['String'];
  sidoName: Scalars['String'];
  sigunguCode: Scalars['String'];
  sigunguName: Scalars['String'];
};

/** 한국 전체 주소 계층 구조 */
export type KoreaAddressHierarchy = {
  administrationType: Scalars['String'];
  children: Array<KoreaAddressHierarchy>;
  code: Scalars['String'];
  /** 화면에 보여지는 시도 지역명 */
  displaySidoName?: Maybe<Scalars['String']>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  name: Scalars['String'];
};

/** 주소 검색 요청 */
export type KoreaAddressSearchRequestInput = {
  /** 시/도 주소 */
  sidoName?: InputMaybe<Scalars['String']>;
  /** 시/군/구 주소 */
  sigunguName?: InputMaybe<Scalars['String']>;
};

/** 주소 검색 요청 V2 */
export type KoreaAddressSearchRequestV2Input = {
  /** 시/도 코드 */
  siDoCode?: InputMaybe<Scalars['String']>;
  /** 시/군/구 코드 */
  siGunGuCode?: InputMaybe<Scalars['String']>;
};

/** Depth별 주소 V2 */
export type KoreaAddressV2 = {
  /** 중심부 위도 */
  centroidLatitude: Scalars['Float'];
  /** 중심부 경도 */
  centroidLongitude: Scalars['Float'];
  /** 화면에 보여지는 지역명 */
  displayName: Scalars['String'];
  /** 지역코드 */
  regionCode: Scalars['String'];
  /** 지역명 */
  regionName: Scalars['String'];
};

/** 최근 건강 기록 (건강탭용) */
export type LatestHealthRecordForTab = {
  /** 최근 혈압 */
  bloodPressureRecord?: Maybe<BloodPressureRecord>;
  /** 최근 혈당 */
  bloodSugarRecord?: Maybe<BloodSugarRecord>;
  /** 최근 신체정보 */
  bodyInfoRecord?: Maybe<BodyMeasurementRecord>;
  /** 최근 신체정보 */
  bodyMeasurementRecord?: Maybe<BodyMeasurementRecord>;
  /** 포인트 지급 가능 여부 */
  pointAvailable: Scalars['Boolean'];
  /** 최근 기록 이후 지난 일수 */
  termFromLastUpdate?: Maybe<Scalars['String']>;
};

export type LiverFunctionGraph = {
  /** ALT */
  alt: Scalars['Float'];
  /** ALT 상태 */
  altStatus: LiverFunctionStatus;
  /** AST */
  ast: Scalars['Float'];
  /** AST 상태 */
  astStatus: LiverFunctionStatus;
  /** 통합 상태 */
  totalStatus: LiverFunctionStatus;
  /** 감마지티피 */
  ygtp: Scalars['Float'];
  /** 감마지티피 상태 */
  ygtpStatus: LiverFunctionStatus;
};

/** 간기능 기록 */
export type LiverFunctionRecord = {
  /** 건강기록 ID */
  healthRecordId: Scalars['ID'];
  /** 기록 타입 */
  healthRecordType: HealthRecordType;
  /** 기록 대상일자 */
  recordDateTime: Scalars['DrTimestamp'];
  /** 데이터 출처 */
  source: HealthRecordSource;
  /** 유저 ID */
  userId: Scalars['ID'];
  /** 간기능 수치 */
  value: LiverFunctionGraph;
};

export enum LiverFunctionStatus {
  Danger = 'DANGER',
  Normal = 'NORMAL',
  Warning = 'WARNING'
}

/** 위치 위경도 */
export type LocationMutationRequestInput = {
  /** 위도 */
  latitude: Scalars['Float'];
  /** 경도 */
  longitude: Scalars['Float'];
};

/** 위/경도 위치 */
export type LocationRequestInput = {
  /** 위도 */
  latitude: Scalars['Float'];
  /** 경도 */
  longitude: Scalars['Float'];
};

/** 로그인 토큰 */
export type LoginResponse = {
  /** auth token */
  auth?: Maybe<AuthToken>;
  /** login 요청 결과 타입 */
  loginResponseType: LoginResponseType;
  /** user 정보 */
  user?: Maybe<MemberUser>;
};

export enum LoginResponseType {
  NeedSignUp = 'NEED_SIGN_UP',
  SigninFail = 'SIGNIN_FAIL',
  Success = 'SUCCESS'
}

export enum LoginType {
  Doctornow = 'DOCTORNOW',
  Oauth = 'OAUTH'
}

export enum LottieOnDiagnosisListAtUserApp {
  InProgress = 'IN_PROGRESS'
}

/** 건강매거진 */
export type Magazine = {
  author?: Maybe<Author>;
  /** 배너 */
  banner?: Maybe<MagazineBannerGraph>;
  bottomButtonType: Scalars['String'];
  content: Scalars['String'];
  contentType: Scalars['String'];
  createdAt: Scalars['DrTimestamp'];
  description: Scalars['String'];
  footnote: Scalars['String'];
  hasJapanese: Scalars['Boolean'];
  hospital?: Maybe<Hospital>;
  isLikedByMe: Scalars['Boolean'];
  likeCount: Scalars['Int'];
  magazineId: Scalars['ID'];
  magazinePid: Scalars['ID'];
  mobileContent: Scalars['String'];
  mobileDescription: Scalars['String'];
  mobileTitle: Scalars['String'];
  questionCategoryId: Scalars['ID'];
  tagNames: Array<Scalars['String']>;
  tags: Array<MagazineTagGraph>;
  title: Scalars['String'];
  titleImageUrl: Scalars['String'];
  updatedAt: Scalars['DrTimestamp'];
};

export type MagazineAuthorGraph = {
  affiliation?: Maybe<Affiliation>;
  career: Array<AuthorCareer>;
  hospitalId?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  profileDescription?: Maybe<Scalars['String']>;
  profileImage: Scalars['String'];
  publicId: Scalars['ID'];
};

/** 매거진 배너 */
export type MagazineBannerGraph = {
  /** CTA 버튼 문구 */
  buttonPhrase: Scalars['String'];
  /** 배너 설명글 */
  description: Scalars['String'];
  /** 이동 링크 (비대면 진료실 등) */
  externalUrl: Scalars['String'];
  /** 배너 ID */
  id: Scalars['ID'];
  /** 배너 이미지 URL */
  imageUrl: Scalars['String'];
  /** 매거진 ID */
  magazineId: Scalars['ID'];
  /** 배너 제목 */
  title: Scalars['String'];
};

export enum MagazineContentType {
  Article = 'ARTICLE',
  Faq = 'FAQ'
}

/** 건강매거진 갯수 */
export type MagazineCount = {
  magazineCount: Scalars['Int'];
};

/** 건강매거진 갯수 조회 조건 */
export type MagazineCountRequestInput = {
  /** 컨텐츠 유형(ARTICLE, FAQ) */
  contentType?: InputMaybe<Scalars['String']>;
  /** 질문 카테고리 아이디 */
  questionCategoryId?: InputMaybe<Scalars['ID']>;
};

export type MagazineCursorPage = {
  elements: Array<Magazine>;
  pivot?: Maybe<Scalars['ID']>;
};

/** 건강매거진 목록 조회 조건 */
export type MagazineCursorPageRequestInput = {
  /** 컨텐츠 유형(ARTICLE, FAQ) */
  contentType?: InputMaybe<Scalars['String']>;
  /** 피벗 아이디 */
  pivot?: InputMaybe<Scalars['ID']>;
  /** 질문 카테고리 아이디 */
  questionCategoryId?: InputMaybe<Scalars['ID']>;
  /** 조회 사이즈 */
  size?: InputMaybe<Scalars['Int']>;
};

export type MagazineListGraph = {
  magazines: Array<Magazine>;
  totalCount: Scalars['Int'];
  totalPageCount: Scalars['Int'];
};

export type MagazineRelatedBoardPostsRequestInput = {
  magazinePid: Scalars['ID'];
  size?: InputMaybe<Scalars['Int']>;
};

/** 매거진 관련 건강매거진 목록 요청 */
export type MagazineRelatedMagazinesRequestInput = {
  contentTypes?: InputMaybe<Array<Scalars['String']>>;
  /** 매거진 아이디 */
  magazinePid: Scalars['ID'];
  /** 사이즈 */
  size?: InputMaybe<Scalars['Int']>;
};

export type MagazineRelatedQuestionCardsRequestInput = {
  magazinePid: Scalars['ID'];
  size?: InputMaybe<Scalars['Int']>;
};

export type MagazineSearchRequestInput = {
  categoryIds: Array<Scalars['ID']>;
  contentTypes: Array<MagazineContentType>;
  page: Scalars['Int'];
  size: Scalars['Int'];
};

/** 매거진 검색 결과 */
export type MagazineSearchResult = {
  /** 매거진 정보 */
  items: Array<MagazineV2>;
  /** 검색 결과 총 갯수 */
  totalCount: Scalars['Int'];
};

export type MagazineTagGraph = {
  coreCategories: Array<CoreCategoryGraph>;
  magazinePid: Scalars['ID'];
  name: Scalars['String'];
  tagId: Scalars['ID'];
  tagType: TagType;
};

/** 건강매거진 */
export type MagazineV2 = {
  /** 배너 */
  banner?: Maybe<MagazineBannerGraph>;
  bottomButtonType: Scalars['String'];
  categoryId: Scalars['ID'];
  content: Scalars['String'];
  contentType: MagazineContentType;
  createdAt: Scalars['DrTimestamp'];
  description: Scalars['String'];
  doctorExternalLinkUrl?: Maybe<Scalars['String']>;
  doctorId?: Maybe<Scalars['ID']>;
  footnote: Scalars['String'];
  hasJapanese: Scalars['Boolean'];
  id: Scalars['ID'];
  likeCount: Scalars['Int'];
  mobileContent: Scalars['String'];
  mobileDescription: Scalars['String'];
  mobileTitle: Scalars['String'];
  publicId: Scalars['ID'];
  tagNames: Array<Scalars['String']>;
  tags: Array<MagazineTagGraph>;
  title: Scalars['String'];
  titleImageUrl: Scalars['String'];
  viewCount: Scalars['Int'];
  visible: Scalars['Boolean'];
};

export enum MainFunction {
  Antioxidation = 'ANTIOXIDATION',
  BloodCirculation = 'BLOOD_CIRCULATION',
  BloodPressure = 'BLOOD_PRESSURE',
  BloodSugar = 'BLOOD_SUGAR',
  BodyFat = 'BODY_FAT',
  Bone = 'BONE',
  BoneJoint = 'BONE_JOINT',
  Cholesterol = 'CHOLESTEROL',
  Eye = 'EYE',
  FatigueImprovement = 'FATIGUE_IMPROVEMENT',
  Gut = 'GUT',
  Immunity = 'IMMUNITY',
  Iron = 'IRON',
  MaleGenital = 'MALE_GENITAL',
  Memory = 'MEMORY',
  Metabolism = 'METABOLISM',
  Skin = 'SKIN',
  Sleep = 'SLEEP',
  Stomach = 'STOMACH',
  Stress = 'STRESS',
  Vitality = 'VITALITY'
}

export type MainFunctionGraph = {
  description: Scalars['String'];
  type: MainFunction;
  warningMent: Scalars['String'];
};

/** 퀴즈 풀 수 있는 상태로 변경 */
export type MakeQuizSolvableRequestInput = {
  /** 퀴즈 아이디 */
  quizPid: Scalars['ID'];
};

/** 메디컬 카테고리(과목, 시술, 비급여) */
export type MedicalCategory = {
  /** 진료과목그룹ID, 예약에 사용 */
  departmentGroupId?: Maybe<Scalars['ID']>;
  /** 카테고리 설명 */
  description: Scalars['String'];
  /** 아이콘 타입 */
  iconType: MedicalCategoryIconType;
  /** 아이콘 이미지 주소 */
  iconUrl: Scalars['String'];
  /** 메디컬 카테고리 ID */
  id: Scalars['ID'];
  /** 진입 타입, 병원 리스트 화면 분기용 */
  inflowType: InflowType;
  /** 아이콘에 붙는 레이블 */
  label?: Maybe<Scalars['String']>;
  medicalSubCategories: Array<MedicalSubCategory>;
  /** 카테고리명 */
  name: Scalars['String'];
};

export enum MedicalCategoryIconType {
  Animation = 'ANIMATION',
  PlainImage = 'PLAIN_IMAGE'
}

export type MedicalCategoryRequestInput = {
  /** 정렬기준 */
  sortType: MedicalCategorySortType;
};

export enum MedicalCategorySortType {
  Alphabet = 'ALPHABET',
  Recommendation = 'RECOMMENDATION'
}

export type MedicalCategoryTargetGraph = {
  id: Scalars['ID'];
  type: MedicalCategoryType;
};

export type MedicalCategoryTargetInput = {
  id: Scalars['ID'];
  type: MedicalCategoryType;
};

export enum MedicalCategoryType {
  Department = 'DEPARTMENT',
  Treatment = 'TREATMENT',
  Vaccination = 'VACCINATION'
}

export enum MedicalFacilityTreatmentType {
  DentalOutpatientClinic = 'DentalOutpatientClinic',
  Etc = 'ETC',
  GeneralHospitalization = 'GeneralHospitalization',
  GeneralOutpatientClinic = 'GeneralOutpatientClinic',
  PrescriptionPreparation = 'PrescriptionPreparation'
}

/** 의료시설 방문내역 */
export type MedicalFacilityVisitHistory = {
  /** 방문날짜 */
  date: Scalars['String'];
  /** 조제내역 */
  dispensationHistory?: Maybe<Array<DispensationHistory>>;
  /** 상세정보가 있는지 여부 */
  hasDetail: Scalars['Boolean'];
  /** 의료시설 방문내역 ID */
  id: Scalars['ID'];
  /** 의료시설명 */
  medicalFacilityName: Scalars['String'];
  /** 처방타입 */
  medicalFacilityTreatmentType: MedicalFacilityTreatmentType;
  /** 주소 */
  simpleAddress?: Maybe<Scalars['String']>;
};

/** 하위 메디컬 카테고리 */
export type MedicalSubCategory = {
  /** 하위 메디컬 카테고리 ID */
  id: Scalars['ID'];
  /** 일반 검색인 경우 검색어 */
  keyword?: Maybe<Scalars['String']>;
  /** 카테고리 ID */
  medicalCategoryId: Scalars['ID'];
  /** 하위 카테고리명 */
  name: Scalars['String'];
  /** 비급여 검색인 경우 카테고리 ID */
  nonBenefitCategoryId?: Maybe<Scalars['Int']>;
  /** 비급여 검색인 경우 아이템 ID */
  nonBenefitItemId?: Maybe<Scalars['Int']>;
  /** 비급여 검색인 경우 처방단위 */
  prescriptionUnit?: Maybe<Scalars['Int']>;
  /** 진입 혹은 검색 타입 */
  searchInflowType: InflowType;
};

export type Medication = {
  /** 대체약 관련 정보 */
  alternativeMedicationInfo: AlternativeMedicationInfo;
  /** 현재 보험코드 */
  currentInsuranceCode?: Maybe<Scalars['ID']>;
  /** 주성분 */
  ingredient?: Maybe<Ingredient>;
  /** 주성분 코드 */
  mainIngredientCode: Scalars['ID'];
  /** 약 카테고리 정보 */
  medicationCategoryInfos: Array<MedicationCategoryInfo>;
  /** 약 이름 */
  name: Scalars['String'];
  /** 원스글로벌 코드 */
  onesglobalCode: Scalars['ID'];
};

export type MedicationCategoryInfo = {
  /** 작용 기전 */
  actionMechanism?: Maybe<Scalars['String']>;
  /** 유효성분 함량 */
  activeIngredientContent: Scalars['String'];
  /** 유효 성분 제형 */
  activeIngredientDosageForm: Scalars['String'];
  /** 유효 성분명 */
  activeIngredientName: Scalars['String'];
  /** 해부학적 분류 */
  anatomicalCategory?: Maybe<Scalars['String']>;
  /** 효능/효과 */
  efficacy?: Maybe<Scalars['String']>;
  /** 약효 성분명 */
  medicinalIngredientName: Scalars['String'];
  /** 원스글로벌 코드 */
  onesglobalCode: Scalars['ID'];
  /** 구조 계열 */
  structuralSeries?: Maybe<Scalars['String']>;
};

export type Medicine = {
  appearanceDescription: Scalars['String'];
  briefLicensedEfficacy: Scalars['String'];
  classificationCodeName: Scalars['String'];
  contralIndications: Array<Scalars['String']>;
  counselingContents: Array<Scalars['String']>;
  counselingEfficacy: Scalars['String'];
  counselingForgettingDescription: Scalars['String'];
  counselingInteractions: Array<Scalars['String']>;
  counselingNotifications: Array<Scalars['String']>;
  counselingPrecautions: Array<Scalars['String']>;
  counselingSideEffects: Array<Scalars['String']>;
  counselingStorageMethod: Scalars['String'];
  dosage: Scalars['String'];
  id: Scalars['ID'];
  ingredients: Array<Scalars['String']>;
  insuranceCode: Scalars['String'];
  isBenefit: Scalars['Boolean'];
  medicineApprovalType: MedicineApprovalType;
  medicineDetail?: Maybe<MedicineDetail>;
  medicineImageUrl: Scalars['String'];
  medicineName: Scalars['String'];
  specialDrugTypes: Array<Scalars['String']>;
  unit: Scalars['String'];
};

export enum MedicineApprovalType {
  General = 'GENERAL',
  PrescriptionBased = 'PRESCRIPTION_BASED'
}

export enum MedicineBenefitType {
  Benefit = 'BENEFIT',
  NonBenefit = 'NON_BENEFIT'
}

export type MedicineDetail = {
  classificationName: Scalars['String'];
  labelCautions: Array<MedicineFormattedContentGraph>;
  labelDosages: Array<MedicineFormattedContentGraph>;
  labelIndications: Array<MedicineFormattedContentGraph>;
  labelInteractions: Array<Scalars['String']>;
  medicationCautions: Array<Scalars['String']>;
  medicationIndication: Scalars['String'];
  medicationSideEffects: Array<Scalars['String']>;
  medicationWholes: Array<Scalars['String']>;
  medicineApprovalType: MedicineApprovalType;
  medicineId: Scalars['ID'];
  medicineImageUrl: Scalars['String'];
  medicineName: Scalars['String'];
  medicineVideoUrl: Scalars['String'];
  pictograms: Array<MedicinePictogramGraph>;
  storageMethod: Scalars['String'];
};

/** 의약품 사전 리스트 커서 기반 조회 정보 */
export type MedicineDictionaryByCursorGraph = {
  /** 의약품 사전 아이템 리스트 */
  items: Array<MedicineDictionaryItemGraph>;
  /** pivot id */
  pivotId?: Maybe<Scalars['String']>;
  /** pivot score */
  pivotScore?: Maybe<Scalars['Float']>;
  /** 전체 데이터 수 */
  totalCount: Scalars['Int'];
};

/** 의약품 사전 리스트 조회 정보 */
export type MedicineDictionaryGraph = {
  /** 의약품 사전 아이템 리스트 */
  items: Array<MedicineDictionaryItemGraph>;
  /** 전체 데이터 수 */
  totalCount: Scalars['Int'];
  /** 전체 페이지 수 */
  totalPage: Scalars['Int'];
};

/** 의약품 사전 상세 정보 */
export type MedicineDictionaryItemGraph = {
  additionalInfos: Array<Scalars['String']>;
  administrationInfo: AdministrationInfo;
  basicInfo: BasicInfo;
  classificationInfo: ClassificationInfo;
  companyInfo: CompanyInfo;
  formInfo: FormInfo;
  /** 약품 ID */
  id: Scalars['ID'];
  ingredientInfo: IngredientInfo;
  insuranceInfo: InsuranceInfo;
  medicineGuide: MedicineGuide;
  packagingInfo: PackagingInfo;
  /** 약품 public ID */
  publicId: Scalars['String'];
  storageInfo: StorageInfo;
};

export type MedicineDictionarySearchByCursorRequestInput = {
  /** 검색 키워드 */
  keyword?: InputMaybe<Scalars['String']>;
  /** 사이즈 */
  limit: Scalars['Int'];
  /** 피벗 검색 아이디 */
  pivotId?: InputMaybe<Scalars['String']>;
  /** 피벗 검색 점수 */
  pivotScore?: InputMaybe<Scalars['Float']>;
  /** 정렬 기준 */
  sortType?: InputMaybe<MedicineDictionarySortType>;
};

export type MedicineDictionarySearchRequestInput = {
  /** 검색 키워드 */
  keyword?: InputMaybe<Scalars['String']>;
  pagingRequest?: InputMaybe<PagingRequestInput>;
  /** 정렬 기준 */
  sortType?: InputMaybe<MedicineDictionarySortType>;
};

export type MedicineDictionarySitemapGraph = {
  /** ID */
  id: Scalars['ID'];
  /** 사이트맵 URL */
  sitemapUrl: Scalars['String'];
};

/** 의약품사전 사이트맵 */
export type MedicineDictionarySitemapPage = {
  /** 사이트맵 */
  elements: Array<MedicineDictionarySitemapGraph>;
  /** 전체 데이터 수 */
  totalCount: Scalars['Int'];
  /** 전체 페이지 수 */
  totalPage: Scalars['Int'];
};

export enum MedicineDictionarySortType {
  Name = 'NAME',
  Score = 'SCORE'
}

/** 약품 조제 가능성 */
export type MedicineDispensability = {
  dispensabilityStatus: MedicineDispensabilityStatus;
  iconImageUrl: Scalars['String'];
  medicineId: Scalars['ID'];
};

export enum MedicineDispensabilityStatus {
  CheckRequired = 'CHECK_REQUIRED',
  SoldBefore = 'SOLD_BEFORE',
  StockConfirmed = 'STOCK_CONFIRMED'
}

/** 복약정보와 약 요약정보 */
export type MedicineDoseDays = {
  /** 하루 복용량 수 */
  doseCountPerDay: Scalars['Int'];
  /** 복용일 수 */
  doseDays: Scalars['Int'];
  medicineSummary?: Maybe<MedicineSummary>;
  /** 1회 투여 용량 */
  singleDoseCapacity: Scalars['Float'];
};

export type MedicineFormattedContentGraph = {
  contents: Array<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type MedicineGraphV2 = {
  formattedMedicineName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  insuranceCode: Scalars['String'];
  insurancePrice?: Maybe<Scalars['Int']>;
  isBenefit: Scalars['Boolean'];
  mainIngredientCode?: Maybe<Scalars['String']>;
  medicineAttachmentId: Scalars['ID'];
  medicineName: Scalars['String'];
  treatmentMedicineId?: Maybe<Scalars['ID']>;
  unit: Scalars['String'];
};

/** 복약 정보 */
export type MedicineGuide = {
  /** 주의사항 HTML */
  cautionHtml: Scalars['String'];
  /** 복약 주의사항 */
  cautions: Array<Scalars['String']>;
  /** 용법·용량 HTML */
  dosageHtml: Scalars['String'];
  /** 복약 용법 */
  dosages: Array<Scalars['String']>;
  /** 효능·효과 HTML */
  indicationHtml: Scalars['String'];
  /** 복약 효능 */
  indications: Array<Scalars['String']>;
  /** 약물상호작용 HTML */
  interactionHtml: Scalars['String'];
  /** 복약 부작용 */
  sideEffects: Array<Scalars['String']>;
  /** 복약 보관법 */
  storages: Array<Scalars['String']>;
  /** 약품 관련 동영상 */
  videoLink: Scalars['String'];
  /** 복약 전체 요약 */
  wholeSummary: Array<Scalars['String']>;
};

export type MedicineInfoMutationRequestInput = {
  /** 약품 ID */
  medicineId: Scalars['ID'];
  /** 약품 가격 */
  medicinePrice?: InputMaybe<Scalars['Int']>;
  /** 약품 수량 */
  medicineUnit?: InputMaybe<Scalars['Int']>;
  /** 요청 약에 대한 원본 처방약품 ID */
  prescribedMedicineId: Scalars['ID'];
};

export type MedicinePictogramGraph = {
  description: Scalars['String'];
  imageUrl: Scalars['String'];
};

export enum MedicineStandardType {
  Box = 'BOX',
  Capsule = 'CAPSULE',
  Ea = 'EA',
  Pen = 'PEN',
  Tablet = 'TABLET',
  Tube = 'TUBE'
}

/** 약 요약정보 */
export type MedicineSummary = {
  /** 분류 코드명 */
  classificationCodeName: Scalars['String'];
  /** 효능 */
  counselingEfficacy: Scalars['String'];
  /** 상세 정보 여부 */
  hasDetailInfo: Scalars['Boolean'];
  /** 약 조제 가능성 */
  medicineDispensability: MedicineDispensability;
  /** 약품 ID */
  medicineId: Scalars['ID'];
  /** 약품 이미지 URL */
  medicineImageUrl: Scalars['String'];
  /** 약품명 */
  medicineName: Scalars['String'];
  /** 약효 한줄 요약 */
  pharmaceuticalEffectLiteracy: Scalars['String'];
  /** public ID */
  publicId: Scalars['String'];
  /** 처뱡량 */
  unit: Scalars['String'];
};


/** 약 요약정보 */
export type MedicineSummaryMedicineDispensabilityArgs = {
  isAlternativeExcluded?: InputMaybe<Scalars['Boolean']>;
};

export enum MedicineType {
  Counselor = 'COUNSELOR',
  Dentist = 'DENTIST',
  Doctor = 'DOCTOR',
  OrientalDoctor = 'ORIENTAL_DOCTOR'
}

/** 메딕터 유저 */
export type MediktorExternUser = {
  authToken: Scalars['String'];
  externUserId: Scalars['String'];
};

/** 메딕터 유저 조회 */
export type MediktorExternUserRequestInput = {
  /** device 고유값 */
  deviceId: Scalars['String'];
};

/** 유저 정보 */
export type MemberUser = {
  account: AccountGraph;
  /** accountId */
  accountId: Scalars['ID'];
  communityUser?: Maybe<CommunityUser>;
  /** 콘텐츠 알림 수신 동의 여부 */
  contentNotificationAllowed: Scalars['Boolean'];
  /** 생성일시 */
  createdAt: Scalars['DrTimestamp'];
  /** 유저 detail 정보 */
  detail?: Maybe<UserDetailGraph>;
  /** deviceId */
  deviceId?: Maybe<Scalars['String']>;
  /** 이메일 */
  email?: Maybe<Scalars['String']>;
  /** invitationCode */
  invitationCode?: Maybe<Scalars['String']>;
  /** 본인인증 여부 */
  isVerified: Scalars['Boolean'];
  /** 마케팅 알림 수신 동의 여부 */
  marketingReceiptAccepted: Scalars['Boolean'];
  /** 야간 마케팅 알림 수신 동의 여부 */
  nightlyMarketingReceiptAccepted: Scalars['Boolean'];
  /** 알림 수신 동의 여부 */
  notificationAllowed: Scalars['Boolean'];
  /** platform */
  platform: PlatformType;
  /** pushToken */
  pushToken?: Maybe<Scalars['String']>;
  /** 유저 아이디 */
  userId: Scalars['ID'];
};

export type MissionCompleteRequestInput = {
  /** 미션 Id */
  missionId: Scalars['ID'];
};

export type MissionGraph = {
  /** 미션 종료일 */
  endAt: Scalars['DrTimestamp'];
  /** 미션 Id */
  id: Scalars['ID'];
  /** 미션 완료 최대 횟수 */
  maxCount: Scalars['Int'];
  /** 미션 이름 */
  name: Scalars['String'];
  /** 미션 기간 (일/주/월/평생) */
  periodType: PeriodType;
  /** 티켓 수량 */
  quantity: Scalars['Int'];
  /** 미션 시작일 */
  startAt: Scalars['DrTimestamp'];
  /** 미션 완료를 위해 이동할 링크 */
  targetLink?: Maybe<Scalars['String']>;
  /** 티켓 타입 */
  ticketType: TicketType;
  /** 미션 타입 */
  type: MissionType;
  /** 미션 노출 여부 */
  visible: Scalars['Boolean'];
};

export type MissionRecordGraph = {
  /** 미션 완료일 */
  completedAt?: Maybe<Scalars['DrTimestamp']>;
  /** 미션 완료 횟수 */
  completionCount: Scalars['Int'];
  /** 미션 정보 */
  mission: MissionGraph;
  /** 미션 상태 */
  status: UserMissionStatus;
};

export enum MissionType {
  AdWatch = 'AD_WATCH',
  AttendanceCheck = 'ATTENDANCE_CHECK',
  MagazineRead = 'MAGAZINE_READ',
  PedometerLevel_1 = 'PEDOMETER_LEVEL_1',
  PedometerLevel_2 = 'PEDOMETER_LEVEL_2',
  PedometerLevel_3 = 'PEDOMETER_LEVEL_3',
  PedometerLevel_4 = 'PEDOMETER_LEVEL_4',
  PedometerLevel_5 = 'PEDOMETER_LEVEL_5',
  QnaRead = 'QNA_READ',
  QuizSolve = 'QUIZ_SOLVE',
  QuizSolve_1 = 'QUIZ_SOLVE_1',
  QuizSolve_4 = 'QUIZ_SOLVE_4',
  QuizSolve_6 = 'QUIZ_SOLVE_6',
  TodayMissionAllComplete = 'TODAY_MISSION_ALL_COMPLETE'
}

export type Mutation = {
  /** 대면진료 접수완료 */
  acceptFaceToFaceDiagnosis: Scalars['Boolean'];
  /** 병원 예약기능 활성화 */
  activateHospitalBooking: Scalars['Boolean'];
  /** 병원 당일예약 기능 활성화 */
  activateHospitalTodayBooking: Scalars['Boolean'];
  /** 답변 좋아요 등록 */
  addAnswerLike: Scalars['Boolean'];
  /**
   * 답변 좋아요 사유 등록
   * @deprecated 더 이상 사용하지 않는다.
   */
  addAnswerLikeReason: Scalars['Boolean'];
  /** 의사 즐겨찾기 추가 */
  addFamilyDoctor: Scalars['Boolean'];
  /** 의사 PublicId로 즐겨찾기 추가 */
  addFamilyDoctorsByDoctorPublicId: Scalars['Boolean'];
  /** 단골약국 등록 */
  addFavoritePharmacy: Scalars['Boolean'];
  /** 병원웹 푸시토큰 추가 */
  addHospitalPushToken: Scalars['Boolean'];
  /** 무료상담 새 질문 등록 */
  addQuestion: Scalars['Boolean'];
  /** 질문 좋아요 등록 */
  addQuestionLike: Scalars['Boolean'];
  /** 무료상담 새 질문 등록 */
  addQuestionV2: QuestionAdd;
  /** 간단 설문조사 등록 */
  addSimpleSurveyAnswer: Scalars['Boolean'];
  /** 약관 동의 / 비동의 처리 */
  approveAgreements: Scalars['Boolean'];
  /** 카카오페이 등록 2차 요청; 카카오페이 결제수단으로 최종 등록 */
  approveKakaopayRegistration: KakaopayRegistrationApprovalGraph;
  /** 커뮤니티 유저 제한(일수) */
  banCommunityUser: Scalars['Boolean'];
  /** AI 답변에 불만족 의견 표현하기 */
  beDissatisfiedWithAiAnswer: Scalars['Boolean'];
  /** AI 답변에 만족 의견 표현하기 */
  beSatisfiedWithAiAnswer: Scalars['Boolean'];
  /** 댓글 블라인드 처리 */
  blindBoardComment: BlindBoardCommentResult;
  /** only 댓글 블라인드 */
  blindBoardCommentOnly: Scalars['Boolean'];
  /** 게시글 블라인드 처리 */
  blindBoardPost: BlindBoardPostResult;
  /** 첨부파일 블라인드 처리 */
  blindBoardPostAttachment: Scalars['Boolean'];
  /** only 게시글 블라인드 */
  blindBoardPostOnly: Scalars['Boolean'];
  /** 푸시 알림 여러 건 확인 */
  bulkCheckPushNotifications: Scalars['Boolean'];
  /** 상담 취소 */
  cancelCounseling: Scalars['Boolean'];
  /** 유저에 의한 진료 취소 */
  cancelDiagnosisByUser: Scalars['Boolean'];
  /** 대면진료 취소 */
  cancelFaceToFaceDiagnosis: Scalars['Boolean'];
  /** (병원) 문진표 요청 취소 */
  cancelHistoryTakingRequestByHospital: Scalars['Boolean'];
  /** 진료 아이디로 주문 유저 취소 */
  cancelOrderByUserDiagnosis: Scalars['Boolean'];
  /** 제휴 방문수령 주문 유저 취소 */
  cancelPartnershipPickupOrderByUser: Scalars['Boolean'];
  /** 맞춤형 건기식 구독 취소 */
  cancelPersonalizedNutritionSubscription: Scalars['Boolean'];
  /** 방문수령 주문 유저 취소 */
  cancelPickupOrderByUser: Scalars['Boolean'];
  /** 퀴즈 도전 */
  challengeQuiz: QuizChallengeResult;
  /** 유저 진료 예약 변경 */
  changeDiagnosisBooking: Scalars['Boolean'];
  /** 약국 재선택 사유 추가 */
  changePharmacySelection: Scalars['Boolean'];
  /** 유저 비밀번호 변경 */
  changeUserPassword: Scalars['Boolean'];
  /** 대면진료 읽음처리 */
  checkFaceToFaceDiagnosis: Scalars['Boolean'];
  /** 문진표 확인 */
  checkHistoryTaking: Scalars['Boolean'];
  /** 유저 위치 의료취약지 여부 */
  checkMedicalWeakRegionByUserLocation: Scalars['Boolean'];
  /** 푸시 알림 단건 확인 */
  checkPushNotificationById: Scalars['Boolean'];
  /** 온보딩(튜토리얼) 완료로 변경 */
  completeCommunityUserTutorial: Scalars['Boolean'];
  /** 대면진료 완료 */
  completeFaceToFaceDiagnosis: Scalars['Boolean'];
  /** 게임 상품 수령 */
  completeMission: Scalars['Boolean'];
  /** 유저 약 수령 완료 */
  completeOrderByUser: Scalars['Boolean'];
  completePedometerMission: Scalars['Boolean'];
  /** 설문 완료 */
  completeSurvey: Scalars['Boolean'];
  /** 병원 제휴완료(인증정보 확인) */
  confirmHospitalPartnership: Scalars['Boolean'];
  /** 피드백 생성 */
  createFeedback: Scalars['Boolean'];
  /**
   * 약국 영수증 리뷰 작성 (Deprecated: createPharmacyReview 사용 권장)
   * @deprecated Use createPharmacyReview with PharmacyReviewCreateRequestV2 instead, replace with createPharmacyReview
   */
  createPharmacyReceiptReviewAndEarnPoint: PharmacyReceiptReviewCreateResponse;
  /**
   * 약국 리뷰 작성 (Deprecated: createPharmacyReview 사용 권장)
   * @deprecated Use createPharmacyReview with PharmacyReviewCreateRequestV2 instead, replace with createPharmacyReview
   */
  createPharmacyReview: Scalars['Boolean'];
  /** 약국 리뷰 작성 V2 (영수증 정보가 있는 경우 포인트 적립) */
  createPharmacyReviewV2: Scalars['Boolean'];
  /** 상담 답변 리뷰 등록 */
  createQnaAnswerReview: Scalars['Boolean'];
  /** 만족도 등록 */
  createSatisfaction: Scalars['Boolean'];
  /** 인증 토큰 발급 */
  createVerification: Scalars['Boolean'];
  /** 병원 예약기능 비활성화 */
  deactivateHospitalBooking: Scalars['Boolean'];
  /** 병원 당일예약 기능 비활성화 */
  deactivateHospitalTodayBooking: Scalars['Boolean'];
  /**
   * AI 답변 수락여부 결정
   * @deprecated beSatisfiedWithAiAnswer, beDissatisfiedWithAiAnswer로 대체
   */
  decideAiAnswer: Scalars['Boolean'];
  /** 답변 좋아요 삭제 */
  deleteAnswerLike: Scalars['Boolean'];
  /** 댓글 삭제 */
  deleteBoardComment: Scalars['Boolean'];
  /** 게시글 삭제 */
  deleteBoardPost: Scalars['Boolean'];
  /** 가족 구성원 삭제 */
  deleteFamily: Scalars['Boolean'];
  /** 건강 기록 삭제 */
  deleteHealthRecord: Scalars['Boolean'];
  /** 병원웹 프로필 이미지 삭제 */
  deleteHospitalProfileImage: Scalars['Boolean'];
  /** 건강매거진 좋아요 삭제 */
  deleteMagazineLike: Scalars['Boolean'];
  /** 질문 좋아요 삭제 */
  deleteQuestionLike: Scalars['Boolean'];
  /** 리뷰 삭제 */
  deleteReview: Scalars['Boolean'];
  /** 유저 주소 삭제 */
  deleteUserAddress: Scalars['Boolean'];
  /** 닥터나우 로그인 요청 */
  doctornowSignIn: AuthToken;
  /** 회원가입 doctornow */
  doctornowSignUp: LoginResponse;
  /** 게임 상품 당첨 */
  drawPrize: PrizeDrawGraph;
  /** 건강기록 포인트 */
  earnHealthRecordPoint: Scalars['Boolean'];
  /** 복약 기록 포인트 적립 요청 */
  earnPointByDoseRecord: Scalars['Boolean'];
  /** 웰컴 포인트 획득 */
  earnWelcomePoint: EarnWelcomePoint;
  /** 대면의사 진료 불가능 상태로 업데이트 */
  faceToFaceDoctorBeAbsent: Scalars['Boolean'];
  /** 대면의사 진료 가능 상태로 업데이트 */
  faceToFaceDoctorBePresent: Scalars['Boolean'];
  /** 의사의 휴게시간 변경 */
  faceToFaceDoctorBreakTimes: Scalars['Boolean'];
  /** 의사의 운영시간 변경 */
  faceToFaceDoctorOperatingTimes: Scalars['Boolean'];
  /** 의사의 정기휴일 설정 */
  faceToFaceDoctorRegularHolidays: Scalars['Boolean'];
  /** 의사의 임시휴일 설정 */
  faceToFaceDoctorTemporaryHolidays: Scalars['Boolean'];
  /** 병원별 전체 대면의사 일괄 진료 불가능 상태로 업데이트 */
  faceToFaceDoctorsBeAbsent: Scalars['Boolean'];
  /** 병원별 전체 대면의사 일괄 진료 가능 상태로 업데이트 */
  faceToFaceDoctorsBePresent: Scalars['Boolean'];
  /** 아이디 찾기 */
  findUsername: FindUsernameResponse;
  /** AI 답변 생성 요청 */
  generateAiAnswer: Scalars['Boolean'];
  /** NICE 휴대폰 본인인증 데이터 요청 */
  getNiceVerificationRequestData: NiceRequestData;
  /** 비밀번호 변경 임시 토큰 발급 */
  getTemporaryToken: Scalars['String'];
  /** 광고 노출 처리 */
  handleAdExposure: Scalars['Boolean'];
  /** NICE 휴대폰 본인인증 결과 적용 */
  handleNiceResult: Scalars['Boolean'];
  /** 유저에 의한 비대면 진료 영상 통화 종료 */
  hangUpNonFaceToFaceDiagnosisCallByUser: Scalars['Boolean'];
  /** 유저 진료 숨기기 */
  hideDiagnosis: Scalars['Boolean'];
  /** 병원의 휴게시간 변경 */
  hospitalBreakTimes: Scalars['Boolean'];
  /** 병원의 운영시간 변경 */
  hospitalOperatingTimes: Scalars['Boolean'];
  /** 병원의 정기휴일 설정 */
  hospitalRegularHolidays: Scalars['Boolean'];
  /** 병원의 임시휴일 설정 */
  hospitalTemporaryHolidays: Scalars['Boolean'];
  /**
   * 주문 즉시 결제
   * @deprecated use immediatePayOrderV2 instead
   */
  immediatePayOrder: Scalars['Boolean'];
  /** 주문 즉시 결제 */
  immediatePayOrderV2: Scalars['Boolean'];
  /** 건강매거진 좋아요 등록 */
  insertMagazineLike: Scalars['Boolean'];
  /** 유저 초대 코드 발급 */
  issueInvitationCodeByUserInviter: IssueInvitationCode;
  /** 포인트 쿠폰 발급 */
  issuePointCoupon: Scalars['Boolean'];
  /** 탈퇴 요청 */
  leave: Scalars['Boolean'];
  /** 댓글 좋아요 */
  likeBoardComment: Scalars['Boolean'];
  /** 게시글 좋아요 */
  likeBoardPost: Scalars['Boolean'];
  /** 리뷰 좋아요 */
  likeReview: Scalars['Boolean'];
  /** 질문 공개범위 나에게만 공개로 변경 */
  makeQuestionPrivate: Scalars['Boolean'];
  /** 퀴즈 풀 수 있는 상태로 변경 */
  makeQuizSolvable: Scalars['Boolean'];
  /** 복약 기록 표시 */
  markDoseState: Scalars['Boolean'];
  /** 약국 선택 매칭 요청 */
  matchSelectedPharmacy: Scalars['Boolean'];
  /** 약국 선택 매칭 요청 v2 (예약 포함) */
  matchSelectedPharmacyWithReservation: Scalars['Boolean'];
  /** 가족 구성원 수정 */
  modifyFamily: Scalars['Boolean'];
  /** 유저 주소 변경 */
  modifyUserAddress: Scalars['Boolean'];
  /** 네이버 액세스 토큰 발급 */
  naverOAuthAccessToken: NaverAccessToken;
  /** 대면진료 환자 알림(호출) */
  notifyToPatient: Scalars['Boolean'];
  /** 유저 로그인(oauth) */
  oAuthSignIn: AuthToken;
  /** 유저 로그인 및 유저 정보 조회 */
  oAuthSignInWithUser: LoginResponse;
  /** 회원가입 oAuth */
  oAuthSignUp: LoginResponse;
  /** 영수증 분석 결과 조회 */
  parseReceipt: PharmacyReceipt;
  /** 알림 설정 변경 */
  patchNotification: Scalars['Boolean'];
  /**
   * 주문(조제비+배송비), 추가주문( 결제
   * @deprecated User payOrderV2 instead
   */
  payAllOrder: Scalars['Boolean'];
  /** 유저 진료 수동결제 */
  payDiagnosisByUser: Scalars['Boolean'];
  /** 주문(조제비+배송비) 결제 */
  payOrder: Scalars['Boolean'];
  /** 주문(조제비+배송비), 추가주문( 결제 */
  payOrderV2: Scalars['Boolean'];
  /** 실시간 상담 질문 결제 */
  payQuestion: Scalars['Boolean'];
  /** 도매 주문 결제 */
  payWholesaleOrder: Scalars['Boolean'];
  /** 대댓글 등록 */
  postBoardCommentOfBoardComment: Scalars['Boolean'];
  /** 댓글 등록 */
  postBoardCommentOfBoardPost: Scalars['Boolean'];
  /** 게시글 등록 */
  postBoardPost: BoardPost;
  /** 카카오페이 등록 1차 요청; 2차 요청에 필요한 transactionId & 카카오페이 등록 후 redirectUrl 반환 */
  readyKakaopayRegistration: KakaopayRegistrationReady;
  /** 대면진료 접수 */
  receiptFaceToFaceDiagnosis: Scalars['Boolean'];
  /** 게임 상품 수령 */
  receivePrize: Scalars['Boolean'];
  /** 혈압 기록 */
  recordBloodPressureInfo: Scalars['Boolean'];
  /** 혈당 기록 */
  recordBloodSugarInfo: Scalars['Boolean'];
  /** 신체 정보 기록 */
  recordBodyInfo: Scalars['Boolean'];
  /** 신체 정보 기록 */
  recordBodyMeasurement: Scalars['Boolean'];
  /** 가족 구성원 추가 */
  registerFamily: Scalars['Boolean'];
  /** 유저 주소 추가 */
  registerUserAddress: Scalars['Boolean'];
  /** 유저 비대면진료 대상군 등록 */
  registerUserAsTelemedicineEligibleGroup: Scalars['Boolean'];
  /** 가족 비대면진료 대상군 등록 */
  registerUserFamilyAsTelemedicineEligibleGroup: Scalars['Boolean'];
  registerUserPayment: UserPaymentRegisterGraph;
  /** 상담 전화 거절 */
  rejectCounselingCallByUser: Scalars['Boolean'];
  /** 비대면 진료 영상 통화 수신 거절 */
  rejectNonFaceToFaceDiagnosisCallByUser: Scalars['Boolean'];
  /** 약국 선택 재매칭 요청 */
  rematchSelectedPharmacy: Scalars['Boolean'];
  /** 의사 즐겨찾기 제거 */
  removeFamilyDoctors: Scalars['Boolean'];
  /** 단골약국 제거 */
  removeFavoritePharmacy: Scalars['Boolean'];
  /** 실시간 상담 질문 재결제 */
  repayQuestion: Scalars['Boolean'];
  /** 답변 신고 */
  reportAnswer: Scalars['Boolean'];
  /** 댓글 신고 */
  reportBoardComment: Scalars['Boolean'];
  /** 게시글 신고 */
  reportBoardPost: Scalars['Boolean'];
  /** 질문 신고 */
  reportQuestion: Scalars['Boolean'];
  /** 리뷰 신고, 사용자 신고 */
  reportReview: Scalars['Boolean'];
  /** 상담 요청 */
  requestCounseling: Scalars['Boolean'];
  /** 유저 진료 요청 V2 */
  requestDiagnosisV2: Scalars['Boolean'];
  /** 약국 팩스 방문수령 조제 요청 */
  requestDispensationToPharmacy: Scalars['Boolean'];
  /** 건강보험 스크래핑 데이터 요청 */
  requestHealthInsuranceInfo: Scalars['Boolean'];
  /** 건강보험 스크래핑 간편인증 요청 */
  requestHealthInsuranceSimpleAuth: Scalars['Boolean'];
  /** 제휴약국 방문수령 조제 요청 V2 */
  requestPartnershipPickupDispensationV2: Scalars['Boolean'];
  /** 제휴약국 방문수령 조제 요청 V3 */
  requestPartnershipPickupDispensationV3: Scalars['Boolean'];
  /** 비그로인 유저 포함 디바이스 정보 저장 요청 */
  requestToSaveDeviceInfo: Scalars['Boolean'];
  /** 유저 비밀번호 리셋 */
  resetUserPassword: Scalars['Boolean'];
  /** 건강 결과 리포트(결과지) 저장 */
  saveHealthAnalysisReport: Scalars['Boolean'];
  saveUserReasonForLeaving: Scalars['Boolean'];
  /** 유저 기본 주소 설정 */
  setUserDefaultAddress: Scalars['Boolean'];
  /** 회원 로그아웃 */
  signOut: Scalars['Boolean'];
  /** 병원 회원가입 */
  signUpHospital: Scalars['Boolean'];
  /** 약국의 결제 요청을 스킵하기 */
  skipOrderByUser: Scalars['Boolean'];
  /** 검색 결과 피드백 접수 */
  submitSearchResultFeedback: Scalars['Boolean'];
  /** 맞춤형 건기식 구독 요청 (결제 포함) */
  subscribePersonalizedNutrition: Scalars['Boolean'];
  /** token refresh 요청 */
  tokenRefresh: AuthToken;
  /** 상담 예약 다찼을 때 알림 켜기 */
  turnOnFullyBookingRemind: Scalars['Boolean'];
  /** 댓글 좋아요 취소 */
  unlikeBoardComment: Scalars['Boolean'];
  /** 게시글 좋아요 취소 */
  unlikeBoardPost: Scalars['Boolean'];
  /** 리뷰 좋아요 취소 */
  unlikeReview: Scalars['Boolean'];
  /** 복약 기록 표시 제거 */
  unmarkDoseState: Scalars['Boolean'];
  /** 커뮤니티 유저 닉네임 변경 */
  updateCommunityUserNickname: Scalars['Boolean'];
  /** 커뮤니티 질문에 대한 답변 푸시 여부 수정 */
  updateCommunityUserPostCommentNotificationAllowed: Scalars['Boolean'];
  /** 커뮤니티 질문에 대한 좋아요 푸시 여부 수정 */
  updateCommunityUserPostLikeNotificationAllowed: Scalars['Boolean'];
  /** 커뮤니티 유저 프로필 이미지 변경 */
  updateCommunityUserProfileImagePath: Scalars['Boolean'];
  /** 무물보 질문에 대한 답변 푸시 여부 수정 */
  updateCommunityUserQnaAnswerNotificationAllowed: Scalars['Boolean'];
  /** 건강 결과 리포트(결과지) 업데이트 */
  updateHealthAnalysisReport: Scalars['Boolean'];
  /** (병원) 문진표 업데이트 */
  updateHistoryTakingByHospital: Scalars['Boolean'];
  /** (환자) 문진표 업데이트 */
  updateHistoryTakingByPatient: Scalars['Boolean'];
  /** 인증 정보 업데이트(+ 병원 제휴 대기) */
  updateHospitalAuthorizationInfo: Scalars['Boolean'];
  /** 병원웹 기본정보 수정 */
  updateHospitalBasicInformation: Scalars['Boolean'];
  /** 병원 진료과목, 태그 수정 */
  updateHospitalDepartmentGroupTags: Scalars['Boolean'];
  /** 병원웹 병원소개 수정 */
  updateHospitalIntroduction: Scalars['Boolean'];
  /** 맞춤형 건기식 구독 업데이트 */
  updatePersonalizedNutritionSubscription: Scalars['Boolean'];
  /** 유저 토큰 정보 저장 */
  updatePushToken: Scalars['Boolean'];
  /** 질문의 위치 정보 수정 */
  updateQuestionLocation: Scalars['Boolean'];
  /** 유저 최근 접속 정보 저장 */
  updateRecentConnectionLocation: Scalars['Boolean'];
  /** 병원웹 대표 프로필 이미지 변경 */
  updateRepresentativeProfileImage: Scalars['Boolean'];
  /** 유저 가입경로 입력 */
  updateSignupPath: Scalars['Boolean'];
  /** 병원웹 프로필 이미지 업로드 */
  uploadHospitalProfileImage: Scalars['Boolean'];
  /** 대상 ID 블럭 (이미 블럭되어 있으면 블럭 해제) */
  upsertBlockingAccount: Scalars['Boolean'];
  /** 병원 비급여 정보 등록 및 수정 */
  upsertHospitalNonBenefitItems: Scalars['Boolean'];
  /** 유저 초대 코드 사용 */
  useInvitationCode: UseInvitationCode;
  /** 토큰 인증 */
  verify: Scalars['Boolean'];
};


export type MutationAcceptFaceToFaceDiagnosisArgs = {
  faceToFaceDiagnosisId: Scalars['ID'];
};


export type MutationAddAnswerLikeArgs = {
  request: AnswerLikeRequestInput;
};


export type MutationAddAnswerLikeReasonArgs = {
  request: AnswerLikeReasonAddRequestInput;
};


export type MutationAddFamilyDoctorArgs = {
  doctorId: Scalars['ID'];
};


export type MutationAddFamilyDoctorsByDoctorPublicIdArgs = {
  doctorPublicId: Scalars['ID'];
};


export type MutationAddFavoritePharmacyArgs = {
  pharmacyId: Scalars['ID'];
};


export type MutationAddHospitalPushTokenArgs = {
  pushToken: Scalars['String'];
};


export type MutationAddQuestionArgs = {
  request: QuestionAddRequestInput;
};


export type MutationAddQuestionLikeArgs = {
  questionPid: Scalars['ID'];
};


export type MutationAddQuestionV2Args = {
  request: QuestionAddRequestInput;
};


export type MutationAddSimpleSurveyAnswerArgs = {
  request: SimpleSurveyAnswerAddRequestInput;
};


export type MutationApproveAgreementsArgs = {
  request: AgreementsApprovedApiRequestInput;
};


export type MutationApproveKakaopayRegistrationArgs = {
  request: KakaopayRegistrationRequestInput;
};


export type MutationBanCommunityUserArgs = {
  request: BanCommunityUserRequestInput;
};


export type MutationBeDissatisfiedWithAiAnswerArgs = {
  request: BeDissatisfiedWithAiAnswerRequestInput;
};


export type MutationBeSatisfiedWithAiAnswerArgs = {
  request: BeSatisfiedWithAiAnswerRequestInput;
};


export type MutationBlindBoardCommentArgs = {
  boardCommentPid: Scalars['ID'];
};


export type MutationBlindBoardCommentOnlyArgs = {
  boardCommentPid: Scalars['ID'];
};


export type MutationBlindBoardPostArgs = {
  boardPostPid: Scalars['ID'];
};


export type MutationBlindBoardPostAttachmentArgs = {
  blindType: AttachmentBlindType;
  boardPostAttachmentId: Scalars['ID'];
};


export type MutationBlindBoardPostOnlyArgs = {
  boardPostPid: Scalars['ID'];
};


export type MutationBulkCheckPushNotificationsArgs = {
  request: PushNotificationBulkCheckMutationRequestInput;
};


export type MutationCancelCounselingArgs = {
  counselingId: Scalars['ID'];
  reason: CounselingCancelReason;
};


export type MutationCancelDiagnosisByUserArgs = {
  request: UserDiagnosisCancelMutationRequestInput;
};


export type MutationCancelFaceToFaceDiagnosisArgs = {
  faceToFaceDiagnosisId: Scalars['ID'];
};


export type MutationCancelHistoryTakingRequestByHospitalArgs = {
  historyTakingId: Scalars['ID'];
};


export type MutationCancelOrderByUserDiagnosisArgs = {
  request: CancelOrderByUserDiagnosisMutationRequestInput;
};


export type MutationCancelPartnershipPickupOrderByUserArgs = {
  request: CancelPartnershipPickupOrderByUserMutationRequestInput;
};


export type MutationCancelPersonalizedNutritionSubscriptionArgs = {
  request: PersonalizedNutritionSubscriptionCancelRequestInput;
};


export type MutationCancelPickupOrderByUserArgs = {
  request: CancelPickupOrderByUserMutationRequestInput;
};


export type MutationChallengeQuizArgs = {
  request: PostUserQuizAnswerRequestInput;
};


export type MutationChangeDiagnosisBookingArgs = {
  request: DiagnosisBookingChangeMutationRequestInput;
};


export type MutationChangePharmacySelectionArgs = {
  request: PharmacySelectionChangeRequestInput;
};


export type MutationChangeUserPasswordArgs = {
  request: UserPasswordChangeMutationRequestInput;
};


export type MutationCheckFaceToFaceDiagnosisArgs = {
  faceToFaceDiagnosisId: Scalars['ID'];
};


export type MutationCheckHistoryTakingArgs = {
  historyTakingId: Scalars['ID'];
};


export type MutationCheckMedicalWeakRegionByUserLocationArgs = {
  request: LocationMutationRequestInput;
};


export type MutationCheckPushNotificationByIdArgs = {
  request: PushNotificationCheckMutationRequestInput;
};


export type MutationCompleteFaceToFaceDiagnosisArgs = {
  faceToFaceDiagnosisId: Scalars['ID'];
};


export type MutationCompleteMissionArgs = {
  request: MissionCompleteRequestInput;
};


export type MutationCompleteOrderByUserArgs = {
  request: OrderCompleteByUserMutationRequestInput;
};


export type MutationCompletePedometerMissionArgs = {
  request: PedometerCompleteMissionRequestInput;
};


export type MutationCompleteSurveyArgs = {
  request: SurveyCompleteRequestInput;
};


export type MutationConfirmHospitalPartnershipArgs = {
  hospitalId: Scalars['ID'];
};


export type MutationCreateFeedbackArgs = {
  request: FeedbackCreateRequestInput;
};


export type MutationCreatePharmacyReceiptReviewAndEarnPointArgs = {
  request: PharmacyReceiptReviewCreateRequestInput;
};


export type MutationCreatePharmacyReviewArgs = {
  request: PharmacyReviewCreateRequestInput;
};


export type MutationCreatePharmacyReviewV2Args = {
  request: PharmacyReviewCreateMutationRequestInput;
};


export type MutationCreateQnaAnswerReviewArgs = {
  request: QnaAnswerReviewCreateRequestInput;
};


export type MutationCreateSatisfactionArgs = {
  satisfactionMutationRequest: SatisfactionMutationRequestInput;
};


export type MutationCreateVerificationArgs = {
  mutationRequest: CreateVerificationMutationRequestInput;
};


export type MutationDecideAiAnswerArgs = {
  request: DecideAiAnswerRequestInput;
};


export type MutationDeleteAnswerLikeArgs = {
  answerPid: Scalars['ID'];
};


export type MutationDeleteBoardCommentArgs = {
  boardCommentPid: Scalars['ID'];
};


export type MutationDeleteBoardPostArgs = {
  boardPostPid: Scalars['ID'];
};


export type MutationDeleteFamilyArgs = {
  familyId: Scalars['ID'];
};


export type MutationDeleteHealthRecordArgs = {
  deleteHealthRecordMutationRequest: DeleteHealthRecordMutationRequestInput;
};


export type MutationDeleteHospitalProfileImageArgs = {
  profileImageId: Scalars['ID'];
};


export type MutationDeleteMagazineLikeArgs = {
  magazinePid: Scalars['ID'];
};


export type MutationDeleteQuestionLikeArgs = {
  questionPid: Scalars['ID'];
};


export type MutationDeleteReviewArgs = {
  reviewId: Scalars['ID'];
};


export type MutationDeleteUserAddressArgs = {
  addressId: Scalars['ID'];
};


export type MutationDoctornowSignInArgs = {
  password: Scalars['String'];
  roleType: RoleType;
  userName: Scalars['String'];
};


export type MutationDoctornowSignUpArgs = {
  request: DoctornowSignUpUserRequestInput;
};


export type MutationDrawPrizeArgs = {
  request: PrizeDrawRequestInput;
};


export type MutationEarnPointByDoseRecordArgs = {
  eventDate: Scalars['String'];
  pointMissionCode: DoseRecordPointMissionCode;
};


export type MutationFaceToFaceDoctorBeAbsentArgs = {
  faceToFaceDoctorId: Scalars['ID'];
};


export type MutationFaceToFaceDoctorBePresentArgs = {
  faceToFaceDoctorId: Scalars['ID'];
};


export type MutationFaceToFaceDoctorBreakTimesArgs = {
  doctorBreakTimeChangeRequests: Array<FaceToFaceDoctorBreakTimeChangeApiRequestInput>;
  doctorId: Scalars['ID'];
};


export type MutationFaceToFaceDoctorOperatingTimesArgs = {
  doctorId: Scalars['ID'];
  doctorOperatingTimeChangeRequests: Array<FaceToFaceDoctorOperatingTimeChangeRequestInput>;
};


export type MutationFaceToFaceDoctorRegularHolidaysArgs = {
  dayOfWeeks: Array<DayOfWeekType>;
  doctorId: Scalars['ID'];
};


export type MutationFaceToFaceDoctorTemporaryHolidaysArgs = {
  dates: Array<Scalars['String']>;
  doctorId: Scalars['ID'];
};


export type MutationFindUsernameArgs = {
  mutationRequest: FindUsernameMutationRequestInput;
};


export type MutationGenerateAiAnswerArgs = {
  request: GenerateAiAnswerRequestInput;
};


export type MutationGetNiceVerificationRequestDataArgs = {
  returnUrl: Scalars['String'];
};


export type MutationGetTemporaryTokenArgs = {
  request: TemporaryTokenMutationRequestInput;
};


export type MutationHandleAdExposureArgs = {
  request: AdExposureHandleMutationRequestInput;
};


export type MutationHandleNiceResultArgs = {
  request: NiceHandleResultRequestInput;
};


export type MutationHangUpNonFaceToFaceDiagnosisCallByUserArgs = {
  request: NonFaceToFaceDiagnosisCallHangUpRequestInput;
};


export type MutationHideDiagnosisArgs = {
  diagnosisId: Scalars['ID'];
};


export type MutationHospitalBreakTimesArgs = {
  hospitalBreakTimeChangeApiRequests: Array<HospitalBreakTimeChangeApiRequestInput>;
};


export type MutationHospitalOperatingTimesArgs = {
  hospitalOperatingTimeChangeRequests: Array<HospitalOperatingTimeChangeRequestInput>;
};


export type MutationHospitalRegularHolidaysArgs = {
  dayOfWeeks: Array<DayOfWeekType>;
};


export type MutationHospitalTemporaryHolidaysArgs = {
  dates: Array<Scalars['String']>;
};


export type MutationImmediatePayOrderArgs = {
  request: OrderImmediatePayRequestInput;
};


export type MutationImmediatePayOrderV2Args = {
  request: OrderImmediatePayV2RequestInput;
};


export type MutationInsertMagazineLikeArgs = {
  magazinePid: Scalars['ID'];
};


export type MutationIssueInvitationCodeByUserInviterArgs = {
  mutationRequest: IssueInvitationCodeMutationRequestInput;
};


export type MutationIssuePointCouponArgs = {
  pointCouponIssueApiRequest: PointCouponIssueApiRequestInput;
};


export type MutationLikeBoardCommentArgs = {
  boardCommentPid: Scalars['ID'];
};


export type MutationLikeBoardPostArgs = {
  boardPostPid: Scalars['ID'];
};


export type MutationLikeReviewArgs = {
  reviewId: Scalars['ID'];
};


export type MutationMakeQuestionPrivateArgs = {
  request: QuestionMakePrivateRequestInput;
};


export type MutationMakeQuizSolvableArgs = {
  request: MakeQuizSolvableRequestInput;
};


export type MutationMarkDoseStateArgs = {
  doseStateId: Scalars['ID'];
};


export type MutationMatchSelectedPharmacyArgs = {
  request: SelectMatchRequestInput;
};


export type MutationMatchSelectedPharmacyWithReservationArgs = {
  request: SelectMatchRequestInput;
};


export type MutationModifyFamilyArgs = {
  familyId: Scalars['ID'];
  request: FamilyModifyMutationRequestInput;
};


export type MutationModifyUserAddressArgs = {
  request: UserAddressModifyRequestInput;
};


export type MutationNaverOAuthAccessTokenArgs = {
  code: Scalars['String'];
  state: Scalars['String'];
};


export type MutationNotifyToPatientArgs = {
  patientNotificationMutationRequest: PatientNotificationMutationRequestInput;
};


export type MutationOAuthSignInArgs = {
  request: OauthSignInUserRequestInput;
};


export type MutationOAuthSignInWithUserArgs = {
  request: OauthSignInUserRequestInput;
};


export type MutationOAuthSignUpArgs = {
  request: OauthSignUpUserRequestInput;
};


export type MutationParseReceiptArgs = {
  request: ReceiptParsingRequestInput;
};


export type MutationPatchNotificationArgs = {
  request: PatchNotificationRequestInput;
};


export type MutationPayAllOrderArgs = {
  request: AllOrderPayRequestInput;
};


export type MutationPayDiagnosisByUserArgs = {
  request: DiagnosisPayByUserMutationRequestInput;
};


export type MutationPayOrderArgs = {
  request: OrderPayRequestInput;
};


export type MutationPayOrderV2Args = {
  request: OrderPayV2RequestInput;
};


export type MutationPayQuestionArgs = {
  request: PayQuestionRequestInput;
};


export type MutationPayWholesaleOrderArgs = {
  request: WholesaleOrderPayRequestInput;
};


export type MutationPostBoardCommentOfBoardCommentArgs = {
  request: PostBoardCommentOfBoardCommentRequestInput;
};


export type MutationPostBoardCommentOfBoardPostArgs = {
  request: PostBoardCommentOfBoardPostRequestInput;
};


export type MutationPostBoardPostArgs = {
  request: PostBoardPostRequestInput;
};


export type MutationReceiptFaceToFaceDiagnosisArgs = {
  faceToFaceDiagnosisReceiptMutationRequest: FaceToFaceDiagnosisReceiptMutationRequestInput;
};


export type MutationReceivePrizeArgs = {
  request: PrizeReceiveRequestInput;
};


export type MutationRecordBloodPressureInfoArgs = {
  bloodPressureRecordMutationRequest: BloodPressureRecordMutationRequestInput;
};


export type MutationRecordBloodSugarInfoArgs = {
  bloodSugarRecordMutationRequest: BloodSugarRecordMutationRequestInput;
};


export type MutationRecordBodyInfoArgs = {
  bodyInfoRecordMutationRequest: BodyInfoRecordMutationRequestInput;
};


export type MutationRecordBodyMeasurementArgs = {
  bodyMeasurementRecordMutationRequest: BodyMeasurementRecordMutationRequestInput;
};


export type MutationRegisterFamilyArgs = {
  request: FamilyRegisterMutationRequestInput;
};


export type MutationRegisterUserAddressArgs = {
  request: UserAddressRegisterRequestInput;
};


export type MutationRegisterUserAsTelemedicineEligibleGroupArgs = {
  request: UserTelemedicineEligibleGroupRegisterMutationRequestInput;
};


export type MutationRegisterUserFamilyAsTelemedicineEligibleGroupArgs = {
  request: FamilyTelemedicineEligibleGroupRegisterMutationRequestInput;
};


export type MutationRegisterUserPaymentArgs = {
  request: UserPaymentRegisterRequestInput;
};


export type MutationRejectCounselingCallByUserArgs = {
  counselingId: Scalars['ID'];
};


export type MutationRejectNonFaceToFaceDiagnosisCallByUserArgs = {
  request: NonFaceToFaceDiagnosisCallRejectRequestInput;
};


export type MutationRematchSelectedPharmacyArgs = {
  request: PharmacyRematchMutationRequestInput;
};


export type MutationRemoveFamilyDoctorsArgs = {
  request: DeleteFamilyDoctorMutationRequestInput;
};


export type MutationRemoveFavoritePharmacyArgs = {
  pharmacyId: Scalars['ID'];
};


export type MutationRepayQuestionArgs = {
  request: RepayQuestionRequestInput;
};


export type MutationReportAnswerArgs = {
  request: AnswerReportRequestInput;
};


export type MutationReportBoardCommentArgs = {
  request: ReportBoardCommentRequestInput;
};


export type MutationReportBoardPostArgs = {
  request: ReportBoardPostRequestInput;
};


export type MutationReportQuestionArgs = {
  request: QuestionReportRequestInput;
};


export type MutationRequestCounselingArgs = {
  request: CounselingRegisterRequestInput;
};


export type MutationRequestDiagnosisV2Args = {
  request: DiagnosisRegistrationRequestV2Input;
};


export type MutationRequestDispensationToPharmacyArgs = {
  request: DispensationPharmacyFaxRequestInput;
};


export type MutationRequestHealthInsuranceSimpleAuthArgs = {
  healthInsuranceSimpleAuthMutationRequest: HealthInsuranceSimpleAuthMutationRequestInput;
};


export type MutationRequestPartnershipPickupDispensationV2Args = {
  request: PartnershipPickupDispensationMutationRequestV2Input;
};


export type MutationRequestPartnershipPickupDispensationV3Args = {
  request: PartnershipPickupDispensationMutationRequestV3Input;
};


export type MutationRequestToSaveDeviceInfoArgs = {
  request: DeviceInfoSaveMutationRequestInput;
};


export type MutationResetUserPasswordArgs = {
  newPassword: Scalars['String'];
};


export type MutationSaveHealthAnalysisReportArgs = {
  request: HealthAnalysisReportSaveRequestInput;
};


export type MutationSaveUserReasonForLeavingArgs = {
  request: UserReasonForLeavingSaveRequestInput;
};


export type MutationSetUserDefaultAddressArgs = {
  addressId: Scalars['ID'];
};


export type MutationSignOutArgs = {
  request: AccountSignOutMutationRequestInput;
};


export type MutationSignUpHospitalArgs = {
  request: HospitalSignUpMutationRequestInput;
};


export type MutationSkipOrderByUserArgs = {
  request: SkipOrderByUserMutationRequestInput;
};


export type MutationSubmitSearchResultFeedbackArgs = {
  request: SearchResultFeedbackSubmitRequestInput;
};


export type MutationSubscribePersonalizedNutritionArgs = {
  request: PersonalizedNutritionSubscriptionRequestInput;
};


export type MutationTokenRefreshArgs = {
  refreshToken: Scalars['String'];
};


export type MutationTurnOnFullyBookingRemindArgs = {
  request: FullyBookingRemindRequestInput;
};


export type MutationUnlikeBoardCommentArgs = {
  boardCommentPid: Scalars['ID'];
};


export type MutationUnlikeBoardPostArgs = {
  boardPostPid: Scalars['ID'];
};


export type MutationUnlikeReviewArgs = {
  reviewId: Scalars['ID'];
};


export type MutationUnmarkDoseStateArgs = {
  doseStateId: Scalars['ID'];
};


export type MutationUpdateCommunityUserNicknameArgs = {
  nickname: Scalars['String'];
};


export type MutationUpdateCommunityUserPostCommentNotificationAllowedArgs = {
  allowed: Scalars['Boolean'];
};


export type MutationUpdateCommunityUserPostLikeNotificationAllowedArgs = {
  allowed: Scalars['Boolean'];
};


export type MutationUpdateCommunityUserProfileImagePathArgs = {
  profileImagePath: Scalars['String'];
};


export type MutationUpdateCommunityUserQnaAnswerNotificationAllowedArgs = {
  allowed: Scalars['Boolean'];
};


export type MutationUpdateHealthAnalysisReportArgs = {
  request: HealthAnalysisReportUpdateRequestInput;
};


export type MutationUpdateHistoryTakingByHospitalArgs = {
  historyTakingHospitalMutationRequest: HistoryTakingHospitalMutationRequestInput;
};


export type MutationUpdateHistoryTakingByPatientArgs = {
  historyTakingPatientMutationRequest: HistoryTakingPatientMutationRequestInput;
};


export type MutationUpdateHospitalAuthorizationInfoArgs = {
  request: HospitalAuthorizationInfoUpdateMutationRequestInput;
};


export type MutationUpdateHospitalBasicInformationArgs = {
  hospitalBasicInformationUpdateMutationRequest: HospitalBasicInformationUpdateMutationRequestInput;
};


export type MutationUpdateHospitalDepartmentGroupTagsArgs = {
  request: Array<HospitalDepartmentGroupTagUpdateMutationRequestInput>;
};


export type MutationUpdateHospitalIntroductionArgs = {
  hospitalIntroductionUpdateMutationRequest: HospitalIntroductionUpdateMutationRequestInput;
};


export type MutationUpdatePersonalizedNutritionSubscriptionArgs = {
  request: PersonalizedNutritionSubscriptionUpdateRequestInput;
};


export type MutationUpdatePushTokenArgs = {
  pushToken: Scalars['String'];
};


export type MutationUpdateQuestionLocationArgs = {
  request: UpdateQuestionLocationRequestInput;
};


export type MutationUpdateRecentConnectionLocationArgs = {
  request: GeoPointMutationRequestInput;
};


export type MutationUpdateRepresentativeProfileImageArgs = {
  profileImageId: Scalars['ID'];
};


export type MutationUpdateSignupPathArgs = {
  request: SignupPathUpdateRequestInput;
};


export type MutationUploadHospitalProfileImageArgs = {
  filePath: Scalars['String'];
};


export type MutationUpsertBlockingAccountArgs = {
  blockingAccountMutationRequest: BlockingAccountMutationRequestInput;
};


export type MutationUpsertHospitalNonBenefitItemsArgs = {
  request: HospitalNonBenefitItemUpdateMutationRequestInput;
};


export type MutationUseInvitationCodeArgs = {
  mutationRequest: UseInvitationCodeMutationRequestInput;
};


export type MutationVerifyArgs = {
  mutationRequest: VerifyMutationRequestInput;
};

export type MyAnswerCursorPageRequestInput = {
  /** 페이지 피벗 답변 ID */
  pivot?: InputMaybe<Scalars['ID']>;
  /** 페이지 사이즈(기본값: 20) */
  size?: InputMaybe<Scalars['Int']>;
};

/** 내 댓글 목록 조회 */
export type MyBoardCommentCursorPageRequestInput = {
  /** 페이지 피벗 아이디(옵션) */
  pivot?: InputMaybe<Scalars['ID']>;
  /** 페이지 사이즈(기본값 20) */
  size?: InputMaybe<Scalars['Int']>;
};

/** 내글 목록 조회 */
export type MyBoardPostCursorPageRequestInput = {
  /** 페이지 피벗 아이디(옵션) */
  pivot?: InputMaybe<Scalars['ID']>;
  /** 페이지 사이즈(기본값 20) */
  size?: InputMaybe<Scalars['Int']>;
};

export type MyLikedQuestionCardCursorPageRequestInput = {
  /** 페이지 피벗 questionLikeId */
  pivot?: InputMaybe<Scalars['ID']>;
  /** 페이지 사이즈(기본값: 20) */
  size?: InputMaybe<Scalars['Int']>;
};

/** 내 질문 목록 조회 */
export type MyQuestionCardCursorPageRequestInput = {
  /** 조회 범위 시간(분) ex. 최근 30분간 */
  criteriaMinutes?: InputMaybe<Scalars['Int']>;
  pivot?: InputMaybe<Scalars['ID']>;
  size?: InputMaybe<Scalars['Int']>;
};

/** 네이버 액세스, 리프레쉬 토큰 */
export type NaverAccessToken = {
  /** access token */
  accessToken: Scalars['String'];
  /** refresh token */
  refreshToken: Scalars['String'];
};

/** 비슷한 시간대에 올라온 다른 질문 */
export type NearSimpleQuestionsRequestInput = {
  /** 기준 질문 */
  questionPid: Scalars['ID'];
  /** 사이즈(홀수만; ex. 5는 자기자신 1개, 이전 질문 2개, 이후 질문 2개로 총 5개가 됨을 의미한다.) */
  size?: InputMaybe<Scalars['Int']>;
};

/** 약국 찾기 목록용 약국 정보 */
export type NearbyPharmacy = {
  /** 약국 속성 V3 (라벨, 태그...) */
  attributesV3: NearbyPharmacyAttributes;
  contact: NearbyPharmacyContact;
  /** 진료비 for 진료비 포함 필터 */
  diagnosisPrice?: Maybe<Scalars['Int']>;
  /** 조제 가능한 약품 정보 목록 */
  dispensableMedicines?: Maybe<PharmacyDispensableMedicines>;
  /** 대체조제 옵션(처방전 그대로, 대체조제 가능) */
  dispensationOptions: DispensationOptions;
  /** 단골 약국 여부 */
  isFavoritePharmacy: Scalars['Boolean'];
  location: NearbyPharmacyLocation;
  name: Scalars['String'];
  /** 별점별 리뷰 개수 */
  numberOfReviewsByRating: Array<NumberOfReviewsByRating>;
  /** 약국 현재 운영 정보 */
  operation: NearbyPharmacyOperationInfo;
  partnership: PharmacyPartnershipType;
  pharmacyId: Scalars['ID'];
  /** 약국 다음 영업시간 */
  pharmacyNextOperationHour: Array<PharmacyNextOperationHour>;
  /** 약국 리뷰 목록 */
  pharmacyReceiptReviews: Array<PharmacyReceiptReview>;
  pickupCompletedCount: Scalars['Int'];
  /** 처방약 정보, 복약정보 */
  prescribedMedicineInfoWithDoseDays: Array<MedicineDoseDays>;
  publicId: Scalars['ID'];
  reviewMeta: NearbyPharmacyReviewMeta;
};


/** 약국 찾기 목록용 약국 정보 */
export type NearbyPharmacyAttributesV3Args = {
  diagnosisId?: InputMaybe<Scalars['ID']>;
  dispensationUnit?: InputMaybe<Scalars['Int']>;
  isAlternativeExcluded?: InputMaybe<Scalars['Boolean']>;
  treatmentMedicineId?: InputMaybe<Scalars['ID']>;
  treatmentMedicineStrengthId?: InputMaybe<Scalars['ID']>;
};


/** 약국 찾기 목록용 약국 정보 */
export type NearbyPharmacyDiagnosisPriceArgs = {
  treatmentId?: InputMaybe<Scalars['ID']>;
  treatmentMedicineId?: InputMaybe<Scalars['ID']>;
};


/** 약국 찾기 목록용 약국 정보 */
export type NearbyPharmacyDispensableMedicinesArgs = {
  diagnosisId?: InputMaybe<Scalars['ID']>;
  dispensationUnit?: InputMaybe<Scalars['Int']>;
  isAlternativeExcluded: Scalars['Boolean'];
  treatmentMedicineId?: InputMaybe<Scalars['ID']>;
  treatmentMedicineStrengthId?: InputMaybe<Scalars['ID']>;
};


/** 약국 찾기 목록용 약국 정보 */
export type NearbyPharmacyDispensationOptionsArgs = {
  diagnosisId?: InputMaybe<Scalars['ID']>;
};


/** 약국 찾기 목록용 약국 정보 */
export type NearbyPharmacyPharmacyReceiptReviewsArgs = {
  limit: Scalars['Int'];
  page: Scalars['Int'];
  sortType: PharmacyReviewSortType;
};


/** 약국 찾기 목록용 약국 정보 */
export type NearbyPharmacyPrescribedMedicineInfoWithDoseDaysArgs = {
  diagnosisId?: InputMaybe<Scalars['ID']>;
};

/** 약국 속성(메인태그, 뱃지, 태그...) */
export type NearbyPharmacyAttribute = {
  imageUrl?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: Scalars['String'];
};

/** 약국 속성(메인태그, 뱃지, 태그...) */
export type NearbyPharmacyAttributes = {
  badges: Array<NearbyPharmacyAttribute>;
  mainTags: Array<NearbyPharmacyAttribute>;
  pharmacyId: Scalars['ID'];
  priceTags: Array<NearbyPharmacyAttribute>;
  /** 방문수령 추천순 정렬에서 사용할 약국 추천 점수 */
  recommendationScore?: Maybe<NearbyPharmacyRecommendationScore>;
  tags: Array<NearbyPharmacyAttribute>;
};


/** 약국 속성(메인태그, 뱃지, 태그...) */
export type NearbyPharmacyAttributesRecommendationScoreArgs = {
  diagnosisId?: InputMaybe<Scalars['ID']>;
  userLocation: NearbyPharmacyGeoPointInput;
};

/** 약국 연락처 정보 */
export type NearbyPharmacyContact = {
  faxNumber?: Maybe<Scalars['String']>;
  safetyNumber?: Maybe<Scalars['String']>;
  tel?: Maybe<Scalars['String']>;
};

export type NearbyPharmacyDepartmentSearchCriteriaInput = {
  /** 과목 ID */
  departmentId: Scalars['ID'];
};

export type NearbyPharmacyDetailGeoPointInput = {
  /** 위도 */
  latitude: Scalars['Float'];
  /** 경도 */
  longitude: Scalars['Float'];
};

export type NearbyPharmacyDetailSearchByPublicIdRequestInput = {
  /** 약국 Public ID */
  publicId: Scalars['ID'];
  /** 사용자 위치 */
  userLocation?: InputMaybe<NearbyPharmacyDetailGeoPointInput>;
};

export type NearbyPharmacyDetailSearchRequestV3Input = {
  /** 약국 ID */
  pharmacyId: Scalars['ID'];
  /** 사용자 위치 */
  userLocation?: InputMaybe<NearbyPharmacyDetailGeoPointInput>;
};

export type NearbyPharmacyGeoBoundInput = {
  /** 북동쪽 위도 */
  northEastLatitude: Scalars['Float'];
  /** 북동쪽 경도 */
  northEastLongitude: Scalars['Float'];
  /** 남서쪽 위도 */
  southWestLatitude: Scalars['Float'];
  /** 남서쪽 경도 */
  southWestLongitude: Scalars['Float'];
};

export type NearbyPharmacyGeoPointInput = {
  /** 위도 */
  latitude: Scalars['Float'];
  /** 경도 */
  longitude: Scalars['Float'];
};

/** 약국 위치 정보 */
export type NearbyPharmacyLocation = {
  detailAddress?: Maybe<Scalars['String']>;
  directions?: Maybe<Scalars['String']>;
  distanceInMeters?: Maybe<Scalars['Int']>;
  jibunAddress?: Maybe<Scalars['String']>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  parkingDescription?: Maybe<Scalars['String']>;
  parkingType?: Maybe<PharmacyParking>;
  pharmacyName: Scalars['String'];
  roadAddress?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type NearbyPharmacyMedicineSearchCriteriaInput = {
  /** 처방 단위 */
  dispensationUnit?: InputMaybe<Scalars['Int']>;
  /** 증상 ID */
  treatmentId: Scalars['ID'];
  /** 약 계열 ID */
  treatmentMedicineId?: InputMaybe<Scalars['ID']>;
  /** 약 계열 함량 ID */
  treatmentMedicineStrengthId?: InputMaybe<Scalars['ID']>;
};

/** 약국 운영 정보 */
export type NearbyPharmacyOperationInfo = {
  display?: Maybe<Scalars['String']>;
  /** 약국 요일별 영업 시간 */
  duties: Array<PharmacyDuty>;
  status: PharmacyOperationStatusV2;
  todayDuty?: Maybe<PharmacyDuty>;
};

/** 근처 약국 추천 점수 for 추천 정렬 */
export type NearbyPharmacyRecommendationScore = {
  pharmacyId: Scalars['ID'];
  score: Scalars['Float'];
};

/** 약국 리뷰 종합 정보 */
export type NearbyPharmacyReviewMeta = {
  averageRating: Scalars['String'];
  totalCount: Scalars['Int'];
};

export type NearbyPharmacySearchByRegionCodeRequestInput = {
  /** 과목 검색 조건 */
  departmentSearchCriteria?: InputMaybe<NearbyPharmacyDepartmentSearchCriteriaInput>;
  /** 약품 검색 조건 */
  medicineSearchCriteria?: InputMaybe<NearbyPharmacyMedicineSearchCriteriaInput>;
  /** 페이지 */
  page?: InputMaybe<Scalars['Int']>;
  /** 지역 코드 */
  regionCode: Scalars['String'];
  /** 사용자 위치 */
  userLocation?: InputMaybe<NearbyPharmacyGeoPointInput>;
};

export type NearbyPharmacySearchRequestV3Input = {
  /** 과목 검색 조건 */
  departmentSearchCriteria?: InputMaybe<NearbyPharmacyDepartmentSearchCriteriaInput>;
  /** 검색 바운더리 */
  geoBound: NearbyPharmacyGeoBoundInput;
  /** 약품 검색 조건 */
  medicineSearchCriteria?: InputMaybe<NearbyPharmacyMedicineSearchCriteriaInput>;
  /** 페이지 */
  page?: InputMaybe<Scalars['Int']>;
  /** 사용자 위치 */
  userLocation: NearbyPharmacyGeoPointInput;
};

export type NearbyPharmacySearchTabGraph = {
  /** 과목/증상 */
  diagnosisType?: Maybe<DiagnosisType>;
  /** 과목/증상 ID */
  diagnosisTypeId?: Maybe<Scalars['ID']>;
  /** 필터타입 */
  filters: Array<PharmacyFilterGraph>;
  /** 탭 ID */
  id: Scalars['ID'];
  /** 탭 이름 */
  name: Scalars['String'];
  /** 정렬기준 */
  sortTypes: Array<PharmacySortGraph>;
  treatmentMedicines: Array<TreatmentMedicineV2>;
};

/** 최신 글 목록 조회 */
export type NewestBoardPostCursorPageRequestInput = {
  /** 카테고리 아이디(옵션) */
  boardCategoryId?: InputMaybe<Scalars['ID']>;
  /** 페이지 피벗 아이디(옵션) */
  pivot?: InputMaybe<Scalars['ID']>;
  /** 페이지 사이즈(기본값 20) */
  size?: InputMaybe<Scalars['Int']>;
};

/** 최신순 질문 목록 조회 조건 */
export type NewestQuestionCardCursorPageRequestInput = {
  /** 답변 완료 여부 */
  answered?: InputMaybe<Scalars['Boolean']>;
  /** 페이지 피벗 질문 ID */
  pivot?: InputMaybe<Scalars['ID']>;
  /** 페이지 사이즈(기본값: 20) */
  size?: InputMaybe<Scalars['Int']>;
};

/** 나이스 핸드폰 본인인증요청 전달 데이터 */
export type NiceHandleResultRequestInput = {
  /** 나이스 본인인증 정보 요청을 위한 암호환 된 데이터 */
  encryptedData: Scalars['String'];
  /** 나이스 본인인증 무결성 키 */
  integrityValue: Scalars['String'];
  /** 나이스 인증창에 넘길 토큰버전 ID */
  tokenVersionId: Scalars['String'];
};

/** 나이스 핸드폰 본인인증 요청 정보 */
export type NiceRequestData = {
  /** 나이스 본인인증 정보 요청을 위한 암호환 된 데이터 */
  encryptedRequestData: Scalars['String'];
  /** 나이스 본인인증 무결성 키 */
  integrityValue: Scalars['String'];
  /** 나이스 인증창에 넘길 토큰버전 ID */
  tokenVersionId: Scalars['String'];
};

/** 비급여 카테고리 */
export type NonBenefitCategory = {
  /** 비급여 카테고리 ID */
  categoryId: Scalars['ID'];
  /** 비급여 카테고리 이름 */
  categoryName: Scalars['String'];
  /** 비급여 카테고리 코드 */
  medicalName: NonBenefitCategoryMedicalNameType;
  nonBenefitItems: Array<NonBenefitItem>;
};

export enum NonBenefitCategoryMedicalNameType {
  Acne = 'Acne',
  Alopecia = 'Alopecia',
  Cataract = 'Cataract',
  Diet = 'Diet',
  ErectileDysfunction = 'Erectile_dysfunction',
  Gardasil = 'Gardasil',
  Influenza = 'Influenza',
  VisionCorrection = 'Vision_Correction'
}

export type NonBenefitCategoryStructureGraph = {
  categoryId: Scalars['ID'];
  categoryName: Scalars['String'];
  nonBenefitItems: Array<NonBenefitItemStructureGraph>;
};

export type NonBenefitCategoryStructureInfoGraph = {
  structures: Array<NonBenefitCategoryStructureGraph>;
};

/** 병원의 비급여진료비 정보(심평원) */
export type NonBenefitDiagnosisPrice = {
  /** 최대 금액 */
  maxPrice: Scalars['Int'];
  /** 중분류명 */
  middleCategoryName: Scalars['String'];
  /** 최소 금액 */
  minPrice: Scalars['Int'];
};

export type NonBenefitHospitalSearchCursorPage = {
  elements: Array<NonBenefitHospitalSearchGraph>;
  pivot?: Maybe<Scalars['String']>;
  pivotScore?: Maybe<Scalars['String']>;
  totalCount: Scalars['Int'];
};

/** NonBenefitHospitalSearch */
export type NonBenefitHospitalSearchGraph = {
  hospitalAdBanners: Array<HospitalAdBanner>;
  /** 병원 주소 */
  hospitalAddress: Scalars['String'];
  /** 병원 뱃지 */
  hospitalBadges: Array<Scalars['String']>;
  /** 병원 거리 */
  hospitalDistance?: Maybe<Scalars['Int']>;
  /** 병원 Id */
  hospitalId: Scalars['ID'];
  /** 병원명 */
  hospitalName: Scalars['String'];
  /** 병원 운영상태 */
  hospitalOperationStatus: HospitalOperatingStatus;
  /** 병원 publicId */
  hospitalPublicId: Scalars['String'];
  /** 병원 대표과목명 */
  hospitalRepresentativeDepartmentName?: Maybe<Scalars['String']>;
  /** 병원 대표 이미지 URL */
  hospitalRepresentativeImageUrl?: Maybe<Scalars['String']>;
  /** 예약가능여부 */
  isBookable: Scalars['Boolean'];
  /** 비급여 가격 정보 */
  nonBenefitPriceInfo?: Maybe<HospitalPriceListNonBenefitItemUnitPrice>;
  /** 운영상태 화면표시 */
  operationDisplay?: Maybe<Scalars['String']>;
  /** 병원 리뷰 평점 */
  reviewAverageRating: Scalars['Float'];
  /** 병원 리뷰 총 개수 */
  reviewTotalCount: Scalars['Int'];
};

/** 비급여 병원 검색 요청 */
export type NonBenefitHospitalSearchRequestInput = {
  /** 비급여 카테고리 ID */
  categoryId: Scalars['ID'];
  /** 병원찾기 필터 */
  commonFilter: HospitalSearchCommonFilterInput;
  /** 위경도 */
  geoPoint: GeoPointInput;
  /** 약제비 포함 필터 */
  hasMedicinePrice?: InputMaybe<Scalars['Boolean']>;
  /** 페이지 사이즈 */
  limit: Scalars['Int'];
  /** 비급여 아이템 ID */
  nonBenefitItemId?: InputMaybe<Scalars['ID']>;
  /** 피벗 검색 아이디 (거리) */
  pivotId?: InputMaybe<Scalars['String']>;
  /** 피벗 검색 스코어 */
  pivotScore?: InputMaybe<Scalars['String']>;
  /** 처방 단위 */
  prescriptionUnit?: InputMaybe<Scalars['Int']>;
  /** 지역 필터 조건 */
  regionByDepth?: InputMaybe<HospitalElasticSearchRegionByDepthRequestInput>;
  /** 정렬타입 */
  sortType: HospitalSortType;
};

/** 비급여 아이템 */
export type NonBenefitItem = {
  /** 비급여 아이템 ID */
  id: Scalars['ID'];
  /** 처방전이 필요한지 여부 */
  isNeedPrescription: Scalars['Boolean'];
  /** 비급여 카테고리 중 대표 아이템인지 여부 */
  isRepresentativeOfCategory: Scalars['Boolean'];
  /** 비급여 아이템 이름 */
  name: Scalars['String'];
  /** 비급여 카테고리 ID */
  nonBenefitCategoryId: Scalars['ID'];
};

/** 비급여 아이템 그룹 */
export type NonBenefitItemGroup = {
  /** 비급여 아이템 ID */
  itemId: Scalars['ID'];
  /** 비급여 아이템명 */
  itemName: Scalars['String'];
  /** 비급여 아이템 처방단위별 금액 */
  unitPrices: Array<NonBenefitItemUnitPrice>;
};

export type NonBenefitItemStructureGraph = {
  isNeedPrescription: Scalars['Boolean'];
  itemId: Scalars['ID'];
  itemName: Scalars['String'];
  units: Array<NonBenefitItemUnitStructureGraph>;
};

/** 비급여 아이템 처방단위별 금액 */
export type NonBenefitItemUnitPrice = {
  /** 진료비 */
  diagnosisPrice?: Maybe<Scalars['Int']>;
  /** 병원 비급여 아이템 처방단위별 약제비 */
  medicinePrice?: Maybe<Scalars['Int']>;
  /** 진료비 + 약제비 포함 총 금액 */
  totalPrice?: Maybe<Scalars['Int']>;
  /** 처방단위별 가격 */
  unit: Scalars['Int'];
  /** 처방단위 텍스트 */
  unitDisplayMessage: Scalars['String'];
  /** 처방단위 ID */
  unitId: Scalars['ID'];
  /** 처방단위 타입 */
  unitType: NonBenefitItemUnitType;
  /** 처방단위 타입 노출명 */
  unitTypeDisplayName: Scalars['String'];
};

export type NonBenefitItemUnitStructureGraph = {
  unit: Scalars['Int'];
  unitDisplayMessage: Scalars['String'];
  unitId: Scalars['ID'];
  unitType: NonBenefitItemUnitType;
};

export enum NonBenefitItemUnitType {
  Count = 'COUNT',
  Day = 'DAY',
  Ea = 'EA',
  Month = 'MONTH',
  Pen = 'PEN',
  Pill = 'PILL',
  Po = 'PO',
  Tablet = 'TABLET',
  Times = 'TIMES',
  Week = 'WEEK'
}

export type NonBenefitItemUpdateMutationRequestInput = {
  /** 병원 비급여 아이템 진료비 */
  diagnosisPrice: Scalars['Int'];
  /** 병원 비급여 아이템 ID */
  itemId: Scalars['ID'];
  /** 병원 비급여 아이템 약제비 */
  medicinePrice?: InputMaybe<Scalars['Int']>;
  /** 병원 비급여 아이템 처방단위 ID */
  unitId: Scalars['ID'];
};

export type NonBenefitMedicinePricingGraph = {
  doctorId: Scalars['ID'];
  doctorTreatmentMedicineUnitPricingId: Scalars['ID'];
  originalPrice: Scalars['Int'];
  priceOnUsingPoint: Scalars['Int'];
  priceType: DiagnosisPriceType;
  treatmentMedicineName: Scalars['String'];
  unitDisplayName: Scalars['String'];
  unitTypeDisplayName: Scalars['String'];
  usablePoint: Scalars['Int'];
};

export type NonBenefitPriceSummary = {
  averagePrice: Scalars['Int'];
  minPrice: Scalars['Int'];
  treatmentMedicineUnitId: Scalars['ID'];
  unitDisplayName: Scalars['String'];
  unitTypeDisplayName: Scalars['String'];
};

export type NonBenefitPriceTotalSummary = {
  /** 전국 가격 요약 정보 */
  nationalSummaries: Array<NonBenefitPriceSummary>;
  /** 지역 코드 */
  regionCode: Scalars['String'];
  /** 지역별 가격 요약 정보 */
  regionSummaries: Array<NonBenefitPriceSummary>;
  /** treatmentMedicineId */
  treatmentMedicineId: Scalars['ID'];
};

/** 비급여 검색 필터 */
export type NonBenefitSearchFilter = {
  /** 적용할 필터들 */
  filters: Array<HospitalFilterType>;
  /** 비급여 아이템 ID */
  nonBenefitItemId: Scalars['ID'];
  /** 정렬 기준 */
  sortTypes: Array<HospitalSearchSortType>;
};

export type NonBenefitTreatmentGraph = {
  doctorId: Scalars['ID'];
  nonBenefitTreatmentUnitInfos: Array<NonBenefitTreatmentUnitGraph>;
  treatment: Treatment;
};

export type NonBenefitTreatmentUnitGraph = {
  doctorId: Scalars['ID'];
  doctorTreatmentMedicineUnitPricingId: Scalars['ID'];
  originalPrice: Scalars['Int'];
  priceOnUsingPoint: Scalars['Int'];
  priceType: DiagnosisPriceType;
  strengthUnit?: Maybe<Scalars['String']>;
  treatmentMedicineId: Scalars['ID'];
  treatmentMedicineName: Scalars['String'];
  treatmentMedicineStrengthId?: Maybe<Scalars['ID']>;
  treatmentMedicineUnitId: Scalars['ID'];
  unitDisplayName: Scalars['String'];
  unitTypeDisplayName: Scalars['String'];
  usablePoint: Scalars['Int'];
};

export type NonF2fDepartment = {
  description?: Maybe<Scalars['String']>;
  iconUrl: Scalars['String'];
  id: Scalars['ID'];
  isProfessional: Scalars['Boolean'];
  name: Scalars['String'];
};

/** 비대면 의사 정보 */
export type NonF2fDoctor = {
  bestReview?: Maybe<DoctorReview>;
  /** 예약 정보 */
  bookingInfo: DoctorBookingGraph;
  /** 계정 생성일 */
  createdAt: Scalars['DrTimestamp'];
  departments: Array<NonF2fDepartment>;
  diagnosisCount?: Maybe<DoctorDiagnosisCount>;
  /** 거리(SortType DISTANCE 일때만 동작) */
  distance?: Maybe<Scalars['Float']>;
  /** 전담의사 정보 */
  familyDoctorInfo?: Maybe<FamilyDoctorInfoGraph>;
  hospital: DoctorHospital;
  /** 병원 이름 */
  hospitalName: Scalars['String'];
  hospitalV2: DoctorHospitalV2;
  /** 의사 ID */
  id: Scalars['ID'];
  /** 제휴 여부 */
  isAffiliated: Scalars['Boolean'];
  /** 10일 이내 가입 여부 */
  isNew: Scalars['Boolean'];
  /** 최대 진료 대기수 */
  maxWaitingCount: Scalars['Int'];
  /** 의사 타입 */
  medicineType: Scalars['String'];
  /** 의사 이름 */
  name: Scalars['String'];
  /** 비급여 의약품 가격 정보 */
  nonBenefitMedicinePricing?: Maybe<NonBenefitMedicinePricingGraph>;
  professionalDepartment?: Maybe<NonF2fDepartment>;
  /** 프로필 이미지 url */
  profileUrl?: Maybe<Scalars['String']>;
  /** public ID */
  publicId: Scalars['ID'];
  /** 영상 진료 가능 여부 */
  readyForVideoCall: Scalars['Boolean'];
  /** 의사 평균 평점 */
  reviewAverageRating: Scalars['Float'];
  /** 의사 리뷰수 */
  reviewCount: Scalars['Int'];
  /** 증상약 오픈일자 조회 */
  treatmentMedicineOpenDate: DoctorTreatmentMedicineOpenDateGraph;
  /** 예방접종 무료지원 정책 목록 */
  vaccinationFreePolicies: Array<VaccinationFreePolicyInfoGraph>;
  /** 백신 제품 최저가 */
  vaccineProductMinPrice: DoctorVaccineMinPriceGraph;
};


/** 비대면 의사 정보 */
export type NonF2fDoctorTreatmentMedicineOpenDateArgs = {
  treatmentMedicineId?: InputMaybe<Scalars['ID']>;
};


/** 비대면 의사 정보 */
export type NonF2fDoctorVaccinationFreePoliciesArgs = {
  vaccinationId?: InputMaybe<Scalars['ID']>;
};


/** 비대면 의사 정보 */
export type NonF2fDoctorVaccineProductMinPriceArgs = {
  vaccinationTypeId?: InputMaybe<Scalars['ID']>;
  vaccinationTypeUnitId?: InputMaybe<Scalars['ID']>;
};

export type NonF2fDoctorSearchRequestInput = {
  /** 의사 타입 */
  doctorType?: InputMaybe<DoctorType>;
  /** 위치 정보 */
  geoPoint?: InputMaybe<GeoPointInput>;
  /** 검색 키워드 */
  keyword?: InputMaybe<Scalars['String']>;
  /** limit */
  limit: Scalars['Int'];
  /** 과목/증상 정보 */
  medicalCategory?: InputMaybe<NonF2fMedicalCategoryRequestInput>;
  /** 의약품 단위 Id */
  medicineUnitId?: InputMaybe<Scalars['ID']>;
  /** 신규가입(10일)대상 여부 */
  newOnly?: InputMaybe<Scalars['Boolean']>;
  /** page */
  page: Scalars['Int'];
  /** 정렬 타입 */
  sortType: DoctorSortType;
  /** 전문의 여부 */
  specialistOnly?: InputMaybe<Scalars['Boolean']>;
  /** 원격의료 타겟 타입 */
  telemedicineEligibleTargetType?: InputMaybe<TelemedicineEligibleTargetType>;
  /** 오늘 예약가능 여부 */
  todayBookableOnly?: InputMaybe<Scalars['Boolean']>;
};

/** 의사 검색 */
export type NonF2fDoctorSearchResult = {
  items: Array<NonF2fDoctor>;
  medicalCategoryGraph?: Maybe<NonF2fMedicalCategory>;
  totalCount: Scalars['Int'];
};

export type NonF2fDoctorSearchResultGraphV2 = {
  items: Array<NonF2fDoctorV2>;
  medicalCategoryGraph?: Maybe<NonF2fMedicalCategory>;
  totalCount: Scalars['Int'];
};

export type NonF2fDoctorSeoSearchRequestInput = {
  /** limit */
  limit: Scalars['Int'];
  /** page */
  page: Scalars['Int'];
  /** 과목/증상 정보 */
  regionCode: Scalars['String'];
  /** treatmentMedicineUnitId */
  treatmentMedicineUnitId: Scalars['ID'];
};

/** 비대면 의사 정보 V2 */
export type NonF2fDoctorV2 = {
  bestReview?: Maybe<DoctorReview>;
  /** 계정 생성일 */
  createdAt: Scalars['DrTimestamp'];
  departments: Array<NonF2fDepartment>;
  diagnosisCount?: Maybe<DoctorDiagnosisCount>;
  /** 거리(SortType DISTANCE 일때만 동작) */
  distance?: Maybe<Scalars['Float']>;
  /** 전담의사 정보 */
  familyDoctorInfo?: Maybe<FamilyDoctorInfoGraph>;
  hospital: DoctorHospital;
  /** 병원 이름 */
  hospitalName: Scalars['String'];
  hospitalV2: DoctorHospitalV2;
  /** 의사 ID */
  id: Scalars['ID'];
  /** 제휴 여부 */
  isAffiliated: Scalars['Boolean'];
  /** 최대 진료 대기수 */
  maxWaitingCount: Scalars['Int'];
  /** 의사 타입 */
  medicineType: Scalars['String'];
  /** 의사 이름 */
  name: Scalars['String'];
  professionalDepartment?: Maybe<NonF2fDepartment>;
  /** 프로필 이미지 url */
  profileUrl?: Maybe<Scalars['String']>;
  /** public ID */
  publicId: Scalars['ID'];
  /** 영상 진료 가능 여부 */
  readyForVideoCall: Scalars['Boolean'];
  /** 의사 평균 평점 */
  reviewAverageRating: Scalars['Float'];
  /** 의사 리뷰수 */
  reviewCount: Scalars['Int'];
  /** 증상약 오픈일자 조회 */
  treatmentMedicineOpenDate: DoctorTreatmentMedicineOpenDateGraph;
};


/** 비대면 의사 정보 V2 */
export type NonF2fDoctorV2TreatmentMedicineOpenDateArgs = {
  treatmentMedicineId?: InputMaybe<Scalars['ID']>;
};

/** 비대면 진료 증상/과목 */
export type NonF2fMedicalCategory = {
  /** 카테고리 (DEPARTMENT | TREATMENT) */
  category: MedicalCategoryType;
  /** 아이콘 URL (PROD-2426: 홈에서 사용하기 위해 추가했는데 지금 잠시 하드코딩으로 들어가있어서 널러블. 곧 정리 예정) */
  iconUrl?: Maybe<Scalars['String']>;
  /** 증상 ID 또는 과목 ID */
  id: Scalars['ID'];
  /** 카테고리명 (PROD-2426: 홈에서 사용하기 위해 추가했는데 지금 잠시 하드코딩으로 들어가있어서 널러블. 곧 정리 예정) */
  name?: Maybe<Scalars['String']>;
};

export type NonF2fMedicalCategoryRequestInput = {
  category: MedicalCategoryType;
  id: Scalars['ID'];
};

export type NonF2fQuickDiagnosisDoctorRequestInput = {
  medicalCategory: MedicalCategoryTargetInput;
  telemedicineEligibleTargetType: TelemedicineEligibleTargetType;
};

/** 빠른 진료 매칭 목록 */
export type NonF2fQuickDiagnosisMatch = {
  /** 의사 정보 */
  doctor: DoctorByUser;
};

/** 비대면 진료 과목 정보 */
export type NonFaceToFaceDepartment = {
  /** 평균 진료비 */
  averageDiagnosisPrice?: Maybe<Scalars['Int']>;
  /** 설명 */
  description?: Maybe<Scalars['String']>;
  /** Id */
  id: Scalars['ID'];
  /** 이름 */
  name: Scalars['String'];
  /** 축약 이름 */
  simplifiedName: Scalars['String'];
};

/** 비대면 진료 영상 통화 종료 */
export type NonFaceToFaceDiagnosisCallHangUpRequestInput = {
  /** 비대면 진료 ID */
  diagnosisId: Scalars['ID'];
};

/** 비대면 진료 영상 통화 수신 거절 */
export type NonFaceToFaceDiagnosisCallRejectRequestInput = {
  /** 비대면 진료 ID */
  diagnosisId: Scalars['ID'];
};

/** 상담 roomToken 정보 */
export type NonFaceToFaceDiagnosisChannelTokenGraph = {
  /** 채널 이름 */
  channelName: Scalars['String'];
  /** 채널 접속 토큰 */
  channelToken: Scalars['String'];
};

/** 비대면 진료 의사 정보 */
export type NonFaceToFaceDoctor = {
  diagnosisCount?: Maybe<DoctorDiagnosisCount>;
  /** 의사명 */
  doctorName: Scalars['String'];
  /** 병원명 */
  hospitalName: Scalars['String'];
  /** 의사 ID */
  id: Scalars['ID'];
  /** 부재중 여부 */
  isAbsent: Scalars['Boolean'];
  /** 예약 가능 여부 */
  isBookable: Scalars['Boolean'];
  /** 최대 대기 인원 수 */
  maxWaitingCount: Scalars['Int'];
  /** 의사 타입 */
  medicineType: MedicineType;
  professionalDepartment: DoctorDepartment;
  /** 의사 프로필 이미지 */
  profileUrl: Scalars['String'];
  /** 의사 퍼블릭 ID */
  publicId: Scalars['String'];
  /** 화상 진료 여부 */
  readyForVideoCall: Scalars['Boolean'];
  /** 리뷰 평균 점수 */
  reviewAverageRating: Scalars['Float'];
  /** 리뷰 갯수 */
  reviewCount: Scalars['Int'];
};

export type NonFaceToFaceDoctorCursorPage = {
  elements: Array<NonFaceToFaceDoctor>;
  pivot?: Maybe<Scalars['ID']>;
};

/** 키워드로 비대면 진료 의사 조회 */
export type NonFaceToFaceDoctorCursorPageRequestInput = {
  /** 검색 키워드. (의사명 / 병원명) */
  keyword: Scalars['String'];
  /** 피벗 아이디 */
  pivot?: InputMaybe<Scalars['ID']>;
  /** 조회 사이즈 */
  size?: InputMaybe<Scalars['Int']>;
};

/** 공지사항 */
export type Notice = {
  /** account Type */
  accountType: NoticeAccountType;
  /** 액션 Url */
  actionUrl?: Maybe<Scalars['String']>;
  /** 버튼 제목 */
  buttonTitle?: Maybe<Scalars['String']>;
  /** 버튼 url */
  buttonUrl?: Maybe<Scalars['String']>;
  /** 카테고리 */
  category: NoticeCategoryType;
  /** 생성 시간 */
  createdAt: Scalars['DrTimestamp'];
  /** 생성자 */
  createdBy: Scalars['String'];
  /** 공지사항 ID */
  id: Scalars['ID'];
  /** 이미지 url */
  imageUrl: Scalars['String'];
  /** 삭제여부 */
  isDeleted: Scalars['Boolean'];
  /** 고졍여부 */
  isFixed: Scalars['Boolean'];
  /** 공지사항 타입 */
  noticeType: NoticeType;
  /** 제목 */
  title: Scalars['String'];
};

export enum NoticeAccountType {
  Admin = 'ADMIN',
  Doctor = 'DOCTOR',
  Hospital = 'HOSPITAL',
  Pharmacist = 'PHARMACIST',
  User = 'USER'
}

export enum NoticeCategoryType {
  Notice = 'NOTICE',
  Update = 'UPDATE'
}

/** 공지사항 리스트 */
export type NoticeList = {
  /** 고정 공지사항 리스트 */
  fixedNotices: Array<Notice>;
  /** 공지사항 리스트 */
  notices: Array<Notice>;
  /** 총 갯수 */
  totalCount: Scalars['Int'];
  /** 총 페이지 갯수 */
  totalPageCount: Scalars['Int'];
};

export enum NoticeType {
  Normal = 'NORMAL',
  Popup = 'POPUP',
  Rolling = 'ROLLING'
}

export enum NowPartnershipStatus {
  AcceptedByAdminAndBeforeStarterPackagePurchase = 'ACCEPTED_BY_ADMIN_AND_BEFORE_STARTER_PACKAGE_PURCHASE',
  None = 'NONE',
  NowPartnershipApproved = 'NOW_PARTNERSHIP_APPROVED',
  NowPartnershipRequestedByPharmacy = 'NOW_PARTNERSHIP_REQUESTED_BY_PHARMACY'
}

/** 별점별 리뷰 개수 */
export type NumberOfReviewsByRating = {
  /** 리뷰 개수 */
  count: Scalars['Int'];
  /** 별점 */
  rating: Scalars['Int'];
};

/** 태그별 리뷰 개수 */
export type NumberOfReviewsByTag = {
  hospitalId: Scalars['ID'];
  tagWithCounts: Array<TagWithCountGraph>;
};

export type OAuthInfoGraph = {
  accountId: Scalars['ID'];
  id: Scalars['ID'];
  providerType: ProviderType;
};

/** OAuth 유저 프로필 */
export type OAuthUserProfile = {
  /** 유저 생일 */
  birthDate?: Maybe<Scalars['String']>;
  /** 유저 CI */
  ci?: Maybe<Scalars['String']>;
  /** 유저 이메일 */
  email?: Maybe<Scalars['String']>;
  /** OAuth 서비스의 유니크 키 */
  externalId: Scalars['String'];
  /** 유저 성별 */
  gender?: Maybe<GenderType>;
  /** 유저 이름 */
  name?: Maybe<Scalars['String']>;
  /** 유저 핸드폰 번호 */
  phone?: Maybe<Scalars['String']>;
};

/** 로그인 파라미터 */
export type OauthSignInUserRequestInput = {
  /** kakao/apple 등 로그인으로 받아온 토큰 */
  accessToken: Scalars['String'];
  /** KAKAO, APPLE 등 제공자 */
  provider: ProviderType;
};

/** 회원가입 파라미터 */
export type OauthSignUpUserRequestInput = {
  /** kakao/apple 등 로그인으로 받아온 토큰 */
  accessToken: Scalars['String'];
  contentNotificationAllowed?: InputMaybe<Scalars['Boolean']>;
  marketingReceiptAccepted: Scalars['Boolean'];
  nightlyMarketingReceiptAccepted?: InputMaybe<Scalars['Boolean']>;
  notificationAllowed: Scalars['Boolean'];
  /** 플랫폼 */
  platform: PlatformType;
  /** KAKAO, APPLE 등 제공자 */
  provider: ProviderType;
};

/** 주문 정보 */
export type Order = {
  additionalOrder?: Maybe<PharmacyAdditionalOrder>;
  cancelInfo: OrderCancelInfo;
  /** 진료정보 */
  diagnosis: Diagnosis;
  /** 진료 ID */
  diagnosisId: Scalars['ID'];
  /** 진료 신청서 조회 */
  forms: Array<DiagnosisForm>;
  /** 외부 노출 주문 ID */
  orderExternalId: Scalars['String'];
  /** 주문 ID (order.id) */
  orderId: Scalars['ID'];
  /** 주문 코드 (order.order_id) */
  orderNumber: Scalars['String'];
  /** 주문 타입 */
  orderType: OrderType;
  /** @deprecated paymentV2 사용 */
  paymentInfo: OrderPayment;
  paymentInfoV2: OrderPaymentV2;
  pharmacy: Pharmacy;
  /** 약국 ID */
  pharmacyId: Scalars['ID'];
  review?: Maybe<PharmacyReview>;
  /** 주문 상태 */
  status: OrderStatus;
  timelineInfo: OrderTimeline;
};

/** 주문 취소 정보 */
export type OrderCancelInfo = {
  /** 취소 일시 */
  cancelAt?: Maybe<Scalars['DrTimestamp']>;
  /** 취소 주체 */
  cancelBy?: Maybe<DoctornowRole>;
  /** 취소 사유 */
  cancelReason?: Maybe<Scalars['String']>;
  /** 주문 취소 예정 일시 */
  cancelScheduledAt?: Maybe<Scalars['DrTimestamp']>;
};

/** 오더 취소 사유 */
export type OrderCancelReason = {
  cancelReasonType: OrderCancelReasonType;
  /** 취소 사유 ID */
  id: Scalars['ID'];
  /** 정렬키 */
  sortKey: Scalars['Float'];
  /** 제목 */
  title: Scalars['String'];
};

export enum OrderCancelReasonCategory {
  PharmacyCancel = 'PHARMACY_CANCEL',
  UserCancelAtNonPartnership = 'USER_CANCEL_AT_NON_PARTNERSHIP',
  UserCancelAtPartnership = 'USER_CANCEL_AT_PARTNERSHIP'
}

export enum OrderCancelReasonType {
  AdditionalOrderProductNoStock = 'ADDITIONAL_ORDER_PRODUCT_NO_STOCK',
  AnotherPharmacySelectionByUser = 'ANOTHER_PHARMACY_SELECTION_BY_USER',
  CustomerService = 'CUSTOMER_SERVICE',
  DistanceTooFar = 'DISTANCE_TOO_FAR',
  HourPassed = 'HOUR_PASSED',
  IllegalNumber = 'ILLEGAL_NUMBER',
  InitByAdmin = 'INIT_BY_ADMIN',
  InitByPharmacist = 'INIT_BY_PHARMACIST',
  InvalidFaxNumber = 'INVALID_FAX_NUMBER',
  MedicineNonSubstitutable = 'MEDICINE_NON_SUBSTITUTABLE',
  NotEligibleForDelivery = 'NOT_ELIGIBLE_FOR_DELIVERY',
  NoAlternativeDispense = 'NO_ALTERNATIVE_DISPENSE',
  NoDrugs = 'NO_DRUGS',
  NoResponse = 'NO_RESPONSE',
  NoStock = 'NO_STOCK',
  Other = 'OTHER',
  PatientRejectedAlternative = 'PATIENT_REJECTED_ALTERNATIVE',
  PaymentOverdue = 'PAYMENT_OVERDUE',
  PharmacistDirect = 'PHARMACIST_DIRECT',
  PharmacyNoAnswer = 'PHARMACY_NO_ANSWER',
  PharmacySkipByUser = 'PHARMACY_SKIP_BY_USER',
  PrescriptionAlreadyUsed = 'PRESCRIPTION_ALREADY_USED',
  PrescriptionChanged = 'PRESCRIPTION_CHANGED',
  PrescriptionRejected = 'PRESCRIPTION_REJECTED',
  PriceTooHigh = 'PRICE_TOO_HIGH',
  Reject = 'REJECT',
  ReturnToPreviousPharmacyByUser = 'RETURN_TO_PREVIOUS_PHARMACY_BY_USER',
  SlowResponse = 'SLOW_RESPONSE',
  TemporaryNoStock = 'TEMPORARY_NO_STOCK',
  UserDirect = 'USER_DIRECT',
  ValidityExpired = 'VALIDITY_EXPIRED'
}

export type OrderCompleteByUserMutationRequestInput = {
  orderId: Scalars['ID'];
};

/** 주문 즉시 결제 요청 */
export type OrderImmediatePayRequestInput = {
  /** 결제해야 할 금액 */
  amountToPay: Scalars['Int'];
  /** 배송 방법 */
  deliveryCategoryType: DeliveryCategoryType;
  /** 배송 전달사항 */
  deliveryComment?: InputMaybe<Scalars['String']>;
  /** 유저가 확인한 배송비 */
  deliveryFee?: InputMaybe<Scalars['Int']>;
  /** 배송비 포인트 */
  deliveryFeePoint?: InputMaybe<Scalars['Int']>;
  /** 상세 주소 */
  detailAddress?: InputMaybe<Scalars['String']>;
  /** 진료 Id */
  diagnosisId: Scalars['ID'];
  /** 할부 개월 */
  installmentMonth?: InputMaybe<Scalars['Int']>;
  /** 주문 요청 당시 유저 대체조제 선택 여부 */
  isUserAlternativeSelected?: InputMaybe<Scalars['Boolean']>;
  /** 지번 주소 */
  jibunAddress?: InputMaybe<Scalars['String']>;
  /** 경도 */
  latitude?: InputMaybe<Scalars['Float']>;
  /** 위도 */
  longitude?: InputMaybe<Scalars['Float']>;
  /** 주문 요청 당시 메인태그 타입 */
  mainTagTypes?: InputMaybe<Array<Scalars['String']>>;
  /** 약품 가격 정보 리스트 */
  medicineRequestInfos: Array<MedicineInfoMutationRequestInput>;
  /** 약국 Id */
  pharmacyId: Scalars['ID'];
  /** 우편 번호 */
  postCode?: InputMaybe<Scalars['String']>;
  /** 주문 요청 당시 유저의 현 위치 */
  receiptLocation?: InputMaybe<LocationMutationRequestInput>;
  /** 도로명 주소 */
  roadAddress?: InputMaybe<Scalars['String']>;
  /** 유저 결제수단 id */
  userPaymentId: Scalars['ID'];
};

/** 주문 즉시 결제 요청 V2 */
export type OrderImmediatePayV2RequestInput = {
  /** 결제해야 할 추가주문 금액 */
  additionalOrderAmountToPay?: InputMaybe<Scalars['Int']>;
  /** 추가주문한 상품 목록 */
  additionalProducts: Array<AdditionalProductRequestInput>;
  /** 결제해야 할 금액 */
  amountToPay: Scalars['Int'];
  /** 배송 방법 */
  deliveryCategoryType: DeliveryCategoryType;
  /** 배송 전달사항 */
  deliveryComment?: InputMaybe<Scalars['String']>;
  /** 유저가 확인한 배송비 */
  deliveryFee?: InputMaybe<Scalars['Int']>;
  /** 배송비 포인트 */
  deliveryFeePoint?: InputMaybe<Scalars['Int']>;
  /** 상세 주소 */
  detailAddress?: InputMaybe<Scalars['String']>;
  /** 진료 Id */
  diagnosisId: Scalars['ID'];
  /** 할부 개월 */
  installmentMonth?: InputMaybe<Scalars['Int']>;
  /** 주문 요청 당시 유저 대체조제 선택 여부 */
  isUserAlternativeSelected?: InputMaybe<Scalars['Boolean']>;
  /** 지번 주소 */
  jibunAddress?: InputMaybe<Scalars['String']>;
  /** 경도 */
  latitude?: InputMaybe<Scalars['Float']>;
  /** 위도 */
  longitude?: InputMaybe<Scalars['Float']>;
  /** 주문 요청 당시 메인태그 타입 */
  mainTagTypes?: InputMaybe<Array<Scalars['String']>>;
  /** 약품 가격 정보 리스트 */
  medicineRequestInfos: Array<MedicineInfoMutationRequestInput>;
  /** 약국 Id */
  pharmacyId: Scalars['ID'];
  /** 우편 번호 */
  postCode?: InputMaybe<Scalars['String']>;
  /** 주문 요청 당시 유저의 현 위치 */
  receiptLocation?: InputMaybe<LocationMutationRequestInput>;
  /** 도로명 주소 */
  roadAddress?: InputMaybe<Scalars['String']>;
  /** 유저 결제수단 id */
  userPaymentId: Scalars['ID'];
};

/** 주문 결제 요청 */
export type OrderPayRequestInput = {
  /** 결제해야 할 금액 */
  amountToPay: Scalars['Int'];
  /** 할부 개월 */
  installmentMonth?: InputMaybe<Scalars['Int']>;
  /** 주문 Id */
  orderId: Scalars['Int'];
  /** 사용할 포인트 */
  point: Scalars['Int'];
  /** 유저 결제수단 id */
  userPaymentId: Scalars['Int'];
};

/** 주문 결제 요청 */
export type OrderPayV2RequestInput = {
  /** 결제해야 할 추가주문 금액 */
  additionalOrderAmountToPay: Scalars['Int'];
  /** 결제해야 할 배송비 금액 */
  deliveryFeeAmountToPay: Scalars['Int'];
  /** 결제해야 할 조제비 금액 */
  dispensationAmountToPay: Scalars['Int'];
  /** 할부 개월 */
  installmentMonth?: InputMaybe<Scalars['Int']>;
  /** 주문 Id */
  orderId: Scalars['Int'];
  /** 사용할 포인트 */
  point: Scalars['Int'];
  /** 유저 결제수단 id */
  userPaymentId: Scalars['Int'];
};

/** 주문 결제 정보 */
export type OrderPayment = {
  /** 현장결제 여부 */
  isOnsitePayment: Scalars['Boolean'];
  /** 결제 상태 */
  payStatus: OrderPaymentStatus;
  /** 조제비 */
  price: Scalars['Int'];
};

export enum OrderPaymentStatus {
  Cancel = 'CANCEL',
  Done = 'DONE',
  Fail = 'FAIL',
  None = 'NONE',
  Ready = 'READY'
}

/** 주문 결제 정보 V2 */
export type OrderPaymentV2 = {
  additionalOrderPrice: Scalars['Int'];
  /** 조제비 */
  dispensationOrderPrice: Scalars['Int'];
  /** 현장결제 여부 */
  isOnsitePayment: Scalars['Boolean'];
  /** 결제 상태 */
  payStatus: OrderPaymentStatus;
  totalPrice: Scalars['Int'];
};

export enum OrderStatus {
  Cancel = 'CANCEL',
  Done = 'DONE',
  None = 'NONE',
  Progress = 'PROGRESS',
  Ready = 'READY'
}

/** 주문 타임라인 정보 */
export type OrderTimeline = {
  /** 기사 호출 일시(배달) 혹은 수령자 호출 일시(방문수령) */
  callAt?: Maybe<Scalars['DrTimestamp']>;
  /** 수령 완료 일시 */
  completedAt?: Maybe<Scalars['DrTimestamp']>;
  /** 처방전 확인 일시 */
  confirmedAt?: Maybe<Scalars['DrTimestamp']>;
  /** 배달 시작 일시 */
  deliveryAt?: Maybe<Scalars['DrTimestamp']>;
};

export enum OrderType {
  Dawn = 'DAWN',
  Delivery = 'DELIVERY',
  PartnershipPickup = 'PARTNERSHIP_PICKUP',
  Pickup = 'PICKUP',
  Post = 'POST',
  Quick = 'QUICK'
}

export type OverallCounselingScheduleGraph = {
  status: OverallCounselingScheduleStatus;
};

export enum OverallCounselingScheduleStatus {
  Bookable = 'BOOKABLE',
  FullyBooked = 'FULLY_BOOKED'
}

/** 포장 정보 */
export type PackagingInfo = {
  /** 포장 이미지(약품 박스) */
  image?: Maybe<Scalars['String']>;
  /** 포장 단위 */
  unit: Scalars['String'];
};

export type PaginationCriteriaInput = {
  /** pivotId 부터 정렬 방향으로 탐색 */
  pivotId?: InputMaybe<Scalars['ID']>;
  /** 몇 개의 데이터를 가져올지 */
  size: Scalars['Int'];
  /** 정렬 방향 */
  sort: SortType;
};

export type PagingRequestInput = {
  /** 몇 개의 데이터를 가져올지 */
  limit?: InputMaybe<Scalars['Int']>;
  /** 페이지 */
  page?: InputMaybe<Scalars['Int']>;
};

/** 제휴약국 방문수령 요청 v2 */
export type PartnershipPickupDispensationMutationRequestV2Input = {
  /** 진료 id */
  diagnosisId: Scalars['ID'];
  /** 주문 요청 당시 유저 대체조제 선택 여부 */
  isUserAlternativeSelected?: InputMaybe<Scalars['Boolean']>;
  /** 주문 요청 당시 메인태그 타입 */
  mainTagTypes?: InputMaybe<Array<Scalars['String']>>;
  /** 약품 가격 정보 리스트 */
  medicineRequestInfos?: InputMaybe<Array<MedicineInfoMutationRequestInput>>;
  /** 약국 id */
  pharmacyId: Scalars['ID'];
  /** 주문 요청 당시 유저의 현 위치 */
  receiptLocation?: InputMaybe<LocationMutationRequestInput>;
};

/** 제휴약국 방문수령 요청 v3 */
export type PartnershipPickupDispensationMutationRequestV3Input = {
  /** 추가주문한 상품 목록 */
  additionalProducts: Array<AdditionalProductRequestInput>;
  /** 진료 id */
  diagnosisId: Scalars['ID'];
  /** 주문 요청 당시 유저 대체조제 선택 여부 */
  isUserAlternativeSelected?: InputMaybe<Scalars['Boolean']>;
  /** 주문 요청 당시 메인태그 타입 */
  mainTagTypes?: InputMaybe<Array<Scalars['String']>>;
  /** 약품 가격 정보 리스트 */
  medicineRequestInfos?: InputMaybe<Array<MedicineInfoMutationRequestInput>>;
  /** 약국 id */
  pharmacyId: Scalars['ID'];
  /** 주문 요청 당시 유저의 현 위치 */
  receiptLocation?: InputMaybe<LocationMutationRequestInput>;
};

export type PatchNotificationRequestInput = {
  contentNotificationAllowed?: InputMaybe<Scalars['Boolean']>;
  doseNotificationAllowed?: InputMaybe<Scalars['Boolean']>;
  marketingReceiptAccepted?: InputMaybe<Scalars['Boolean']>;
  nightlyMarketingReceiptAccepted?: InputMaybe<Scalars['Boolean']>;
  notificationAllowed?: InputMaybe<Scalars['Boolean']>;
};

/** 환자 */
export type Patient = {
  /** 주소 */
  address: Scalars['String'];
  /** 상세주소 */
  detailAddress?: Maybe<Scalars['String']>;
  /** 성별 */
  gender: PatientGender;
  /** 상세주소 */
  height?: Maybe<Scalars['Float']>;
  /** 환자 ID */
  id: Scalars['ID'];
  /** 환자명 */
  name: Scalars['String'];
  /** 환자 핸드폰번호 */
  phone: Scalars['String'];
  /** 환자 주민등록번호 */
  registrationNumber: Scalars['String'];
  /** 상세주소 */
  weight?: Maybe<Scalars['Float']>;
};

export type PatientFormRequestInput = {
  diagnosisAttachments: Array<DiagnosisAttachmentRequestInput>;
  isBrandRevisiting: Scalars['Boolean'];
  /** 환자 생년월일 (YYYY-MM-DD) */
  patientBirth: Scalars['String'];
  /** 환자 키 */
  patientHeight?: InputMaybe<Scalars['Float']>;
  /** 환자 나이 */
  patientKoreanAge?: InputMaybe<Scalars['String']>;
  /** 환자 특이사항 */
  patientNote?: InputMaybe<Scalars['String']>;
  patientTarget: PatientTargetInput;
  /** 환자 몸무게 */
  patientWeight?: InputMaybe<Scalars['Float']>;
  requestForVideoCall: Scalars['Boolean'];
  ssnLastPart: Scalars['String'];
  symptomDescription: Scalars['String'];
};

export enum PatientGender {
  Female = 'FEMALE',
  Male = 'MALE',
  None = 'NONE'
}

/** 환자 알림(호출) 정보 */
export type PatientNotificationHistory = {
  /** 생성일시 */
  createdAt: Scalars['DrTimestamp'];
  /** 대면진료 ID */
  faceToFaceDiagnosisId: Scalars['ID'];
  /** 알림 히스토리 ID */
  id: Scalars['ID'];
  /** 알림(호출) 타입 */
  notificationType: PatientNotificationType;
  /** 환자 ID */
  patientId: Scalars['ID'];
};

/** 환자 호출(알림) */
export type PatientNotificationMutationRequestInput = {
  /** 대면진료ID */
  faceToFaceDiagnosisId: Scalars['ID'];
  /** 호출(알림) 타입 */
  notificationType: PatientNotificationType;
  /** 환자ID */
  patientId: Scalars['ID'];
};

export enum PatientNotificationType {
  CallUp = 'CALL_UP',
  HistoryTaking = 'HISTORY_TAKING'
}

export type PatientTargetInput = {
  relation: FamilyRelation;
  targetId: Scalars['ID'];
};

export enum PayCompany {
  Inisis = 'INISIS',
  Kakaopay = 'KAKAOPAY',
  Payple = 'PAYPLE',
  TossPg = 'TOSS_PG'
}

/** 실시간 상담 질문 결제 요청 */
export type PayQuestionRequestInput = {
  /** 결제 금액 */
  cashAmountToPay: Scalars['Int'];
  /** 할인 금액 */
  discountAmount: Scalars['Int'];
  /** 사용할 포인트 */
  pointToUse: Scalars['Int'];
  /** 주문서에서 확인한 가격 */
  price: Scalars['Int'];
  /** 질문 PID */
  questionPid: Scalars['String'];
  /** 유저 결제수단 ID */
  userPaymentId: Scalars['ID'];
};

export type PaymentInformation = {
  cardCompany?: Maybe<Scalars['String']>;
  cardNumber?: Maybe<Scalars['String']>;
  paidDate?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
};

export type PaymentTotalGraph = {
  /** 현재 결제액 */
  currentAmount: Scalars['Int'];
  /** 결제 추적번호 */
  payTrackingNumber: Scalars['String'];
  /** 결제 종합 사유 */
  reason?: Maybe<Scalars['String']>;
  /** 결제 종합 상태 */
  status: PaymentTotalStatus;
  /** 유저 결제정보 */
  userPayment?: Maybe<UserPayment>;
  /** 유저 결제정보 id */
  userPaymentId?: Maybe<Scalars['ID']>;
  /** 유저 결제정보 */
  userPayments?: Maybe<UserPayment>;
};

export enum PaymentTotalStatus {
  AllCancelled = 'ALL_CANCELLED',
  Paid = 'PAID',
  PartialCancelled = 'PARTIAL_CANCELLED',
  PayFailed = 'PAY_FAILED',
  Pending = 'PENDING'
}

/** 소아과 리뷰 */
export type PediatricsReviewGraph = {
  /** 의사 ID */
  doctorId: Scalars['ID'];
  /** 의사 Public ID */
  doctorPid: Scalars['ID'];
  /** 리뷰 이미지 URL */
  imageUrl: Scalars['String'];
  /** 정렬 순서 */
  sortKey: Scalars['Float'];
};

export type PedometerCompleteMissionRequestInput = {
  pedometerMissionId: Scalars['ID'];
  steps: Scalars['Int'];
};

export type PedometerDailyInfo = {
  food: Food;
  isMissionCompleted: Scalars['Boolean'];
  missions: Array<UserPedometerMission>;
  percentage: Scalars['Int'];
  steps: Scalars['Int'];
  totalRewardAmount: Scalars['Int'];
  userId: Scalars['ID'];
};

export enum PeriodType {
  Daily = 'DAILY',
  Lifetime = 'LIFETIME',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

/** 맞춤형 건기식 종합 정보 */
export type PersonalizedNutritionAggregate = {
  /** 상담 정보 */
  counseling?: Maybe<Counseling>;
  /** 건강 분석 리포트 */
  healthAnalysisReport?: Maybe<HealthAnalysisReport>;
  /** 현재 구독에서 진행중인 주문 */
  orderInProgress?: Maybe<CommerceOrder>;
  /** 맞춤형 건기식 종합 상태 */
  status: PersonalizedNutritionAggregateStatus;
  /** 구독 정보 */
  subscription?: Maybe<SubscriptionInfo>;
};

export enum PersonalizedNutritionAggregateStatus {
  BeforeSurvey = 'BEFORE_SURVEY',
  CounselingBookConfirmed = 'COUNSELING_BOOK_CONFIRMED',
  CounselingBookRequested = 'COUNSELING_BOOK_REQUESTED',
  CounselingCancelled = 'COUNSELING_CANCELLED',
  CounselingCompleted = 'COUNSELING_COMPLETED',
  CounselingProgress = 'COUNSELING_PROGRESS',
  SubscriptionCancelled = 'SUBSCRIPTION_CANCELLED',
  SubscriptionCompleted = 'SUBSCRIPTION_COMPLETED',
  SubscriptionNoOrderInProgress = 'SUBSCRIPTION_NO_ORDER_IN_PROGRESS',
  SubscriptionOrderInProgressPayFailed = 'SUBSCRIPTION_ORDER_IN_PROGRESS_PAY_FAILED',
  SubscriptionProgress = 'SUBSCRIPTION_PROGRESS',
  SurveyCompleted = 'SURVEY_COMPLETED'
}

export type PersonalizedNutritionDescriptionDetailGraph = {
  content: Scalars['String'];
  title: Scalars['String'];
};

/** 맞춤형 영양제 상담 정보 */
export type PersonalizedNutritionDetail = {
  counseling: Counseling;
  subscription?: Maybe<SubscriptionInfo>;
};

export type PersonalizedNutritionOrderSheetGraph = {
  /** 상담 ID */
  counselingId: Scalars['ID'];
  /** 결제 예정 금액 */
  expectedAmountToPay: Scalars['Int'];
  /** 총 할인 금액 */
  totalDiscountAmount: Scalars['Int'];
  /** 총 가격 */
  totalPrice: Scalars['Int'];
};

export type PersonalizedNutritionOrderSheetRequestInput = {
  /** 상담 ID */
  counselingId: Scalars['ID'];
  /** 총 구독 기간 */
  termType: SubscriptionTermType;
};

/** 맞춤형 건기식 아이템 정보 */
export type PersonalizedNutritionProduct = AbstractProduct & {
  category: CommerceCategoryGraph;
  description: Scalars['String'];
  descriptionDetails: Array<PersonalizedNutritionDescriptionDetailGraph>;
  displayName: Scalars['String'];
  dosePerDay: Scalars['String'];
  id: Scalars['ID'];
  isVisible: Scalars['Boolean'];
  mainFunction: MainFunctionGraph;
  name: Scalars['String'];
  price: Scalars['Int'];
  rawMaterials: Array<PersonalizedNutritionRawMaterialGraph>;
  sellerId: Scalars['ID'];
  thumbnailUrl: Scalars['String'];
  volume: Scalars['String'];
};

export type PersonalizedNutritionRawMaterialGraph = {
  content: Scalars['String'];
  name: Scalars['String'];
  type: RawMaterialType;
};

/** 건강검진 항목별 결과 */
export type PersonalizedNutritionRecommendationItem = {
  /** 추천 영양제 상품 */
  product: AbstractProduct;
  /** 추천 근거로 삼은 결핍된 주기능 */
  recommendationReason: MainFunction;
};

export type PersonalizedNutritionSubscriptionCancelRequestInput = {
  requestedBy: Scalars['String'];
  subscriptionId: Scalars['Int'];
};

export type PersonalizedNutritionSubscriptionRequestInput = {
  amountToPay: Scalars['Int'];
  counselingId: Scalars['Int'];
  discountAmount: Scalars['Int'];
  pointToUse: Scalars['Int'];
  term: SubscriptionTermType;
  userAddressId: Scalars['Int'];
  userPaymentId: Scalars['Int'];
};

export type PersonalizedNutritionSubscriptionUpdateRequestInput = {
  regularPaymentDay?: InputMaybe<Scalars['Int']>;
  subscriptionId: Scalars['Int'];
  userAddressId?: InputMaybe<Scalars['Int']>;
  userPaymentId?: InputMaybe<Scalars['Int']>;
};

/** PG사 개별 약관 */
export type PgAgreement = {
  /** 약관 카테고리 */
  category: AgreementCategory;
  /** 약관 내용 */
  content?: Maybe<Scalars['String']>;
  /** 삭제일시 */
  deletedAt?: Maybe<Scalars['DrTimestamp']>;
  /** 약관 ID */
  id: Scalars['ID'];
  /** 약관 필수여부 */
  required: Scalars['Boolean'];
  /** 약관 타이틀 */
  title: Scalars['String'];
  /** 약관 URL */
  url?: Maybe<Scalars['String']>;
  /** 약관 버전 */
  version: Scalars['Int'];
};

/** 카드번호에 해당하는 PG사 및 약관 */
export type PgAgreementInfo = {
  /** PG사별 약관목록 */
  agreements: Array<PgAgreement>;
  /** PG사 */
  payCompany: PayCompany;
};

/** 약사 정보 */
export type Pharmacist = {
  /** 약사 account id */
  accountId: Scalars['ID'];
  /** 계정정보 */
  accountInfo: DoctornowAuthInfo;
  /** 예금주명 */
  accountName?: Maybe<Scalars['String']>;
  /** 계좌번호 */
  accountNumber?: Maybe<Scalars['String']>;
  /** 은행명 */
  bank?: Maybe<Scalars['String']>;
  /** 약사 디바이스 */
  devices: Array<PharmacistDevice>;
  /** 약사 id */
  id: Scalars['ID'];
  /** 약사명 */
  pharmacistName: Scalars['String'];
  /** 약국 ID */
  pharmacyId?: Maybe<Scalars['ID']>;
  /** 핸드폰 번호 */
  phone: Scalars['String'];
};

/** 약사 디바이스 */
export type PharmacistDevice = {
  /** 기기 별칭 */
  alias: Scalars['String'];
  /** 기기 고유ID */
  deviceId: Scalars['String'];
  /** 푸시토큰 */
  firebaseToken: Scalars['String'];
  /** 기기 ID */
  id: Scalars['ID'];
  /** 약사 ID */
  pharmacistId: Scalars['ID'];
};

/** 약국 정보 */
export type Pharmacy = {
  /** 계정정보 */
  accountInfo: DoctornowAuthInfo;
  /** 상세 주소 */
  detailAddress?: Maybe<Scalars['String']>;
  /** 이메일 */
  email?: Maybe<Scalars['String']>;
  /** 팩스번호 */
  faxNumber?: Maybe<Scalars['String']>;
  /** 약국 id */
  id: Scalars['ID'];
  /** 부재중 여부 */
  isAbsent: Scalars['Boolean'];
  /** 지번 주소 */
  jibunAddress?: Maybe<Scalars['String']>;
  /** 위도 */
  latitude: Scalars['Float'];
  /** 경도 */
  longitude: Scalars['Float'];
  /** 약국명 */
  name: Scalars['String'];
  /**
   * 나우약국 제휴여부
   * @deprecated wholesalePartnershipStatus로 옮겨가야 함
   */
  nowPartnershipStatus: NowPartnershipStatus;
  /** 제휴여부 */
  partnerShip: PharmacyPartnerShip;
  /** 약사 */
  pharmacist?: Maybe<Pharmacist>;
  /** 약국 연락처 */
  pharmacyContacts: Array<PharmacyContact>;
  /** 약국 영업시간 */
  pharmacyDuties: Array<PharmacyDuty>;
  /** 도로명 주소 */
  roadAddress?: Maybe<Scalars['String']>;
  /** 전화번호 */
  tel?: Maybe<Scalars['String']>;
};

/** 약국 추가 주문 */
export type PharmacyAdditionalOrder = {
  channelType: ChannelType;
  commerceOrderId: Scalars['ID'];
  dispensationOrderId: Scalars['ID'];
  orderItems: Array<PharmacyAdditionalOrderItem>;
  orderNumber: Scalars['ID'];
  paidAmount: Scalars['Int'];
  status: CommerceOrderStatus;
  totalItemPrice: Scalars['Int'];
};

/** 약국 추가 주문 상품 카테고리 */
export type PharmacyAdditionalOrderCategory = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** 약국 추가 주문 아이템 */
export type PharmacyAdditionalOrderItem = {
  commerceOrderId: Scalars['ID'];
  commerceOrderItemId: Scalars['ID'];
  commerceOrderItemNumber: Scalars['ID'];
  imageUrl: Scalars['String'];
  name: Scalars['String'];
  paidAmount: Scalars['Int'];
  price: Scalars['Int'];
  product: PharmacyAdditionalOrderProduct;
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
  status: CommerceOrderItemStatus;
};

/** 약국 추가 주문 상품 정보 */
export type PharmacyAdditionalOrderProduct = {
  category: PharmacyAdditionalOrderCategory;
  /** 카테고리 ID */
  categoryId: Scalars['ID'];
  /** 내용 */
  content: Scalars['String'];
  /** 설명 */
  description: Scalars['String'];
  /** 추가 주문 상품 ID */
  id: Scalars['ID'];
  /** 이미지 URL */
  imageUrl: Scalars['String'];
  /** 제조사 */
  manufacturer: Scalars['String'];
  /** 추가 주문 상품명 */
  name: Scalars['String'];
  /** 약국 ID */
  pharmacyId: Scalars['ID'];
  /** 가격 */
  price: Scalars['Int'];
};

/** 약국 정보 */
export type PharmacyByUser = {
  /** 상세 주소 */
  detailAddress?: Maybe<Scalars['String']>;
  /** 팩스번호 */
  faxNumber?: Maybe<Scalars['String']>;
  /** 약국 id */
  id: Scalars['ID'];
  /** 부재중 여부 */
  isAbsent: Scalars['Boolean'];
  /** 지번 주소 */
  jibunAddress?: Maybe<Scalars['String']>;
  /** 위도 */
  latitude: Scalars['Float'];
  /** 경도 */
  longitude: Scalars['Float'];
  /** 약국명 */
  name: Scalars['String'];
  /** 약국 영업시간 */
  pharmacyDuties: Array<PharmacyDuty>;
  /** 도로명 주소 */
  roadAddress?: Maybe<Scalars['String']>;
  /** 전화번호 */
  tel?: Maybe<Scalars['String']>;
};

export type PharmacyCandidateRequestInput = {
  /** 배송 방법 */
  deliveryCategoryType: DeliveryCategoryType;
  /** 진료 ID */
  diagnosisId: Scalars['ID'];
  /** 유저 주소 ID */
  userAddressId: Scalars['ID'];
};

/** 약국 연락처 정보 */
export type PharmacyContact = {
  /** 별칭 */
  contactAlias?: Maybe<Scalars['String']>;
  /** 연락처 id */
  id: Scalars['ID'];
  /** 활성화 여부 */
  isActive: Scalars['Boolean'];
  /** 약국 id */
  pharmacyId: Scalars['ID'];
  /** 핸드폰 번호 */
  phone: Scalars['String'];
};

/** 약국 조제 가능한 약품 목록 정보 */
export type PharmacyDispensableMedicines = {
  dispensableMedicines: Array<DispensableMedicine>;
  pharmacyId: Scalars['ID'];
  /** 약품 총 금액 */
  totalAmount?: Maybe<Scalars['Int']>;
};

/** 약국 처방가능한 약품 요청 */
export type PharmacyDispensableMedicinesRequestInput = {
  /** 진료 ID */
  diagnosisId: Scalars['ID'];
  /** 대체조제 제외 여부 */
  isAlternativeExcluded: Scalars['Boolean'];
  /** 약국 ID */
  pharmacyId: Scalars['ID'];
};

/** 약국 영업시간 */
export type PharmacyDuty = {
  /** 휴게 종료 시각 */
  breakEndTime: Scalars['String'];
  /** 휴게 시작 시각 */
  breakStartTime: Scalars['String'];
  /** 마감 시각 */
  closeTime: Scalars['String'];
  /** 휴게 시간 여부 */
  hasBreakTime: Scalars['Boolean'];
  /** 영업시간 id */
  id: Scalars['ID'];
  /** 휴무일 여부 */
  isClosed: Scalars['Boolean'];
  /** 오픈 시각 */
  openTime: Scalars['String'];
  /** 약국 id */
  pharmacyId: Scalars['ID'];
  /** 요일 */
  weekDay: Scalars['Int'];
};

export type PharmacyFilterGraph = {
  activeIconUrl?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  inactiveIconUrl?: Maybe<Scalars['String']>;
  mode: PharmacyFilterMode;
  subFilters: Array<PharmacyFilterGraph>;
  title: Scalars['String'];
  type: PharmacyFilterType;
};

export enum PharmacyFilterMode {
  List = 'LIST',
  Range = 'RANGE',
  Toggle = 'TOGGLE'
}

export enum PharmacyFilterType {
  ConfirmedDispensation = 'CONFIRMED_DISPENSATION',
  DispensationProbability = 'DISPENSATION_PROBABILITY',
  FavoritePharmacy = 'FAVORITE_PHARMACY',
  HandlingMedicine = 'HANDLING_MEDICINE',
  HighDispensationProbability = 'HIGH_DISPENSATION_PROBABILITY',
  IncludeDiagnosisPrice = 'INCLUDE_DIAGNOSIS_PRICE',
  IsOpenAtLateNight = 'IS_OPEN_AT_LATE_NIGHT',
  IsOpenEveryDay = 'IS_OPEN_EVERY_DAY',
  Now = 'NOW',
  Operating = 'OPERATING',
  Partnership = 'PARTNERSHIP',
  PossibleDispensation = 'POSSIBLE_DISPENSATION',
  RequestWithApp = 'REQUEST_WITH_APP',
  SameMedicine = 'SAME_MEDICINE',
  TreatmentMedicine = 'TREATMENT_MEDICINE'
}

/** 약국 라벨 */
export type PharmacyLabel = {
  /** 이미지 주소 */
  imageUrl?: Maybe<Scalars['String']>;
  /** 타이틀 */
  title: Scalars['String'];
  /** 타입 */
  type: Scalars['String'];
};

export type PharmacyMarketplaceProductRecommendationGraph = {
  catalogRecommendation: CatalogRecommendationGraph;
  products: Array<PharmacyAdditionalOrderProduct>;
};

/** 약국 매칭 이력 */
export type PharmacyMatchingHistory = {
  /** 메시지 */
  message?: Maybe<Scalars['String']>;
  /** 약제비 */
  price?: Maybe<Scalars['Int']>;
  /** 타입 */
  type: PharmacyMatchingHistoryType;
};

export enum PharmacyMatchingHistoryType {
  PharmacyCheckPrescriptions = 'PHARMACY_CHECK_PRESCRIPTIONS',
  PharmacyIssue = 'PHARMACY_ISSUE',
  PharmacyNoResponse = 'PHARMACY_NO_RESPONSE',
  PharmacyPriceSet = 'PHARMACY_PRICE_SET',
  ReservePharmacy = 'RESERVE_PHARMACY',
  UserCancelledAfterPriceSet = 'USER_CANCELLED_AFTER_PRICE_SET',
  UserCancelledBeforePriceSet = 'USER_CANCELLED_BEFORE_PRICE_SET'
}

export type PharmacyMedicinePriceSummary = {
  averagePrice: Scalars['Int'];
  minPrice: Scalars['Int'];
  unit: Scalars['Int'];
  unitTypeDisplayName: Scalars['String'];
};

export type PharmacyMedicinePriceTotalSummary = {
  /** 전국 가격 요약 정보 */
  nationalSummaries: Array<PharmacyMedicinePriceSummary>;
  /** 지역 코드 */
  regionCode: Scalars['String'];
  /** 지역별 가격 요약 정보 */
  regionSummaries: Array<PharmacyMedicinePriceSummary>;
  /** treatmentMedicineId */
  treatmentMedicineId: Scalars['ID'];
};

/** 약국 약품 요약 */
export type PharmacyMedicineSummary = {
  displayName?: Maybe<Scalars['String']>;
  isAlternativeMedicine?: Maybe<Scalars['Boolean']>;
  /** 약 */
  medicine: MedicineGraphV2;
  medicineId: Scalars['ID'];
  pharmacyId: Scalars['ID'];
  price?: Maybe<Scalars['Int']>;
  /** 약 계열 */
  treatmentMedicine?: Maybe<TreatmentMedicineV2>;
  treatmentMedicineId?: Maybe<Scalars['ID']>;
  unit?: Maybe<Scalars['Int']>;
  unitType?: Maybe<MedicineStandardType>;
};

/** 약국 다음 영업시간 */
export type PharmacyNextOperationHour = {
  /** 가장 빠른 예약가능시간 (MM월 dd일 a HH:mm) */
  earliestAvailableReservationHour?: Maybe<Scalars['DrTimestamp']>;
  /** 가장 빠른 예약가능시간 */
  earliestAvailableReservationHourString?: Maybe<Scalars['String']>;
  /** 다음 영업시간 텍스트 (MM월 dd일 a HH:mm) */
  nextOperationHour?: Maybe<Scalars['DrTimestamp']>;
  /** 다음 영업시간 */
  nextOperationHourString?: Maybe<Scalars['String']>;
  /** 약국 id */
  pharmacyId: Scalars['ID'];
};

export enum PharmacyOperationStatusV2 {
  Absent = 'ABSENT',
  BeforeOpen = 'BEFORE_OPEN',
  BreakTime = 'BREAK_TIME',
  Closed = 'CLOSED',
  ClosedSoon = 'CLOSED_SOON',
  DayOff = 'DAY_OFF',
  Open = 'OPEN',
  Unknown = 'UNKNOWN'
}

/** 약국 주차 유형 선택 옵션 */
export type PharmacyParking = {
  /** 주차 유형 이름 */
  name: Scalars['String'];
  /** 주차 유형 */
  type: PharmacyParkingType;
};

export enum PharmacyParkingType {
  Free = 'FREE',
  Paid = 'PAID',
  Unavailable = 'UNAVAILABLE'
}

export enum PharmacyPartnerShip {
  Nonpartnership = 'nonpartnership',
  Partnership = 'partnership',
  Pending = 'pending'
}

export enum PharmacyPartnershipType {
  Nonpartnership = 'nonpartnership',
  Partnership = 'partnership',
  Pending = 'pending'
}

export type PharmacyReceipt = {
  paymentInformation?: Maybe<PaymentInformation>;
  storeInformation?: Maybe<StoreInformation>;
  success: Scalars['Boolean'];
};

/** 영수증 정보 V2 */
export type PharmacyReceiptInfoMutationRequestInput = {
  /** 사업자등록번호 */
  businessNumber?: InputMaybe<Scalars['String']>;
  /** 결제카드사 */
  cardCompany?: InputMaybe<Scalars['String']>;
  /** 카드번호 */
  cardNumber?: InputMaybe<Scalars['String']>;
  /** 결제 날짜(유저가 수정함) */
  editedPaidDate?: InputMaybe<Scalars['String']>;
  /** 결제 금액(유저가 수정함) */
  editedPrice?: InputMaybe<Scalars['Int']>;
  /** 영수증 파일 경로 */
  filePath: Scalars['String'];
  /** 상점명, 금액, 방문 날짜 수정 여부 */
  isModified: Scalars['Boolean'];
  /** 결제 날짜(분석결과 원본) */
  paidDate?: InputMaybe<Scalars['String']>;
  /** 결제 금액(분석결과 원본) */
  price?: InputMaybe<Scalars['Int']>;
  /** 상점주소 */
  storeAddress?: InputMaybe<Scalars['String']>;
  /** 상점명(분석결과 원본) */
  storeName: Scalars['String'];
};

/** 약국 리뷰 */
export type PharmacyReceiptReview = {
  /** 리뷰 내용 */
  content: Scalars['String'];
  /** 과목 혹은 증상명 */
  diagnosisCategoryName: Scalars['String'];
  /** 약국 영수증 리뷰 ID */
  id: Scalars['ID'];
  /** 숨기기 여부 */
  isPrivate: Scalars['Boolean'];
  /** 환자 이름(마스킹) */
  maskedPatientName: Scalars['String'];
  /** 주문 */
  order: PharmacyReviewOrder;
  /** 주문 ID */
  orderId: Scalars['ID'];
  /** 방문 날짜 */
  paidDate: Scalars['String'];
  /** 약국 ID */
  pharmacyId: Scalars['ID'];
  /** 결제 금액 */
  price: Scalars['String'];
  /** 별점 */
  rating: Scalars['Int'];
  /** 리뷰 ID */
  reviewId: Scalars['ID'];
  /** 리뷰 태그 */
  reviewTags: Array<ReviewTagMap>;
  /** 방문 약국명 */
  storeName: Scalars['String'];
  /** 리뷰 제목 */
  title: Scalars['String'];
  /** 유저 ID */
  userId: Scalars['ID'];
};

/** 약국 영수증 리뷰 작성 요청 */
export type PharmacyReceiptReviewCreateRequestInput = {
  /** 사업자등록번호 */
  businessNumber?: InputMaybe<Scalars['String']>;
  /** 결제카드사 */
  cardCompany?: InputMaybe<Scalars['String']>;
  /** 카드번호 */
  cardNumber?: InputMaybe<Scalars['String']>;
  /** 리뷰 내용 */
  content?: InputMaybe<Scalars['String']>;
  /** 결제 날짜(유저가 수정함) */
  editedPaidDate?: InputMaybe<Scalars['String']>;
  /** 결제 금액(유저가 수정함) */
  editedPrice?: InputMaybe<Scalars['Int']>;
  /** 영수증 파일 경로 */
  filePath: Scalars['String'];
  /** 상점명, 금액, 방문 날짜 수정 여부 */
  isModified: Scalars['Boolean'];
  /** 주문 ID */
  orderId: Scalars['ID'];
  /** 결제 날짜(분석결과 원본) */
  paidDate?: InputMaybe<Scalars['String']>;
  /** 약국 ID */
  pharmacyId: Scalars['ID'];
  /** 결제 금액(분석결과 원본) */
  price?: InputMaybe<Scalars['Int']>;
  /** 별점 */
  rating: Scalars['Int'];
  /** 리뷰 태그 ID 목록 */
  reviewTagIds: Array<Scalars['ID']>;
  /** 상점주소 */
  storeAddress?: InputMaybe<Scalars['String']>;
  /** 상점명(분석결과 원본) */
  storeName: Scalars['String'];
};

/** 약국 리뷰 작성 결과 */
export type PharmacyReceiptReviewCreateResponse = {
  isPointEarned: Scalars['Boolean'];
  isReviewWritingSuccess: Scalars['Boolean'];
};

export type PharmacyRematchMutationRequestInput = {
  /** 주문 Id */
  orderId: Scalars['ID'];
  /** 약국 Id */
  pharmacyId: Scalars['ID'];
};

export type PharmacyReview = {
  content: Scalars['String'];
  createdAt: Scalars['DrTimestamp'];
  id: Scalars['ID'];
  isPrivate: Scalars['Boolean'];
  maskedHolderName?: Maybe<Scalars['String']>;
  rating: Scalars['Int'];
  reviewContext: ReviewContextGraph;
  reviewImages: Array<ReviewImageGraph>;
  /** 리뷰 태그 */
  reviewTags: Array<ReviewTagMap>;
  targetCategoryName?: Maybe<Scalars['String']>;
  targetPrice?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt: Scalars['DrTimestamp'];
};

/** 약국 리뷰 작성 요청 V2 (영수증 정보 선택적 포함) */
export type PharmacyReviewCreateMutationRequestInput = {
  /** 리뷰 내용 */
  content?: InputMaybe<Scalars['String']>;
  /** 주문 ID */
  orderId: Scalars['ID'];
  /** 약국 ID */
  pharmacyId: Scalars['ID'];
  /** 별점 */
  rating: Scalars['Int'];
  /** 영수증 정보 (선택적) */
  receiptInfo?: InputMaybe<PharmacyReceiptInfoMutationRequestInput>;
  /** 리뷰 태그 ID 목록 */
  reviewTagIds: Array<Scalars['ID']>;
};

/** 약국 리뷰 작성 요청 (Deprecated) */
export type PharmacyReviewCreateRequestInput = {
  /** 리뷰 내용 */
  content?: InputMaybe<Scalars['String']>;
  /** 주문 ID */
  orderId: Scalars['ID'];
  /** 약국 ID */
  pharmacyId: Scalars['ID'];
  /** 별점 */
  rating: Scalars['Int'];
  /** 리뷰 태그 ID 목록 */
  reviewTagIds: Array<Scalars['ID']>;
};

/** 주문 정보 */
export type PharmacyReviewOrder = {
  /** 진료정보 */
  diagnosis: ReviewDiagnosis;
  /** 진료 ID */
  diagnosisId: Scalars['ID'];
  /** 외부 노출 주문 ID */
  orderExternalId: Scalars['String'];
  /** 주문 ID (order.id) */
  orderId: Scalars['ID'];
  /** 주문 코드 (order.order_id) */
  orderNumber: Scalars['String'];
};

export type PharmacyReviewRequestInput = {
  /** 사이즈 */
  limit: Scalars['Int'];
  /** 페이지 */
  page: Scalars['Int'];
  /** 약국 ID */
  pharmacyId: Scalars['ID'];
  /** 정렬기준 */
  sortType: PharmacyReviewSortType;
};

export enum PharmacyReviewSortType {
  HighRating = 'HIGH_RATING',
  Newest = 'NEWEST'
}

/** 약국 리뷰 태그 */
export type PharmacyReviewTag = {
  /** 태그 id */
  id: Scalars['ID'];
  /** 태그내용 */
  text: Scalars['String'];
};

export type PharmacySearchByRegionCodeRequestInput = {
  /** 사이즈 */
  limit: Scalars['Int'];
  /** 페이지 */
  page: Scalars['Int'];
  /** 지역 코드 */
  regionCode: Scalars['String'];
};

/** 약국 재선택 사유 */
export type PharmacySelectionChangeReason = {
  description: Scalars['String'];
  reason: PharmacySelectionChangeReasonType;
};

export enum PharmacySelectionChangeReasonType {
  Other = 'OTHER',
  OutOfStock = 'OUT_OF_STOCK',
  PharmacyNotResponding = 'PHARMACY_NOT_RESPONDING',
  PrescriptionRejected = 'PRESCRIPTION_REJECTED'
}

/** 약국 재선택 요청 */
export type PharmacySelectionChangeRequestInput = {
  diagnosisId: Scalars['Int'];
  otherReason?: InputMaybe<Scalars['String']>;
  pharmacyId: Scalars['Int'];
  reason: PharmacySelectionChangeReasonType;
};

export type PharmacySortGraph = {
  title: Scalars['String'];
  type: PharmacySortType;
};

export enum PharmacySortType {
  DispensationProbability = 'DISPENSATION_PROBABILITY',
  Distance = 'DISTANCE',
  HighRating = 'HIGH_RATING',
  LowPrice = 'LOW_PRICE',
  MostReviews = 'MOST_REVIEWS',
  QuickReceipt = 'QUICK_RECEIPT',
  VisitCount = 'VISIT_COUNT'
}

/** 약국 태그 */
export type PharmacyTag = {
  /** 이미지 주소 */
  imageUrl?: Maybe<Scalars['String']>;
  /** 타이틀 */
  title: Scalars['String'];
  /** 타입 */
  type: Scalars['String'];
};

export enum PlatformType {
  Android = 'ANDROID',
  Ios = 'IOS',
  None = 'NONE',
  Web = 'WEB'
}

/** 포인트 쿠폰 정보 */
export type PointCoupon = {
  /** 브랜드 */
  brand: Scalars['String'];
  /** 포인트 쿠폰 코드 */
  goodsCode: Scalars['String'];
  /** 포인트 쿠폰 id */
  id: Scalars['ID'];
  /** 이미지 */
  imageUrl?: Maybe<Scalars['String']>;
  /** 포인트 금액 */
  point: Scalars['Int'];
  /** 포인트 쿠폰 public id */
  publicId: Scalars['String'];
  /** 썸네일 이미지 */
  thumbnailImageUrl?: Maybe<Scalars['String']>;
  /** 쿠폰 제목 */
  title: Scalars['String'];
};

/** 포인트 쿠폰 상세 정보 */
export type PointCouponDetailInfo = {
  /** 포인트 쿠폰 정보 */
  pointCouponGraph?: Maybe<PointCoupon>;
  /** 쿠폰 발급 가능 여부 정보 */
  pointCouponIssueAvailableInfoGraph?: Maybe<PointCouponIssueAvailableInfo>;
  publicId: Scalars['String'];
};

export type PointCouponIssueApiRequestInput = {
  goodsCode: Scalars['String'];
};

/** 포인트 쿠폰 발급 가능 여부 정보 */
export type PointCouponIssueAvailableInfo = {
  /** 쿠폰 포인트 금액 */
  couponPoint: Scalars['Int'];
  /** 발급 가능 여부 */
  isAvailable: Scalars['Boolean'];
  /** 발급한 횟수 */
  issuedCount: Scalars['Int'];
  /** 총 발급 가능 횟수 */
  totalAvailableCount: Scalars['Int'];
  /** 유저 잔여 포인트 금액 */
  userPoint: Scalars['Int'];
};

export enum PointEventType {
  Cancel = 'CANCEL',
  Earn = 'EARN',
  Expire = 'EXPIRE',
  Return = 'RETURN',
  Use = 'USE'
}

/** 포인트 이벤트 */
export type PointEvents = {
  /** 금액 */
  amount: Scalars['Int'];
  /** 설명 */
  description?: Maybe<Scalars['String']>;
  /** 진료 아이디 */
  diagnosisId?: Maybe<Scalars['Int']>;
  /** 적립/사용일자 */
  eventAt: Scalars['DrTimestamp'];
  /** 포인트 이벤트 타입, EARN(적립), USE(사용), EXPIRE(만료) */
  eventType: PointEventType;
  /** 포인트 이벤트 아이디 */
  id: Scalars['ID'];
  /** 포인트를 발급한 서비스 코드 */
  serviceCode: Scalars['String'];
  /** 제목 */
  title: Scalars['String'];
};

export type PointReward = {
  rewardAmount: Scalars['Int'];
  serviceCode: PointServiceCodeType;
};

export enum PointServiceCodeType {
  CommerceOrderPointUse = 'COMMERCE_ORDER_POINT_USE',
  CorrectDailyOxQuizAnswer = 'CORRECT_DAILY_OX_QUIZ_ANSWER',
  CorrectDailyOxQuizAnswerV2 = 'CORRECT_DAILY_OX_QUIZ_ANSWER_V2',
  DailyExpiration = 'DAILY_EXPIRATION',
  DailyOxQuizBonusRewardPoint = 'DAILY_OX_QUIZ_BONUS_REWARD_POINT',
  DoseRecordMission = 'DOSE_RECORD_MISSION',
  Event = 'EVENT',
  ExchangePoint = 'EXCHANGE_POINT',
  FriendInvitation = 'FRIEND_INVITATION',
  HealthRecordMission = 'HEALTH_RECORD_MISSION',
  NonFaceToFaceDiagnosisNonBenefitDiagnosisUse = 'NON_FACE_TO_FACE_DIAGNOSIS_NON_BENEFIT_DIAGNOSIS_USE',
  NonFaceToFaceDiagnosisNonBenefitDiagnosisUseReturn = 'NON_FACE_TO_FACE_DIAGNOSIS_NON_BENEFIT_DIAGNOSIS_USE_RETURN',
  NonFaceToFaceDiagnosisReviewEvent = 'NON_FACE_TO_FACE_DIAGNOSIS_REVIEW_EVENT',
  OnboardingPoint = 'ONBOARDING_POINT',
  OrderPointUse = 'ORDER_POINT_USE',
  OrderPointUseReturn = 'ORDER_POINT_USE_RETURN',
  PedometerMission = 'PEDOMETER_MISSION',
  PersonalizedNutritionPreBooking = 'PERSONALIZED_NUTRITION_PRE_BOOKING',
  PersonalizedNutritionReviewEvent = 'PERSONALIZED_NUTRITION_REVIEW_EVENT',
  QuestionPointUse = 'QUESTION_POINT_USE',
  UserPaymentRegisterTossPgReward = 'USER_PAYMENT_REGISTER_TOSS_PG_REWARD',
  WritePharmacyReviewWithReceipt = 'WRITE_PHARMACY_REVIEW_WITH_RECEIPT'
}

/** 인기 질환 */
export type PopularDisease = {
  /** 인기 질환 이름 */
  name: Scalars['String'];
  /** 인기 질환 공개 id */
  publicId: Scalars['String'];
};

/** 인기 증상 */
export type PopularSymptom = {
  /** 인기 증상 이름 */
  name: Scalars['String'];
  /** 인기 증상 공개 id */
  publicId: Scalars['String'];
};

/** 대댓글 등록 */
export type PostBoardCommentOfBoardCommentRequestInput = {
  /** 상위 코멘트 아이디 */
  boardCommentPid: Scalars['ID'];
  /** 코멘트 */
  content: Scalars['String'];
};

/** 글에 대한 댓글 등록 */
export type PostBoardCommentOfBoardPostRequestInput = {
  /** 게시글 아이디 */
  boardPostPid: Scalars['ID'];
  /** 댓글 */
  content: Scalars['String'];
};

export type PostBoardPostAttachmentRequestInput = {
  blindType: AttachmentBlindType;
  filePath: Scalars['String'];
};

/** 게시글 등록 */
export type PostBoardPostRequestInput = {
  /** 첨부 파일 */
  attachments?: InputMaybe<Array<PostBoardPostAttachmentRequestInput>>;
  /** 카테고리 아이디 */
  boardCategoryId: Scalars['ID'];
  /** 내용 */
  content: Scalars['String'];
  /** 제목 */
  title: Scalars['String'];
  /** user-agent */
  userAgent: Scalars['String'];
};

/** 퀴즈에 대한 정답 제출 */
export type PostUserQuizAnswerRequestInput = {
  /** 퀴즈 정답 */
  answer: Scalars['String'];
  /** 퀴즈 아이디 */
  quizPid: Scalars['ID'];
};

export enum PrescriptionDispensingType {
  InHospital = 'IN_HOSPITAL',
  OutHospital = 'OUT_HOSPITAL'
}

export type PresignedUrlGraph = {
  filePath: Scalars['String'];
  presignedUrl: Scalars['String'];
};

export type PrizeDrawGraph = {
  /** 추첨된 상품 정보 */
  prize: PrizeGraph;
  /** 추첨된 상품 수량 */
  quantity: Scalars['Int'];
  /** 유저 상품 Id */
  userPrizeId: Scalars['ID'];
};

export type PrizeDrawRequestInput = {
  /** 게임 타입 */
  gameType: GameType;
};

export type PrizeGraph = {
  /** 상품 수량 */
  amount: Scalars['Int'];
  /** 상품 표시 이름 */
  displayName: Scalars['String'];
  /** 포맷팅된 안내 문구 */
  formattedGuidance: Scalars['String'];
  /** 상품 ID */
  id: Scalars['ID'];
  /** 상품 이름 */
  name: Scalars['String'];
  /** 상품 썸네일 URL */
  thumbnailUrl: Scalars['String'];
  /** 상품 타입 */
  type: PrizeType;
  /** 당첨 이미지 URL */
  winningImageUrl: Scalars['String'];
};

export type PrizeReceiveRequestInput = {
  /** 유저 상품 Id */
  userPrizeId: Scalars['ID'];
};

export enum PrizeType {
  DoctornowPoint = 'DOCTORNOW_POINT',
  Gifticon = 'GIFTICON',
  Manual = 'MANUAL'
}

/** 상품 정보 리스트 */
export type ProductList = {
  /** 상품 정보 */
  items: Array<AbstractProduct>;
};

export type ProductMetadataGraph = {
  /** 메타 정보 키 (PHARMACEUTICAL_COMPANY, ...) */
  key: Scalars['String'];
  /** 메타 정보 값 */
  value: Scalars['String'];
};

export type ProfessionalField = {
  name: Scalars['String'];
  professionalFieldId: Scalars['ID'];
  professionalFieldType: ProfessionalFieldType;
};

export enum ProfessionalFieldType {
  Department = 'DEPARTMENT'
}

export enum ProviderType {
  Apple = 'APPLE',
  Doctornow = 'DOCTORNOW',
  Kakao = 'KAKAO',
  Naver = 'NAVER'
}

/** 푸시 알림 */
export type PushNotification = {
  /** 알림 클릭시 이동 url */
  actionUrl?: Maybe<Scalars['String']>;
  /** 카테고리 정보 */
  category: PushNotificationCategory;
  /** 알림 코드 */
  code?: Maybe<Scalars['String']>;
  /** 알림 내용 */
  contents?: Maybe<Scalars['String']>;
  /** 알림 생성일 */
  createdAt: Scalars['DrTimestamp'];
  /** 알림 ID */
  id: Scalars['ID'];
  /** 알림 봤는지 여부 */
  isRead: Scalars['Boolean'];
  /** 알림 타이틀 */
  title: Scalars['String'];
};

/** 푸시 알림 벌크 확인 요청 */
export type PushNotificationBulkCheckMutationRequestInput = {
  /** 카테고리 아이디 */
  categoryId?: InputMaybe<Scalars['Int']>;
  /** 알림 아이디 */
  id: Scalars['ID'];
};

/** 푸시 알림 카테고리 */
export type PushNotificationCategory = {
  /** 알림 카테고리 코드 */
  code: Scalars['String'];
  /** 알림 ID */
  id: Scalars['ID'];
  /** 알림 카테고리 이름 */
  name: Scalars['String'];
};

/** 푸시 알림 확인 요청 */
export type PushNotificationCheckMutationRequestInput = {
  /** 알림 아이디 */
  id: Scalars['ID'];
};

/** 푸시 알림 내역 조회 요청 */
export type PushNotificationRequestInput = {
  /** 카테고리 아이디 */
  categoryId?: InputMaybe<Scalars['Int']>;
};

/** 실시간 상담 리뷰 */
export type QnaAnswerReview = {
  /** 답변 ID */
  answerPid: Scalars['ID'];
  /** 내용 */
  content?: Maybe<Scalars['String']>;
  /** 리뷰 생성일시 */
  createdAt: Scalars['DrTimestamp'];
  /** 리뷰 ID */
  id: Scalars['ID'];
  /** 평점 */
  rating: Scalars['Int'];
  /** 리뷰 태그 목록 */
  reviewTags: Array<QnaAnswerReviewTag>;
  /** 리뷰 최근 수정일시 */
  updatedAt: Scalars['DrTimestamp'];
};

export type QnaAnswerReviewCreateRequestInput = {
  /** 리뷰 컨텍스트 */
  answerPid: Scalars['ID'];
  /** 리뷰 내용 */
  content?: InputMaybe<Scalars['String']>;
  /** 리뷰 점수 */
  rating: Scalars['Int'];
  /** 리뷰 태그ID 리스트 */
  reviewTagIds: Array<Scalars['ID']>;
};

/** 실시간 상담 리뷰 태그 */
export type QnaAnswerReviewTag = {
  /** 리뷰 작성 화면에서 이 태그가 어떤 조건에서 노출되어야 하는지를 결정하는 값 */
  exposureType: QnaAnswerReviewTagExposureType;
  /** 리뷰 태그 ID */
  id: Scalars['ID'];
  /** 내용 */
  text: Scalars['String'];
};

export enum QnaAnswerReviewTagExposureType {
  Always = 'ALWAYS',
  Negative = 'NEGATIVE',
  Positive = 'POSITIVE'
}

export type QnaExpectedAnswerLeadTime = {
  expectedAnswerMinutes: Scalars['Int'];
  exposureType: QuestionDelayExposureType;
  isExposed: Scalars['Boolean'];
};

export type QnaRegistrationStatus = {
  registeredAnswerCount: Scalars['Int'];
  registeredQuestionCount: Scalars['Int'];
};

/** 질문답변 등록 현황 조회 조건 */
export type QnaRegistrationStatusRequestInput = {
  /** 검색 범위(분) */
  rangeMinute?: InputMaybe<Scalars['Int']>;
};

export type Query = {
  /** 좌표로 주소 조회(내부데이터) */
  addressByLocationFromDoctornow: Array<KoreaAddressGraphV3>;
  /** EMR 전체 조회 */
  allElectronicMedicalRecords: Array<ElectronicMedicalRecordGraph>;
  /**
   * 홈 배너 목록 조회
   * @deprecated Use allHomeBannersV2
   */
  allHomeBanners: Array<HomeBanner>;
  /** 홈 배너 목록 조회 V2 */
  allHomeBannersV2: Array<HomeBannerV2>;
  /** 빈혈 기록 */
  anemiaRecords: Array<AnemiaRecord>;
  /** 앱 버전 및 강제 업데이트 필요 여부 체크 */
  appVersion: AppVersionCheck;
  /** 첨부파일 다운로드 Pre-signed URL */
  attachmentDownloadPreSignedUrl: Scalars['String'];
  /** 첨부파일 썸네일 다운로드 Pre-signed URL */
  attachmentThumbnailDownloadPreSignedUrl: Scalars['String'];
  /** 첨부파일 업로드 Pre-signed URL */
  attachmentUploadPreSignedUrl: QuestionAttachmentUploadPreSignedUrl;
  /** 예약 가능한 전체 타임슬롯 조회 (오늘, 내일) */
  availableBookingTimeSlots: Array<DiagnosisDayScheduleGraph>;
  /** 방문 수령만 가능한지 확인 */
  availablePickupOnlyMethods: Scalars['Boolean'];
  /** 베스트 의사 리뷰 */
  bestDoctorReview?: Maybe<DoctorReview>;
  /** v2 베스트 건강매거진 조회 */
  bestMagazineV2: Magazine;
  /** 베스트 질문 */
  bestQuestionCards: Array<QuestionCard>;
  /** 자주 찾는 키워드 */
  bestTags: Array<QuestionTag>;
  /** 혈압 기록 */
  bloodPressureRecords: Array<BloodPressureRecord>;
  /** 혈당 기록 */
  bloodSugarRecords: Array<BloodSugarRecord>;
  /** 홈화면 카테고리 목록 */
  boardCategories: Array<BoardCategory>;
  /** 댓글에 속한 댓글 목록 */
  boardCommentBelongedBoardComments: Array<BoardCommentGraph>;
  /** 게시글 보기 */
  boardPost: BoardPost;
  /** 게시글 업로드 presigned_url 가져오기 */
  boardPostAttachmentUploadInfo: BoardPostAttachmentUploadInfoGraph;
  /** 신체 기록 */
  bodyInfoRecords: Array<BodyInfoRecord>;
  /** 신체 기록 */
  bodyMeasurementRecords: Array<BodyMeasurementRecord>;
  /** 전체 브랜드 조회 */
  brands: Array<BrandGraph>;
  /** 카테고리별 베스트 질문 목록 */
  categoryBestSimpleQuestions: Array<SimpleQuestionGraph>;
  /** 약관 동의했는지 여부 확인 */
  checkApproved: Scalars['Boolean'];
  /** 약관 동의했는지 여부 확인 */
  checkApprovedByType: CheckApprovedAgreementGraph;
  /** 해당 약국이 유저의 단골약국인지 조회 */
  checkUserFavoritePharmacy: Scalars['Boolean'];
  /** 마이페이지 상단 & 설정 페이지의 프사 및 닉네임 */
  communityUser: CommunityUser;
  /** 설정 페이지 프로필 이미지 프리셋 */
  communityUserProfileImagePresets: Array<CommunityUserProfileImagePreset>;
  /** 커스텀 프로필 이미지 업로드 pre-signed URL */
  communityUserProfileImageUploadInfo: CommunityUserProfileImageUploadInfo;
  /** 여러날짜 상담 스케쥴 조회 (유저용) */
  counselingBookingDaySchedulesByUser: Array<CounselingBookingDayScheduleGraph>;
  /** 상담 스케쥴 조회 (유저용) */
  counselingBookingSchedulesByUser: Array<CounselingBookingScheduleGraph>;
  /** 유저 상담 조회 */
  counselingByUser: Counseling;
  /** 유저를 위한 Agora 채팅 토큰 생성 */
  counselingChannelTokenByUser: CounselingChannelTokenGraph;
  /** 정책따라 여러날짜 상담 스케쥴 조회 */
  counselingDaySchedulesByPolicy: Array<CounselingDayScheduleGraph>;
  /** 유저 상담 목록 조회 */
  counselingListByUser: Array<Counseling>;
  /** 유저에 의한 상담자 목록 조회 */
  counselorsByUser: Array<Counselor>;
  /** 서버 날짜와 시간에 따른 비대면 진료 허용시간 타입 조회 */
  currentTelemedicineEligibleTimeType: TelemedicineEligibleTimeType;
  dailyPedometerInfo: PedometerDailyInfo;
  /** 요일 조회 */
  dayOfWeek?: Maybe<DayOfWeekType>;
  /** 과목ID로 건강매거진 목록 조회 */
  departmentMappedMagazineCursorPage: MagazineCursorPage;
  /** 과목 아이디로 과목 조회 */
  departmentsById?: Maybe<Department>;
  /** 유저의 진료 리스트 V2 */
  diagnosesByUserV2: Array<UserDiagnosis>;
  /** 진료 첨부파일 업로드용 pre-signed url 목록 조회 */
  diagnosisAttachmentPreSignedUrls: Array<SymptomImageUploadPreSignedUrl>;
  /** 유저의 진료 상세 */
  diagnosisById: UserDiagnosis;
  /** 진료 추가서류 파일 조회 (로그인 필요) */
  diagnosisDocumentPreSignedUrl: Scalars['String'];
  /** 아이디로 질병 가져오기 */
  disease: Disease;
  /** 질병 목록 전체 가져오기 */
  diseaseCards: Array<DiseaseCard>;
  /** 질병백과 가져오기 */
  diseaseEncyclopediaByUser: DiseaseEncyclopediaItem;
  /** 질병 키워드로 병원 리스트 조회 */
  diseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPage: HospitalInfoWithReviewSummaryCursorPageV3;
  /** 유저앱 의사 상세페이지 무료상담 질문 목록 */
  doctorDetailQuestionCursorPage: DoctorDetailQuestionCursorPage;
  /** 의사 리뷰 publicId */
  doctorReview: Array<DoctorReview>;
  /** 의사 리뷰 지표 */
  doctorReviewMetric: DoctorReviewMetric;
  /** 유저의 복약중인 진료 리스트 */
  doseActiveDiagnosesByUser: Array<Diagnosis>;
  /** 닉네임 중복 조회 */
  existCommunityUserNickname: Scalars['Boolean'];
  /** 추가 주문 상품이 존재하는지 확인 */
  existPharmacyAdditionalOrderProductsByPharmacyId: Scalars['Boolean'];
  /** 네이버 블로그, 카페 검색결과 */
  externalPortalSearchResults: HospitalSearchResultGraph;
  /** 네이버 블로그, 카페 검색결과 */
  externalPortalSearchResultsV2: HospitalSearchResultGraph;
  /** 대면의사ID로 대면의사 조회 */
  faceToFaceDoctorById: HospitalDoctor;
  /** 대면의사 PublicID로 대면의사 조회 */
  faceToFaceDoctorByPublicId: HospitalDoctor;
  /** 병원찾기 홈 증상 키워드 */
  faceToFaceTreatmentKeywords: Array<FaceToFaceTreatmentKeyword>;
  /** 가족 목록 조회 */
  families: Array<FamilyGraph>;
  /** 가족 상세 조회 */
  family: FamilyGraph;
  favoritePharmacies: Array<NearbyPharmacy>;
  /** 자주 찾는 검색어 */
  frequentSearchKeywords: Array<Scalars['String']>;
  /** 약국찾기 리스트 탭 목록 조회 */
  generalNearbyPharmacySearchTabs: Array<NearbyPharmacySearchTabGraph>;
  /** 일반 검색 정렬 기준과 필터 목록 조회 */
  generalSearchFilters: GeneralSearchFilter;
  generalSearchMetaByKeyword?: Maybe<GeneralSearchMeta>;
  /**
   * ip로 주소 조회, ip 넘겨받음
   * @deprecated V2로 전환된 예정
   */
  getAddressByIp?: Maybe<GeoLocation>;
  /** ip로 주소 조회 */
  getAddressByIpV2?: Maybe<GeoLocation>;
  /** 좌표로 주소 조회 */
  getAddressByLocation?: Maybe<GeneralAddress>;
  /** 카테고리 조건으로 약관 조회 */
  getAgreementsByCategory: Array<Agreement>;
  /** 판매 채널별 모든 카테고리 리스트 */
  getAllCategoriesByChannelType: Array<CommerceCategoryGraph>;
  /** 전체 병원 리스트 조회, SEO를 위해 사용 */
  getAllHospitals: Array<Hospital>;
  /** 노출할 광고 소재 가져오기 */
  getBannerAdExchange?: Maybe<BannerAdExchange>;
  /** 요청 컨텍스트로 커머스 주문 조회 */
  getCommerceOrdersByRequestContext: Array<CommerceOrder>;
  /** 유저의 커머스 주문 리스트 */
  getCommerceOrdersByUser: Array<CommerceOrder>;
  /** 전체 진료과목 그룹 리스트 조회 (커스텀 과목) */
  getDepartmentGroups: Array<DepartmentGroup>;
  /** 전체 진료과목 그룹 리스트와 추천태그 조회 (커스텀 과목) */
  getDepartmentGroupsWithRecommendationTags: Array<DepartmentGroupWithRecommendationTag>;
  /** 전체 진료과목 리스트 조회 (심평원 과목) */
  getDepartments: Array<DepartmentV2>;
  /** 진료 과목 그룹에 해당하는 진료과목 조회 */
  getDepartmentsByDepartmentGroupIds: Array<DepartmentV2>;
  /** 유저 진료 취소 사유 조회 */
  getDiagnosisCancelReasons: Array<DiagnosisCancelReason>;
  /** 사용자용 진료 취소 사유 조회 V2 - 진료 상태와 타입에 맞는 취소 사유 반환 */
  getDiagnosisCancelReasonsV2: Array<DiagnosisCancelReasonV2>;
  /** 진료(증상/과목) 전체 카테고리 조회 V2 */
  getDiagnosisCategoriesV2: DiagnosisCategory;
  /** 질병 백과사전 사이트맵 조회 */
  getDiseaseEncyclopediaSitemaps: DiseaseEncyclopediaSitemapPage;
  /** 유저에 의한 의사 단건 조회 by id */
  getDoctorByIdByUser: DoctorByUserV2;
  /** 유저에 의한 의사 단건 조회 by public id */
  getDoctorByUser: DoctorByUserV2;
  /** 특정 의사의 진료 예약 스케줄 가져오기(오늘, 내일) */
  getDoctorDiagnosisBookingSchedules: Array<DiagnosisDayScheduleGraph>;
  /** 의사의 증상약 진료 오픈일자 조회 */
  getDoctorTreatmentMedicineOpenDate: DoctorTreatmentMedicineOpenDateGraph;
  /** 키워드 (ex. 의사명, 병원명)로 비대면 진료 의사 목록 조회 */
  getDoctorsByKeyword: NonFaceToFaceDoctorCursorPage;
  /** 대면진료 목록 조회 */
  getFaceToFaceDiagnoses: Array<FaceToFaceDiagnosis>;
  /** 대면진료 상세 조회 */
  getFaceToFaceDiagnosis: FaceToFaceDiagnosis;
  /** publicId로 대면진료 예약 폼 조회 */
  getFaceToFaceDiagnosisBookingFormByPublicId: FaceToFaceDiagnosisBookingForm;
  /** 대면진료 예약 폼 리스트 조회 */
  getFaceToFaceDiagnosisBookingFormsByBookingIds: Array<FaceToFaceDiagnosisBookingForm>;
  /** 대면 의사리스트 조회 */
  getFaceToFaceDoctors: Array<HospitalDoctor>;
  /** 병원 PublicId로 대면 의사리스트 조회 */
  getFaceToFaceDoctorsByHospitalPublicId: Array<HospitalDoctor>;
  /** 타겟별 피드백 사유 목록 조회 */
  getFeedbackReasons: Array<FeedbackReason>;
  /** publicId로 문진표 조회 */
  getHistoryTakingByPublicId: HistoryTaking;
  /** 공휴일 날짜 조회 */
  getHolidays: Array<Scalars['String']>;
  /** 병원 정보 조회 (의사리스트 포함), 병원웹, 태블릿에서 사용 */
  getHospital: Hospital;
  /** 병원 정보 조회, 미사용인것으로 추정 */
  getHospitalById: Hospital;
  /** publicId로 병원 정보 조회, 병원찾기에서 사용 */
  getHospitalByPublicId: Hospital;
  /** 병원 사이트맵 조회 */
  getHospitalSitemaps: HospitalSitemapPage;
  /** 병원 이름 패턴으로 병원 목록 조회, 병원웹 회원가입에서 사용 */
  getHospitalsByHospitalNamePattern: Array<Hospital>;
  /** 병원 이름 패턴과 파트너쉽 상태로 병원 목록 조회 */
  getHospitalsByHospitalNamePatternAndPartnershipStatus: Array<Hospital>;
  /** 의약품사전 사이트맵 조회 */
  getMedicineDictionarySitemaps: MedicineDictionarySitemapPage;
  /** 비급여 진료비 지원금 추천코드 조회 */
  getNonBenefitDiagnosisPriceSupportInvitationCode: InvitationCode;
  /**
   * 비급여 SEO 사이트맵 조회
   * @deprecated Use getNonBenefitSeoSitemapsV2 instead
   */
  getNonBenefitSeoSitemaps: HospitalSitemapPage;
  /** 비급여 SEO 사이트맵 조회 V2 */
  getNonBenefitSeoSitemapsV2: HospitalSitemapPage;
  /** 진료 과목 그룹에 해당하는 진료과목 조회 */
  getNonFaceToFaceDepartments: Array<NonFaceToFaceDepartment>;
  /** 공지사항 디테일 */
  getNoticeDetail: Notice;
  /** 공지사항 */
  getNotices: NoticeList;
  /** 센드버드 유저 생성 또는 정보 가져오기 */
  getOrCreateSendbirdUser: SendbirdUserGraph;
  /** 주문 취소 사유 조회 */
  getOrderCancelReasons: Array<OrderCancelReason>;
  /** 환자 상세 조회 */
  getPatient?: Maybe<Patient>;
  /** 결제 종합 상세 조회 */
  getPaymentTotal?: Maybe<Array<PaymentTotalGraph>>;
  /** 카드번호에 따라 PG사 및 해당 PG사 약관 반환 */
  getPgAgreementsByCardNumber: PgAgreementInfo;
  /**
   * 인기 있는 질환 조회
   * @deprecated 이거 사용중인데 사용하면 안 됩니다.
   */
  getPopularDiseases: Array<PopularDisease>;
  /**
   * 인기 검색어 조회
   * @deprecated 프론트에 코드가 남아있습니다. - 인기 검색어를 위한 임시 코드
   */
  getPopularSymptoms: Array<PopularSymptom>;
  /** 팝업 공지사항 */
  getPopupNotice?: Maybe<Notice>;
  /** 최근 진료받은 의사 조회 */
  getRecentDoctor?: Maybe<RecentDoctor>;
  /** 롤링 공지사항 */
  getRollingNotices: Array<Notice>;
  /** 만족도조사 노출정보 조회 */
  getSatisfactionVisibleInfo?: Maybe<SatisfactionVisibleInfo>;
  /** 병원의 전체 리뷰 개수와 평점 */
  getTotalReviewCountWithAverageRatingByPublicId: TotalReviewCountWithAverageRating;
  /** 사용자 주소 리스트 조회 */
  getUserAddresses: Array<UserAddress>;
  /** 건강 분석 정보 가져오기 (유저용) */
  healthAnalysisReportByUser: HealthAnalysisReport;
  /** 건강 조회 대시보드 조회 (탭홈용) */
  healthDashboardForTabHome: HealthDashboardForTabHome;
  /** 최신 건강보험 스크래핑 완료 일시 */
  healthInsuranceLastUpdatedDate?: Maybe<Scalars['DrTimestamp']>;
  /** 최신 건강보험 스크래핑 상태 */
  healthInsuranceScrapingStatus?: Maybe<HealthInsuranceScrapingStatus>;
  /** 홈 환영인사 조회 */
  homeGreeting: HomeGreeting;
  /** 홈 증상 카테고리 목록 조회 */
  homeMedicalCategories: Array<HomeMedicalCategory>;
  /** 네이버 플레이스 블로그 리뷰 */
  hospitalExternalPost: HospitalExternalPost;
  /** 병원의 비급여 카테고리 아이템 항목 가격표 조회 */
  hospitalNonBenefitCategoryItemPriceList?: Maybe<HospitalNonBenefitCategoryItemPriceListGraph>;
  /** 병원 비급여 정보 조회 */
  hospitalNonBenefitInfo: HospitalNonBenefitInfo;
  /** 병원 프로필 이미지 업로드용 pre-signed url 조회 */
  hospitalProfileImageUploadPreSignedUrl: HospitalProfileImageUploadPreSignedUrl;
  /** 병원찾기 홈 인기검색어 출력 */
  hotKeywords: Array<HotKeyword>;
  /** 배너 목록 조회 */
  imageBanners: Array<ImageBanner>;
  /** 유저 코드 조회 */
  invitationCodeByUserInviter?: Maybe<InvitationCode>;
  /** 피쳐가 on 상태인지 여부 확인 */
  isFeatureOn: Scalars['Boolean'];
  /** 건강매거진 키워드 검색 */
  keywordSearchMagazineCursorPage: MagazineCursorPage;
  /** 키워드 검색 질문 목록 */
  keywordSearchQuestionCardCursorPage: QuestionCardCursorPage;
  /** 질병 검색 */
  keywordSearchedDiseaseCursorPage: DiseaseCursorPage;
  /** 최근 건강 기록 (건강탭용) */
  latestHealthRecordForTab: LatestHealthRecordForTab;
  /** 간기능 기록 */
  liverFunctionRecords: Array<LiverFunctionRecord>;
  /** 건강매거진 저자 정보 조회 */
  magazineAuthor: MagazineAuthorGraph;
  /** 저자가 작성한 건강매거진 목록 조회 */
  magazineByAuthorPublicId: MagazineListGraph;
  /** 건강매거진 갯수 조회 */
  magazineCount: MagazineCount;
  /** v2 건강매거진 목록 조회 */
  magazineCursorPage: MagazineCursorPage;
  /** 매거진 관련 게시글 목록 */
  magazineRelatedBoardPosts: Array<BoardPost>;
  /** 건강매거진 관련 건강매거진 조회 */
  magazineRelatedMagazines: Array<Magazine>;
  /** 매거진 관련 질문 카드 목록 */
  magazineRelatedQuestionCards: Array<QuestionCard>;
  /** v2 건강매거진 단건 조회 */
  magazineV2: Magazine;
  /** 병원찾기 홈 메디컬 카테고리(과목, 시술, 비급여) 출력 */
  medicalCategories: Array<MedicalCategory>;
  /** 의료시설 방문내역 */
  medicalFacilityVisitHistory: Array<MedicalFacilityVisitHistory>;
  /** 약 조회 */
  medicine: Medicine;
  /** 의약품 사전 상세 조회 */
  medicineDictionaryItemByPublicId: MedicineDictionaryItemGraph;
  /** 메딕터 유저 정보 */
  mediktorExternUser: MediktorExternUser;
  /** 내 질문에 답변한 의료진 */
  myAnswerCursorPage: AnswerCursorPage;
  /** 내 댓글 보기 */
  myBoardCommentCursorPage: BoardCommentCursorPage;
  /** 내 게시물 가져오기 */
  myBoardPostCursorPage: BoardPostCursorPage;
  /** 내가 좋아요한 질문 목록 */
  myLikedQuestionCardCursorPage: QuestionCardCursorPage;
  /** 내가 작성한 질문 목록(삭제된 것 포함) */
  myQuestionCardCursorPage: QuestionCardCursorPage;
  /** 내가 작성한 리뷰 개수 조회 */
  myReviewCount: Scalars['Int'];
  /** 내가 작성한 리뷰 목록 조회 */
  myReviews: Array<Review>;
  /** 내 추가 확인이 필요한 질문 조회 */
  myUncheckedQuestion?: Maybe<Question>;
  /** 질병명으로 질병 가져오기 */
  nameMatchedDisease: Disease;
  /** 비슷한 시간대에 올라온 다른 질문 */
  nearSimpleQuestions: Array<SimpleQuestionGraph>;
  /** public id 기반 주변 약국 상세 조회 */
  nearbyPharmacyDetailByPublicId?: Maybe<NearbyPharmacy>;
  /** 주변 약국 상세 조회 */
  nearbyPharmacyDetailV3ByUser?: Maybe<NearbyPharmacy>;
  /** 지역 코드 기반 주변 약국 검색 */
  nearbyPharmacyV3ByRegionCode: Array<NearbyPharmacy>;
  /** 처방전 기반 가장 저렴한 약품 가격 정보와 함께 주변 약국 검색 */
  nearbyPharmacyV3ByUser: Array<NearbyPharmacy>;
  /** 홈화면 전체 & 카테고리별 포스트 목록 */
  newestBoardPostCursorPage: BoardPostCursorPage;
  /** 최신순 질문 목록 */
  newestQuestionCardCursorPage: QuestionCardCursorPage;
  /** 다음 건강매거진 PID 조회 */
  nextMagazinePid?: Maybe<Scalars['ID']>;
  /** 비급여 항목 카테고리 목록 조회 */
  nonBenefitCategories?: Maybe<Array<NonBenefitCategory>>;
  /** 비급여 카테고리 단건 조회 */
  nonBenefitCategoryById?: Maybe<NonBenefitCategory>;
  /** 비급여 카테고리 id로 대표 아이템 처방단위 목록 조회 */
  nonBenefitCategoryPrescriptionUnits?: Maybe<Array<NonBenefitItemUnitStructureGraph>>;
  /** 비급여 카테고리 구조 조회 */
  nonBenefitCategoryStructures?: Maybe<NonBenefitCategoryStructureInfoGraph>;
  /** 비급여 지도 약국찾기 리스트 탭 목록 조회 */
  nonBenefitMapNearbyPharmacySearchTabs: Array<NearbyPharmacySearchTabGraph>;
  /**
   * SEO 를 위한 비급여 처방약 조회
   * @deprecated Use nonBenefitMedicinesForSeoV2 instead
   */
  nonBenefitMedicinesForSeo: Array<TreatmentMedicine>;
  /** SEO 를 위한 비급여 처방약 조회 V2 */
  nonBenefitMedicinesForSeoV2: Array<TreatmentMedicine>;
  /** 정렬을 위한 비급여 처방약 조회 V2 */
  nonBenefitMedicinesForSortingV2: Array<TreatmentMedicine>;
  /**
   * 방문 수령만 가능한지 확인
   * @deprecated Use nonBenefitPriceTotalSummaryV2 instead
   */
  nonBenefitPriceTotalSummary: NonBenefitPriceTotalSummary;
  /** 방문 수령만 가능한지 확인 V2 */
  nonBenefitPriceTotalSummaryV2: NonBenefitPriceTotalSummary;
  /** 비급여 검색 정렬 기준과 필터 목록 조회 */
  nonBenefitSearchFilters: NonBenefitSearchFilter;
  /**
   * 홈 > 비대면 진료 시작하기 > 대표 증상/과목 목록 보여주기
   * @deprecated use homeMedicalCategories instead
   */
  nonF2fMedicalCategories: Array<NonF2fMedicalCategory>;
  /** 빠른 비대면진료 의사 조회 */
  nonF2fQuickDiagnosisDoctor?: Maybe<NonF2fQuickDiagnosisMatch>;
  /** 유저를 위한 Agora 채팅 토큰 생성 */
  nonFaceToFaceDiagnosisChannelTokenByUser: NonFaceToFaceDiagnosisChannelTokenGraph;
  /** 과목/증상별 리뷰 개수 */
  numberOfReviewsByDiagnosisType: Array<ReviewCount>;
  /** 별점별 리뷰 개수 */
  numberOfReviewsByRating: Array<NumberOfReviewsByRating>;
  oAuthUserProfile: OAuthUserProfile;
  /** 상담 스케쥴 전체 상태 조회 */
  overallCounselingSchedule: OverallCounselingScheduleGraph;
  /** 소아과 리뷰 목록 조회 */
  pediatricsReviews: Array<PediatricsReviewGraph>;
  /** 맞춤형 건기식 종합 정보 */
  personalizedNutritionAggregateByUser: PersonalizedNutritionAggregate;
  /** 맞춤형 건기식 상담 정보 */
  personalizedNutritionDetailByUser: PersonalizedNutritionDetail;
  /** 맞춤형 건기식 상담 정보 리스트 */
  personalizedNutritionDetailListByUser: Array<PersonalizedNutritionDetail>;
  /** 맞춤형 건기식 주문서 정보 */
  personalizedNutritionOrderSheetByUser: PersonalizedNutritionOrderSheetGraph;
  /** 약국 마켓플레이스 카테고리 조회 */
  pharmacyAdditionalOrderCategories: Array<PharmacyAdditionalOrderCategory>;
  /** 카테고리별 추가 주문 상품 목록 조회 */
  pharmacyAdditionalOrderProductsByPharmacyIdAndCategoryId: Array<PharmacyAdditionalOrderProduct>;
  /** 약국 처방 가능한 약 목록 조회 */
  pharmacyDispensableMedicines?: Maybe<PharmacyDispensableMedicines>;
  /** 약국 약품 가격 요약 정보 조회 (지역별/전국) */
  pharmacyMedicinePriceTotalSummary: PharmacyMedicinePriceTotalSummary;
  /**
   * 약국별 리뷰 목록 조회
   * @deprecated pharmacyReviews 사용
   */
  pharmacyReceiptReviews: Array<PharmacyReceiptReview>;
  /** 별점별 리뷰 태그 조회 */
  pharmacyReviewTagsByRating: Array<PharmacyReviewTag>;
  pharmacyReviews: Array<PharmacyReview>;
  /** 약국 재선택 사유 조회 */
  pharmacySelectionChangeReasons: Array<PharmacySelectionChangeReason>;
  /** 방문수령 리스트 탭 단일 조회 */
  pickupNearbyPharmacySearchTab?: Maybe<NearbyPharmacySearchTabGraph>;
  /** 포인트 쿠폰 상세 조회 */
  pointCoupon: PointCouponDetailInfo;
  /** 포인트 쿠폰 상품 목록 조회 */
  pointCoupons: Array<PointCoupon>;
  /** 포인트 이벤트 내역 조회 */
  pointEvents: Array<PointEvents>;
  pointRewards: Array<PointReward>;
  /** 인기 질병백과 조회 */
  popularDiseaseEncyclopedias: Array<DiseaseEncyclopediaItem>;
  /** 의약품 사전 많이 검색된 아이템 조회 */
  popularMedicineDictionaryItems: Array<MedicineDictionaryItemGraph>;
  /** 검색 키워드 가져오기 */
  popularSearchKeywords: Array<Scalars['String']>;
  /** 영수증 업로드용 presigned url 조회 */
  preSignedUrlForReceiptUpload: ReceiptUploadPreSignedUrl;
  /** 이전 건강매거진 PID 조회 */
  prevMagazinePid?: Maybe<Scalars['ID']>;
  /** 푸시 알림 카테고리 목록 조회 */
  pushNotificationCategories: Array<PushNotificationCategory>;
  /** 푸시 알림 목록 조회 */
  pushNotifications: Array<PushNotification>;
  /** 리뷰 태그 목록 조회 (리뷰 작성 화면용) */
  qnaAnswerReviewTags: Array<QnaAnswerReviewTag>;
  /** 리뷰 목록 조회 */
  qnaAnswerReviews: Array<QnaAnswerReview>;
  qnaExpectedAnswerLeadTime: QnaExpectedAnswerLeadTime;
  /** 질문답변 등록 상태 */
  qnaRegistrationStatus: QnaRegistrationStatus;
  /**
   * 단일 질문 조회
   * @deprecated Use questionV2
   */
  question: Question;
  /** 질문 카테고리 목록 조회 */
  questionCategories: Array<QuestionCategory>;
  /** 질문 카테고리 단일 조회 */
  questionCategory: QuestionCategory;
  /** 질문 카테고리 그룹 목록 조회 */
  questionCategoryGroups: Array<QuestionCategoryGroup>;
  /** 실시간 상담 주문서 정보 */
  questionOrderSheetByUser: QuestionOrderSheetGraph;
  /** 질문 관련 건강매거진 조회 */
  questionRelatedMagazines: Array<Magazine>;
  /** 간략 질문 가져오기 - 제목이 생성되었는지의 용도로도 사용한다. */
  questionTitleGenerated: Scalars['Boolean'];
  /** 단일 질문 조회 V2 */
  questionV2?: Maybe<Question>;
  /** 연속 퀴즈 진행 결과 조회 */
  quizStreakProgress?: Maybe<QuizStreakProgress>;
  /** 건강매거진 목록 랜덤 조회 */
  randomMagazines: Array<Magazine>;
  reasonsForLeaving: Array<ReasonForLeavingGraph>;
  /** 유저의 최근 진료 조회 */
  recentDiagnosisByUser?: Maybe<UserDiagnosis>;
  /** 추천 추가 주문 상품 목록 조회 */
  recommendedPharmacyAdditionalOrderProducts: PharmacyMarketplaceProductRecommendationGraph;
  /** 홈화면 추천/인기 포스트 목록 */
  recommendedPopularBoardPosts: Array<BoardPost>;
  /** 대체 성분 검색 */
  searchAlternativeIngredients: Array<Ingredient>;
  /** 배송 방법 조회 */
  searchAvailableDeliveryMethods: Array<SearchAvailableDeliveryMethod>;
  /** 검색 포스트 목록 */
  searchBoardPostCursorPage: BoardPostCursorPage;
  /** 브랜드에 소속된 의사 목록 조회 */
  searchBrandDoctors: Array<DoctorByUserV2>;
  /** 배달 가능한 약국 후보 조회 */
  searchDeliveryAvailableCandidates?: Maybe<SearchPharmacyDeliverableCandidateGraph>;
  /** 질환백과 리스트 조회 */
  searchDiseaseEncyclopedia: DiseaseEncyclopediaSearch;
  /** 질환백과 리스트 커서 기반 조회 */
  searchDiseaseEncyclopediaByCursorScorePage: DiseaseEncyclopediaByCursor;
  /** 시간 우선 의사 검색 */
  searchDoctorsByTimeSlot: NonF2fDoctorSearchResultGraphV2;
  /** 유저앱 의사 리스트 조회 */
  searchDoctorsByUser: NonF2fDoctorSearchResult;
  /** SEO 용 의사 목록 조회 */
  searchDoctorsForSeoByUser: Array<DoctorByUserV2>;
  /** 대면진료 예약 리스트 조회 */
  searchFaceToFaceDiagnosisBookingsByHospital: Array<FaceToFaceDiagnosisBooking>;
  /** 전담의사 검색 */
  searchFamilyDoctors: SearchFamilyDoctor;
  /** 일반적인 병원 키워드 검색 */
  searchHospitalGenerally?: Maybe<HospitalGeneralSearchCursorPage>;
  /**
   * 병원 키워드 검색 v2
   * @deprecated searchHospitalsV3 사용
   */
  searchHospitalsV2?: Maybe<HospitalInfoWithReviewSummaryCursorPageV3>;
  /** [독감예방접종] 병원 검색 */
  searchInfluenzaHospitals?: Maybe<HospitalInfluenzaCursorPage>;
  /** 주소 검색 */
  searchKoreaAddress: KoreaAddress;
  /** 전체 주소 검색 */
  searchKoreaAddressHierarchy: Array<KoreaAddressHierarchy>;
  /** 주소 검색 V2 */
  searchKoreaAddressV2: Array<KoreaAddressV2>;
  /** 매거진 목록 */
  searchMagazines: MagazineSearchResult;
  /** 의약품 사전 리스트 조회 */
  searchMedicineDictionary: MedicineDictionaryGraph;
  /** 의약품 사전 리스트 커서 기반 조회 */
  searchMedicineDictionaryByCursorScorePage: MedicineDictionaryByCursorGraph;
  /** 비급여 병원 키워드 검색 */
  searchNonBenefitHospitals?: Maybe<NonBenefitHospitalSearchCursorPage>;
  /** 비대면 의사 검색 */
  searchNonF2fDoctors: NonF2fDoctorSearchResult;
  /**
   * 유저에 의한 SEO 용 의사 목록 조회
   * @deprecated Use searchDoctorsForSeoByUser instead
   */
  searchNonF2fDoctorsForSeoByUser: Array<DoctorByUserV2>;
  /** 지역 기반 약국 조회 */
  searchPharmaciesByRegionCode: Array<PharmacyByUser>;
  /** 매칭중인 약국 후보 조회 */
  searchPharmacyMatchingCandidates: Array<SearchMatchingPharmacyCandidate>;
  /** 유저의 상품 검색 (레거시) */
  searchProducts: Array<CommerceProductGraph>;
  /** 유저의 상품 검색 (최신) */
  searchProductsByUser: ProductList;
  /** 최신순 질문 목록 */
  searchQuestions: QuestionSearchResult;
  /** 검색 결과 피드백 상위 카테고리 조회 */
  searchResultFeedbackCategories: Array<SearchResultFeedbackCategory>;
  /** 검색 결과 피드백 서브 카테고리 조회 */
  searchResultFeedbackSubCategoriesByCategoryId: Array<SearchResultFeedbackCategory>;
  /** 송장 출력에 필요한 데이터 조회 */
  shippingLabel?: Maybe<ShippingLabel>;
  /** 키워드 검색 유사한 질문 목록 */
  similarSearchQuestionCardCursorPageRequest: QuestionCardCursorPage;
  /** 구독 유저 조회 */
  subscriptionByUser: Array<SubscriptionInfo>;
  /** 구독 유저 조회 */
  subscriptionListByUser: Array<SubscriptionInfo>;
  /** 설문 문항 목록 조회 */
  surveyQuestionList: SurveyQuestionList;
  /** 건강매거진 태그 검색 */
  tagMagazineCursorPage: MagazineCursorPage;
  /** 비대면진료 대상 그룹 목록 조회 */
  telemedicineEligibleGroups: Array<TelemedicineEligibleGroup>;
  /** 임시 파일 업로드용 Presigned URL */
  temporaryPresignedUrls: Array<PresignedUrlGraph>;
  /** 오늘 복약기록 포인트 미션 정보 */
  todayDoseRecordPointMission: DoseRecordPointMission;
  /** 오늘의 퀴즈 조회 v2 */
  todayQuiz?: Maybe<Quiz>;
  /** 증상 카테고리 출력 */
  treatmentCategories: Array<TreatmentCategory>;
  /** 증상에 해당하는 카테고리 조회 V2 */
  treatmentCategoriesByTreatmentIdV2: TreatmentCategoryByTreatment;
  /** 증상ID로 약 계열 조회 */
  treatmentMedicinesByTreatmentId: Array<TreatmentMedicineV2>;
  /** 증상 출력 */
  treatments: Array<Treatment>;
  /** 사용자 정보 조회 */
  user: MemberUser;
  /** 유저 게임 상품 정보 조회 */
  userGamePrizes: UserGamePrizesGraph;
  /** 유저 미션 정보 조회 */
  userMissions: UserMissionsGraph;
  /** 유저 결제수단 리스트 */
  userPayments: Array<UserPayment>;
  /** 유저 잔여 포인트 조회 */
  userPointAmount: UserPointAmount;
  /** 유저 프로필 목록 조회 */
  userProfiles: Array<UserProfile>;
  /** 예방접종 필터 정보 조회 */
  vaccinationsForUser: Array<VaccinationInfoGraph>;
  /** 가능한 닉네임 확인 */
  validateCommunityUserNickname: CommunityUserNicknameValidationGraph;
  /** 웰컴 포인트 조회 */
  welcomePoint: Scalars['Int'];
};


export type QueryAddressByLocationFromDoctornowArgs = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};


export type QueryAllHomeBannersV2Args = {
  request: HomeBannerRequestInput;
};


export type QueryAnemiaRecordsArgs = {
  paginationCriteria: PaginationCriteriaInput;
  source?: InputMaybe<Scalars['String']>;
};


export type QueryAppVersionArgs = {
  currentVersion: Scalars['String'];
};


export type QueryAttachmentDownloadPreSignedUrlArgs = {
  questionAttachmentId: Scalars['ID'];
};


export type QueryAttachmentThumbnailDownloadPreSignedUrlArgs = {
  questionAttachmentId: Scalars['ID'];
};


export type QueryAttachmentUploadPreSignedUrlArgs = {
  fileExtension: Scalars['String'];
};


export type QueryAvailablePickupOnlyMethodsArgs = {
  request: AvailablePickupOnlyMethodsRequestInput;
};


export type QueryBestDoctorReviewArgs = {
  doctorPublicId: Scalars['ID'];
};


export type QueryBestQuestionCardsArgs = {
  size?: InputMaybe<Scalars['Int']>;
};


export type QueryBestTagsArgs = {
  size: Scalars['Int'];
};


export type QueryBloodPressureRecordsArgs = {
  paginationCriteria: PaginationCriteriaInput;
  source?: InputMaybe<Scalars['String']>;
};


export type QueryBloodSugarRecordsArgs = {
  paginationCriteria: PaginationCriteriaInput;
  source?: InputMaybe<Scalars['String']>;
};


export type QueryBoardCommentBelongedBoardCommentsArgs = {
  request: BoardCommentBelongedBoardCommentsRequestInput;
};


export type QueryBoardPostArgs = {
  boardPostPid: Scalars['ID'];
};


export type QueryBoardPostAttachmentUploadInfoArgs = {
  fileExtension: Scalars['String'];
};


export type QueryBodyInfoRecordsArgs = {
  paginationCriteria: PaginationCriteriaInput;
  source?: InputMaybe<Scalars['String']>;
};


export type QueryBodyMeasurementRecordsArgs = {
  paginationCriteria: PaginationCriteriaInput;
  source?: InputMaybe<Scalars['String']>;
};


export type QueryCategoryBestSimpleQuestionsArgs = {
  request: CategoryBestSimpleQuestionsRequestInput;
};


export type QueryCheckApprovedArgs = {
  category: AgreementCategory;
};


export type QueryCheckApprovedByTypeArgs = {
  request: AgreementsApprovedCheckApiRequestInput;
};


export type QueryCheckUserFavoritePharmacyArgs = {
  pharmacyId: Scalars['ID'];
};


export type QueryCommunityUserProfileImageUploadInfoArgs = {
  fileExtension: Scalars['String'];
};


export type QueryCounselingBookingDaySchedulesByUserArgs = {
  request: CounselingBookingDaySchedulesByUserRequestInput;
};


export type QueryCounselingBookingSchedulesByUserArgs = {
  request: CounselingBookingSchedulesByUserRequestInput;
};


export type QueryCounselingByUserArgs = {
  counselingId: Scalars['ID'];
};


export type QueryCounselingChannelTokenByUserArgs = {
  counselingId: Scalars['Int'];
};


export type QueryCounselingDaySchedulesByPolicyArgs = {
  request: CounselingDaySchedulesByPolicyRequestInput;
};


export type QueryDayOfWeekArgs = {
  date: Scalars['String'];
};


export type QueryDepartmentMappedMagazineCursorPageArgs = {
  request: DepartmentMappedMagazineCursorPageRequestInput;
};


export type QueryDepartmentsByIdArgs = {
  departmentId: Scalars['ID'];
};


export type QueryDiagnosesByUserV2Args = {
  paginationCriteria: PaginationCriteriaInput;
};


export type QueryDiagnosisAttachmentPreSignedUrlsArgs = {
  fileExtensions: Array<Scalars['String']>;
};


export type QueryDiagnosisByIdArgs = {
  diagnosisId: Scalars['ID'];
};


export type QueryDiagnosisDocumentPreSignedUrlArgs = {
  diagnosisDocumentId: Scalars['ID'];
};


export type QueryDiseaseArgs = {
  diseaseId: Scalars['ID'];
};


export type QueryDiseaseEncyclopediaByUserArgs = {
  diseaseEncyclopediaPid: Scalars['ID'];
};


export type QueryDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageArgs = {
  request: DiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageRequestInput;
};


export type QueryDoctorDetailQuestionCursorPageArgs = {
  request: DoctorDetailQuestionCursorPageRequestInput;
};


export type QueryDoctorReviewArgs = {
  doctorReviewRequest: DoctorReviewRequestInput;
  doctorReviewSort: DoctorReviewSort;
  pagingRequest: PagingRequestInput;
};


export type QueryDoctorReviewMetricArgs = {
  doctorReviewSearchRequest: DoctorReviewSearchRequestV2Input;
};


export type QueryExistCommunityUserNicknameArgs = {
  nickname: Scalars['String'];
};


export type QueryExistPharmacyAdditionalOrderProductsByPharmacyIdArgs = {
  pharmacyId: Scalars['ID'];
};


export type QueryExternalPortalSearchResultsArgs = {
  hospitalId: Scalars['ID'];
  pivotId?: InputMaybe<Scalars['Int']>;
  portal: HospitalSearchPortalType;
  size: Scalars['Int'];
};


export type QueryExternalPortalSearchResultsV2Args = {
  hospitalPublicId: Scalars['ID'];
  pivotId?: InputMaybe<Scalars['Int']>;
  portal: HospitalSearchPortalType;
  size: Scalars['Int'];
};


export type QueryFaceToFaceDoctorByIdArgs = {
  doctorId: Scalars['ID'];
};


export type QueryFaceToFaceDoctorByPublicIdArgs = {
  publicId: Scalars['String'];
};


export type QueryFamilyArgs = {
  familyId: Scalars['ID'];
};


export type QueryFavoritePharmaciesArgs = {
  request: FavoritePharmaciesRequestInput;
};


export type QueryGeneralSearchFiltersArgs = {
  keyword: Scalars['ID'];
};


export type QueryGeneralSearchMetaByKeywordArgs = {
  keyword: Scalars['String'];
};


export type QueryGetAddressByIpArgs = {
  ip: Scalars['String'];
};


export type QueryGetAddressByLocationArgs = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};


export type QueryGetAgreementsByCategoryArgs = {
  category: AgreementCategory;
};


export type QueryGetAllCategoriesByChannelTypeArgs = {
  channelType: ChannelType;
};


export type QueryGetAllHospitalsArgs = {
  limit: Scalars['Int'];
  page: Scalars['Int'];
};


export type QueryGetBannerAdExchangeArgs = {
  request: BannerAdExchangeRequestInput;
};


export type QueryGetCommerceOrdersByRequestContextArgs = {
  requestContextRequest: DomainRequestContextRequestInput;
};


export type QueryGetDepartmentsByDepartmentGroupIdsArgs = {
  departmentGroupIds: Array<Scalars['ID']>;
};


export type QueryGetDiagnosisCancelReasonsV2Args = {
  diagnosisId: Scalars['ID'];
};


export type QueryGetDiagnosisCategoriesV2Args = {
  contactType: DiagnosisContactType;
};


export type QueryGetDiseaseEncyclopediaSitemapsArgs = {
  limit: Scalars['Int'];
  page: Scalars['Int'];
};


export type QueryGetDoctorByIdByUserArgs = {
  id: Scalars['ID'];
};


export type QueryGetDoctorByUserArgs = {
  doctorPublicId: Scalars['ID'];
};


export type QueryGetDoctorDiagnosisBookingSchedulesArgs = {
  request: DoctorDiagnosisBookingSchedulesQueryRequestInput;
};


export type QueryGetDoctorTreatmentMedicineOpenDateArgs = {
  doctorId: Scalars['ID'];
  treatmentMedicineId: Scalars['ID'];
};


export type QueryGetDoctorsByKeywordArgs = {
  request: NonFaceToFaceDoctorCursorPageRequestInput;
};


export type QueryGetFaceToFaceDiagnosesArgs = {
  faceToFaceDiagnosisRequest: FaceToFaceDiagnosisRequestInput;
  paginationCriteria: PaginationCriteriaInput;
};


export type QueryGetFaceToFaceDiagnosisArgs = {
  faceToFaceDiagnosisId: Scalars['ID'];
};


export type QueryGetFaceToFaceDiagnosisBookingFormByPublicIdArgs = {
  publicId: Scalars['String'];
};


export type QueryGetFaceToFaceDiagnosisBookingFormsByBookingIdsArgs = {
  bookingIds: Array<Scalars['ID']>;
};


export type QueryGetFaceToFaceDoctorsArgs = {
  faceToFaceTreatmentId: Scalars['ID'];
};


export type QueryGetFaceToFaceDoctorsByHospitalPublicIdArgs = {
  hospitalPublicId: Scalars['String'];
};


export type QueryGetFeedbackReasonsArgs = {
  feedbackTarget: FeedbackTarget;
};


export type QueryGetHistoryTakingByPublicIdArgs = {
  publicId: Scalars['String'];
};


export type QueryGetHolidaysArgs = {
  searchEndDate: Scalars['String'];
  searchStartDate: Scalars['String'];
};


export type QueryGetHospitalByIdArgs = {
  hospitalId: Scalars['ID'];
};


export type QueryGetHospitalByPublicIdArgs = {
  publicId: Scalars['String'];
};


export type QueryGetHospitalSitemapsArgs = {
  limit: Scalars['Int'];
  page: Scalars['Int'];
};


export type QueryGetHospitalsByHospitalNamePatternArgs = {
  hospitalNamePattern: Scalars['String'];
  pivotId?: InputMaybe<Scalars['Int']>;
  size: Scalars['Int'];
};


export type QueryGetHospitalsByHospitalNamePatternAndPartnershipStatusArgs = {
  hospitalNamePattern: Scalars['String'];
  partnershipStatus?: InputMaybe<HospitalPartnershipStatus>;
  pivotId?: InputMaybe<Scalars['Int']>;
  size: Scalars['Int'];
};


export type QueryGetMedicineDictionarySitemapsArgs = {
  limit: Scalars['Int'];
  page: Scalars['Int'];
};


export type QueryGetNonBenefitSeoSitemapsArgs = {
  limit: Scalars['Int'];
  page: Scalars['Int'];
};


export type QueryGetNonBenefitSeoSitemapsV2Args = {
  limit: Scalars['Int'];
  page: Scalars['Int'];
};


export type QueryGetNoticeDetailArgs = {
  id: Scalars['ID'];
};


export type QueryGetNoticesArgs = {
  pagingRequest: PagingRequestInput;
};


export type QueryGetOrderCancelReasonsArgs = {
  orderCancelReasonCategory: OrderCancelReasonCategory;
};


export type QueryGetPatientArgs = {
  registrationNumber: Scalars['String'];
};


export type QueryGetPaymentTotalArgs = {
  payTrackingNumbers: Array<Scalars['String']>;
};


export type QueryGetPgAgreementsByCardNumberArgs = {
  cardNumberEightDigits: Scalars['String'];
};


export type QueryGetTotalReviewCountWithAverageRatingByPublicIdArgs = {
  publicId: Scalars['String'];
};


export type QueryHealthAnalysisReportByUserArgs = {
  counselingId: Scalars['ID'];
};


export type QueryHealthDashboardForTabHomeArgs = {
  healthCheckedDate?: InputMaybe<Scalars['String']>;
};


export type QueryHomeMedicalCategoriesArgs = {
  size?: InputMaybe<Scalars['Int']>;
};


export type QueryHospitalExternalPostArgs = {
  hospitalPublicId: Scalars['ID'];
  pivotId?: InputMaybe<Scalars['Int']>;
  size: Scalars['Int'];
};


export type QueryHospitalNonBenefitCategoryItemPriceListArgs = {
  categoryId: Scalars['ID'];
  hospitalId: Scalars['ID'];
};


export type QueryHospitalProfileImageUploadPreSignedUrlArgs = {
  fileExtension: Scalars['String'];
};


export type QueryHotKeywordsArgs = {
  request: HotKeywordRequestInput;
};


export type QueryImageBannersArgs = {
  request: ImageBannersRequestInput;
};


export type QueryInvitationCodeByUserInviterArgs = {
  codeType: InvitationCodeType;
};


export type QueryIsFeatureOnArgs = {
  flag: Scalars['String'];
};


export type QueryKeywordSearchMagazineCursorPageArgs = {
  request: KeywordSearchMagazineCursorPageRequestInput;
};


export type QueryKeywordSearchQuestionCardCursorPageArgs = {
  request: KeywordSearchQuestionCardCursorPageRequestInput;
};


export type QueryKeywordSearchedDiseaseCursorPageArgs = {
  request: KeywordSearchedDiseaseCursorPageRequestInput;
};


export type QueryLiverFunctionRecordsArgs = {
  paginationCriteria: PaginationCriteriaInput;
  source?: InputMaybe<Scalars['String']>;
};


export type QueryMagazineAuthorArgs = {
  authorPublicId: Scalars['ID'];
};


export type QueryMagazineByAuthorPublicIdArgs = {
  authorPublicId: Scalars['ID'];
  pagingRequest: PagingRequestInput;
};


export type QueryMagazineCountArgs = {
  request: MagazineCountRequestInput;
};


export type QueryMagazineCursorPageArgs = {
  request: MagazineCursorPageRequestInput;
};


export type QueryMagazineRelatedBoardPostsArgs = {
  request: MagazineRelatedBoardPostsRequestInput;
};


export type QueryMagazineRelatedMagazinesArgs = {
  request: MagazineRelatedMagazinesRequestInput;
};


export type QueryMagazineRelatedQuestionCardsArgs = {
  request: MagazineRelatedQuestionCardsRequestInput;
};


export type QueryMagazineV2Args = {
  magazinePid: Scalars['ID'];
};


export type QueryMedicalCategoriesArgs = {
  request: MedicalCategoryRequestInput;
};


export type QueryMedicalFacilityVisitHistoryArgs = {
  paginationCriteria: PaginationCriteriaInput;
};


export type QueryMedicineArgs = {
  medicineId: Scalars['ID'];
};


export type QueryMedicineDictionaryItemByPublicIdArgs = {
  publicId: Scalars['String'];
};


export type QueryMediktorExternUserArgs = {
  request: MediktorExternUserRequestInput;
};


export type QueryMyAnswerCursorPageArgs = {
  request: MyAnswerCursorPageRequestInput;
};


export type QueryMyBoardCommentCursorPageArgs = {
  request: MyBoardCommentCursorPageRequestInput;
};


export type QueryMyBoardPostCursorPageArgs = {
  request: MyBoardPostCursorPageRequestInput;
};


export type QueryMyLikedQuestionCardCursorPageArgs = {
  request: MyLikedQuestionCardCursorPageRequestInput;
};


export type QueryMyQuestionCardCursorPageArgs = {
  request: MyQuestionCardCursorPageRequestInput;
};


export type QueryMyReviewCountArgs = {
  reviewTargetType: ReviewTargetType;
};


export type QueryMyReviewsArgs = {
  pagingRequest: PagingRequestInput;
  reviewTargetType: ReviewTargetType;
};


export type QueryNameMatchedDiseaseArgs = {
  name: Scalars['String'];
};


export type QueryNearSimpleQuestionsArgs = {
  request: NearSimpleQuestionsRequestInput;
};


export type QueryNearbyPharmacyDetailByPublicIdArgs = {
  request: NearbyPharmacyDetailSearchByPublicIdRequestInput;
};


export type QueryNearbyPharmacyDetailV3ByUserArgs = {
  request: NearbyPharmacyDetailSearchRequestV3Input;
};


export type QueryNearbyPharmacyV3ByRegionCodeArgs = {
  request: NearbyPharmacySearchByRegionCodeRequestInput;
};


export type QueryNearbyPharmacyV3ByUserArgs = {
  request: NearbyPharmacySearchRequestV3Input;
};


export type QueryNewestBoardPostCursorPageArgs = {
  request: NewestBoardPostCursorPageRequestInput;
};


export type QueryNewestQuestionCardCursorPageArgs = {
  request: NewestQuestionCardCursorPageRequestInput;
};


export type QueryNextMagazinePidArgs = {
  contentType?: InputMaybe<Scalars['String']>;
  magazinePid: Scalars['ID'];
};


export type QueryNonBenefitCategoryByIdArgs = {
  nonBenefitCategoryId: Scalars['ID'];
};


export type QueryNonBenefitCategoryPrescriptionUnitsArgs = {
  categoryId: Scalars['ID'];
};


export type QueryNonBenefitMedicinesForSeoV2Args = {
  contactType: DiagnosisContactType;
  treatmentId: Scalars['ID'];
};


export type QueryNonBenefitMedicinesForSortingV2Args = {
  contactType: DiagnosisContactType;
};


export type QueryNonBenefitPriceTotalSummaryArgs = {
  regionCode: Scalars['String'];
  treatmentMedicineId: Scalars['ID'];
};


export type QueryNonBenefitPriceTotalSummaryV2Args = {
  contactType: DiagnosisContactType;
  regionCode: Scalars['String'];
  treatmentMedicineId: Scalars['ID'];
};


export type QueryNonBenefitSearchFiltersArgs = {
  nonBenefitItemId: Scalars['ID'];
};


export type QueryNonF2fMedicalCategoriesArgs = {
  size?: InputMaybe<Scalars['Int']>;
};


export type QueryNonF2fQuickDiagnosisDoctorArgs = {
  request: NonF2fQuickDiagnosisDoctorRequestInput;
};


export type QueryNonFaceToFaceDiagnosisChannelTokenByUserArgs = {
  diagnosisId: Scalars['Int'];
};


export type QueryNumberOfReviewsByDiagnosisTypeArgs = {
  doctorIds: Array<Scalars['ID']>;
};


export type QueryNumberOfReviewsByRatingArgs = {
  doctorIds: Array<Scalars['ID']>;
};


export type QueryOAuthUserProfileArgs = {
  accessToken: Scalars['String'];
  provider: ProviderType;
};


export type QueryPersonalizedNutritionDetailByUserArgs = {
  counselingId: Scalars['ID'];
};


export type QueryPersonalizedNutritionOrderSheetByUserArgs = {
  request: PersonalizedNutritionOrderSheetRequestInput;
};


export type QueryPharmacyAdditionalOrderProductsByPharmacyIdAndCategoryIdArgs = {
  categoryId?: InputMaybe<Scalars['ID']>;
  pagingRequest: PagingRequestInput;
  pharmacyId: Scalars['ID'];
};


export type QueryPharmacyDispensableMedicinesArgs = {
  request: PharmacyDispensableMedicinesRequestInput;
};


export type QueryPharmacyMedicinePriceTotalSummaryArgs = {
  contactType: DiagnosisContactType;
  regionCode: Scalars['String'];
  treatmentMedicineId: Scalars['ID'];
};


export type QueryPharmacyReceiptReviewsArgs = {
  request: PharmacyReviewRequestInput;
};


export type QueryPharmacyReviewTagsByRatingArgs = {
  rating: Scalars['Int'];
};


export type QueryPharmacyReviewsArgs = {
  request: PharmacyReviewRequestInput;
};


export type QueryPickupNearbyPharmacySearchTabArgs = {
  diagnosisId: Scalars['ID'];
};


export type QueryPointCouponArgs = {
  publicId: Scalars['String'];
};


export type QueryPointCouponsArgs = {
  pagingRequest: PagingRequestInput;
};


export type QueryPointEventsArgs = {
  paginationCriteria: PaginationCriteriaInput;
};


export type QueryPopularDiseaseEncyclopediasArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryPreSignedUrlForReceiptUploadArgs = {
  request: ReceiptUploadPreSignedUrlRequestInput;
};


export type QueryPrevMagazinePidArgs = {
  contentType?: InputMaybe<Scalars['String']>;
  magazinePid: Scalars['ID'];
};


export type QueryPushNotificationsArgs = {
  paginationCriteria: PaginationCriteriaInput;
  request: PushNotificationRequestInput;
};


export type QueryQnaAnswerReviewsArgs = {
  answerPid: Scalars['ID'];
};


export type QueryQnaRegistrationStatusArgs = {
  request: QnaRegistrationStatusRequestInput;
};


export type QueryQuestionArgs = {
  questionPid: Scalars['ID'];
};


export type QueryQuestionCategoryArgs = {
  request: QuestionCategoryRequestInput;
};


export type QueryQuestionOrderSheetByUserArgs = {
  request: QuestionOrderSheetRequestInput;
};


export type QueryQuestionRelatedMagazinesArgs = {
  request: QuestionRelatedMagazinesRequestInput;
};


export type QueryQuestionTitleGeneratedArgs = {
  questionPid: Scalars['ID'];
};


export type QueryQuestionV2Args = {
  questionPid: Scalars['ID'];
};


export type QueryRandomMagazinesArgs = {
  request: RandomMagazineRequestInput;
};


export type QueryRecommendedPharmacyAdditionalOrderProductsArgs = {
  request: RecommendedPharmacyAdditionalOrderProductsRequestInput;
};


export type QueryRecommendedPopularBoardPostsArgs = {
  size: Scalars['Int'];
};


export type QuerySearchAlternativeIngredientsArgs = {
  request: AlternativeIngredientSearchRequestInput;
};


export type QuerySearchAvailableDeliveryMethodsArgs = {
  request: DeliveryMethodSearchRequestInput;
};


export type QuerySearchBoardPostCursorPageArgs = {
  request: SearchBoardPostCursorPageRequestInput;
};


export type QuerySearchBrandDoctorsArgs = {
  request: BrandDoctorSearchRequestInput;
};


export type QuerySearchDeliveryAvailableCandidatesArgs = {
  request: PharmacyCandidateRequestInput;
};


export type QuerySearchDiseaseEncyclopediaArgs = {
  request: DiseaseEncyclopediaSearchRequestInput;
};


export type QuerySearchDiseaseEncyclopediaByCursorScorePageArgs = {
  request: DiseaseEncyclopediaSearchByCursorRequestInput;
};


export type QuerySearchDoctorsByTimeSlotArgs = {
  request: TimeSlotBasedDoctorSearchMutationRequestInput;
};


export type QuerySearchDoctorsByUserArgs = {
  request: DoctorSearchByUserRequestInput;
};


export type QuerySearchDoctorsForSeoByUserArgs = {
  request: DoctorSeoSearchRequestInput;
};


export type QuerySearchFaceToFaceDiagnosisBookingsByHospitalArgs = {
  request: FaceToFaceDiagnosisBookingSearchRequestInput;
};


export type QuerySearchFamilyDoctorsArgs = {
  request: FamilyDoctorSearchRequestInput;
};


export type QuerySearchHospitalGenerallyArgs = {
  request: HospitalGeneralSearchRequestInput;
};


export type QuerySearchHospitalsV2Args = {
  request: HospitalElasticSearchV2RequestInput;
};


export type QuerySearchInfluenzaHospitalsArgs = {
  request: HospitalInfluenzaSearchRequestInput;
};


export type QuerySearchKoreaAddressArgs = {
  koreaAddressSearchRequest: KoreaAddressSearchRequestInput;
};


export type QuerySearchKoreaAddressV2Args = {
  request: KoreaAddressSearchRequestV2Input;
};


export type QuerySearchMagazinesArgs = {
  request: MagazineSearchRequestInput;
};


export type QuerySearchMedicineDictionaryArgs = {
  request: MedicineDictionarySearchRequestInput;
};


export type QuerySearchMedicineDictionaryByCursorScorePageArgs = {
  request: MedicineDictionarySearchByCursorRequestInput;
};


export type QuerySearchNonBenefitHospitalsArgs = {
  request: NonBenefitHospitalSearchRequestInput;
};


export type QuerySearchNonF2fDoctorsArgs = {
  request: NonF2fDoctorSearchRequestInput;
};


export type QuerySearchNonF2fDoctorsForSeoByUserArgs = {
  request: NonF2fDoctorSeoSearchRequestInput;
};


export type QuerySearchPharmaciesByRegionCodeArgs = {
  request: PharmacySearchByRegionCodeRequestInput;
};


export type QuerySearchPharmacyMatchingCandidatesArgs = {
  diagnosisId: Scalars['ID'];
};


export type QuerySearchProductsArgs = {
  request: CommerceProductSearchRequestInput;
};


export type QuerySearchProductsByUserArgs = {
  request: CommerceProductSearchRequestInput;
};


export type QuerySearchQuestionsArgs = {
  request: QuestionSearchRequestInput;
};


export type QuerySearchResultFeedbackSubCategoriesByCategoryIdArgs = {
  categoryId: Scalars['ID'];
};


export type QueryShippingLabelArgs = {
  shippingLabelRequest: ShippingLabelRequestInput;
};


export type QuerySimilarSearchQuestionCardCursorPageRequestArgs = {
  request: SimilarSearchQuestionCardCursorPageRequestInput;
};


export type QuerySubscriptionByUserArgs = {
  subscriptionId: Scalars['ID'];
};


export type QuerySurveyQuestionListArgs = {
  request: SurveyQuestionListRequestInput;
};


export type QueryTagMagazineCursorPageArgs = {
  request: TagMagazineCursorPageRequestInput;
};


export type QueryTemporaryPresignedUrlsArgs = {
  extensions: Array<Scalars['String']>;
};


export type QueryTreatmentCategoriesByTreatmentIdV2Args = {
  contactType: DiagnosisContactType;
  treatmentId: Scalars['ID'];
};


export type QueryTreatmentMedicinesByTreatmentIdArgs = {
  treatmentId: Scalars['ID'];
};


export type QueryTreatmentsArgs = {
  treatmentSearchType: TreatmentSearchType;
};


export type QueryUserGamePrizesArgs = {
  gameType: GameType;
};


export type QueryValidateCommunityUserNicknameArgs = {
  nickname: Scalars['String'];
};

/** 실시간 건강상담 질문 */
export type Question = {
  /** 질문 접근 권한 */
  accessibleType: QuestionAccessibleType;
  /** ai 답변 정보 */
  aiAnswer?: Maybe<AiAnswerGraph>;
  /** AI 답변 확인 버튼 배치 유형 */
  aiAnswerButtonType: AiAnswerButtonType;
  /** AI 답변 상태 */
  aiAnswerStatus: AiAnswerStatus;
  /** 답변 상태 */
  answeredStatus: QuestionAnsweredStatus;
  /** 답변자 수 */
  answererCount: Scalars['Int'];
  /** 답변자 프로필이미지 목록 */
  answererProfileImageUrls: Array<Scalars['String']>;
  /** 답변 목록 */
  answers: Array<Answer>;
  /** 첨부파일 목록 */
  attachments: Array<QuestionAttachment>;
  /** 질문 카테고리 */
  category: QuestionCategory;
  /** 질문 내용 */
  content: Scalars['String'];
  /** 질문 생성 시각 */
  createdAt: Scalars['DrTimestamp'];
  /** 내가 차단한 질문 여부 */
  isBlockedByMe: Scalars['Boolean'];
  /** 내가 좋아요한 질문 여부 */
  isLikedByMe: Scalars['Boolean'];
  /** 내 질문 여부 */
  isMine: Scalars['Boolean'];
  /** 좋아요 수 */
  likeCount: Scalars['Int'];
  /** 결제 정보 */
  paymentInfo?: Maybe<QuestionPaymentInfo>;
  /** 결제 종합 정보 */
  paymentTotal?: Maybe<PaymentTotalGraph>;
  /** 임신여부 */
  pregnant: Scalars['Boolean'];
  /** 질문 PID */
  questionPid: Scalars['ID'];
  /** 개인정보 노출 여부 */
  showUserPersonalInfo: Scalars['Boolean'];
  /** 질문 상태 */
  status: QuestionStatus;
  /** 태그 목록 */
  tags: Array<QuestionTag>;
  /** 질문 제목 */
  title: Scalars['String'];
  /** 질문한 유저 */
  user: User;
  /** 조회수 */
  viewCount: Scalars['Int'];
};

export enum QuestionAccessibleType {
  All = 'ALL',
  DoctorsAndMe = 'DOCTORS_AND_ME',
  Me = 'ME'
}

export type QuestionAdd = {
  aiAnswerAvailable: Scalars['Boolean'];
  questionPid: Scalars['String'];
};

/** 실시간 상담 질문 등록 요청 */
export type QuestionAddRequestInput = {
  /** AI 답변 생성여부 (default: true) */
  aiAnswerAvailable?: InputMaybe<Scalars['Boolean']>;
  /** 첨부파일 목록(Optional) */
  attachments?: InputMaybe<Array<QuestionAttachmentAddRequestInput>>;
  /** 카테고리 ID */
  categoryId: Scalars['ID'];
  /** 본문 */
  content: Scalars['String'];
  /** 위/경도 위치 */
  location?: InputMaybe<LocationRequestInput>;
  /** 임신여부 */
  pregnant?: InputMaybe<Scalars['Boolean']>;
  /** 태그 목록(Optional) */
  tagNames?: InputMaybe<Array<Scalars['String']>>;
};

export enum QuestionAnsweredStatus {
  Answered = 'ANSWERED',
  Answering = 'ANSWERING',
  Checking = 'CHECKING'
}

export type QuestionAttachment = {
  blindType: AttachmentBlindType;
  questionAttachmentId: Scalars['ID'];
};

/** 무료상담 질문 첨부파일 등록 요청 */
export type QuestionAttachmentAddRequestInput = {
  /** 원본 이미지 Path */
  originalPath: Scalars['String'];
  /** 썸네일 이미지 Path */
  thumbnailPath: Scalars['String'];
};

/** 질문 첨부파일 업로드용 pre-signed url */
export type QuestionAttachmentUploadPreSignedUrl = {
  originalPath: Scalars['String'];
  originalPreSignedUrl: Scalars['String'];
  thumbnailPath: Scalars['String'];
  thumbnailPreSignedUrl: Scalars['String'];
};

export type QuestionAttachmentV2 = {
  blindType: AttachmentBlindType;
  id: Scalars['ID'];
  questionId: Scalars['ID'];
};

export type QuestionCard = {
  /** @deprecated 현재 사용하지 않습니다. */
  answer?: Maybe<AnswerSection>;
  answeredStatus: QuestionAnsweredStatus;
  answererCount: Scalars['Int'];
  answererProfileImageUrls: Array<Scalars['String']>;
  /** 결제 종합 정보 */
  paymentTotal?: Maybe<PaymentTotalGraph>;
  question: QuestionSection;
};

export type QuestionCardCursorPage = {
  elements: Array<QuestionCard>;
  pivot?: Maybe<Scalars['ID']>;
};

export type QuestionCategory = {
  /** AI 답변을 만드는지 여부 */
  aiAnswerAvailable: Scalars['Boolean'];
  /** 카테고리 아이콘 이미지 URL */
  iconImageUrl: Scalars['String'];
  /** 카테고리명 */
  name: Scalars['String'];
  /** 카테고리 아이디 */
  questionCategoryId: Scalars['ID'];
  /** 카테고리 타입(증상, 과목) */
  type: Scalars['String'];
};

/** 무료상담 카테고리 */
export type QuestionCategoryDetail = {
  /** AI 답변 이용가능 여부 */
  aiAnswerAvailable: Scalars['Boolean'];
  /** 질문 본문 작성 가이드 */
  contentPlaceholder: Scalars['String'];
  /** 카테고리 설명 ex. 건강검진, 예방, 만성질환 등 */
  description?: Maybe<Scalars['String']>;
  /** 카테고리 아이콘 이미지 URL */
  iconImageUrl: Scalars['String'];
  /** 카테고리 이미지 URL */
  imageUrl: Scalars['String'];
  /** 카테고리명 ex. 가정의학과 */
  name: Scalars['String'];
  /** 카테고리 아이디 */
  questionCategoryId: Scalars['ID'];
  /** 카테고리별 추천 태그 목록 */
  tags: Array<QuestionTag>;
  /** 질문 제목 작성 가이드 */
  titlePlaceholder: Scalars['String'];
};

/** 무료상담 카테고리 그룹 */
export type QuestionCategoryGroup = {
  /** 카테고리 그룹 키 ex. department, treatment */
  key: Scalars['String'];
  /** 카테고리 그룹 이름 ex. 과목, 증상 */
  name: Scalars['String'];
  /** 카테고리 리스트 */
  questionCategories: Array<QuestionCategoryDetail>;
};

export type QuestionCategoryRequestInput = {
  questionCategoryId: Scalars['ID'];
};

export enum QuestionCategoryType {
  Department = 'DEPARTMENT',
  Life = 'LIFE',
  Treatment = 'TREATMENT'
}

export type QuestionCategoryV2 = {
  aiAnswerAvailable: Scalars['Boolean'];
  bestQuestionIds?: Maybe<Scalars['String']>;
  contentPlaceholder: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  iconImagePath: Scalars['String'];
  id: Scalars['ID'];
  imagePath: Scalars['String'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  needCheck: Scalars['Boolean'];
  titlePlaceholder: Scalars['String'];
  type: QuestionCategoryType;
  typeId?: Maybe<Scalars['ID']>;
  typeRank: Scalars['Int'];
  typeRecommendRank?: Maybe<Scalars['Int']>;
};

export enum QuestionDelayExposureType {
  DelayTimeExposed = 'DELAY_TIME_EXPOSED',
  Hidden = 'HIDDEN',
  TooLongDelayExposed = 'TOO_LONG_DELAY_EXPOSED'
}

export type QuestionMakePrivateRequestInput = {
  questionPid: Scalars['ID'];
};

export type QuestionOrderSheetGraph = {
  /** 결제 예정 금액 */
  expectedAmountToPay: Scalars['Int'];
  /** 질문 PID */
  questionPid: Scalars['String'];
  /** 총 할인 금액 */
  totalDiscountAmount: Scalars['Int'];
  /** 총 가격 */
  totalPrice: Scalars['Int'];
};

export type QuestionOrderSheetRequestInput = {
  /** 질문 PID */
  questionPid: Scalars['String'];
};

/** 실시간 건강상담 질문 결제 정보 */
export type QuestionPaymentInfo = {
  /** 할인받은 금액 */
  discountAmount: Scalars['Int'];
  /** 결제한 금액 */
  paidAmount: Scalars['Int'];
  /** 결제 일시 */
  paidAt: Scalars['DrTimestamp'];
  /** 결제 시도 횟수 */
  payTryCount: Scalars['Int'];
  /** 가격 */
  price: Scalars['Int'];
  /** 사용한 포인트 */
  usedPoint: Scalars['Int'];
};

/** 질문 관련 건강매거진 목록 요청 */
export type QuestionRelatedMagazinesRequestInput = {
  /** 컨텐츠 유형(ARTICLE, FAQ) */
  contentType?: InputMaybe<Scalars['String']>;
  /** 질문 아이디 */
  questionPid: Scalars['ID'];
  /** 사이즈 */
  size?: InputMaybe<Scalars['Int']>;
};

export type QuestionReportRequestInput = {
  questionPid: Scalars['ID'];
  reason: Scalars['String'];
};

export type QuestionSearchRequestInput = {
  categoryIds: Array<Scalars['ID']>;
  page: Scalars['Int'];
  size: Scalars['Int'];
  sort: QuestionSearchSort;
};

/** 상품 정보 검색 결과 */
export type QuestionSearchResult = {
  /** 질문 정보 */
  items: Array<QuestionV2>;
  /** 검색 결과 총 갯수 */
  totalCount: Scalars['Int'];
};

export enum QuestionSearchSort {
  Recent = 'RECENT'
}

export type QuestionSection = {
  accessibleType: QuestionAccessibleType;
  aiAnswerStatus: AiAnswerStatus;
  attachments: Array<QuestionAttachment>;
  category: QuestionCategory;
  content: Scalars['String'];
  createdAt: Scalars['DrTimestamp'];
  isBlockedByMe: Scalars['Boolean'];
  isLikedByMe: Scalars['Boolean'];
  isMine: Scalars['Boolean'];
  likeCount: Scalars['Int'];
  questionPid: Scalars['ID'];
  status?: Maybe<QuestionStatus>;
  tags: Array<QuestionTag>;
  title: Scalars['String'];
  user: User;
  viewCount: Scalars['Int'];
};

export enum QuestionStatus {
  AiAnswered = 'AI_ANSWERED',
  AiAnswerFailed = 'AI_ANSWER_FAILED',
  AiAnswerRequested = 'AI_ANSWER_REQUESTED',
  AwaitingBasicAnswer = 'AWAITING_BASIC_ANSWER',
  AwaitingPremiumAnswer = 'AWAITING_PREMIUM_ANSWER',
  HasBasicAnswer = 'HAS_BASIC_ANSWER',
  PaymentFailed = 'PAYMENT_FAILED',
  PendingPayment = 'PENDING_PAYMENT',
  PremiumAnswered = 'PREMIUM_ANSWERED',
  PremiumAnswering = 'PREMIUM_ANSWERING',
  Refunded = 'REFUNDED'
}

/** 실시간 건강상담 질문 태그 */
export type QuestionTag = {
  name: Scalars['String'];
  questionTagId: Scalars['ID'];
};

export type QuestionTagV2 = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum QuestionType {
  Multi = 'MULTI',
  Single = 'SINGLE'
}

/** 질문 정보 */
export type QuestionV2 = {
  accessibleType: QuestionAccessibleType;
  /** 질문 정보 */
  attachments: Array<QuestionAttachmentV2>;
  /** 질문 정보 */
  category: QuestionCategoryV2;
  categoryId: Scalars['ID'];
  content: Scalars['String'];
  createdAt: Scalars['DrTimestamp'];
  deleted: Scalars['Boolean'];
  discountAmount: Scalars['Int'];
  doctorViewCount: Scalars['Int'];
  id: Scalars['ID'];
  /** 유저가 block 한 질문 여부 */
  isBlockedByMe: Scalars['Boolean'];
  lastViewedAdminDoctorId?: Maybe<Scalars['Int']>;
  paidAmount: Scalars['Int'];
  paidAt?: Maybe<Scalars['DrTimestamp']>;
  payTryCount: Scalars['Int'];
  pregnant: Scalars['Boolean'];
  price: Scalars['Int'];
  publicId: Scalars['String'];
  showUserPersonalInfo: Scalars['Boolean'];
  status?: Maybe<QuestionStatus>;
  /** 질문 정보 */
  tags: Array<QuestionTagV2>;
  title?: Maybe<Scalars['String']>;
  usedPoint: Scalars['Int'];
  userAgent: Scalars['String'];
  userId: Scalars['ID'];
  userMaskedName: Scalars['String'];
};

/** 퀴즈 */
export type Quiz = {
  content: Scalars['String'];
  deeplink: Scalars['String'];
  quizPid: Scalars['ID'];
  rewardAmount: Scalars['Int'];
  /** @deprecated rewardAmount로 대체 */
  rewardPoint: Scalars['Int'];
  rewardType: QuizRewardType;
  status: QuizStatus;
  targetDate: Scalars['String'];
  title: Scalars['String'];
  type: QuizType;
};

export enum QuizBonusType {
  Normal = 'NORMAL',
  WithBonus = 'WITH_BONUS'
}

/** 퀴즈 도전 결과 */
export type QuizChallengeResult = {
  /**
   * 퀴즈 도전 결과 상세메시지
   * @deprecated 대신 detailMessages 사용
   */
  detailMessage?: Maybe<Scalars['String']>;
  /** 퀴즈 도전 결과 상세메시지 */
  detailMessages: Array<QuizMessage>;
  /** 광고 시청 가능 여부 */
  isAdWatchable: Scalars['Boolean'];
  /** 퀴즈 도전 결과 메시지 */
  message: Scalars['String'];
  /** 퀴즈 보상 타입 */
  rewardType: QuizRewardType;
  /** 퀴즈 상태 */
  status: QuizStatus;
};

/** 퀴즈 메시지 */
export type QuizMessage = {
  text: Scalars['String'];
  type: QuizMessageType;
};

export enum QuizMessageType {
  Highlighted = 'HIGHLIGHTED',
  Plain = 'PLAIN'
}

export enum QuizRewardType {
  Point = 'POINT',
  Ticket = 'TICKET'
}

export enum QuizStatus {
  Correct = 'CORRECT',
  Expired = 'EXPIRED',
  Incorrect = 'INCORRECT',
  Pending = 'PENDING',
  Solvable = 'SOLVABLE'
}

/** 연속 퀴즈 진행 상황 */
export type QuizStreakProgress = {
  /** 일일 퀴즈 목록 */
  dailyQuizzes: Array<DailyQuiz>;
  /**
   * 메시지
   * @deprecated messages 사용
   */
  message: Scalars['String'];
  /** 메시지 */
  messages: Array<QuizMessage>;
};

export enum QuizType {
  Ox = 'OX'
}

/** 건강매거진 랜덤 목록 조회 */
export type RandomMagazineRequestInput = {
  /** 컨텐츠 유형(ARTICLE, FAQ) */
  contentType?: InputMaybe<Scalars['String']>;
  /** 제외할 매거진 PID 목록(Optional) */
  excludedMagazinePids?: InputMaybe<Array<Scalars['ID']>>;
  /** 사이즈 */
  size?: InputMaybe<Scalars['Int']>;
};

export enum RawMaterialType {
  FunctionalRawMaterial = 'FUNCTIONAL_RAW_MATERIAL',
  Nutrient = 'NUTRIENT'
}

export type ReasonForLeavingGraph = {
  id: Scalars['ID'];
  inputType: ReasonForLeavingInputType;
  reason: Scalars['String'];
  type: ReasonForLeavingType;
};

export enum ReasonForLeavingInputType {
  Select = 'SELECT',
  Text = 'TEXT'
}

export type ReasonForLeavingSaveRequestInput = {
  reason?: InputMaybe<Scalars['String']>;
  reasonId: Scalars['ID'];
};

export enum ReasonForLeavingType {
  Leave = 'LEAVE',
  Signup = 'SIGNUP'
}

export type ReceiptParsingRequestInput = {
  /** filePath */
  filePath: Scalars['String'];
};

/** 영수증 업로드용 pre-signed url */
export type ReceiptUploadPreSignedUrl = {
  filePath: Scalars['String'];
  preSignedUrl: Scalars['String'];
};

export type ReceiptUploadPreSignedUrlRequestInput = {
  /** 파일 확장자 */
  fileFormat: Scalars['String'];
  /** 약국 ID */
  pharmacyId: Scalars['ID'];
};

export type Receiver = {
  /** 주소 */
  address: Address;
  /** 이름 */
  name: Scalars['String'];
  /** 핸드폰번호 */
  phone: Scalars['String'];
};

/** 최근 진료받은 의사 정보 */
export type RecentDoctor = {
  /** createdAt */
  createdAt: Scalars['DrTimestamp'];
  diagnosisCount?: Maybe<DoctorDiagnosisCount>;
  /** 의사 ID */
  doctorId: Scalars['ID'];
  /** 의사 이름 */
  doctorName: Scalars['String'];
  hospital: DoctorHospital;
  /** 병원 이름 */
  hospitalName: Scalars['String'];
  /** 부재여부 */
  isAbsent: Scalars['Boolean'];
  /** 전담의사 여부 */
  isFamilyDoctor: Scalars['Boolean'];
  /** 10일 이내 가입 여부 */
  isNew: Scalars['Boolean'];
  /** 최대 진료 대기수 */
  maxWaitingCount: Scalars['Int'];
  /** 의사 타입 */
  medicineType: Scalars['String'];
  professionalDepartment: DoctorDepartment;
  /** 프로필 이미지 url */
  profileUrl?: Maybe<Scalars['String']>;
  /** 영상 진료 가능 여부 */
  readyForVideoCall: Scalars['Boolean'];
  /** 의사 평균 평점 */
  reviewAverageRating: Scalars['Float'];
  /** 의사 리뷰수 */
  reviewCount: Scalars['Int'];
};

export type RecommendedMagazineGraph = {
  description: Scalars['String'];
  magazinePid: Scalars['ID'];
  title: Scalars['String'];
  titleImageUrl: Scalars['String'];
};

/** 추천 추가 주문 상품 목록 조회 요청 */
export type RecommendedPharmacyAdditionalOrderProductsRequestInput = {
  /** 진료 ID */
  diagnosisId: Scalars['ID'];
  /** 약국 ID */
  pharmacyId: Scalars['ID'];
};

export enum RecordedTimeType {
  BreakfastAfterMeal = 'BREAKFAST_AFTER_MEAL',
  DinnerAfterMeal = 'DINNER_AFTER_MEAL',
  EmptyStomach = 'EMPTY_STOMACH',
  LunchAfterMeal = 'LUNCH_AFTER_MEAL'
}

export type RegionByDepthGraph = {
  administrationEupMyeonDongName?: Maybe<Scalars['String']>;
  eupMyeonDongCode?: Maybe<Scalars['String']>;
  legalEupMyeonDongName: Scalars['String'];
  siDoCode?: Maybe<Scalars['String']>;
  siDoName: Scalars['String'];
  siGunGuCode?: Maybe<Scalars['String']>;
  siGunGuName?: Maybe<Scalars['String']>;
};

/** 유저 결제정보 */
export type RegisteredUserPaymentGraph = {
  /** 할부 여부 */
  canInstallment: Scalars['Boolean'];
  /** 카드 이름 */
  cardName: Scalars['String'];
  /** 카드 번호 */
  cardNumber: Scalars['String'];
  /** 카드 타입 */
  cardType: CardType;
  /** 유저 결제정보 id */
  id: Scalars['ID'];
  /** 약관 승인 여부 */
  isApproved: Scalars['Boolean'];
  /** 기본 결제수단 등록여부 */
  isDefault: Scalars['Boolean'];
  /** 결제사 */
  payCompany: PayCompany;
  /** 유저 id */
  userId: Scalars['ID'];
};

/** 실시간 상담 질문 재결제 요청 */
export type RepayQuestionRequestInput = {
  /** 사용할 포인트 */
  pointToUse: Scalars['Int'];
  /** 질문 PID */
  questionPid: Scalars['String'];
  /** 유저 결제수단 ID */
  userPaymentId: Scalars['ID'];
};

export type ReportBoardCommentRequestInput = {
  boardCommentPid: Scalars['ID'];
  reason: Scalars['String'];
};

export type ReportBoardPostRequestInput = {
  boardPostPid: Scalars['ID'];
  reason: Scalars['String'];
};

export enum ResultType {
  Available = 'AVAILABLE',
  ContainBannedWord = 'CONTAIN_BANNED_WORD',
  Duplication = 'DUPLICATION'
}

export type ReviewCommentHolderGraph = {
  id: Scalars['ID'];
  name: Scalars['String'];
  profileImageUrl?: Maybe<Scalars['String']>;
  reviewHolderType: ReviewCommentHolderType;
};

export enum ReviewCommentHolderType {
  Doctor = 'DOCTOR'
}

/** 의사 리뷰 코멘트V2 */
export type ReviewCommentV2 = {
  /** 리뷰 코멘트 내용 */
  content: Scalars['String'];
  /** 생성일시 */
  createdAt: Scalars['DrTimestamp'];
  /** 삭제일시 */
  deletedAt?: Maybe<Scalars['DrTimestamp']>;
  /** 차단 여부 */
  isBlocked: Scalars['Boolean'];
  /** 리뷰 코멘트 ID */
  reviewCommentId: Scalars['ID'];
  /** 리뷰 ID */
  reviewId: Scalars['ID'];
  /** 업데이트일시 */
  updatedAt: Scalars['DrTimestamp'];
};

export type ReviewContextGraph = {
  reviewHolderId?: Maybe<Scalars['ID']>;
  reviewHolderType: ReviewHolderType;
  reviewReceiver: ReviewReceiverGraph;
  reviewReceiverId?: Maybe<Scalars['ID']>;
  reviewReceiverType?: Maybe<ReviewReceiverType>;
  reviewTargetId?: Maybe<Scalars['ID']>;
  reviewTargetType: ReviewTargetType;
};

/** 과목/증상별 리뷰 개수 */
export type ReviewCount = {
  /** 리뷰 개수 */
  count: Scalars['Int'];
  /** 과목/증상 구분 */
  diagnosisType: DiagnosisType;
  /** 과목/증상 ID */
  diagnosisTypeId: Scalars['ID'];
  /** 과목/증상명 */
  name: Scalars['String'];
};

/** 리뷰 진료 정보 */
export type ReviewDiagnosis = {
  /** 외부 노출 진료 ID */
  diagnosisExternalId: Scalars['String'];
  /** 진료 ID */
  diagnosisId: Scalars['ID'];
  doctor: Doctor;
  /** 의사 ID */
  doctorId: Scalars['ID'];
  /** 리뷰 진료 요청서 */
  forms: ReviewDiagnosisForm;
  /** 진료비 */
  price: Scalars['Int'];
};

/** 리뷰 진료 요청서 정보 */
export type ReviewDiagnosisForm = {
  /** 과목 혹은 증상명 */
  departmentOrTreatmentName: Scalars['String'];
  /** 진료 요청서 ID */
  diagnosisFormId: Scalars['ID'];
  /** 진료 ID */
  diagnosisId: Scalars['ID'];
  /** 환자 이름(마스킹) */
  maskedPatientName: Scalars['String'];
};

export enum ReviewHolderType {
  User = 'USER'
}

export type ReviewImageGraph = {
  filePath: Scalars['String'];
  reviewImageType: ReviewImageType;
};

export enum ReviewImageType {
  Default = 'DEFAULT',
  Medicine = 'MEDICINE',
  Receipt = 'RECEIPT'
}

export type ReviewReceiverGraph = {
  id: Scalars['ID'];
  name: Scalars['String'];
  reviewReceiverType: ReviewReceiverType;
};

export enum ReviewReceiverType {
  Doctor = 'DOCTOR',
  Hospital = 'HOSPITAL',
  Pharmacy = 'PHARMACY'
}

/** 리뷰 태그 */
export type ReviewTag = {
  /** 생성일시 */
  createdAt: Scalars['DrTimestamp'];
  /** 삭제일시 */
  deletedAt?: Maybe<Scalars['DrTimestamp']>;
  /** 태그 ID */
  tagId: Scalars['ID'];
  /** 태그 내용 */
  text: Scalars['String'];
  /** 업데이트일시 */
  updatedAt: Scalars['DrTimestamp'];
};

/** 리뷰 태그 그룹 정보 */
export type ReviewTagGroup = {
  count: Scalars['Int'];
  name: Scalars['String'];
  receiverId: Scalars['ID'];
  receiverType: ReviewReceiverType;
  tagId: Scalars['ID'];
};

/** 리뷰-태그 맵핑 */
export type ReviewTagMap = {
  id: Scalars['ID'];
  reviewId: Scalars['ID'];
  /** 태그 */
  tag: ReviewTag;
  tagId: Scalars['ID'];
};

export enum ReviewTargetType {
  Diagnosis = 'DIAGNOSIS',
  Order = 'ORDER',
  QnaAnswer = 'QNA_ANSWER'
}

export enum RoleType {
  Admin = 'ADMIN',
  Doctor = 'DOCTOR',
  Hospital = 'HOSPITAL',
  Patient = 'PATIENT',
  Pharmacist = 'PHARMACIST',
  Pharmacy = 'PHARMACY',
  Temp = 'TEMP',
  User = 'USER'
}

/** 만족도 등록 */
export type SatisfactionMutationRequestInput = {
  /** 사유 */
  reason?: InputMaybe<Scalars['String']>;
  /** 만족도 */
  status: SatisfactionStatus;
};

export enum SatisfactionStatus {
  Dissatisfaction = 'DISSATISFACTION',
  Satisfaction = 'SATISFACTION',
  Visited = 'VISITED'
}

/** 만족도 노출정보 */
export type SatisfactionVisibleInfo = {
  /** 만족 데이터 여부 */
  hasSatisfactionRecord: Scalars['Boolean'];
  /** 노출여부 */
  isVisible: Scalars['Boolean'];
};

/** 가능한 배송 수단 조회 */
export type SearchAvailableDeliveryMethod = {
  deliveryCategories: Array<SearchAvailableDeliveryMethodGraph>;
  estimatedDateGroup: Scalars['String'];
  estimatedDateGroupType: Scalars['String'];
};

export type SearchAvailableDeliveryMethodGraph = {
  discountRate: Scalars['Float'];
  estimatedTime: Scalars['String'];
  fee: Scalars['Int'];
  originalFee: Scalars['Int'];
  title: Scalars['String'];
  type: Scalars['String'];
};

/** 검색 목록 조회 */
export type SearchBoardPostCursorPageRequestInput = {
  /** 카테고리 아이디(옵션) */
  boardCategoryId?: InputMaybe<Scalars['ID']>;
  /** 검색어 */
  keyword: Scalars['String'];
  /** 페이지 피벗 아이디(옵션) */
  pivot?: InputMaybe<Scalars['ID']>;
  /** 페이지 사이즈(기본값 10) */
  size?: InputMaybe<Scalars['Int']>;
};

/** 의사 즐겨찾기 조회 */
export type SearchFamilyDoctor = {
  /** 전담의사 수 */
  familyDoctorCount: Scalars['Int'];
  /** 전담의사 정보 */
  familyDoctors: Array<FamilyDoctor>;
};

/** 매칭 중인 약국 후보 검색 */
export type SearchMatchingPharmacyCandidate = {
  /** 약국 별칭 */
  alias?: Maybe<Scalars['String']>;
  /** 이전 매칭 이력 관련 메시지 */
  matchingHistory?: Maybe<PharmacyMatchingHistory>;
  /** 약국 ID */
  pharmacyId: Scalars['ID'];
};

/** 배달 가능한 약국 후보 검색 */
export type SearchPharmacyDeliverableCandidateGraph = {
  description: Scalars['String'];
  estimatedDateGroupType: Scalars['String'];
  estimatedTime: Scalars['String'];
  isForReservation: Scalars['Boolean'];
  pharmacyCandidates: Array<SearchPharmacyDeliveryAvailableCandidate>;
};

/** 배달 가능한 약국 후보 검색 */
export type SearchPharmacyDeliveryAvailableCandidate = {
  /** 약국 별칭 */
  alias?: Maybe<Scalars['String']>;
  /** 약국과의 거리 */
  distance: Scalars['Int'];
  /** 약국 라벨 */
  labels: Array<PharmacyLabel>;
  /** 이전 매칭 이력 관련 메시지 */
  matchingHistory?: Maybe<PharmacyMatchingHistory>;
  /** 약국 ID */
  pharmacyId: Scalars['ID'];
  /** 약국 태그 */
  tags: Array<PharmacyTag>;
};

/** 검색 결과 피드백 메인 카테고리 */
export type SearchResultFeedbackCategory = {
  /** 카테고리 ID */
  id: Scalars['ID'];
  /** 직접 입력 필요 여부 */
  isNeedToUserDirectInput: Scalars['Boolean'];
  /** 카테고리명 */
  name: Scalars['String'];
};

/** 검색 결과 피드백 접수 */
export type SearchResultFeedbackSubmitRequestInput = {
  /** 카테고리 id 목록 */
  categoryIds: Array<Scalars['ID']>;
  /** 유저가 직접 작성한 피드백 내용 */
  feedbackText?: InputMaybe<Scalars['String']>;
  /** 검색 키워드 */
  keyword: Scalars['String'];
};

export type SelectMatchRequestInput = {
  /** 배송 방법 */
  deliveryCategoryType: DeliveryCategoryType;
  /** 위도 */
  deliveryComment?: InputMaybe<Scalars['String']>;
  /** 유저가 확인한 배송비 */
  deliveryFee?: InputMaybe<Scalars['ID']>;
  /** 배송비 포인트 */
  deliveryFeePoint?: InputMaybe<Scalars['ID']>;
  /** 상세 주소 */
  detailAddress?: InputMaybe<Scalars['String']>;
  /** 진료 Id */
  diagnosisId: Scalars['ID'];
  /** 지번 주소 */
  jibunAddress?: InputMaybe<Scalars['String']>;
  /** 경도 */
  latitude?: InputMaybe<Scalars['Float']>;
  /** 위도 */
  longitude?: InputMaybe<Scalars['Float']>;
  /** 약국 ID 목록 */
  pharmacyIds: Array<Scalars['ID']>;
  /** 우편 번호 */
  postCode?: InputMaybe<Scalars['String']>;
  /** 도로명 주소 */
  roadAddress?: InputMaybe<Scalars['String']>;
};

export enum SellerType {
  Doctornow = 'DOCTORNOW',
  Pharmacy = 'PHARMACY'
}

export type SendbirdUserGraph = {
  accessToken: Scalars['String'];
  sendbirdUserId: Scalars['String'];
};

export type Sender = {
  /** 주소 */
  address: Address;
  /** 이름 */
  name: Scalars['String'];
  /** 핸드폰번호 */
  phone: Scalars['String'];
};

/** 배송 */
export type Shipment = {
  /** 배송 요청 도메인 */
  domain: Scalars['String'];
  /** 배송 요청키 */
  key: Scalars['String'];
  /** 배송 아이디 */
  shipmentId: Scalars['ID'];
  /** 배송 정보 */
  shippingInfo: ShippingInfo;
  /** 배송 상태 */
  status: ShipmentStatus;
};

export enum ShipmentStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  PickedUp = 'PICKED_UP',
  Requested = 'REQUESTED'
}

export enum ShippingCompany {
  Barogo = 'BAROGO',
  BarogoToday = 'BAROGO_TODAY',
  Cj = 'CJ',
  Doobal = 'DOOBAL',
  InsungQuick = 'INSUNG_QUICK',
  KakaoDobo = 'KAKAO_DOBO',
  KakaoQuick = 'KAKAO_QUICK',
  Logen = 'LOGEN',
  Logiall = 'LOGIALL',
  Logispot = 'LOGISPOT',
  Lotte = 'LOTTE',
  ManualQuick = 'MANUAL_QUICK',
  PartnershipPickup = 'PARTNERSHIP_PICKUP',
  Pickup = 'PICKUP',
  PostOffice = 'POST_OFFICE',
  TeamFresh = 'TEAM_FRESH',
  Todaypickup = 'TODAYPICKUP',
  Vroong = 'VROONG',
  VroongDawn = 'VROONG_DAWN',
  Yongma = 'YONGMA'
}

/** 배송 정보 */
export type ShippingInfo = {
  /** 배송사 */
  company: ShippingCompany;
  /** 추적 아이디 (송장번호 등) */
  trackingId?: Maybe<Scalars['String']>;
};

/** 송장 출력에 필요한 데이터 */
export type ShippingLabel = {
  /** 배송사별 추가 정보 */
  additionalInformation: Scalars['String'];
  /** 업체별로 관리하는 주문번호, 송장번호와 다르거나 없을 수 있음 */
  agencyOrderNumber?: Maybe<Scalars['String']>;
  /** 권역코드 */
  areaGroupCode: Scalars['String'];
  /** 배송 메모 */
  deliveryMemo?: Maybe<Scalars['String']>;
  /** 배송종류, 업체별로 명칭이 다름 */
  deliveryType: Scalars['String'];
  /** 허브명 */
  hubName?: Maybe<Scalars['String']>;
  /** 주문번호 */
  orderNumber: Scalars['String'];
  /** 받는 사람 */
  receiver: Receiver;
  /** 보내는 사람 */
  sender: Sender;
  /** 송장번호 */
  trackingNumber: Scalars['String'];
};

/** 송장 출력에 필요한 데이터 요청 */
export type ShippingLabelRequestInput = {
  /** 주문번호 */
  orderNumber: Scalars['String'];
  /** 배송사 */
  shippingCompany: ShippingCompany;
};

export enum SignupPath {
  Blog = 'BLOG',
  Community = 'COMMUNITY',
  DoctornowHomepage = 'DOCTORNOW_HOMEPAGE',
  Etc = 'ETC',
  FriendRecommendation = 'FRIEND_RECOMMENDATION',
  Hospital = 'HOSPITAL',
  Instagram = 'INSTAGRAM',
  MedicalFacilityAdvertisement = 'MEDICAL_FACILITY_ADVERTISEMENT',
  MedicalFacilityStaffGuide = 'MEDICAL_FACILITY_STAFF_GUIDE',
  OutdoorAdvertisement = 'OUTDOOR_ADVERTISEMENT',
  PcMobileAdvertisement = 'PC_MOBILE_ADVERTISEMENT',
  Pharmacy = 'PHARMACY',
  PortalSearch = 'PORTAL_SEARCH',
  Tv = 'TV',
  Youtube = 'YOUTUBE'
}

/** 가입경로 입력 요청 */
export type SignupPathUpdateRequestInput = {
  /** 가입경로 */
  signupPath: SignupPath;
};

/** 받은 질문과 유사한 질문 목록 가져오기 */
export type SimilarSearchQuestionCardCursorPageRequestInput = {
  /** 페이지 피벗 질문 ID */
  pivot?: InputMaybe<Scalars['ID']>;
  /** 질문 pid */
  questionPid: Scalars['ID'];
  /** 페이지 사이즈(기본값: 20) */
  size?: InputMaybe<Scalars['Int']>;
};

export type SimpleQuestionGraph = {
  content: Scalars['String'];
  questionPid: Scalars['ID'];
  title: Scalars['String'];
};

export type SimpleSurveyAnswerAddRequestInput = {
  question1st: Scalars['String'];
  question1stAnswer?: InputMaybe<Scalars['String']>;
  question2nd: Scalars['String'];
  question2ndAnswer?: InputMaybe<Scalars['String']>;
  version: Scalars['String'];
};

export type SkipOrderByUserMutationRequestInput = {
  orderId: Scalars['ID'];
};

export enum SortType {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** 보관 정보 */
export type StorageInfo = {
  /** 유효기간(제조일로부터 n개월/년 등) */
  expirationPeriod: Scalars['String'];
  /** 보관 방법(실온, 냉장 등) */
  storageSummary: Scalars['String'];
};

export type StoreInformation = {
  address?: Maybe<Scalars['String']>;
  businessNumber?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

/** 구독 정보 */
export type SubscriptionInfo = {
  /** 구독 취소일시 */
  cancelledAt?: Maybe<Scalars['DrTimestamp']>;
  /** 구독 id */
  id: Scalars['ID'];
  /** 구독 아이템 정보 */
  items: Array<SubscriptionItem>;
  /** 구독 Key */
  key: Scalars['String'];
  /** 구독의 주문 정보 리스트 */
  orders: Array<CommerceOrderV2>;
  /** 구독 진행 기간 */
  progressTerm: Scalars['Int'];
  /** 정기결제일 */
  regularPaymentDay?: Maybe<Scalars['Int']>;
  requestContext: DomainRequestContextGraph;
  /** 구독 시작일시 */
  startedAt?: Maybe<Scalars['DrTimestamp']>;
  /** 구독 상태 */
  status: SubscriptionStatus;
  termType: SubscriptionTermType;
  /** 총 구독 기간 */
  totalTerm: Scalars['Int'];
  /** 구독 타입 */
  type: SubscriptionType;
  /** 유저 주소 id */
  userAddressId?: Maybe<Scalars['ID']>;
  /** 유저 id */
  userId: Scalars['ID'];
  /** 유저 결제 id */
  userPaymentId: Scalars['ID'];
};

/** 구독 아이템 정보 */
export type SubscriptionItem = {
  /** 구독 아이템 Id */
  id: Scalars['ID'];
  /** 상품 가격 */
  price: Scalars['Int'];
  /** 상품 정보 */
  product: AbstractProduct;
  /** 상품 Id */
  productId: Scalars['ID'];
  /** 상품 이름 */
  productName: Scalars['String'];
  /** 구독 Id */
  subscriptionId: Scalars['ID'];
  /** 구독 타입 */
  subscriptionType: SubscriptionType;
};

export enum SubscriptionStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  Progress = 'PROGRESS'
}

export enum SubscriptionTermType {
  Infinite = 'INFINITE',
  One = 'ONE'
}

export enum SubscriptionType {
  PersonalizedNutrition = 'PERSONALIZED_NUTRITION'
}

/** 설문 응답 항목 (객관식 보기) */
export type SurveyAnswerItem = {
  /** 응답 ID */
  answerId: Scalars['ID'];
  /** 응답 내용 */
  text: Scalars['String'];
};

/** 설문 문항별 응답 결과 */
export type SurveyAnswerItemRequestInput = {
  /** 설문 응답 ID */
  answerId: Scalars['ID'];
  /** 설문 응답 내용 */
  text: Scalars['String'];
};

export enum SurveyCategory {
  Food = 'FOOD',
  GeneAnalysis = 'GENE_ANALYSIS',
  Health = 'HEALTH',
  LifeStyle = 'LIFE_STYLE',
  Precaution = 'PRECAUTION'
}

/** 설문 완료 요청 */
export type SurveyCompleteRequestInput = {
  /** 설문조사에 응하는 유저의 생년월일 (ex: 1993-07-13) */
  birthDate: Scalars['String'];
  /** 설문조사에 응하는 유저의 성별 */
  gender: Gender;
  /** 설문조사에 응하는 유저의 키 */
  height: Scalars['Float'];
  /** 질문에 대한 응답 목록 */
  surveyResultItems: Array<SurveyResultItemRequestInput>;
  /** 설문조사에 응하는 유저의 몸무게 */
  weight: Scalars['Float'];
};

/** 설문 문항 */
export type SurveyQuestionItem = {
  /** 설문 응답 (객관식 보기) */
  answers: Array<SurveyAnswerItem>;
  /** 설문 카테고리 [LIFE_STYLE(생활습관) | FOOD(식습관/소화) | HEALTH(건강분야) | GENE_ANALYSIS(유전자분석) | PRECAUTION(주의사항)] */
  category: SurveyCategory;
  /** 필수 문항 여부 */
  isRequired: Scalars['Boolean'];
  /** 설문 문항 ID */
  questionId: Scalars['ID'];
  /** 문항 타입 [MULTI(복수선택 객관식) | SINGLE(단수선택 객관식)] */
  questionType: QuestionType;
  /** 설문 문항 내용 */
  text: Scalars['String'];
};

/** 설문 문항 목록 */
export type SurveyQuestionList = {
  /** 설문 문항 목록 */
  questions: Array<SurveyQuestionItem>;
};

export type SurveyQuestionListRequestInput = {
  /** 설문조사에 응하는 유저의 생년월일 (ex: 1993-07-13) */
  birthDate: Scalars['String'];
  /** 설문조사에 응하는 유저의 성별 */
  gender: Gender;
};

/** 설문 응답 */
export type SurveyResult = {
  /** 생년월일 */
  birthDate: Scalars['String'];
  /** 성별 */
  gender: GenderType;
  /** 키 */
  height: Scalars['Float'];
  /** 설문 결과 ID */
  id: Scalars['ID'];
  /** 설문 항목별 응답 결과 */
  items: Array<SurveyResultItem>;
  /** 유저 ID */
  userId: Scalars['ID'];
  /** 체중 */
  weight: Scalars['Float'];
};

/** 설문 항목별 응답 결과 */
export type SurveyResultItem = {
  /** 응답목록 (단일선택 문항인 경우 길이가 1, 복수선택 문항인 경우 길이 > 1) */
  answerItems: Array<SurveyAnswerItem>;
  category: SurveyCategory;
  /** 문항 ID */
  questionId: Scalars['ID'];
  /** 문항 내용 */
  questionText: Scalars['String'];
  /** 문항 타입 */
  questionType: QuestionType;
};

/** 설문 문항별 응답 결과 */
export type SurveyResultItemRequestInput = {
  /** 설문 응답 목록 */
  answerItems: Array<SurveyAnswerItemRequestInput>;
  /** 설문 카테고리 [LIFE_STYLE(생활습관) | FOOD(식습관/소화) | HEALTH(건강분야) | GENE_ANALYSIS(유전자분석) | PRECAUTION(주의사항)] */
  category: SurveyCategory;
  /** 설문 문항 ID */
  questionId: Scalars['ID'];
  /** 설문 문항 내용 */
  questionText: Scalars['String'];
  /** 문항 타입 [MULTI(복수선택 객관식) | SINGLE(단수선택 객관식)] */
  questionType: QuestionType;
};

/** 증상 이미지 업로드용 pre-signed url */
export type SymptomImageUploadPreSignedUrl = {
  filePath: Scalars['String'];
  preSignedUrl: Scalars['String'];
};

/** 건강매거진 태그 검색 요청 */
export type TagMagazineCursorPageRequestInput = {
  /** 컨텐츠 유형(ARTICLE, FAQ) */
  contentType?: InputMaybe<Scalars['String']>;
  /** 피벗 아이디 */
  pivot?: InputMaybe<Scalars['ID']>;
  /** 조회 사이즈 */
  size?: InputMaybe<Scalars['Int']>;
  /** 태그이름 */
  tagName: Scalars['String'];
};

export enum TagType {
  Department = 'DEPARTMENT',
  Disease = 'DISEASE',
  Free = 'FREE',
  Symptom = 'SYMPTOM'
}

export type TagWithCountGraph = {
  count: Scalars['Int'];
  tag: Scalars['String'];
};

/** 비대면진료 대상 그룹 */
export type TelemedicineEligibleGroup = {
  eligibilityTags: Array<EligibilityTag>;
  message: Scalars['String'];
  telemedicineEligibleGroupType: TelemedicineEligibleGroupType;
  telemedicineTargetType: TelemedicineTargetType;
};

export enum TelemedicineEligibleGroupType {
  BackwoodsResident = 'BACKWOODS_RESIDENT',
  InfectiousDiseaseCase = 'INFECTIOUS_DISEASE_CASE',
  LongTermCareClassifier = 'LONG_TERM_CARE_CLASSIFIER',
  MedicalVulnerableAreaResident = 'MEDICAL_VULNERABLE_AREA_RESIDENT',
  Others = 'OTHERS',
  RegisteredDisabled = 'REGISTERED_DISABLED',
  Under_18Child = 'UNDER_18_CHILD',
  VisitedPatient = 'VISITED_PATIENT'
}

export enum TelemedicineEligibleTargetType {
  AlwaysEligible = 'ALWAYS_ELIGIBLE',
  NightAndHolidayOnly = 'NIGHT_AND_HOLIDAY_ONLY'
}

export enum TelemedicineEligibleTime {
  OffHoursOrWeekend = 'OFF_HOURS_OR_WEEKEND',
  RegularBusinessHours = 'REGULAR_BUSINESS_HOURS'
}

/** 비대면 진료 허용시간 타입 */
export type TelemedicineEligibleTimeType = {
  eligibleTimeType: TelemedicineEligibleTime;
};

export enum TelemedicineTargetType {
  AlwaysEligible = 'ALWAYS_ELIGIBLE',
  NightAndHolidayOnly = 'NIGHT_AND_HOLIDAY_ONLY'
}

/** 비밀번호 변경 임시 토큰 요청 */
export type TemporaryTokenMutationRequestInput = {
  /** phone number */
  phone: Scalars['String'];
  /** Role Type */
  roleType: RoleType;
  /** token */
  token: Scalars['String'];
  /** 아이디 */
  username: Scalars['String'];
};

export enum TicketType {
  Basic = 'BASIC'
}

/** 시간 슬롯 기반 의사 검색 조건 요청 */
export type TimeSlotBasedDoctorSearchConditionMutationRequestInput = {
  /** 종료 슬롯 (0-143, 10분 단위) */
  endTimeSlotValue: Scalars['Int'];
  /** 위치 정보 */
  geoPoint?: InputMaybe<GeoPointRequestInput>;
  /** 후기 많은 의사 */
  highReviewCount?: InputMaybe<Scalars['Boolean']>;
  /** 후기 좋은 의사 */
  highReviewRating?: InputMaybe<Scalars['Boolean']>;
  /** 과목/증상 정보 */
  medicalCategory?: InputMaybe<NonF2fMedicalCategoryRequestInput>;
  /** 전문의 여부 */
  specialistOnly?: InputMaybe<Scalars['Boolean']>;
  /** 시작 슬롯 (0-143, 10분 단위) */
  startTimeSlotValue: Scalars['Int'];
  /** 예약 희망 날짜 */
  targetDate: Scalars['String'];
  /** 원격의료 타겟 타입 */
  telemedicineEligibleTargetType?: InputMaybe<TelemedicineEligibleTargetType>;
};

/** 시간 우선 의사 검색 요청 */
export type TimeSlotBasedDoctorSearchMutationRequestInput = {
  condition: TimeSlotBasedDoctorSearchConditionMutationRequestInput;
  /** limit */
  limit: Scalars['Int'];
  /** page */
  page: Scalars['Int'];
  /** 정렬 타입 */
  sortType: DoctorSortType;
};

export type TimeSlotGraph = {
  /** 화면에 노출되는 시간 */
  displayTime: Scalars['String'];
  /** 타임슬롯 값 */
  timeSlotValue: Scalars['Int'];
};

/** 병원의 전체 리뷰 개수와 평점 */
export type TotalReviewCountWithAverageRating = {
  /** 평점 */
  averageRating: Scalars['Float'];
  /** 총 리뷰 개수 */
  totalCount: Scalars['Int'];
};

/** 증상 */
export type Treatment = {
  /** 평균 진료비 */
  averageDiagnosisPrice?: Maybe<Scalars['Int']>;
  /** 카테고리 ID */
  categoryId: Scalars['ID'];
  /** 증상 아이콘 주소 */
  iconUrl: Scalars['String'];
  /** 증상 ID */
  id: Scalars['ID'];
  /** 급여 여부 */
  isBenefit: Scalars['Boolean'];
  /** 처방약 목록 */
  medicines?: Maybe<Array<TreatmentMedicine>>;
  /** 증상명 */
  name: Scalars['String'];
};

/** 증상 카테고리 */
export type TreatmentCategory = {
  /** 증상 카테고리 아이콘 URL */
  iconUrl: Scalars['String'];
  /** 증상 카테고리 ID */
  id: Scalars['ID'];
  /** 증상 카테고리명 */
  name: Scalars['String'];
  /**
   * 증상 목록
   * @deprecated use v2
   */
  treatments: Array<Treatment>;
  /** 증상 목록 V2 */
  treatmentsV2: Array<Treatment>;
};


/** 증상 카테고리 */
export type TreatmentCategoryTreatmentsV2Args = {
  contactType: DiagnosisContactType;
};

/** 증상으로 증상 카테고리 조회용 그래프 */
export type TreatmentCategoryByTreatment = {
  /** 증상 카테고리 ID */
  id: Scalars['ID'];
  /** 증상 카테고리명 */
  name: Scalars['String'];
  /** 증상 리스트 */
  treatments: Array<Treatment>;
};

/** 증상 처방약 */
export type TreatmentMedicine = {
  /** 처방 단위 */
  dispensationUnits: Array<DispensationUnit>;
  /** 처방약 ID */
  id: Scalars['ID'];
  /** 처방약 코드 */
  medicineCode: Scalars['String'];
  /** 처방약 설명 */
  medicineDescription?: Maybe<Scalars['String']>;
  /** 처방약 이름 */
  medicineName: Scalars['String'];
  /** 증상 */
  treatment: Treatment;
  /** 증상 ID */
  treatmentId: Scalars['ID'];
  /** 약 계열 함량 */
  treatmentMedicineStrengths: Array<TreatmentMedicineStrength>;
  /** 처방약 단위 */
  units: Array<TreatmentMedicineUnit>;
};

/** 약 계열 함량 */
export type TreatmentMedicineStrength = {
  /** 디폴트 여부 */
  isDefault: Scalars['Boolean'];
  /** treatmentMedicineId */
  treatmentMedicineId: Scalars['ID'];
  /** treatmentMedicineStrengthId */
  treatmentMedicineStrengthId: Scalars['ID'];
  /** 용량 */
  unit: Scalars['String'];
};

/** 증상 처방약 단위 */
export type TreatmentMedicineUnit = {
  /** 단위 ID */
  id: Scalars['ID'];
  /** 기본값 여부 */
  isDefault: Scalars['Boolean'];
  /** 단위 */
  unit: Scalars['String'];
  /** 단위 타입 */
  unitType: Scalars['String'];
  /** 사용자에게 보여주는 단위 타입 */
  unitTypeDisplayName: Scalars['String'];
};

/** 약 계열 */
export type TreatmentMedicineV2 = {
  /** 약 계열 설명 */
  description?: Maybe<Scalars['String']>;
  /** 처방 단위 */
  dispensationUnits: Array<DispensationUnit>;
  /** 약 계열 ID */
  id: Scalars['ID'];
  /** 약 계열 이름 */
  name: Scalars['String'];
  /** 정렬키 */
  sortKey: Scalars['Int'];
  /** 증상 ID */
  treatmentId: Scalars['ID'];
  /** 약 계열 함량 */
  treatmentMedicineStrengths: Array<TreatmentMedicineStrength>;
};

export type TreatmentMenuGraph = {
  price: Scalars['Int'];
  treatmentName: Scalars['String'];
};

export enum TreatmentSearchType {
  All = 'ALL',
  Benefit = 'BENEFIT',
  NonBenefit = 'NON_BENEFIT'
}

export type UpdateQuestionLocationRequestInput = {
  /** 위/경도 위치 */
  location: LocationRequestInput;
  /** 질문 ID */
  questionPid: Scalars['ID'];
};

/** 초대 코드 사용 결과 */
export type UseInvitationCode = {
  /** 얻은 포인트 */
  earnedPointAmount: Scalars['Int'];
  /** 총 포인트 */
  totalPointAmount: Scalars['Int'];
};

/** 초대 코드 사용 요청 */
export type UseInvitationCodeMutationRequestInput = {
  /** 코드 */
  code: Scalars['String'];
};

export type User = {
  birth?: Maybe<Scalars['String']>;
  gender: GenderType;
  name: Scalars['String'];
  userId: Scalars['ID'];
};

/** 사용자 주소 */
export type UserAddress = {
  /** 사용자 주소 ID */
  addressType: AddressType;
  /** 별칭 */
  alias: Scalars['String'];
  /** 배송 코멘트 */
  deliveryComment?: Maybe<Scalars['String']>;
  /** 상세주소 */
  detailAddress: Scalars['String'];
  /** 현관 비밀번호 */
  frontDoorPassword?: Maybe<Scalars['String']>;
  /** 기본값 여부(마지막으로 선택된 주소) */
  isDefault: Scalars['Boolean'];
  /** 좌표 정보 */
  location: GeoPoint;
  /** 지번주소 */
  oldAddress: Scalars['String'];
  /** 도로명주소 */
  roadAddress?: Maybe<Scalars['String']>;
  /** 사용자 주소 ID */
  userAddressId?: Maybe<Scalars['ID']>;
  /** 사용자 ID */
  userId: Scalars['ID'];
  /** 우편번호 */
  zipCode?: Maybe<Scalars['String']>;
};

/** 유저 주소 생성 요청 */
export type UserAddressModifyRequestInput = {
  /** 주소 타입 */
  addressType: AddressType;
  /** 별칭 */
  alias: Scalars['String'];
  /** 배송요청사항 */
  deliveryComment?: InputMaybe<Scalars['String']>;
  /** 상세주소 */
  detailAddress: Scalars['String'];
  /** 공동현관 비밀번호 */
  frontDoorPassword?: InputMaybe<Scalars['String']>;
  /** 지번주소 */
  jibunAddress: Scalars['String'];
  /** 위도 */
  latitude: Scalars['Float'];
  /** 경도 */
  longitude: Scalars['Float'];
  /** 우편번호 */
  postCode?: InputMaybe<Scalars['String']>;
  /** 도로명주소 */
  roadAddress: Scalars['String'];
  /** 주소 id */
  userAddressId: Scalars['ID'];
};

/** 유저 주소 생성 요청 */
export type UserAddressRegisterRequestInput = {
  /** 주소 타입 */
  addressType: AddressType;
  /** 별칭 */
  alias: Scalars['String'];
  /** 배송요청사항 */
  deliveryComment?: InputMaybe<Scalars['String']>;
  /** 상세주소 */
  detailAddress: Scalars['String'];
  /** 공동현관 비밀번호 */
  frontDoorPassword?: InputMaybe<Scalars['String']>;
  /** 지번주소 */
  jibunAddress: Scalars['String'];
  /** 위도 */
  latitude: Scalars['Float'];
  /** 경도 */
  longitude: Scalars['Float'];
  /** 우편번호 */
  postCode?: InputMaybe<Scalars['String']>;
  /** 도로명주소 */
  roadAddress: Scalars['String'];
};

export type UserDetailGraph = {
  /** 생년월일 */
  birthDate?: Maybe<Scalars['String']>;
  /** 복약알림여부 */
  doseNotificationAllowed?: Maybe<Scalars['Boolean']>;
  /** 성별 */
  gender?: Maybe<GenderType>;
  /** 외국인 여부 */
  isForeigner: Scalars['Boolean'];
  /** 진료를 보기위해 본인인증이 필요한지 여부 */
  isNeedVerificationForDiagnosis: Scalars['Boolean'];
  /** 이름 */
  name?: Maybe<Scalars['String']>;
  /** phone */
  phone?: Maybe<Scalars['String']>;
  /** 의료취약지 거주자인지 등 */
  telemedicineEligibleGroupType?: Maybe<TelemedicineEligibleGroupType>;
};

/** 유저 진료 정보 */
export type UserDiagnosis = {
  diagnosis: Diagnosis;
  /** 진료 및 조제 데이터 상태에 따른 요약 정보 */
  diagnosisSummary: DiagnosisSummaryGraph;
};

/** 유저에 의한 진료 취소 요청 */
export type UserDiagnosisCancelMutationRequestInput = {
  /** 진료 취소 사유를 유저가 직접 입력하는 경우 */
  cancelReason?: InputMaybe<Scalars['String']>;
  /** 진료 취소 사유 Id */
  cancelReasonId: Scalars['ID'];
  /** 진료 Id */
  diagnosisId: Scalars['ID'];
};

export type UserGamePrizesGraph = {
  /** 활성화된 상품 전략 리스트 */
  activePrizeStrategies: Array<GamePrizeStrategyGraph>;
  /** 게임 타입 */
  gameType: GameType;
  /** 유저 Id */
  userId: Scalars['ID'];
  /** 유저 상품 정보 리스트 */
  userPrizes: Array<UserPrizeGraph>;
};

export enum UserMissionStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

export type UserMissionsGraph = {
  /** 미션 기록 리스트 (완료여부 포함) */
  missionRecords: Array<MissionRecordGraph>;
  /** 유저 Id */
  userId: Scalars['ID'];
  /** 유저 티켓 리스트 */
  userTickets: Array<UserTicketGraph>;
};

/** 유저 비밀번호 변경 요청 */
export type UserPasswordChangeMutationRequestInput = {
  /** 새로운 비밀번호 */
  newPassword: Scalars['String'];
  /** 기존 비밀번호 */
  originalPassword: Scalars['String'];
};

/** 유저 결제정보 */
export type UserPayment = {
  /** 할부 가능 여부 */
  canInstallment: Scalars['Boolean'];
  /** 카드 이름 */
  cardName: Scalars['String'];
  /** 카드 번호 */
  cardNumber: Scalars['String'];
  /** 카드 타입 */
  cardType: CardType;
  /** 유저 결제정보 id */
  id: Scalars['ID'];
  /** 약관 승인 여부 */
  isApproved: Scalars['Boolean'];
  /** 기본 카드 여부 */
  isDefault: Scalars['Boolean'];
  /** PG사 */
  payCompany: PayCompany;
  /** 유저 id */
  userId: Scalars['ID'];
};

export type UserPaymentRegisterGraph = {
  isRewarded: Scalars['Boolean'];
  rewardPointAmount: Scalars['Int'];
};

export type UserPaymentRegisterRequestInput = {
  agreements: Array<AgreementApproveRequestInput>;
  birthNumber: Scalars['String'];
  cardNumber: Scalars['String'];
  checkText: Scalars['String'];
  expirationMonth: Scalars['String'];
  expirationYear: Scalars['String'];
};

export type UserPedometerMission = {
  missionRecord: MissionRecordGraph;
  pedometerMissionId: Scalars['ID'];
  requiredStep: Scalars['Int'];
  userId: Scalars['ID'];
};

/** 유저 잔여 포인트 */
export type UserPointAmount = {
  point: Scalars['Int'];
};

export type UserPrizeGraph = {
  /** 추첨 시간 */
  drawnAt: Scalars['DrTimestamp'];
  /** 유저 상품 Id */
  id: Scalars['ID'];
  /** 상품 정보 */
  prize: PrizeGraph;
  /** 상품 수량 */
  quantity: Scalars['Int'];
  /** 수령 시간 */
  receivedAt?: Maybe<Scalars['DrTimestamp']>;
  /** 상품 상태 */
  status: UserPrizeStatus;
  /** 유저 Id */
  userId: Scalars['ID'];
};

export enum UserPrizeStatus {
  Drawn = 'DRAWN',
  Received = 'RECEIVED'
}

/** 유저 프로필 */
export type UserProfile = {
  /** 생년월일 (YYYY-MM-DD */
  birthDate: Scalars['String'];
  /** 비대면진료 대상 그룹 관련 자격 태그 ex) 항상 비대면진료 가능, 약배송 가능 */
  eligibilityTags: Array<EligibilityTag>;
  /** 주민등록번호 뒤 첫 자리 */
  followingResidentFirstNumber: Scalars['Int'];
  /** 성별 */
  gender: Gender;
  /** 주민번호 변경 여부 */
  isSsnChanged: Scalars['Boolean'];
  /** 진료신청서 아이 정보 섹션에 대한 노출여부 */
  isVisibleChildSection: Scalars['Boolean'];
  /** 나이 (36개월 미만은 개월수, 그 이상은 만나이) */
  koreanAge: Scalars['String'];
  /** 이름 */
  name: Scalars['String'];
  /** 전화번호 */
  phone?: Maybe<Scalars['String']>;
  /** 관계 */
  relation: UserProfileRelation;
  /** user ID or family ID */
  targetId: Scalars['ID'];
  /** 비대면진료 대상 그룹 */
  telemedicineEligibleGroupType?: Maybe<TelemedicineEligibleGroupType>;
  /** 비대면진료 대상 타입 */
  telemedicineTargetType?: Maybe<TelemedicineTargetType>;
  /** user profile type */
  userProfileType: UserProfileType;
};

export enum UserProfileRelation {
  Children = 'CHILDREN',
  Me = 'ME',
  Parents = 'PARENTS',
  Spouse = 'SPOUSE'
}

export enum UserProfileType {
  Family = 'FAMILY',
  User = 'USER'
}

export type UserReasonForLeavingSaveRequestInput = {
  reasonForLeaving: ReasonForLeavingSaveRequestInput;
  reasonForSignUp: ReasonForLeavingSaveRequestInput;
};

/** 유저 비대면진료 대상 그룹 등록 요청 */
export type UserTelemedicineEligibleGroupRegisterMutationRequestInput = {
  /** 비대면진료 대상 그룹 타입 */
  type: TelemedicineEligibleGroupType;
};

export type UserTicketGraph = {
  /** 유저 티켓 ID */
  id: Scalars['ID'];
  /** 티켓 수량 */
  quantity: Scalars['Int'];
  /** 티켓 타입 */
  ticketType: TicketType;
  /** 유저 ID */
  userId: Scalars['ID'];
};

/** 예방접종 무료 정책 정보 */
export type VaccinationFreePolicyInfoGraph = {
  /** 화면 표시용 무료 정책 레이블 */
  freeLabel: Scalars['String'];
  /** 정책 ID */
  id: Scalars['ID'];
  /** 정책명 */
  name: Scalars['String'];
  /** 대상 그룹 */
  targetGroup: Scalars['String'];
};

/** 예방접종 정보 */
export type VaccinationInfoGraph = {
  /** 무료 정책 정보 */
  freePolicies: Array<VaccinationFreePolicyInfoGraph>;
  /** 예방접종 ID (treatmentId) */
  id: Scalars['ID'];
  /** 예방접종명 */
  name: Scalars['String'];
  /** 예방접종 타입 정보 */
  types: Array<VaccinationTypeInfoGraph>;
};

export type VaccinationInfoMutationRequestInput = {
  vaccinationFreePolicyId?: InputMaybe<Scalars['ID']>;
  vaccinationTypeId?: InputMaybe<Scalars['ID']>;
  vaccinationTypeUnitId?: InputMaybe<Scalars['ID']>;
};

export type VaccinationSearchFilterRequestInput = {
  /** 무료접종 정책 ID */
  vaccinationFreePolicyId?: InputMaybe<Scalars['ID']>;
  /** 백신 종류 ID */
  vaccinationTypeId?: InputMaybe<Scalars['ID']>;
  /** 백신 종류 단위 ID */
  vaccinationTypeUnitId?: InputMaybe<Scalars['ID']>;
};

/** 예방접종 타입 정보 */
export type VaccinationTypeInfoGraph = {
  /** 예방접종 타입 ID */
  id: Scalars['ID'];
  /** 예방접종 타입명 (e.g. 3가, 4가) */
  name: Scalars['String'];
  /** 접종 단위 정보 */
  units: Array<VaccinationTypeUnitInfoGraph>;
};

/** 예방접종 타입 단위 정보 */
export type VaccinationTypeUnitInfoGraph = {
  /** 단위 ID */
  id: Scalars['ID'];
  /** 접종 단위 */
  unit: Scalars['Int'];
};

/** 백신 제품 정보 */
export type VaccineProductGraph = {
  /** 백신 제품 ID */
  id: Scalars['ID'];
  /** 사용 가능 여부 */
  isAvailable: Scalars['Boolean'];
  /** 제조사 */
  manufacturer: Scalars['String'];
  /** 백신 제품명 */
  name: Scalars['String'];
  /** 예방접종 타입 ID */
  vaccinationTypeId: Scalars['ID'];
};

export enum VerificationType {
  Email = 'EMAIL',
  Phone = 'PHONE'
}

/** 토큰 인증 요청 */
export type VerifyMutationRequestInput = {
  /** email or phone number */
  target: Scalars['String'];
  /** token */
  token: Scalars['String'];
  /** 인증 타입 */
  type: VerificationType;
};

/** 주문 결제 요청 */
export type WholesaleOrderPayRequestInput = {
  /** 결제해야 할 금액 */
  amountToPay: Scalars['Int'];
  /** 주문 Id */
  orderId: Scalars['Int'];
  /** 사용할 포인트 */
  pointToUse: Scalars['Int'];
  /** 유저 결제수단 id */
  userPaymentId: Scalars['Int'];
};

/** 리뷰 */
export type Review = {
  comments: Array<ReviewComment>;
  /** 리뷰 내용 */
  content: Scalars['String'];
  /** 생성일시 */
  createdAt: Scalars['DrTimestamp'];
  /** 리뷰 ID */
  id: Scalars['ID'];
  /** 차단 여부 */
  isBlocked: Scalars['Boolean'];
  /** 유저가 리뷰 좋아요를 눌렀는지 여부 */
  isLiked: Scalars['Boolean'];
  /** 숨김 여부 */
  isPrivate: Scalars['Boolean'];
  /** 좋아요 개수 */
  likeCount: Scalars['Int'];
  /** 리뷰 작성자 이름(마스킹) */
  maskedHolderName: Scalars['String'];
  /** 별점 */
  rating: Scalars['Int'];
  /** 리뷰 컨텍스트 */
  reviewContext: ReviewContextGraph;
  /** 리뷰 태그 */
  tags: Array<ReviewTagMap>;
  /** 리뷰 타켓 카테고리 */
  targetCategoryName: Scalars['String'];
  /** 리뷰 타켓 금액 */
  targetPrice?: Maybe<Scalars['Int']>;
  /** 리뷰 타이틀 */
  title: Scalars['String'];
};

/** 리뷰 코멘트 */
export type ReviewComment = {
  /** 리뷰 코멘트 내용 */
  content: Scalars['String'];
  /** 생성일시 */
  createdAt: Scalars['DrTimestamp'];
  /** 리뷰 코멘트 ID */
  id: Scalars['ID'];
  /** 차단 여부 */
  isBlocked: Scalars['Boolean'];
  reviewCommentHolder: ReviewCommentHolderGraph;
  /** 리뷰 코멘트 작성자 ID */
  reviewCommentHolderId: Scalars['ID'];
  /** 리뷰 코멘트 작성자 타입 */
  reviewCommentHolderType: ReviewCommentHolderType;
};

export type ExistPharmacyAdditionalOrderProductsByPharmacyIdQueryVariables = Exact<{
  pharmacyId: Scalars['ID'];
}>;


export type ExistPharmacyAdditionalOrderProductsByPharmacyIdQuery = { existPharmacyAdditionalOrderProductsByPharmacyId: boolean };

export type PharmacyAdditionalOrderCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type PharmacyAdditionalOrderCategoriesQuery = { pharmacyAdditionalOrderCategories: Array<{ id: string, name: string }> };

export type PharmacyAdditionalOrderProductFieldsFragment = { id: string, categoryId: string, name: string, manufacturer: string, imageUrl: string, price: number, description: string };

export type PharmacyAdditionalOrderProductsByPharmacyIdAndCategoryIdQueryVariables = Exact<{
  pharmacyId: Scalars['ID'];
  categoryId?: InputMaybe<Scalars['ID']>;
  pagingRequest: PagingRequestInput;
}>;


export type PharmacyAdditionalOrderProductsByPharmacyIdAndCategoryIdQuery = { pharmacyAdditionalOrderProductsByPharmacyIdAndCategoryId: Array<{ id: string, categoryId: string, name: string, manufacturer: string, imageUrl: string, price: number, description: string }> };

export type RecommendedPharmacyAdditionalOrderProductsQueryVariables = Exact<{
  request: RecommendedPharmacyAdditionalOrderProductsRequestInput;
}>;


export type RecommendedPharmacyAdditionalOrderProductsQuery = { recommendedPharmacyAdditionalOrderProducts: { catalogRecommendation: { description: string, name: string }, products: Array<{ id: string, categoryId: string, name: string, manufacturer: string, imageUrl: string, price: number, description: string }> } };

export type ReadyKakaopayRegistrationMutationVariables = Exact<{ [key: string]: never; }>;


export type ReadyKakaopayRegistrationMutation = { readyKakaopayRegistration: { transactionId: string, nextRedirectAppUrl: string, nextRedirectMobileUrl: string, nextRedirectPcUrl: string, androidScheme: string, iosScheme: string } };

export type ApproveKakaopayRegistrationMutationVariables = Exact<{
  request: KakaopayRegistrationRequestInput;
}>;


export type ApproveKakaopayRegistrationMutation = { approveKakaopayRegistration: { isSuccess: boolean } };

export type GetDoctorTreatmentMedicineOpenDateQueryVariables = Exact<{
  doctorId: Scalars['ID'];
  treatmentMedicineId: Scalars['ID'];
}>;


export type GetDoctorTreatmentMedicineOpenDateQuery = { getDoctorTreatmentMedicineOpenDate: { date?: string | null } };

export type DiagnosesByUserV2QueryVariables = Exact<{
  paginationCriteria: PaginationCriteriaInput;
}>;


export type DiagnosesByUserV2Query = { diagnosesByUserV2: Array<{ diagnosis: { diagnosisForm: { id: string, symptom?: string | null } } }> };

export type DiseaseEncyclopediaByUserQueryVariables = Exact<{
  diseaseEncyclopediaPid: Scalars['ID'];
}>;


export type DiseaseEncyclopediaByUserQuery = { diseaseEncyclopediaByUser: { bottomButtonType: DiseaseEncyclopediaBottomButtonType, content: string, departmentTags: Array<string>, id: string, publicId: string, searchTags: Array<string>, title: string, titleImageUrl?: string | null, symptomTags: Array<string>, banner?: { buttonPhrase: string, description: string, diseaseEncyclopediaId: string, externalUrl: string, id: string, imageUrl: string, title: string } | null, faqs: Array<{ question: string, answer: string }> } };

export type SearchMagazinesQueryVariables = Exact<{
  request: MagazineSearchRequestInput;
}>;


export type SearchMagazinesQuery = { searchMagazines: { items: Array<{ id: string, title: string, description: string, publicId: string, createdAt: number, titleImageUrl: string, mobileTitle: string, mobileDescription: string, visible: boolean }> } };

export type SearchMagazinesTotalCountQueryVariables = Exact<{
  request: MagazineSearchRequestInput;
}>;


export type SearchMagazinesTotalCountQuery = { searchMagazines: { totalCount: number } };

export type NonF2fMedicalCategoriesQueryVariables = Exact<{
  size?: InputMaybe<Scalars['Int']>;
}>;


export type NonF2fMedicalCategoriesQuery = { nonF2fMedicalCategories: Array<{ category: MedicalCategoryType, id: string, name?: string | null, iconUrl?: string | null }> };

export type GetNonBenefitDiagnosisPriceSupportInvitationCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNonBenefitDiagnosisPriceSupportInvitationCodeQuery = { getNonBenefitDiagnosisPriceSupportInvitationCode: { code: string } };

export type NonBenefitMedicinesForSortingV2QueryVariables = Exact<{
  contactType: DiagnosisContactType;
}>;


export type NonBenefitMedicinesForSortingV2Query = { nonBenefitMedicinesForSortingV2: Array<{ id: string, medicineName: string, medicineDescription?: string | null, treatment: { id: string, name: string }, units: Array<{ id: string, unit: string, unitType: string, unitTypeDisplayName: string }>, treatmentMedicineStrengths: Array<{ treatmentMedicineStrengthId: string, unit: string }> }> };

export type NonBenefitMedicinesForSeoV2QueryVariables = Exact<{
  treatmentId: Scalars['ID'];
  contactType: DiagnosisContactType;
}>;


export type NonBenefitMedicinesForSeoV2Query = { nonBenefitMedicinesForSeoV2: Array<{ id: string, treatmentId: string, medicineName: string, medicineCode: string, medicineDescription?: string | null, units: Array<{ id: string, unit: string, unitType: string, unitTypeDisplayName: string }>, treatment: { id: string, categoryId: string, isBenefit: boolean, name: string }, dispensationUnits: Array<{ dispensationUnit: number, treatmentMedicineUnitId: string }> }> };

export type NonBenefitPriceTotalSummaryV2QueryVariables = Exact<{
  treatmentMedicineId: Scalars['ID'];
  regionCode: Scalars['String'];
  contactType: DiagnosisContactType;
}>;


export type NonBenefitPriceTotalSummaryV2Query = { nonBenefitPriceTotalSummaryV2: { nationalSummaries: Array<{ averagePrice: number, minPrice: number, treatmentMedicineUnitId: string, unitDisplayName: string, unitTypeDisplayName: string }>, regionSummaries: Array<{ averagePrice: number, minPrice: number, treatmentMedicineUnitId: string, unitDisplayName: string, unitTypeDisplayName: string }> } };

export type SearchDoctorsForSeoByUserQueryVariables = Exact<{
  request: DoctorSeoSearchRequestInput;
  contactType: DiagnosisContactType;
}>;


export type SearchDoctorsForSeoByUserQuery = { searchDoctorsForSeoByUser: Array<{ doctorId: string, name: string, medicineType: MedicineType, readyForVideoCall: boolean, publicId: string, nonBenefitTreatmentsV2: Array<{ nonBenefitTreatmentUnitInfos: Array<{ originalPrice: number, unitDisplayName: string, treatmentMedicineUnitId: string }> }>, detail?: { profileImageUrl?: string | null } | null, departments: Array<{ name: string, isProfessional: boolean }>, hospital: { hospitalName: string, hospitalAddress: { jibunAddress?: string | null, roadAddress: string, regionByDepth: { siDoName: string, siGunGuName?: string | null, legalEupMyeonDongName: string } } } }> };

export type PharmacyMedicinePriceTotalSummaryQueryVariables = Exact<{
  treatmentMedicineId: Scalars['ID'];
  contactType: DiagnosisContactType;
  regionCode: Scalars['String'];
}>;


export type PharmacyMedicinePriceTotalSummaryQuery = { pharmacyMedicinePriceTotalSummary: { treatmentMedicineId: string, regionCode: string, regionSummaries: Array<{ unit: number, unitTypeDisplayName: string, minPrice: number, averagePrice: number }>, nationalSummaries: Array<{ unit: number, unitTypeDisplayName: string, minPrice: number, averagePrice: number }> } };

export type NearbyPharmacyV3ByRegionCodeQueryVariables = Exact<{
  request: NearbyPharmacySearchByRegionCodeRequestInput;
  treatmentMedicineId?: InputMaybe<Scalars['ID']>;
  dispensationUnit?: InputMaybe<Scalars['Int']>;
}>;


export type NearbyPharmacyV3ByRegionCodeQuery = { nearbyPharmacyV3ByRegionCode: Array<{ pharmacyId: string, publicId: string, name: string, location: { roadAddress?: string | null, jibunAddress?: string | null, latitude: number, longitude: number }, dispensableMedicines?: { totalAmount?: number | null } | null }> };

export type GetSearchKoreaAddressHierarchyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSearchKoreaAddressHierarchyQuery = { searchKoreaAddressHierarchy: Array<{ name: string, displaySidoName?: string | null, code: string, administrationType: string, latitude: number, longitude: number, children: Array<{ name: string, code: string, latitude: number, longitude: number, administrationType: string, children: Array<{ name: string, code: string, latitude: number, longitude: number, administrationType: string }> }> }> };

export type RequestPartnershipPickupDispensationV3MutationVariables = Exact<{
  request: PartnershipPickupDispensationMutationRequestV3Input;
}>;


export type RequestPartnershipPickupDispensationV3Mutation = { requestPartnershipPickupDispensationV3: boolean };

export type GetNearbyPharmacyDetailV3ByUserWithPrescriptionOptionsQueryVariables = Exact<{
  request: NearbyPharmacyDetailSearchByPublicIdRequestInput;
  diagnosisId?: InputMaybe<Scalars['ID']>;
}>;


export type GetNearbyPharmacyDetailV3ByUserWithPrescriptionOptionsQuery = { nearbyPharmacyDetailByPublicId?: { dispensationOptions: { asPrescribed: { totalAmount?: number | null, mainTags: Array<{ type: string, title: string, imageUrl?: string | null }> }, alternativeAvailable: { totalAmount?: number | null, mainTags: Array<{ type: string, title: string, imageUrl?: string | null }> } } } | null };

export type SearchQuestionsItemsQueryVariables = Exact<{
  request: QuestionSearchRequestInput;
}>;


export type SearchQuestionsItemsQuery = { searchQuestions: { items: Array<{ status?: QuestionStatus | null, accessibleType: QuestionAccessibleType, createdAt: number, content: string, isBlockedByMe: boolean, publicId: string, title?: string | null, userMaskedName: string, userId: string, attachments: Array<{ blindType: AttachmentBlindType, id: string }>, category: { name: string, id: string, iconImagePath: string }, tags: Array<{ name: string }> }> } };

export type SearchQuestionsTotalCountQueryVariables = Exact<{
  request: QuestionSearchRequestInput;
}>;


export type SearchQuestionsTotalCountQuery = { searchQuestions: { totalCount: number } };

export type AvailableBookingTimeSlotsQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableBookingTimeSlotsQuery = { availableBookingTimeSlots: Array<{ targetDate: string, status: DayScheduleStatus, displayName: string, schedules: Array<{ remainingCount: number, bookingStatus: BookingScheduleType, startTimeSlot: { displayTime: string, value: number, fromDisplayTime: string, toDisplayTime: string }, endTimeSlot: { displayTime: string, value: number, fromDisplayTime: string, toDisplayTime: string } }> }> };

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = { user: { accountId: string, deviceId?: string | null, email?: string | null, invitationCode?: string | null, isVerified: boolean, marketingReceiptAccepted: boolean, notificationAllowed: boolean, nightlyMarketingReceiptAccepted: boolean, contentNotificationAllowed: boolean, platform: PlatformType, pushToken?: string | null, userId: string, createdAt: number, detail?: { birthDate?: string | null, doseNotificationAllowed?: boolean | null, gender?: GenderType | null, isForeigner: boolean, isNeedVerificationForDiagnosis: boolean, name?: string | null, phone?: string | null, telemedicineEligibleGroupType?: TelemedicineEligibleGroupType | null } | null, account: { id: string, loginType: LoginType, role: RoleType, status: AccountStatus, oAuthInfo?: { accountId: string, id: string, providerType: ProviderType } | null } } };

export type SetUserDefaultAddressMutationVariables = Exact<{
  addressId: Scalars['ID'];
}>;


export type SetUserDefaultAddressMutation = { setUserDefaultAddress: boolean };

export type DeleteUserAddressMutationVariables = Exact<{
  addressId: Scalars['ID'];
}>;


export type DeleteUserAddressMutation = { deleteUserAddress: boolean };

export type RegisterUserAddressMutationVariables = Exact<{
  request: UserAddressRegisterRequestInput;
}>;


export type RegisterUserAddressMutation = { registerUserAddress: boolean };

export type ModifyUserAddressMutationVariables = Exact<{
  request: UserAddressModifyRequestInput;
}>;


export type ModifyUserAddressMutation = { modifyUserAddress: boolean };

export type AddressByLocationFromDoctornowQueryVariables = Exact<{
  longitude: Scalars['Float'];
  latitude: Scalars['Float'];
}>;


export type AddressByLocationFromDoctornowQuery = { addressByLocationFromDoctornow: Array<{ dongName: string, dongType: KoreaAddressDongType }> };

export type GetBannerAdExchangeQueryVariables = Exact<{
  request: BannerAdExchangeRequestInput;
}>;


export type GetBannerAdExchangeQuery = { getBannerAdExchange?: { bannerAdId: string, bannerImageUrl?: string | null, colorTheme: AdColorTheme, ctaButtonLabel?: string | null, deliberatedCode?: string | null, longSubTitle?: string | null, subTitle?: string | null, longTitle?: string | null, title?: string | null, targetPlaceCode: string, content?: string | null, clickAction: { clickActionType: ClickActionType, outlink?: string | null, phoneNumber?: string | null }, badges: Array<{ content: string }> } | null };

export type HandleAdExposureMutationVariables = Exact<{
  request: AdExposureHandleMutationRequestInput;
}>;


export type HandleAdExposureMutation = { handleAdExposure: boolean };

export type GetPgAgreementsByCardNumberQueryVariables = Exact<{
  cardNumberEightDigits: Scalars['String'];
}>;


export type GetPgAgreementsByCardNumberQuery = { getPgAgreementsByCardNumber: { payCompany: PayCompany, agreements: Array<{ id: string, title: string, url?: string | null, required: boolean }> } };

export type RegisterUserPaymentMutationVariables = Exact<{
  request: UserPaymentRegisterRequestInput;
}>;


export type RegisterUserPaymentMutation = { registerUserPayment: { isRewarded: boolean, rewardPointAmount: number } };

export type GetUserAddressesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAddressesQuery = { getUserAddresses: Array<{ userAddressId?: string | null, userId: string, alias: string, roadAddress?: string | null, oldAddress: string, detailAddress: string, addressType: AddressType, zipCode?: string | null, deliveryComment?: string | null, frontDoorPassword?: string | null, isDefault: boolean, location: { latitude: number, longitude: number } }> };

export type UserProfilesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserProfilesQuery = { userProfiles: Array<{ isSsnChanged: boolean, birthDate: string, userProfileType: UserProfileType, targetId: string, name: string, relation: UserProfileRelation, phone?: string | null, followingResidentFirstNumber: number, telemedicineTargetType?: TelemedicineTargetType | null, telemedicineEligibleGroupType?: TelemedicineEligibleGroupType | null, koreanAge: string, isVisibleChildSection: boolean, eligibilityTags: Array<{ type: CombinedEligibilityTagType, message: string }> }> };

export type UserPaymentsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserPaymentsQuery = { userPayments: Array<{ canInstallment: boolean, cardName: string, cardNumber: string, id: string, isApproved: boolean, isDefault: boolean, payCompany: PayCompany }> };

export type UserPointAmountQueryVariables = Exact<{ [key: string]: never; }>;


export type UserPointAmountQuery = { userPointAmount: { point: number } };

export type IsFeatureOnQueryVariables = Exact<{
  flag: Scalars['String'];
}>;


export type IsFeatureOnQuery = { isFeatureOn: boolean };

export type GetBoardCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBoardCategoriesQuery = { boardCategories: Array<{ boardCategoryId: string, imageUrl: string, name: string }> };

export type GetRecommendedPopularBoardPostsQueryVariables = Exact<{
  size: Scalars['Int'];
}>;


export type GetRecommendedPopularBoardPostsQuery = { recommendedPopularBoardPosts: Array<{ boardPostPid: string, isPopular: boolean, isRecommended: boolean, title: string }> };

export type GetNewestBoardPostCursorPageQueryVariables = Exact<{
  request: NewestBoardPostCursorPageRequestInput;
}>;


export type GetNewestBoardPostCursorPageQuery = { newestBoardPostCursorPage: { pivot?: string | null, elements: Array<{ boardPostPid: string, title: string, content: string, createdAt: number, isPopular: boolean, isRecommended: boolean, likeCount: number, boardCommentCount: number, isLikedByMe: boolean, isMine: boolean, blinded: boolean, boardPostAttachments: Array<{ boardPostAttachmentId: string, boardPostPid: string, blindType: AttachmentBlindType }>, communityUser: { nickname: string, userId: string, profileImageUrl: string }, boardCategory: { name: string } }> } };

export type GetSearchBoardPostCursorPageQueryVariables = Exact<{
  request: SearchBoardPostCursorPageRequestInput;
}>;


export type GetSearchBoardPostCursorPageQuery = { searchBoardPostCursorPage: { pivot?: string | null, elements: Array<{ boardPostPid: string, title: string, content: string, createdAt: number, isPopular: boolean, isRecommended: boolean, likeCount: number, boardCommentCount: number, isLikedByMe: boolean, isMine: boolean, blinded: boolean, boardPostAttachments: Array<{ boardPostAttachmentId: string, boardPostPid: string, blindType: AttachmentBlindType }>, communityUser: { nickname: string, userId: string, profileImageUrl: string }, boardCategory: { name: string } }> } };

export type GetBoardPopularSearchKeywordsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBoardPopularSearchKeywordsQuery = { popularSearchKeywords: Array<string> };

export type GetBoardPostQueryVariables = Exact<{
  boardPostPid: Scalars['ID'];
}>;


export type GetBoardPostQuery = { boardPost: { boardPostPid: string, boardCategoryId: string, title: string, content: string, likeCount: number, boardCommentCount: number, createdAt: number, isLikedByMe: boolean, isMine: boolean, blinded: boolean, boardPostAttachments: Array<{ boardPostAttachmentId: string, blindType: AttachmentBlindType }>, communityUser: { nickname: string, userId: string, profileImageUrl: string }, boardCategory: { name: string }, boardComments: Array<{ boardCommentPid: string, parentBoardCommentPid: string, boardPostPid: string, content: string, createdAt: number, deleted: boolean, isLikedByMe: boolean, isMine: boolean, likeCount: number, blinded: boolean, communityUser: { nickname: string, userId: string, profileImageUrl: string } }> } };

export type SetLikeBoardPostMutationVariables = Exact<{
  boardPostPid: Scalars['ID'];
}>;


export type SetLikeBoardPostMutation = { likeBoardPost: boolean };

export type GetMyBoardPostCursorPageQueryVariables = Exact<{
  request: MyBoardPostCursorPageRequestInput;
}>;


export type GetMyBoardPostCursorPageQuery = { myBoardPostCursorPage: { pivot?: string | null, elements: Array<{ boardPostPid: string, title: string, content: string, createdAt: number, isPopular: boolean, isRecommended: boolean, likeCount: number, boardCommentCount: number, isLikedByMe: boolean, isMine: boolean, blinded: boolean, boardPostAttachments: Array<{ boardPostAttachmentId: string, boardPostPid: string, blindType: AttachmentBlindType }>, communityUser: { nickname: string, userId: string, profileImageUrl: string }, boardCategory: { name: string } }> } };

export type GetMyBoardCommentQueryVariables = Exact<{
  request: MyBoardCommentCursorPageRequestInput;
}>;


export type GetMyBoardCommentQuery = { myBoardCommentCursorPage: { pivot?: string | null, elements: Array<{ boardCommentPid: string, parentBoardCommentPid: string, boardPostPid: string, content: string, createdAt: number, isLikedByMe: boolean, isMine: boolean, likeCount: number, blinded: boolean, boardPost?: { boardPostPid: string, title: string } | null }> } };

export type SetLikeBoardCommentMutationVariables = Exact<{
  boardCommentPid: Scalars['ID'];
}>;


export type SetLikeBoardCommentMutation = { likeBoardComment: boolean };

export type GetBoardCommentBelongedBoardCommentsQueryVariables = Exact<{
  request: BoardCommentBelongedBoardCommentsRequestInput;
}>;


export type GetBoardCommentBelongedBoardCommentsQuery = { boardCommentBelongedBoardComments: Array<{ boardCommentPid: string, parentBoardCommentPid: string, boardPostPid: string, content: string, createdAt: number, deleted: boolean, isLikedByMe: boolean, isMine: boolean, likeCount: number, blinded: boolean, communityUser: { nickname: string, userId: string, profileImageUrl: string } }> };

export type GetUserProfileImageUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserProfileImageUrlQuery = { communityUser: { userId: string, profileImageUrl: string } };

export type AddPostBoardCommentOfBoardPostMutationVariables = Exact<{
  request: PostBoardCommentOfBoardPostRequestInput;
}>;


export type AddPostBoardCommentOfBoardPostMutation = { postBoardCommentOfBoardPost: boolean };

export type AddPostBoardCommentOfBoardCommentMutationVariables = Exact<{
  request: PostBoardCommentOfBoardCommentRequestInput;
}>;


export type AddPostBoardCommentOfBoardCommentMutation = { postBoardCommentOfBoardComment: boolean };

export type GetCommunityUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCommunityUserQuery = { communityUser: { nickname: string, userId: string, postCommentNotificationAllowed: boolean, postLikeNotificationAllowed: boolean, qnaAnswerNotificationAllowed: boolean, tutorialCompleted: boolean, profileImageUrl: string, isAdmin: boolean, bannedUntil?: number | null } };

export type UpdateCommunityUserNicknameMutationVariables = Exact<{
  nickname: Scalars['String'];
}>;


export type UpdateCommunityUserNicknameMutation = { updateCommunityUserNickname: boolean };

export type GetValidateCommunityUserNicknameQueryVariables = Exact<{
  nickname: Scalars['String'];
}>;


export type GetValidateCommunityUserNicknameQuery = { validateCommunityUserNickname: { resultType: ResultType, available: boolean } };

export type GetCommunityUserProfileImageUploadInfoQueryVariables = Exact<{
  request: Scalars['String'];
}>;


export type GetCommunityUserProfileImageUploadInfoQuery = { communityUserProfileImageUploadInfo: { path: string, preSignedUrl: string } };

export type UpdateCommunityUserProfileImagePathMutationVariables = Exact<{
  profileImagePath: Scalars['String'];
}>;


export type UpdateCommunityUserProfileImagePathMutation = { updateCommunityUserProfileImagePath: boolean };

export type GetCommunityUserProfileImagePresetsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCommunityUserProfileImagePresetsQuery = { communityUserProfileImagePresets: Array<{ path: string, url: string }> };

export type BoardPostAttachmentUploadInfoQueryVariables = Exact<{
  request: Scalars['String'];
}>;


export type BoardPostAttachmentUploadInfoQuery = { boardPostAttachmentUploadInfo: { path: string, preSignedUrl: string } };

export type PostBoardPostMutationVariables = Exact<{
  request: PostBoardPostRequestInput;
}>;


export type PostBoardPostMutation = { postBoardPost: { boardPostPid: string } };

export type SetReportBoardPostMutationVariables = Exact<{
  request: ReportBoardPostRequestInput;
}>;


export type SetReportBoardPostMutation = { reportBoardPost: boolean };

export type SetReportBoardCommentMutationVariables = Exact<{
  request: ReportBoardCommentRequestInput;
}>;


export type SetReportBoardCommentMutation = { reportBoardComment: boolean };

export type DeleteBoardPostMutationVariables = Exact<{
  boardPostPid: Scalars['ID'];
}>;


export type DeleteBoardPostMutation = { deleteBoardPost: boolean };

export type DeleteBoardCommentMutationVariables = Exact<{
  boardCommentPid: Scalars['ID'];
}>;


export type DeleteBoardCommentMutation = { deleteBoardComment: boolean };

export type BlindBoardPostMutationVariables = Exact<{
  boardPostPid: Scalars['ID'];
}>;


export type BlindBoardPostMutation = { blindBoardPost: { userBlindedCount: number, userBannedDayCount: number, userBannedDayCountMessage: string } };

export type BlindBoardCommentMutationVariables = Exact<{
  boardCommentPid: Scalars['ID'];
}>;


export type BlindBoardCommentMutation = { blindBoardComment: { userBlindedCount: number, userBannedDayCount: number, userBannedDayCountMessage: string } };

export type BlindBoardPostAttachmentMutationVariables = Exact<{
  boardPostAttachmentId: Scalars['ID'];
  blindType: AttachmentBlindType;
}>;


export type BlindBoardPostAttachmentMutation = { blindBoardPostAttachment: boolean };

export type UpdateBlindBoardPostOnlyMutationVariables = Exact<{
  boardPostPid: Scalars['ID'];
}>;


export type UpdateBlindBoardPostOnlyMutation = { blindBoardPostOnly: boolean };

export type UpdateBlindBoardCommentOnlyMutationVariables = Exact<{
  boardCommentPid: Scalars['ID'];
}>;


export type UpdateBlindBoardCommentOnlyMutation = { blindBoardCommentOnly: boolean };

export type RequestDiagnosisV2MutationVariables = Exact<{
  request: DiagnosisRegistrationRequestV2Input;
}>;


export type RequestDiagnosisV2Mutation = { requestDiagnosisV2: boolean };

export type DiagnosisAttachmentPreSignedUrlsQueryVariables = Exact<{
  fileExtensions: Array<Scalars['String']> | Scalars['String'];
}>;


export type DiagnosisAttachmentPreSignedUrlsQuery = { diagnosisAttachmentPreSignedUrls: Array<{ filePath: string, preSignedUrl: string }> };

export type GetDoctorIdByUserByTreatmentRequestQueryVariables = Exact<{
  id: Scalars['ID'];
  contactType: DiagnosisContactType;
}>;


export type GetDoctorIdByUserByTreatmentRequestQuery = { getDoctorByIdByUser: { name: string, doctorId: string, readyForVideoCall: boolean, medicineType: MedicineType, hospital: { brand?: { brandName: string, diagnosisFormType: DiagnosisFormType } | null }, detail?: { profileImageUrl?: string | null } | null, departmentsV2: Array<{ name: string, id: string, description?: string | null, iconUrl: string }>, treatmentCategoriesV2: Array<{ id: string, name: string, iconUrl: string, doctorTreatments: Array<{ treatmentCategoryId: string, treatment: { id: string, name: string }, doctorMedicinesV2: Array<{ medicineName: string, treatmentMedicineId: string }> }> }>, doctorVaccinations: Array<{ treatmentId: string, treatmentName: string, supportedFreePolicyIds: Array<string>, vaccinationTypes: Array<{ vaccinationTypeId: string, name: string, products: Array<{ vaccineProductId: string, vaccinationTypeUnitId: string, price: number, isAvailable: boolean }> }> }> } };

export type ChangeDiagnosisBookingMutationVariables = Exact<{
  bookingChangeRequest: DiagnosisBookingChangeMutationRequestInput;
}>;


export type ChangeDiagnosisBookingMutation = { changeDiagnosisBooking: boolean };

export type GetDoctorDetailQuestionCursorPageQueryVariables = Exact<{
  request: DoctorDetailQuestionCursorPageRequestInput;
}>;


export type GetDoctorDetailQuestionCursorPageQuery = { doctorDetailQuestionCursorPage: { pivot?: string | null, elements: Array<{ categoryName: string, content: string, createdAt: number, isBlockedByUser: boolean, questionPid: string, title: string, userId: string, userName: string, answer: { answerPid: string, content: string, doctorId: string, doctorName: string, doctorProfileImageUrl: string, isBlockedByUser: boolean } }> } };

export type GetDoctorDiagnosisBookingSchedulesQueryVariables = Exact<{
  contactType: DiagnosisContactType;
  doctorId: Scalars['ID'];
  telemedicineTargetType: TelemedicineTargetType;
}>;


export type GetDoctorDiagnosisBookingSchedulesQuery = { getDoctorDiagnosisBookingSchedules: Array<{ displayName: string, status: DayScheduleStatus, targetDate: string, schedules: Array<{ bookingStatus: BookingScheduleType, remainingCount: number, endTimeSlot: { displayTime: string, fromDisplayTime: string, toDisplayTime: string, value: number }, startTimeSlot: { displayTime: string, fromDisplayTime: string, toDisplayTime: string, value: number } }> }> };

export type GetDayOfWeekQueryVariables = Exact<{
  date: Scalars['String'];
}>;


export type GetDayOfWeekQuery = { dayOfWeek?: DayOfWeekType | null };

export type LikeReviewMutationVariables = Exact<{
  reviewId: Scalars['ID'];
}>;


export type LikeReviewMutation = { likeReview: boolean };

export type UnlikeReviewMutationVariables = Exact<{
  reviewId: Scalars['ID'];
}>;


export type UnlikeReviewMutation = { unlikeReview: boolean };

export type GetDoctorByUserQueryVariables = Exact<{
  doctorPublicId: Scalars['ID'];
  telemedicineEligibleTargetType: TelemedicineTargetType;
  contactType: DiagnosisContactType;
  isSelectedVaccination: Scalars['Boolean'];
}>;


export type GetDoctorByUserQuery = { getDoctorByUser: { name: string, doctorId: string, readyForVideoCall: boolean, reviewCount: number, reviewAverageRating: number, medicineType: MedicineType, detail?: { contractType: ContractType, isBookable: boolean, isBookableF2F: boolean, personalHexColor?: string | null, presentedAt?: number | null, profileImageUrl?: string | null, simpleIntroduce?: string | null, introduce?: string | null, detailImages: Array<string> } | null, hospital: { doctorHospitalId: string, hospitalName: string, hospitalTelNumber?: string | null, hospitalAddress: { detailAddress?: string | null, jibunAddress?: string | null, roadAddress: string }, geoPoint: { latitude: number, longitude: number }, brand?: { brandName: string, diagnosisFormType: DiagnosisFormType } | null }, departmentsV2: Array<{ description?: string | null, id: string, isProfessional: boolean, name: string }>, reviewTagGroups: Array<{ count: number, name: string, receiverId: string, receiverType: ReviewReceiverType, tagId: string }>, careers: Array<{ isRepresentative: boolean, careerType: DoctorCareerType, content: string, id: string, sequence: number }>, doctorDuties: { f2f: Array<{ breakEndTime?: string | null, breakStartTime?: string | null, contactType: DiagnosisContactType, dayOfWeek: DayOfWeekType, doctorId: string, endTime: string, hasBreakTime: boolean, id: string, isClosed: boolean, startTime: string }>, nonF2f: Array<{ breakEndTime?: string | null, breakStartTime?: string | null, contactType: DiagnosisContactType, dayOfWeek: DayOfWeekType, doctorId: string, endTime: string, hasBreakTime: boolean, id: string, isClosed: boolean, startTime: string }> }, nonBenefitTreatmentsV2: Array<{ nonBenefitTreatmentUnitInfos: Array<{ doctorTreatmentMedicineUnitPricingId: string, originalPrice: number, priceOnUsingPoint: number, treatmentMedicineName: string, unitDisplayName: string, unitTypeDisplayName: string, usablePoint: number, priceType: DiagnosisPriceType, strengthUnit?: string | null }>, treatment: { categoryId: string, id: string, isBenefit: boolean, name: string } }>, doctorTreatments: Array<{ doctorId: string, treatmentId: string, treatment: { id: string, name: string } }>, treatmentCategoriesV2: Array<{ doctorTreatments: Array<{ treatment: { id: string, name: string } }> }>, doctorBadges: Array<{ badges: Array<{ title: string, description: string, iconUrl: string, type: DoctorBadgeType }> }>, doctorNotice?: { title: string, content: string } | null, doctorDiagnosisTypeReviewRatingStatistics: Array<{ diagnosisTypeId: string, diagnosisType: DiagnosisType, name: string, averageRating: number, count: number }>, bookingInfo: { bookingAvailability: BookingAvailability, doctorId: string, isBookable: boolean, todayBookable: boolean, todayCutoffTime: string, todayKickoffTime: string, tomorrowBookable: boolean, tomorrowCutoffTime: string, tomorrowKickoffTime: string }, bookingSchedules: Array<{ displayName: string, status: DayScheduleStatus, targetDate: string, schedules: Array<{ bookingStatus: BookingScheduleType, remainingCount: number, startTimeSlot: { displayTime: string, fromDisplayTime: string, toDisplayTime: string, value: number }, endTimeSlot: { displayTime: string, fromDisplayTime: string, toDisplayTime: string, value: number } }> }>, familyDoctorInfo?: { createdAt: number, doctorId: string } | null, doctorVaccinations?: Array<{ treatmentId: string, treatmentName: string, freePolicies: Array<{ id: string, name: string, targetGroup: string }>, vaccinationTypes: Array<{ vaccinationTypeId: string, name: string, products: Array<{ vaccineProductId: string, vaccinationTypeUnitId: string, unit: number, price: number, product: { name: string } }> }> }> } };

export type GetDoctorReviewQueryVariables = Exact<{
  doctorReviewRequest: DoctorReviewRequestInput;
  pagingRequest: PagingRequestInput;
  doctorReviewSort: DoctorReviewSort;
}>;


export type GetDoctorReviewQuery = { doctorReview: Array<{ doctorId: string, reviewId: string, createdAt: number, content: string, maskedPatientName: string, diagnosisCategoryName: string, isPrivate: boolean, diagnosisId: string, rating: number, title: string, userId: string, isBlocked: boolean, likeCount: number, isLiked: boolean, comments: Array<{ createdAt: number, content: string, isBlocked: boolean }>, tags: Array<{ tag: { tagId: string, text: string } }>, doctor: { doctorId: string, medicineType: MedicineType, name: string, profileImage: string } }> };

export type BestDoctorReviewQueryVariables = Exact<{
  doctorPublicId: Scalars['ID'];
}>;


export type BestDoctorReviewQuery = { bestDoctorReview?: { doctorId: string, reviewId: string, createdAt: number, content: string, maskedPatientName: string, diagnosisCategoryName: string, isPrivate: boolean, diagnosisId: string, rating: number, title: string, userId: string, isBlocked: boolean, likeCount: number, isLiked: boolean, comments: Array<{ createdAt: number, content: string, isBlocked: boolean }>, tags: Array<{ tagId: string, tag: { text: string } }>, doctor: { doctorId: string, medicineType: MedicineType, name: string, profileImage: string } } | null };

export type SearchFamilyDoctorsQueryVariables = Exact<{
  request: FamilyDoctorSearchRequestInput;
}>;


export type SearchFamilyDoctorsQuery = { searchFamilyDoctors: { familyDoctorCount: number, familyDoctors: Array<{ createdAt: number, doctorId: string, publicId: string, doctorName: string, hospitalName: string, isAbsent: boolean, isNew: boolean, maxWaitingCount: number, medicineType: string, profileUrl?: string | null, readyForVideoCall: boolean, reviewAverageRating: number, reviewCount: number, professionalDepartment: { doctorId: string, professionalDepartmentId?: string | null, professionalDepartmentName?: string | null }, bookingInfo: { bookingAvailability: BookingAvailability, doctorId: string, isBookable: boolean, todayBookable: boolean, todayCutoffTime: string, todayKickoffTime: string, todaySchedule: string, tomorrowBookable: boolean, tomorrowCutoffTime: string, tomorrowKickoffTime: string, tomorrowSchedule: string } }> } };

export type AddFamilyDoctorMutationVariables = Exact<{
  doctorId: Scalars['ID'];
}>;


export type AddFamilyDoctorMutation = { addFamilyDoctor: boolean };

export type RemoveFamilyDoctorsMutationVariables = Exact<{
  doctorIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RemoveFamilyDoctorsMutation = { removeFamilyDoctors: boolean };

export type RegisterUserAsTelemedicineEligibleGroupMutationVariables = Exact<{
  request: UserTelemedicineEligibleGroupRegisterMutationRequestInput;
}>;


export type RegisterUserAsTelemedicineEligibleGroupMutation = { registerUserAsTelemedicineEligibleGroup: boolean };

export type DeleteFamilyMutationVariables = Exact<{
  familyId: Scalars['ID'];
}>;


export type DeleteFamilyMutation = { deleteFamily: boolean };

export type ModifyFamilyMutationVariables = Exact<{
  familyId: Scalars['ID'];
  request: FamilyModifyMutationRequestInput;
}>;


export type ModifyFamilyMutation = { modifyFamily: boolean };

export type RegisterFamilyMutationVariables = Exact<{
  request: FamilyRegisterMutationRequestInput;
}>;


export type RegisterFamilyMutation = { registerFamily: boolean };

export type InvitationCodeByUserInviterQueryVariables = Exact<{
  codeType: InvitationCodeType;
}>;


export type InvitationCodeByUserInviterQuery = { invitationCodeByUserInviter?: { code: string, invitationCount: number, inviterReceivedPoints: number, inviterRewardAmount: number, inviteeRewardAmount: number, inviterReceivableTotalPoints: number } | null };

export type IssueInvitationCodeByUserInviterMutationVariables = Exact<{
  request: IssueInvitationCodeMutationRequestInput;
}>;


export type IssueInvitationCodeByUserInviterMutation = { issueInvitationCodeByUserInviter: { code: string } };

export type GetHospitalByIdQueryVariables = Exact<{
  publicId: Scalars['String'];
}>;


export type GetHospitalByIdQuery = { getHospitalByPublicId: { id: string, name: string, isBookable: boolean, isTodayBookable: boolean, partnershipTemplate: boolean, badges: Array<string>, temporaryHolidaysNotice?: string | null, temporaryHolidays: Array<string>, longitude?: number | null, latitude?: number | null, jibunAddress?: string | null, roadAddress?: string | null, detailAddress?: string | null, directionGuidance?: string | null, parkingInformation?: string | null, isFreeParking?: boolean | null, tel?: string | null, viewCount: number, introduction?: string | null, profileImages: Array<{ url: string, isRepresentative: boolean }>, naverPlaceDetail: { hashtags?: Array<string> | null, treatmentMenus: Array<{ treatmentName: string, price: number }> }, todayDuty: { dayOfWeek: DayOfWeekType, openTime?: string | null, closeTime?: string | null, breakStartTime?: string | null, breakEndTime?: string | null, operationTimes: string, breakTimes: string, isClosed?: boolean | null, operatingStatus: HospitalOperatingStatus }, duties: Array<{ dayOfWeek: DayOfWeekType, openTime?: string | null, closeTime?: string | null, breakStartTime?: string | null, breakEndTime?: string | null, operationTimes: string, breakTimes: string, isClosed?: boolean | null }>, departmentsV2: Array<{ departmentId: string, departmentName: string }>, departmentGroups: Array<{ averageRating: number, departmentGroupId: string, departmentGroupName: string, departmentGroupIconUrl: string, tags: Array<string> }>, nonBenefitDiagnosisPrices: Array<{ middleCategoryName: string, minPrice: number, maxPrice: number }>, regionByDepth: { siDoName: string, siGunGuName?: string | null, eupMyeonDongName: string }, treatments: Array<{ id: string, name: string }>, hospitalAdBanners: Array<{ displayDiscount: string, displayPrice: string, id: string, thumbnailImageUrl: string, title: string, url: string, hospitalId: string }>, hospitalSurgeries: Array<{ surgeryCount: number, surgeryName: string, badges: Array<string>, id: string }>, doctors: Array<{ id: string, publicId: string, hospitalId: string, isAbsent: boolean, name: string, displayName: string, medicineType: MedicineType, gender: DoctorGender, profileImagePath?: string | null, contractType: ContractType, partnershipStatus: DoctorPartnershipStatus, departmentGroups: Array<{ departmentGroupId: string, departmentGroupName: string, departmentGroupIconUrl: string, averageRating: number }>, professionalDepartmentsV2: Array<{ departmentId: string, departmentName: string, departmentCode: string }>, careers: Array<{ careerType: DoctorCareerType, content: string, id: string }>, reviewMetric: { averageRating: number, totalCount: number, groupByDiagnosisType: Array<{ count: number, diagnosisType: DiagnosisType, diagnosisTypeId: string, name: string }>, groupByRating: Array<{ count: number, rating: number }> } }>, topRatedDoctorReviews: Array<{ content: string, createdAt: number, id: string, isPrivate: boolean, likeCount: number, maskedHolderName: string, rating: number, targetCategoryName: string, title: string, isBlocked: boolean, isLiked: boolean, comments: Array<{ content: string, createdAt: number, id: string, isBlocked: boolean, reviewCommentHolder: { id: string, name: string, profileImageUrl?: string | null } }>, reviewContext: { reviewReceiver: { id: string, name: string } }, tags: Array<{ id: string, reviewId: string, tagId: string, tag: { tagId: string, text: string } }> }> } };

export type DoctorReviewMetricQueryVariables = Exact<{
  doctorReviewSearchRequest: DoctorReviewSearchRequestV2Input;
}>;


export type DoctorReviewMetricQuery = { doctorReviewMetric: { totalCount: number, averageRating: number, groupByRating: Array<{ count: number, rating: number }>, groupByDiagnosisType: Array<{ diagnosisType: DiagnosisType, diagnosisTypeId: string, name: string, count: number }> } };

export type GetFaceToFaceDiagnosisBookingFormByPublicIdQueryVariables = Exact<{
  publicId: Scalars['String'];
}>;


export type GetFaceToFaceDiagnosisBookingFormByPublicIdQuery = { getFaceToFaceDiagnosisBookingFormByPublicId: { bookingId: string, targetDate: string, targetDateDisplayText: string, detailSymptom?: string | null, name: string, registrationNumber: string, address: string, detailAddress?: string | null, hospital: { name: string }, doctor: { name: string, medicineType: MedicineType }, booking: { status: BookingStatus }, diagnosis?: { status: FaceToFaceDiagnosisStatus } | null } };

export type GetTotalReviewCountWithAverageRatingByPublicIdQueryVariables = Exact<{
  publicId: Scalars['String'];
}>;


export type GetTotalReviewCountWithAverageRatingByPublicIdQuery = { getTotalReviewCountWithAverageRatingByPublicId: { averageRating: number, totalCount: number } };

export type GetAddressByLocationQueryVariables = Exact<{
  longitude: Scalars['Float'];
  latitude: Scalars['Float'];
}>;


export type GetAddressByLocationQuery = { getAddressByLocation?: { detailAddress: string, jibunAddress: string, roadAddress: string, sido: string, zipCode: string, sigungu: string, dongLi: string } | null };

export type SearchKoreaAddressV2QueryVariables = Exact<{
  request: KoreaAddressSearchRequestV2Input;
}>;


export type SearchKoreaAddressV2Query = { searchKoreaAddressV2: Array<{ centroidLatitude: number, centroidLongitude: number, displayName: string, regionCode: string, regionName: string }> };

export type HospitalExternalPostQueryVariables = Exact<{
  hospitalPublicId: Scalars['ID'];
  size: Scalars['Int'];
  pivotId?: InputMaybe<Scalars['Int']>;
}>;


export type HospitalExternalPostQuery = { hospitalExternalPost: { totalCount: number, items: Array<{ id: string, title: string, content: string, postedAt: string, url: string }> } };

export type SearchHospitalGenerallyQueryVariables = Exact<{
  request: HospitalGeneralSearchRequestInput;
}>;


export type SearchHospitalGenerallyQuery = { searchHospitalGenerally?: { pivot?: string | null, pivotScore?: string | null, totalCount: number, elements: Array<{ hospitalId: string, hospitalPublicId: string, hospitalRepresentativeImageUrl?: string | null, hospitalName: string, hospitalAddress: string, hospitalDistance?: number | null, hospitalBadges: Array<string>, hospitalOperationStatus: HospitalOperatingStatus, hospitalRepresentativeDepartmentName?: string | null, reviewAverageRating: number, reviewTotalCount: number, isBookable: boolean, operationDisplay?: string | null, hospitalAdBanners: Array<{ displayDiscount: string, hospitalId: string, id: string, displayPrice: string, thumbnailImageUrl: string, title: string, url: string }>, doctors: Array<{ name: string, publicId: string, reviewAverageRating: number, medicineType: MedicineType, reviewTotalCount: number, readyForVideoCall: boolean, detail?: { contractType: ContractType, profileImageUrl?: string | null } | null, departments: Array<{ name: string, isProfessional: boolean }>, hospital: { hospitalName: string } }> }> } | null };

export type MedicalCategoriesQueryVariables = Exact<{
  request: MedicalCategoryRequestInput;
}>;


export type MedicalCategoriesQuery = { medicalCategories: Array<{ id: string, name: string, description: string, iconUrl: string, inflowType: InflowType, label?: string | null, departmentGroupId?: string | null, iconType: MedicalCategoryIconType, medicalSubCategories: Array<{ id: string, name: string, searchInflowType: InflowType, nonBenefitCategoryId?: number | null, nonBenefitItemId?: number | null, prescriptionUnit?: number | null, keyword?: string | null }> }> };

export type FaceToFaceTreatmentKeywordsQueryVariables = Exact<{ [key: string]: never; }>;


export type FaceToFaceTreatmentKeywordsQuery = { faceToFaceTreatmentKeywords: Array<{ id: string, name: string }> };

export type SearchPharmaciesByRegionCodeQueryVariables = Exact<{
  request: PharmacySearchByRegionCodeRequestInput;
}>;


export type SearchPharmaciesByRegionCodeQuery = { searchPharmaciesByRegionCode: Array<{ detailAddress?: string | null, id: string, jibunAddress?: string | null, name: string, roadAddress?: string | null, tel?: string | null, pharmacyDuties: Array<{ weekDay: number, openTime: string, closeTime: string, isClosed: boolean }> }> };

export type NonBenefitCategoryPrescriptionUnitsQueryVariables = Exact<{
  categoryId: Scalars['ID'];
}>;


export type NonBenefitCategoryPrescriptionUnitsQuery = { nonBenefitCategoryPrescriptionUnits?: Array<{ unit: number, unitType: NonBenefitItemUnitType, unitDisplayMessage: string, unitId: string }> | null };

export type HospitalNonBenefitCategoryItemPriceListQueryVariables = Exact<{
  hospitalId: Scalars['ID'];
  categoryId: Scalars['ID'];
}>;


export type HospitalNonBenefitCategoryItemPriceListQuery = { hospitalNonBenefitCategoryItemPriceList?: { hospitalId: string, nonBenefitCategory: { categoryId: string, categoryName: string, imageUrl?: string | null, nonBenefitItemGroup: { itemId: string, itemName: string, hasMedicinePrice: boolean, unitPrices: Array<{ unitDisplayMessage: string, diagnosisPrice?: string | null, totalPrice?: string | null }> } } } | null };

export type SearchNonBenefitHospitalsQueryVariables = Exact<{
  request: NonBenefitHospitalSearchRequestInput;
}>;


export type SearchNonBenefitHospitalsQuery = { searchNonBenefitHospitals?: { pivot?: string | null, pivotScore?: string | null, totalCount: number, elements: Array<{ hospitalId: string, hospitalPublicId: string, hospitalName: string, hospitalAddress: string, hospitalDistance?: number | null, hospitalRepresentativeImageUrl?: string | null, isBookable: boolean, hospitalOperationStatus: HospitalOperatingStatus, reviewAverageRating: number, reviewTotalCount: number, hospitalRepresentativeDepartmentName?: string | null, operationDisplay?: string | null, hospitalBadges: Array<string>, nonBenefitPriceInfo?: { diagnosisPrice?: string | null, totalPrice?: string | null } | null, hospitalAdBanners: Array<{ displayDiscount: string, hospitalId: string, id: string, displayPrice: string, thumbnailImageUrl: string, title: string, url: string }> }> } | null };

export type GetAddressByIpV2QueryVariables = Exact<{ [key: string]: never; }>;


export type GetAddressByIpV2Query = { getAddressByIpV2?: { regionCode: string, siDoName: string, siGunGuName: string, administrationEupMyeonDongName: string, latitude: number, longitude: number } | null };

export type SearchHospitalsV2QueryVariables = Exact<{
  request: HospitalElasticSearchV2RequestInput;
}>;


export type SearchHospitalsV2Query = { searchHospitalsV2?: { pivot?: number | null, pivotScore?: number | null, totalCount: number, elements: Array<{ hospitalId: string, hospitalPublicId: string, hospitalRepresentativeImageUrl?: string | null, hospitalName: string, hospitalAddress: string, hospitalDistance?: number | null, hospitalBadges: Array<string>, hospitalOperationStatus: HospitalOperatingStatus, hospitalRepresentativeDepartmentName?: string | null, reviewAverageRating: number, reviewTotalCount: number, isBookable: boolean }> } | null };

export type SearchInfluenzaHospitalsQueryVariables = Exact<{
  request: HospitalInfluenzaSearchRequestInput;
}>;


export type SearchInfluenzaHospitalsQuery = { searchInfluenzaHospitals?: { pivot?: number | null, pivotScore?: number | null, totalCount: number, elements: Array<{ hospitalId: string, hospitalPublicId: string, hospitalRepresentativeImageUrl?: string | null, hospitalName: string, hospitalAddress: string, hospitalDistance?: number | null, hospitalBadges: Array<string>, hospitalOperationStatus: HospitalOperatingStatus, hospitalRepresentativeDepartmentName?: string | null, reviewAverageRating: number, reviewTotalCount: number, isBookable: boolean, influenzaPriceWithMetadata?: { diagnosisPrice?: number | null, labels?: Array<string> | null } | null }> } | null };

export type SetOAuthSignInMutationVariables = Exact<{
  request: OauthSignInUserRequestInput;
}>;


export type SetOAuthSignInMutation = { oAuthSignIn: { accountId: string, accessToken: string, refreshToken: string, roleId?: string | null, roleType: string } };

export type OAuthSignInWithUserMutationVariables = Exact<{
  request: OauthSignInUserRequestInput;
}>;


export type OAuthSignInWithUserMutation = { oAuthSignInWithUser: { auth?: { accountId: string, accessToken: string, refreshToken: string, roleId?: string | null, roleType: string } | null } };

export type NaverOAuthAccessTokenMutationVariables = Exact<{
  code: Scalars['String'];
  state: Scalars['String'];
}>;


export type NaverOAuthAccessTokenMutation = { naverOAuthAccessToken: { accessToken: string, refreshToken: string } };

export type OAuthUserProfileQueryVariables = Exact<{
  provider: ProviderType;
  accessToken: Scalars['String'];
}>;


export type OAuthUserProfileQuery = { oAuthUserProfile: { email?: string | null, externalId: string } };

export type InsertMagazineLikeMutationVariables = Exact<{
  magazinePid: Scalars['ID'];
}>;


export type InsertMagazineLikeMutation = { insertMagazineLike: boolean };

export type DeleteMagazineLikeMutationVariables = Exact<{
  magazinePid: Scalars['ID'];
}>;


export type DeleteMagazineLikeMutation = { deleteMagazineLike: boolean };

export type GetQuestionRelatedMagazinesQueryVariables = Exact<{
  request: QuestionRelatedMagazinesRequestInput;
}>;


export type GetQuestionRelatedMagazinesQuery = { questionRelatedMagazines: Array<{ description: string, title: string, magazinePid: string, createdAt: number, titleImageUrl: string }> };

export type GetMagazineTagListPageQueryVariables = Exact<{
  request: TagMagazineCursorPageRequestInput;
}>;


export type GetMagazineTagListPageQuery = { tagMagazineCursorPage: { pivot?: string | null, elements: Array<{ createdAt: number, description: string, magazinePid: string, mobileContent: string, mobileDescription: string, mobileTitle: string, title: string, titleImageUrl: string, content: string }> } };

export type GetMagazineRelatedMagazinesQueryVariables = Exact<{
  request: MagazineRelatedMagazinesRequestInput;
}>;


export type GetMagazineRelatedMagazinesQuery = { magazineRelatedMagazines: Array<{ title: string, mobileTitle: string, description: string, mobileDescription: string, content: string, mobileContent: string, createdAt: number, titleImageUrl: string, magazinePid: string, contentType: string }> };

export type GetPrevNextMagazinePidQueryVariables = Exact<{
  magazinePid: Scalars['ID'];
  contentType?: InputMaybe<Scalars['String']>;
}>;


export type GetPrevNextMagazinePidQuery = { prevMagazinePid?: string | null, nextMagazinePid?: string | null };

export type GetMagazineRelatedQuestionCardsQueryVariables = Exact<{
  request: MagazineRelatedQuestionCardsRequestInput;
}>;


export type GetMagazineRelatedQuestionCardsQuery = { magazineRelatedQuestionCards: Array<{ answeredStatus: QuestionAnsweredStatus, answererCount: number, answererProfileImageUrls: Array<string>, question: { status?: QuestionStatus | null, title: string, questionPid: string, content: string, createdAt: number, isBlockedByMe: boolean, attachments: Array<{ blindType: AttachmentBlindType, questionAttachmentId: string }>, category: { name: string, iconImageUrl: string, questionCategoryId: string }, tags: Array<{ name: string, questionTagId: string }> } }> };

export type GetMagazineRelatedBoardPostsQueryVariables = Exact<{
  request: MagazineRelatedBoardPostsRequestInput;
}>;


export type GetMagazineRelatedBoardPostsQuery = { magazineRelatedBoardPosts: Array<{ title: string, content: string, blinded: boolean, boardPostPid: string, boardPostAttachments: Array<{ blindType: AttachmentBlindType, boardPostAttachmentId: string }> }> };

export type GetMagazineAuthorQueryVariables = Exact<{
  authorPublicId: Scalars['ID'];
}>;


export type GetMagazineAuthorQuery = { magazineAuthor: { name: string, profileDescription?: string | null, profileImage: string, publicId: string, affiliation?: { affiliationType: AffiliationType, affiliationPid: string, name: string } | null, career: Array<{ careerType: DoctorCareerType, content: string, id: string, isRepresentative: boolean }> } };

export type GetMagazineByAuthorPublicIdQueryVariables = Exact<{
  authorPublicId: Scalars['ID'];
  pagingRequest: PagingRequestInput;
}>;


export type GetMagazineByAuthorPublicIdQuery = { magazineByAuthorPublicId: { totalCount: number, totalPageCount: number, magazines: Array<{ createdAt: number, description: string, titleImageUrl: string, magazinePid: string, mobileDescription: string, title: string, mobileTitle: string }> } };

export type GetMagazinesBannerQueryVariables = Exact<{
  magazineCursorPageRequestInput: MagazineCursorPageRequestInput;
}>;


export type GetMagazinesBannerQuery = { magazineCursorPage: { elements: Array<{ magazinePid: string, mobileTitle: string, titleImageUrl: string }> } };

export type GetMagazinesQueryVariables = Exact<{
  magazineCursorPageRequestInput: MagazineCursorPageRequestInput;
}>;


export type GetMagazinesQuery = { magazineCursorPage: { pivot?: string | null, elements: Array<{ createdAt: number, magazinePid: string, title: string, titleImageUrl: string, mobileTitle: string, mobileDescription: string, description: string, author?: { affiliatedInstitutionName: string, authorId: string, authorType: AuthorType, externalLinkUrl?: string | null, name: string, profileImageUrl: string, professionalFields: Array<{ name: string }> } | null }> } };

export type GetMagazineDetailQueryVariables = Exact<{
  magazinePid: Scalars['ID'];
}>;


export type GetMagazineDetailQuery = { magazineV2: { content: string, contentType: string, mobileContent: string, createdAt: number, tagNames: Array<string>, description: string, likeCount: number, magazinePid: string, questionCategoryId: string, title: string, mobileTitle: string, mobileDescription: string, titleImageUrl: string, footnote: string, isLikedByMe: boolean, hasJapanese: boolean, bottomButtonType: string, author?: { affiliatedInstitutionName: string, authorId: string, authorType: AuthorType, authorPublicId?: string | null, externalLinkUrl?: string | null, name: string, profileImageUrl: string, profileDescription?: string | null, professionalFields: Array<{ name: string }>, careers: Array<{ content: string, isRepresentative: boolean, careerType: DoctorCareerType }> } | null, hospital?: { name: string, publicId: string, roadAddress?: string | null, profileImages: Array<{ url: string }> } | null, tags: Array<{ magazinePid: string, name: string, tagId: string, tagType: TagType, coreCategories: Array<{ coreId: string, coreType: CoreCategoryType }> }>, banner?: { id: string, magazineId: string, externalUrl: string, title: string, description: string, imageUrl: string, buttonPhrase: string } | null } };

export type GetRandomMagazinesQueryVariables = Exact<{
  randomMagazineRequestInput: RandomMagazineRequestInput;
}>;


export type GetRandomMagazinesQuery = { randomMagazines: Array<{ createdAt: number, magazinePid: string, titleImageUrl: string, mobileTitle: string, mobileDescription: string, author?: { authorId: string, authorType: AuthorType } | null }> };

export type GetMagazinesCurationQueryVariables = Exact<{
  magazineCursorPageRequestInput: MagazineCursorPageRequestInput;
}>;


export type GetMagazinesCurationQuery = { magazineCursorPage: { elements: Array<{ magazinePid: string, mobileTitle: string, mobileDescription: string, titleImageUrl: string, createdAt: number }> } };

export type GetKeywordSearchMagazineCursorPageQueryVariables = Exact<{
  request: KeywordSearchMagazineCursorPageRequestInput;
}>;


export type GetKeywordSearchMagazineCursorPageQuery = { keywordSearchMagazineCursorPage: { pivot?: string | null, elements: Array<{ createdAt: number, magazinePid: string, title: string, description: string, titleImageUrl: string, mobileTitle: string, mobileDescription: string, content: string, author?: { affiliatedInstitutionName: string, authorId: string, authorType: AuthorType, externalLinkUrl?: string | null, name: string, profileImageUrl: string, professionalFields: Array<{ name: string }> } | null }> } };

export type MedicineDictionaryItemByPublicIdQueryVariables = Exact<{
  publicId: Scalars['String'];
}>;


export type MedicineDictionaryItemByPublicIdQuery = { medicineDictionaryItemByPublicId: { id: string, publicId: string, basicInfo: { name: string, simplifiedName: string, pharmaceuticalEffectLiteracy: string, medicineImage?: string | null, medicinePictogramImages: Array<string> }, classificationInfo: { ethicalType: string }, companyInfo: { companyName: string }, ingredientInfo: { formattedIngredientName?: string | null }, medicineGuide: { interactionHtml: string, indications: Array<string>, dosages: Array<string>, dosageHtml: string, sideEffects: Array<string>, cautions: Array<string>, storages: Array<string>, videoLink: string }, packagingInfo: { image?: string | null } } };

export type PopularMedicineDictionaryItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type PopularMedicineDictionaryItemsQuery = { popularMedicineDictionaryItems: Array<{ id: string, publicId: string, basicInfo: { name: string, simplifiedName: string, pharmaceuticalEffectLiteracy: string, medicineImage?: string | null }, medicineGuide: { wholeSummary: Array<string> }, packagingInfo: { image?: string | null } }> };

export type MedicineQueryVariables = Exact<{
  medicineId: Scalars['ID'];
}>;


export type MedicineQuery = { medicine: { appearanceDescription: string, briefLicensedEfficacy: string, classificationCodeName: string, contralIndications: Array<string>, counselingContents: Array<string>, counselingEfficacy: string, counselingForgettingDescription: string, counselingInteractions: Array<string>, counselingNotifications: Array<string>, counselingPrecautions: Array<string>, counselingSideEffects: Array<string>, counselingStorageMethod: string, dosage: string, id: string, ingredients: Array<string>, insuranceCode: string, isBenefit: boolean, medicineApprovalType: MedicineApprovalType, medicineImageUrl: string, medicineName: string, specialDrugTypes: Array<string>, unit: string, medicineDetail?: { classificationName: string, medicationWholes: Array<string>, medicationIndication: string, medicationCautions: Array<string>, medicationSideEffects: Array<string>, storageMethod: string, labelInteractions: Array<string>, medicineApprovalType: MedicineApprovalType, medicineId: string, medicineImageUrl: string, medicineName: string, medicineVideoUrl: string, labelIndications: Array<{ contents: Array<string>, title?: string | null }>, labelDosages: Array<{ contents: Array<string>, title?: string | null }>, labelCautions: Array<{ contents: Array<string>, title?: string | null }>, pictograms: Array<{ description: string, imageUrl: string }> } | null } };

export type UserMissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserMissionsQuery = { userMissions: { userId: string, missionRecords: Array<{ completionCount: number, completedAt?: number | null, status: UserMissionStatus, mission: { id: string, endAt: number, name: string, periodType: PeriodType, quantity: number, startAt: number, ticketType: TicketType, type: MissionType, visible: boolean, targetLink?: string | null, maxCount: number } }>, userTickets: Array<{ id: string, quantity: number, ticketType: TicketType, userId: string }> } };

export type CompleteMissionMutationVariables = Exact<{
  request: MissionCompleteRequestInput;
}>;


export type CompleteMissionMutation = { completeMission: boolean };

export type UserGamePrizeQueryVariables = Exact<{
  gameType: GameType;
}>;


export type UserGamePrizeQuery = { userGamePrizes: { gameType: GameType, userId: string, activePrizeStrategies: Array<{ gameType: GameType, id: string, quantity: number, prize: { amount: number, displayName: string, id: string, name: string, type: PrizeType, thumbnailUrl: string, formattedGuidance: string, winningImageUrl: string } }>, userPrizes: Array<{ drawnAt: number, id: string, quantity: number, receivedAt?: number | null, status: UserPrizeStatus, userId: string, prize: { amount: number, displayName: string, id: string, name: string, type: PrizeType, thumbnailUrl: string, formattedGuidance: string, winningImageUrl: string } }> } };

export type DrawPrizeMutationVariables = Exact<{
  request: PrizeDrawRequestInput;
}>;


export type DrawPrizeMutation = { drawPrize: { quantity: number, userPrizeId: string, prize: { amount: number, displayName: string, id: string, name: string, type: PrizeType, thumbnailUrl: string, formattedGuidance: string, winningImageUrl: string } } };

export type ReceivePrizeMutationVariables = Exact<{
  request: PrizeReceiveRequestInput;
}>;


export type ReceivePrizeMutation = { receivePrize: boolean };

export type NonBenefitMapNearbyPharmacySearchTabsQueryVariables = Exact<{ [key: string]: never; }>;


export type NonBenefitMapNearbyPharmacySearchTabsQuery = { nonBenefitMapNearbyPharmacySearchTabs: Array<{ id: string, name: string, diagnosisType?: DiagnosisType | null, diagnosisTypeId?: string | null, sortTypes: Array<{ type: PharmacySortType, title: string }>, filters: Array<{ type: PharmacyFilterType, title: string, description?: string | null, mode: PharmacyFilterMode, activeIconUrl?: string | null, inactiveIconUrl?: string | null, subFilters: Array<{ type: PharmacyFilterType, title: string, description?: string | null, mode: PharmacyFilterMode, inactiveIconUrl?: string | null, activeIconUrl?: string | null }> }>, treatmentMedicines: Array<{ id: string, treatmentId: string, name: string, description?: string | null, dispensationUnits: Array<{ isDefault: boolean, dispensationUnit: number, dispensationUnitDisplayName: string, treatmentMedicineId: string, treatmentMedicineUnitId: string }>, treatmentMedicineStrengths: Array<{ treatmentMedicineStrengthId: string, unit: string, treatmentMedicineId: string, isDefault: boolean }> }> }> };

export type PreSignedUrlForReceiptUploadQueryVariables = Exact<{
  request: ReceiptUploadPreSignedUrlRequestInput;
}>;


export type PreSignedUrlForReceiptUploadQuery = { preSignedUrlForReceiptUpload: { preSignedUrl: string, filePath: string } };

export type ParseReceiptMutationVariables = Exact<{
  request: ReceiptParsingRequestInput;
}>;


export type ParseReceiptMutation = { parseReceipt: { success: boolean, storeInformation?: { name: string, address?: string | null, businessNumber?: string | null } | null, paymentInformation?: { price?: number | null, paidDate?: string | null, cardCompany?: string | null, cardNumber?: string | null } | null } };

export type PharmacyReviewTagsByRatingQueryVariables = Exact<{
  rating: Scalars['Int'];
}>;


export type PharmacyReviewTagsByRatingQuery = { pharmacyReviewTagsByRating: Array<{ id: string, text: string }> };

export type CreatePharmacyReviewV2MutationVariables = Exact<{
  request: PharmacyReviewCreateMutationRequestInput;
}>;


export type CreatePharmacyReviewV2Mutation = { createPharmacyReviewV2: boolean };

export type RequestPartnershipPickupDispensationV2MutationVariables = Exact<{
  request: PartnershipPickupDispensationMutationRequestV2Input;
}>;


export type RequestPartnershipPickupDispensationV2Mutation = { requestPartnershipPickupDispensationV2: boolean };

export type PharmacyReviewsQueryVariables = Exact<{
  request: PharmacyReviewRequestInput;
}>;


export type PharmacyReviewsQuery = { pharmacyReviews: Array<{ content: string, createdAt: number, id: string, isPrivate: boolean, maskedHolderName?: string | null, rating: number, targetCategoryName?: string | null, targetPrice?: number | null, title: string, reviewContext: { reviewHolderId?: string | null }, reviewTags: Array<{ reviewId: string, tag: { tagId: string, text: string } }> }> };

export type PickupNearbyPharmacySearchTabQueryVariables = Exact<{
  diagnosisId: Scalars['ID'];
}>;


export type PickupNearbyPharmacySearchTabQuery = { pickupNearbyPharmacySearchTab?: { sortTypes: Array<{ type: PharmacySortType, title: string }>, filters: Array<{ type: PharmacyFilterType, title: string, description?: string | null, mode: PharmacyFilterMode, activeIconUrl?: string | null, inactiveIconUrl?: string | null, subFilters: Array<{ type: PharmacyFilterType, title: string, description?: string | null, mode: PharmacyFilterMode, inactiveIconUrl?: string | null, activeIconUrl?: string | null }> }> } | null };

export type GeneralNearbyPharmacySearchTabsQueryVariables = Exact<{ [key: string]: never; }>;


export type GeneralNearbyPharmacySearchTabsQuery = { generalNearbyPharmacySearchTabs: Array<{ id: string, name: string, diagnosisType?: DiagnosisType | null, diagnosisTypeId?: string | null, sortTypes: Array<{ type: PharmacySortType, title: string }>, filters: Array<{ type: PharmacyFilterType, title: string, description?: string | null, mode: PharmacyFilterMode, activeIconUrl?: string | null, inactiveIconUrl?: string | null, subFilters: Array<{ type: PharmacyFilterType, title: string, description?: string | null, mode: PharmacyFilterMode, inactiveIconUrl?: string | null, activeIconUrl?: string | null }> }>, treatmentMedicines: Array<{ id: string, treatmentId: string, name: string, description?: string | null, dispensationUnits: Array<{ isDefault: boolean, dispensationUnit: number, dispensationUnitDisplayName: string, treatmentMedicineId: string, treatmentMedicineUnitId: string }>, treatmentMedicineStrengths: Array<{ treatmentMedicineStrengthId: string, unit: string, treatmentMedicineId: string, isDefault: boolean }> }> }> };

export type TreatmentMedicinesByTreatmentIdQueryVariables = Exact<{
  treatmentId: Scalars['ID'];
}>;


export type TreatmentMedicinesByTreatmentIdQuery = { treatmentMedicinesByTreatmentId: Array<{ id: string, treatmentId: string, name: string, description?: string | null, dispensationUnits: Array<{ isDefault: boolean, dispensationUnit: number, dispensationUnitDisplayName: string, treatmentMedicineId: string, treatmentMedicineUnitId: string }> }> };

export type GetPharmacyDispensableMedicinesQueryVariables = Exact<{
  request: PharmacyDispensableMedicinesRequestInput;
}>;


export type GetPharmacyDispensableMedicinesQuery = { pharmacyDispensableMedicines?: { totalAmount?: number | null, dispensableMedicines: Array<{ prescribedMedicineId?: string | null, pharmacyMedicine?: { medicineId: string, price?: number | null, isAlternativeMedicine?: boolean | null, unitType?: MedicineStandardType | null, unit?: number | null, displayName?: string | null, medicine: { medicineName: string }, treatmentMedicine?: { name: string } | null } | null }> } | null };

export type FindGeneralListOfNearbyPharmacyV3ByUserQueryVariables = Exact<{
  request: NearbyPharmacySearchRequestV3Input;
  treatmentId?: InputMaybe<Scalars['ID']>;
  treatmentMedicineId?: InputMaybe<Scalars['ID']>;
  treatmentMedicineStrengthId?: InputMaybe<Scalars['ID']>;
  dispensationUnit?: InputMaybe<Scalars['Int']>;
  shouldIncludeDispensableMedicine?: Scalars['Boolean'];
  shouldIncludeDiagnosisPrice?: Scalars['Boolean'];
}>;


export type FindGeneralListOfNearbyPharmacyV3ByUserQuery = { nearbyPharmacyV3ByUser: Array<{ name: string, partnership: PharmacyPartnershipType, pharmacyId: string, publicId: string, pickupCompletedCount: number, diagnosisPrice?: number | null, isFavoritePharmacy: boolean, contact: { tel?: string | null, safetyNumber?: string | null }, location: { distanceInMeters?: number | null, latitude: number, longitude: number, pharmacyName: string, roadAddress?: string | null, jibunAddress?: string | null, detailAddress?: string | null }, reviewMeta: { averageRating: string, totalCount: number }, attributesV3: { mainTags: Array<{ title: string, type: string, imageUrl?: string | null }>, badges: Array<{ title: string, type: string, imageUrl?: string | null }>, tags: Array<{ title: string, type: string, imageUrl?: string | null }>, priceTags: Array<{ title: string, type: string, imageUrl?: string | null }> }, dispensableMedicines?: { totalAmount?: number | null, dispensableMedicines: Array<{ pharmacyMedicine?: { medicineId: string, price?: number | null, isAlternativeMedicine?: boolean | null, unitType?: MedicineStandardType | null, unit?: number | null, displayName?: string | null, medicine: { medicineName: string }, treatmentMedicine?: { name: string } | null } | null }> } | null, operation: { status: PharmacyOperationStatusV2, display?: string | null }, pharmacyNextOperationHour: Array<{ earliestAvailableReservationHour?: number | null, earliestAvailableReservationHourString?: string | null }> }> };

export type FindPickupListOfNearbyPharmacyV3ByUserQueryVariables = Exact<{
  request: NearbyPharmacySearchRequestV3Input;
  userLocation: NearbyPharmacyGeoPointInput;
  diagnosisId?: InputMaybe<Scalars['ID']>;
  shouldIncludeDispensableMedicine?: InputMaybe<Scalars['Boolean']>;
  isAlternativeExcluded: Scalars['Boolean'];
}>;


export type FindPickupListOfNearbyPharmacyV3ByUserQuery = { nearbyPharmacyV3ByUser: Array<{ name: string, partnership: PharmacyPartnershipType, pharmacyId: string, publicId: string, pickupCompletedCount: number, isFavoritePharmacy: boolean, contact: { faxNumber?: string | null, safetyNumber?: string | null, tel?: string | null }, location: { distanceInMeters?: number | null, latitude: number, longitude: number, pharmacyName: string, roadAddress?: string | null, jibunAddress?: string | null, detailAddress?: string | null }, reviewMeta: { averageRating: string, totalCount: number }, attributesV3: { mainTags: Array<{ title: string, type: string, imageUrl?: string | null }>, badges: Array<{ title: string, type: string, imageUrl?: string | null }>, tags: Array<{ title: string, type: string, imageUrl?: string | null }>, priceTags: Array<{ title: string, type: string, imageUrl?: string | null }>, recommendationScore?: { pharmacyId: string, score: number } | null }, dispensableMedicines?: { totalAmount?: number | null, dispensableMedicines: Array<{ pharmacyMedicine?: { medicineId: string, price?: number | null, isAlternativeMedicine?: boolean | null, unitType?: MedicineStandardType | null, unit?: number | null, displayName?: string | null, medicine: { medicineName: string }, treatmentMedicine?: { name: string } | null } | null, medicine: { medicineName: string } }> } | null, operation: { status: PharmacyOperationStatusV2, display?: string | null }, pharmacyNextOperationHour: Array<{ earliestAvailableReservationHour?: number | null, earliestAvailableReservationHourString?: string | null }> }> };

export type GetNearbyPharmacyDetailV3ByUserQueryVariables = Exact<{
  request: NearbyPharmacyDetailSearchByPublicIdRequestInput;
  diagnosisId?: InputMaybe<Scalars['ID']>;
  isAlternativeExcluded: Scalars['Boolean'];
}>;


export type GetNearbyPharmacyDetailV3ByUserQuery = { nearbyPharmacyDetailByPublicId?: { partnership: PharmacyPartnershipType, pharmacyId: string, publicId: string, pickupCompletedCount: number, isFavoritePharmacy: boolean, contact: { faxNumber?: string | null, tel?: string | null, safetyNumber?: string | null }, location: { detailAddress?: string | null, distanceInMeters?: number | null, jibunAddress?: string | null, latitude: number, longitude: number, pharmacyName: string, roadAddress?: string | null, zipCode?: string | null, parkingDescription?: string | null, directions?: string | null, parkingType?: { name: string, type: PharmacyParkingType } | null }, reviewMeta: { totalCount: number, averageRating: string }, pharmacyNextOperationHour: Array<{ earliestAvailableReservationHour?: number | null, earliestAvailableReservationHourString?: string | null }>, operation: { display?: string | null, status: PharmacyOperationStatusV2, todayDuty?: { weekDay: number, openTime: string, closeTime: string, isClosed: boolean, hasBreakTime: boolean, breakStartTime: string, breakEndTime: string } | null, duties: Array<{ weekDay: number, openTime: string, closeTime: string, isClosed: boolean, hasBreakTime: boolean, breakStartTime: string, breakEndTime: string }> }, numberOfReviewsByRating: Array<{ rating: number, count: number }>, attributesV3: { mainTags: Array<{ imageUrl?: string | null, type: string }>, badges: Array<{ imageUrl?: string | null, type: string }>, tags: Array<{ imageUrl?: string | null, type: string }>, priceTags: Array<{ title: string, type: string, imageUrl?: string | null }> }, prescribedMedicineInfoWithDoseDays: Array<{ medicineSummary?: { medicineId: string, medicineName: string, medicineImageUrl: string, hasDetailInfo: boolean, pharmaceuticalEffectLiteracy: string, publicId: string, medicineDispensability: { medicineId: string, dispensabilityStatus: MedicineDispensabilityStatus, iconImageUrl: string } } | null }> } | null };

export type AddFavoritePharmacyMutationVariables = Exact<{
  pharmacyId: Scalars['ID'];
}>;


export type AddFavoritePharmacyMutation = { addFavoritePharmacy: boolean };

export type RemoveFavoritePharmacyMutationVariables = Exact<{
  pharmacyId: Scalars['ID'];
}>;


export type RemoveFavoritePharmacyMutation = { removeFavoritePharmacy: boolean };

export type CheckUserFavoritePharmacyQueryVariables = Exact<{
  pharmacyId: Scalars['ID'];
}>;


export type CheckUserFavoritePharmacyQuery = { checkUserFavoritePharmacy: boolean };

export type GetPharmacyAttributesQueryVariables = Exact<{
  request: NearbyPharmacyDetailSearchRequestV3Input;
  diagnosisId: Scalars['ID'];
  isAlternativeExcluded: Scalars['Boolean'];
}>;


export type GetPharmacyAttributesQuery = { nearbyPharmacyDetailV3ByUser?: { attributesV3: { mainTags: Array<{ title: string, type: string, imageUrl?: string | null }>, badges: Array<{ title: string, type: string, imageUrl?: string | null }>, tags: Array<{ title: string, type: string, imageUrl?: string | null }>, priceTags: Array<{ title: string, type: string, imageUrl?: string | null }> } } | null };

export type RequestDispensationToPharmacyMutationVariables = Exact<{
  request: DispensationPharmacyFaxRequestInput;
}>;


export type RequestDispensationToPharmacyMutation = { requestDispensationToPharmacy: boolean };

export type FavoritePharmaciesQueryVariables = Exact<{
  request: FavoritePharmaciesRequestInput;
}>;


export type FavoritePharmaciesQuery = { favoritePharmacies: Array<{ name: string, partnership: PharmacyPartnershipType, pharmacyId: string, publicId: string, pickupCompletedCount: number, isFavoritePharmacy: boolean, contact: { faxNumber?: string | null, safetyNumber?: string | null, tel?: string | null }, location: { detailAddress?: string | null, distanceInMeters?: number | null, jibunAddress?: string | null, latitude: number, longitude: number, pharmacyName: string, roadAddress?: string | null, zipCode?: string | null }, reviewMeta: { averageRating: string, totalCount: number }, attributesV3: { badges: Array<{ imageUrl?: string | null, title: string, type: string }>, mainTags: Array<{ imageUrl?: string | null, title: string, type: string }>, priceTags: Array<{ imageUrl?: string | null, title: string, type: string }>, tags: Array<{ imageUrl?: string | null, title: string, type: string }> }, numberOfReviewsByRating: Array<{ count: number, rating: number }>, operation: { display?: string | null, status: PharmacyOperationStatusV2, duties: Array<{ closeTime: string, id: string, isClosed: boolean, openTime: string, pharmacyId: string, weekDay: number }> }, pharmacyNextOperationHour: Array<{ earliestAvailableReservationHour?: number | null, earliestAvailableReservationHourString?: string | null, pharmacyId: string }> }> };

export type PointCouponsQueryVariables = Exact<{
  pagingRequest: PagingRequestInput;
}>;


export type PointCouponsQuery = { pointCoupons: Array<{ id: string, publicId: string, goodsCode: string, brand: string, title: string, point: number, imageUrl?: string | null, thumbnailImageUrl?: string | null }> };

export type IssuePointCouponMutationVariables = Exact<{
  request: PointCouponIssueApiRequestInput;
}>;


export type IssuePointCouponMutation = { issuePointCoupon: boolean };

export type PointCouponQueryVariables = Exact<{
  publicId: Scalars['String'];
}>;


export type PointCouponQuery = { pointCoupon: { pointCouponGraph?: { id: string, publicId: string, goodsCode: string, brand: string, title: string, point: number, imageUrl?: string | null, thumbnailImageUrl?: string | null } | null, pointCouponIssueAvailableInfoGraph?: { totalAvailableCount: number, issuedCount: number, userPoint: number, couponPoint: number, isAvailable: boolean } | null } };

export type GetAgreementsByCategoryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgreementsByCategoryQuery = { getAgreementsByCategory: Array<{ id: string, title: string, category: AgreementCategory, url?: string | null }> };

export type CheckApprovedByTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckApprovedByTypeQuery = { checkApprovedByType: { result: boolean } };

export type ApproveAgreementsMutationVariables = Exact<{
  request: AgreementsApprovedApiRequestInput;
}>;


export type ApproveAgreementsMutation = { approveAgreements: boolean };

export type PharmacySelectionChangeReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type PharmacySelectionChangeReasonsQuery = { pharmacySelectionChangeReasons: Array<{ reason: PharmacySelectionChangeReasonType, description: string }> };

export type ChangePharmacySelectionMutationVariables = Exact<{
  request: PharmacySelectionChangeRequestInput;
}>;


export type ChangePharmacySelectionMutation = { changePharmacySelection: boolean };

export type GetOrderCancelReasonsQueryVariables = Exact<{
  orderCancelReasonCategory: OrderCancelReasonCategory;
}>;


export type GetOrderCancelReasonsQuery = { getOrderCancelReasons: Array<{ id: string, sortKey: number, title: string, cancelReasonType: OrderCancelReasonType }> };

export type CancelPartnershipPickupOrderByUserMutationVariables = Exact<{
  request: CancelPartnershipPickupOrderByUserMutationRequestInput;
}>;


export type CancelPartnershipPickupOrderByUserMutation = { cancelPartnershipPickupOrderByUser: boolean };

export type CancelPickupOrderByUserMutationVariables = Exact<{
  request: CancelPickupOrderByUserMutationRequestInput;
}>;


export type CancelPickupOrderByUserMutation = { cancelPickupOrderByUser: boolean };

export type GetNewsQuestionQueryVariables = Exact<{
  newestQuestionCardCursorPageRequestInput: NewestQuestionCardCursorPageRequestInput;
}>;


export type GetNewsQuestionQuery = { newestQuestionCardCursorPage: { elements: Array<{ answeredStatus: QuestionAnsweredStatus, question: { status?: QuestionStatus | null, aiAnswerStatus: AiAnswerStatus, accessibleType: QuestionAccessibleType, content: string, isBlockedByMe: boolean, questionPid: string, title: string, attachments: Array<{ blindType: AttachmentBlindType, questionAttachmentId: string }>, category: { name: string, questionCategoryId: string, iconImageUrl: string }, tags: Array<{ name: string }> } }> } };

export type GetNewsMyQuestionQueryVariables = Exact<{
  myQuestionCardCursorPageRequestInput: MyQuestionCardCursorPageRequestInput;
}>;


export type GetNewsMyQuestionQuery = { myQuestionCardCursorPage: { elements: Array<{ answeredStatus: QuestionAnsweredStatus, question: { status?: QuestionStatus | null, aiAnswerStatus: AiAnswerStatus, accessibleType: QuestionAccessibleType, content: string, questionPid: string, title: string, attachments: Array<{ blindType: AttachmentBlindType, questionAttachmentId: string }>, category: { name: string, questionCategoryId: string, iconImageUrl: string }, tags: Array<{ name: string }> } }> } };

export type GetBestTagsQueryVariables = Exact<{
  size: Scalars['Int'];
}>;


export type GetBestTagsQuery = { bestTags: Array<{ name: string, questionTagId: string }> };

export type GetBestQuestionMobileCardsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBestQuestionMobileCardsQuery = { bestQuestionCards: Array<{ answeredStatus: QuestionAnsweredStatus, answererCount: number, answererProfileImageUrls: Array<string>, question: { status?: QuestionStatus | null, content: string, questionPid: string, title: string, attachments: Array<{ blindType: AttachmentBlindType, questionAttachmentId: string }>, category: { iconImageUrl: string, name: string }, tags: Array<{ name: string }> } }> };

export type GetAttachmentOriginPreSignedUrlQueryVariables = Exact<{
  questionAttachmentId: Scalars['ID'];
}>;


export type GetAttachmentOriginPreSignedUrlQuery = { attachmentDownloadPreSignedUrl: string };

export type GetAttachmentThumbnailPreSignedUrlQueryVariables = Exact<{
  questionAttachmentId: Scalars['ID'];
}>;


export type GetAttachmentThumbnailPreSignedUrlQuery = { attachmentThumbnailDownloadPreSignedUrl: string };

export type GetMyAnswerCursorPageQueryVariables = Exact<{
  myAnswerCursorPageRequestInput: MyAnswerCursorPageRequestInput;
}>;


export type GetMyAnswerCursorPageQuery = { myAnswerCursorPage: { elements: Array<{ answerPid: string, content: string, questionPid: string, answerer: { affiliatedInstitutionName: string, answererId: string, answererType: AnswererType, name: string, profileImageUrl: string, professionalFields: Array<{ name: string, professionalFieldId: string, professionalFieldType: ProfessionalFieldType }> } }> } };

export type GetQuestionDetailWithNearSimplyQuestionsQueryVariables = Exact<{
  questionPid: Scalars['ID'];
  size?: InputMaybe<Scalars['Int']>;
}>;


export type GetQuestionDetailWithNearSimplyQuestionsQuery = { questionV2?: { accessibleType: QuestionAccessibleType, status: QuestionStatus, answererCount: number, answeredStatus: QuestionAnsweredStatus, content: string, createdAt: number, isBlockedByMe: boolean, isLikedByMe: boolean, isMine: boolean, likeCount: number, questionPid: string, showUserPersonalInfo: boolean, title: string, paymentInfo?: { discountAmount: number, paidAmount: number, paidAt: number, payTryCount: number, price: number, usedPoint: number } | null, paymentTotal?: { currentAmount: number, payTrackingNumber: string, reason?: string | null, status: PaymentTotalStatus, userPaymentId?: string | null, userPayment?: { cardName: string, cardNumber: string, id: string } | null } | null, answers: Array<{ answerPid: string, content: string, createdAt: number, dislikeCount: number, footer?: string | null, header?: string | null, isBlockedByMe: boolean, likeCount: number, myLikeType?: AnswerLikeType | null, answerer: { affiliatedInstitutionName: string, answererId: string, answererPublicId?: string | null, answererType: AnswererType, name: string, profileImageUrl: string, affiliation?: { address?: string | null, affiliationPid: string, imageUrl?: string | null, name: string } | null }, reviews: Array<{ id: string, answerPid: string, rating: number, content?: string | null, createdAt: number, updatedAt: number, reviewTags: Array<{ id: string, text: string }> }>, recommendedMagazineGraph?: { description: string, magazinePid: string, title: string, titleImageUrl: string } | null }>, attachments: Array<{ blindType: AttachmentBlindType, questionAttachmentId: string }>, category: { name: string, questionCategoryId: string, type: string }, tags: Array<{ name: string }>, user: { name: string, userId: string, birth?: string | null, gender: GenderType }, aiAnswer?: { checkStatus?: AiAnswerCheckStatus | null } | null } | null, nearSimpleQuestions: Array<{ questionPid: string }> };

export type SetBlockingAccountMutationVariables = Exact<{
  blockingAccountMutationRequest: BlockingAccountMutationRequestInput;
}>;


export type SetBlockingAccountMutation = { upsertBlockingAccount: boolean };

export type SetReportQuestionMutationVariables = Exact<{
  request: QuestionReportRequestInput;
}>;


export type SetReportQuestionMutation = { reportQuestion: boolean };

export type SetReportAnswerMutationVariables = Exact<{
  request: AnswerReportRequestInput;
}>;


export type SetReportAnswerMutation = { reportAnswer: boolean };

export type SetQuestionLikeMutationVariables = Exact<{
  questionPid: Scalars['ID'];
}>;


export type SetQuestionLikeMutation = { addQuestionLike: boolean };

export type SetQuestionDisLikeMutationVariables = Exact<{
  questionPid: Scalars['ID'];
}>;


export type SetQuestionDisLikeMutation = { deleteQuestionLike: boolean };

export type SetAnswerLikeMutationVariables = Exact<{
  request: AnswerLikeRequestInput;
}>;


export type SetAnswerLikeMutation = { addAnswerLike: boolean };

export type SetDeleteAnswerLikeMutationVariables = Exact<{
  answerPid: Scalars['ID'];
}>;


export type SetDeleteAnswerLikeMutation = { deleteAnswerLike: boolean };

export type GetQnaCategoryGroupQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQnaCategoryGroupQuery = { questionCategoryGroups: Array<{ key: string, name: string, questionCategories: Array<{ aiAnswerAvailable: boolean, contentPlaceholder: string, description?: string | null, iconImageUrl: string, name: string, questionCategoryId: string, titlePlaceholder: string, tags: Array<{ name: string }> }> }> };

export type GetNewestQuestionCardCursorPageQueryVariables = Exact<{
  request: NewestQuestionCardCursorPageRequestInput;
}>;


export type GetNewestQuestionCardCursorPageQuery = { newestQuestionCardCursorPage: { pivot?: string | null, elements: Array<{ answeredStatus: QuestionAnsweredStatus, answererCount: number, answererProfileImageUrls: Array<string>, answer?: { answerPid: string, content: string, createdAt: number, dislikeCount: number, footer?: string | null, header?: string | null, isBlockedByUser: boolean, likeCount: number, myLikeType?: AnswerLikeType | null, answerer: { affiliatedInstitutionName: string, answererId: string, answererType: AnswererType, name: string, profileImageUrl: string, professionalFields: Array<{ name: string, professionalFieldId: string, professionalFieldType: ProfessionalFieldType }> } } | null, question: { status?: QuestionStatus | null, accessibleType: QuestionAccessibleType, content: string, createdAt: number, isBlockedByMe: boolean, isLikedByMe: boolean, isMine: boolean, likeCount: number, questionPid: string, title: string, attachments: Array<{ blindType: AttachmentBlindType, questionAttachmentId: string }>, category: { name: string, questionCategoryId: string, iconImageUrl: string }, tags: Array<{ name: string }>, user: { name: string, userId: string } } }> } };

export type GetKeywordQuestionCardCursorPageQueryVariables = Exact<{
  request: KeywordSearchQuestionCardCursorPageRequestInput;
}>;


export type GetKeywordQuestionCardCursorPageQuery = { keywordSearchQuestionCardCursorPage: { pivot?: string | null, elements: Array<{ answeredStatus: QuestionAnsweredStatus, answererCount: number, answererProfileImageUrls: Array<string>, answer?: { answerPid: string, content: string, createdAt: number, dislikeCount: number, footer?: string | null, header?: string | null, isBlockedByUser: boolean, likeCount: number, myLikeType?: AnswerLikeType | null, answerer: { affiliatedInstitutionName: string, answererId: string, answererType: AnswererType, name: string, profileImageUrl: string, professionalFields: Array<{ name: string, professionalFieldId: string, professionalFieldType: ProfessionalFieldType }> } } | null, question: { status?: QuestionStatus | null, accessibleType: QuestionAccessibleType, content: string, createdAt: number, isBlockedByMe: boolean, isLikedByMe: boolean, isMine: boolean, likeCount: number, questionPid: string, title: string, attachments: Array<{ blindType: AttachmentBlindType, questionAttachmentId: string }>, category: { name: string, iconImageUrl: string, questionCategoryId: string }, tags: Array<{ name: string }>, user: { name: string, userId: string } } }> } };

export type GetMyQuestionCardCursorPageMobileQueryVariables = Exact<{
  request: MyQuestionCardCursorPageRequestInput;
}>;


export type GetMyQuestionCardCursorPageMobileQuery = { myQuestionCardCursorPage: { pivot?: string | null, elements: Array<{ answeredStatus: QuestionAnsweredStatus, answererCount: number, answererProfileImageUrls: Array<string>, paymentTotal?: { currentAmount: number, payTrackingNumber: string, reason?: string | null, status: PaymentTotalStatus, userPaymentId?: string | null, userPayment?: { cardName: string, cardNumber: string, id: string } | null } | null, answer?: { answerPid: string, content: string, createdAt: number, dislikeCount: number, footer?: string | null, header?: string | null, isBlockedByUser: boolean, likeCount: number, myLikeType?: AnswerLikeType | null, answerer: { affiliatedInstitutionName: string, answererId: string, answererType: AnswererType, name: string, profileImageUrl: string, professionalFields: Array<{ name: string, professionalFieldId: string, professionalFieldType: ProfessionalFieldType }> } } | null, question: { status?: QuestionStatus | null, accessibleType: QuestionAccessibleType, content: string, createdAt: number, isBlockedByMe: boolean, isLikedByMe: boolean, isMine: boolean, likeCount: number, questionPid: string, title: string, attachments: Array<{ blindType: AttachmentBlindType, questionAttachmentId: string }>, category: { name: string, iconImageUrl: string, questionCategoryId: string }, tags: Array<{ name: string }>, user: { name: string, userId: string } } }> } };

export type GetMyLikedQuestionCardCursorPageQueryVariables = Exact<{
  request: MyLikedQuestionCardCursorPageRequestInput;
}>;


export type GetMyLikedQuestionCardCursorPageQuery = { myLikedQuestionCardCursorPage: { pivot?: string | null, elements: Array<{ answeredStatus: QuestionAnsweredStatus, answererCount: number, answererProfileImageUrls: Array<string>, answer?: { answerPid: string, content: string, createdAt: number, dislikeCount: number, footer?: string | null, header?: string | null, isBlockedByUser: boolean, likeCount: number, myLikeType?: AnswerLikeType | null, answerer: { affiliatedInstitutionName: string, answererId: string, answererType: AnswererType, name: string, profileImageUrl: string, professionalFields: Array<{ name: string, professionalFieldId: string, professionalFieldType: ProfessionalFieldType }> } } | null, question: { status?: QuestionStatus | null, accessibleType: QuestionAccessibleType, content: string, createdAt: number, isBlockedByMe: boolean, isLikedByMe: boolean, isMine: boolean, likeCount: number, questionPid: string, title: string, attachments: Array<{ blindType: AttachmentBlindType, questionAttachmentId: string }>, category: { name: string, iconImageUrl: string, questionCategoryId: string }, tags: Array<{ name: string }>, user: { name: string, userId: string } } }> } };

export type QnaSimpleSurveyAnswerMutationVariables = Exact<{
  request: SimpleSurveyAnswerAddRequestInput;
}>;


export type QnaSimpleSurveyAnswerMutation = { addSimpleSurveyAnswer: boolean };

export type GetFrequentSearchKeywordsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFrequentSearchKeywordsQuery = { frequentSearchKeywords: Array<string> };

export type GetRelatedQuestionQueryVariables = Exact<{
  similarSearchQuestionInput: SimilarSearchQuestionCardCursorPageRequestInput;
}>;


export type GetRelatedQuestionQuery = { similarSearchQuestionCardCursorPageRequest: { elements: Array<{ answeredStatus: QuestionAnsweredStatus, answererCount: number, answererProfileImageUrls: Array<string>, question: { title: string, status?: QuestionStatus | null, content: string, createdAt: number, isBlockedByMe: boolean, questionPid: string, category: { name: string, iconImageUrl: string, questionCategoryId: string }, tags: Array<{ name: string }>, attachments: Array<{ blindType: AttachmentBlindType, questionAttachmentId: string }> } }> } };

export type GetQuestionDetailWithAiAnswerQueryVariables = Exact<{
  questionPid: Scalars['ID'];
}>;


export type GetQuestionDetailWithAiAnswerQuery = { questionV2?: { content: string, questionPid: string, title: string, aiAnswerStatus: AiAnswerStatus, aiAnswerButtonType: AiAnswerButtonType, pregnant: boolean, status: QuestionStatus, attachments: Array<{ blindType: AttachmentBlindType, questionAttachmentId: string }>, category: { name: string, iconImageUrl: string, questionCategoryId: string, type: string }, aiAnswer?: { aiAnswerStatus: AiAnswerStatus, content: string, questionPid: string } | null } | null };

export type GetMyUncheckedQuestionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyUncheckedQuestionQuery = { myUncheckedQuestion?: { aiAnswerStatus: AiAnswerStatus, questionPid: string, status: QuestionStatus, paymentInfo?: { discountAmount: number, paidAmount: number, paidAt: number, payTryCount: number, price: number, usedPoint: number } | null, paymentTotal?: { currentAmount: number, payTrackingNumber: string, reason?: string | null, status: PaymentTotalStatus, userPaymentId?: string | null, userPayment?: { cardName: string, cardNumber: string, id: string } | null } | null } | null };

export type QnaDecideAiAnswerMutationVariables = Exact<{
  request: DecideAiAnswerRequestInput;
}>;


export type QnaDecideAiAnswerMutation = { decideAiAnswer: boolean };

export type QnaGenerateAiAnswerMutationVariables = Exact<{
  request: GenerateAiAnswerRequestInput;
}>;


export type QnaGenerateAiAnswerMutation = { generateAiAnswer: boolean };

export type AddQuestionWithAiAnswerMutationVariables = Exact<{
  request: QuestionAddRequestInput;
}>;


export type AddQuestionWithAiAnswerMutation = { addQuestionV2: { aiAnswerAvailable: boolean, questionPid: string } };

export type GetAgreementsByLocationCategoryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgreementsByLocationCategoryQuery = { getAgreementsByCategory: Array<{ id: string, title: string, url?: string | null }> };

export type GetCheckApprovedByLocationCategoryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCheckApprovedByLocationCategoryQuery = { checkApproved: boolean };

export type SetApproveAgreementsMutationVariables = Exact<{
  request: AgreementsApprovedApiRequestInput;
}>;


export type SetApproveAgreementsMutation = { approveAgreements: boolean };

export type GetImageBannersQueryVariables = Exact<{
  request: ImageBannersRequestInput;
}>;


export type GetImageBannersQuery = { imageBanners: Array<{ image360Url: string, image640Url: string, linkUrl?: string | null }> };

export type GetQnaRegistrationStatusQueryVariables = Exact<{
  request: QnaRegistrationStatusRequestInput;
}>;


export type GetQnaRegistrationStatusQuery = { qnaRegistrationStatus: { registeredAnswerCount: number, registeredQuestionCount: number } };

export type GetQuestionQueryVariables = Exact<{
  questionPid: Scalars['ID'];
  size?: InputMaybe<Scalars['Int']>;
}>;


export type GetQuestionQuery = { questionV2?: { status: QuestionStatus, accessibleType: QuestionAccessibleType, answeredStatus: QuestionAnsweredStatus, answererCount: number, answererProfileImageUrls: Array<string>, content: string, createdAt: number, likeCount: number, questionPid: string, showUserPersonalInfo: boolean, title: string, viewCount: number, paymentInfo?: { discountAmount: number, paidAmount: number, paidAt: number, payTryCount: number, price: number, usedPoint: number } | null, paymentTotal?: { currentAmount: number, payTrackingNumber: string, reason?: string | null, status: PaymentTotalStatus, userPaymentId?: string | null, userPayment?: { cardName: string, cardNumber: string, id: string } | null } | null, answers: Array<{ content: string, createdAt: number, footer?: string | null, header?: string | null, answerer: { affiliatedInstitutionName: string, answererId: string, answererType: AnswererType, name: string, profileImageUrl: string }, recommendedMagazineGraph?: { description: string, magazinePid: string, title: string, titleImageUrl: string } | null }>, attachments: Array<{ blindType: AttachmentBlindType, questionAttachmentId: string }>, category: { name: string, type: string, questionCategoryId: string }, tags: Array<{ name: string, questionTagId: string }>, user: { name: string, birth?: string | null, gender: GenderType } } | null, nearSimpleQuestions: Array<{ questionPid: string, title: string }>, similarSearchQuestionCardCursorPageRequest: { elements: Array<{ question: { questionPid: string, title: string, createdAt: number } }> } };

export type GetBestQuestionCardsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBestQuestionCardsQuery = { bestQuestionCards: Array<{ question: { questionPid: string, title: string } }> };

export type GetCurationListQueryVariables = Exact<{
  request: MagazineCursorPageRequestInput;
}>;


export type GetCurationListQuery = { magazineCursorPage: { pivot?: string | null, elements: Array<{ createdAt: number, description: string, magazinePid: string, title: string, titleImageUrl: string }> } };

export type GetBestMagazineQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBestMagazineQuery = { bestMagazineV2: { createdAt: number, description: string, likeCount: number, magazinePid: string, title: string, titleImageUrl: string } };

export type GetMagazineListQueryVariables = Exact<{
  request: MagazineCursorPageRequestInput;
}>;


export type GetMagazineListQuery = { magazineCursorPage: { pivot?: string | null, elements: Array<{ createdAt: number, description: string, magazinePid: string, title: string, titleImageUrl: string }> } };

export type GetMagazineCountQueryVariables = Exact<{
  magazineCountRequestInput: MagazineCountRequestInput;
}>;


export type GetMagazineCountQuery = { magazineCount: { magazineCount: number } };

export type GetQuestionCategoryGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuestionCategoryGroupsQuery = { questionCategoryGroups: Array<{ key: string, name: string, questionCategories: Array<{ description?: string | null, name: string, questionCategoryId: string, tags: Array<{ name: string, questionTagId: string }> }> }> };

export type NewestQuestionCardCursorPageQueryVariables = Exact<{
  request: NewestQuestionCardCursorPageRequestInput;
}>;


export type NewestQuestionCardCursorPageQuery = { newestQuestionCardCursorPage: { pivot?: string | null, elements: Array<{ answeredStatus: QuestionAnsweredStatus, answererCount: number, answererProfileImageUrls: Array<string>, question: { status?: QuestionStatus | null, accessibleType: QuestionAccessibleType, content: string, createdAt: number, likeCount: number, questionPid: string, title: string, viewCount: number, attachments: Array<{ blindType: AttachmentBlindType, questionAttachmentId: string }>, category: { name: string, questionCategoryId: string }, tags: Array<{ name: string }>, user: { name: string } } }> } };

export type MagazineQueryVariables = Exact<{
  magazinePid: Scalars['ID'];
}>;


export type MagazineQuery = { magazineV2: { isLikedByMe: boolean, content: string, createdAt: number, description: string, likeCount: number, magazinePid: string, questionCategoryId: string, title: string, titleImageUrl: string, footnote: string, author?: { affiliatedInstitutionName: string, externalLinkUrl?: string | null, name: string, profileImageUrl: string, professionalFields: Array<{ name: string }> } | null } };

export type GetQuestionAttachmentPreSignedUrlQueryVariables = Exact<{
  questionAttachmentId: Scalars['ID'];
}>;


export type GetQuestionAttachmentPreSignedUrlQuery = { attachmentDownloadPreSignedUrl: string };

export type GetAttachmentThumbnailDownloadPreSignedUrlQueryVariables = Exact<{
  questionAttachmentId: Scalars['ID'];
}>;


export type GetAttachmentThumbnailDownloadPreSignedUrlQuery = { attachmentThumbnailDownloadPreSignedUrl: string };

export type AddQuestionMutationVariables = Exact<{
  request: QuestionAddRequestInput;
}>;


export type AddQuestionMutation = { addQuestion: boolean };

export type AttachmentUploadPreSignedUrlQueryVariables = Exact<{
  fileExtension: Scalars['String'];
}>;


export type AttachmentUploadPreSignedUrlQuery = { attachmentUploadPreSignedUrl: { originalPath: string, originalPreSignedUrl: string, thumbnailPath: string, thumbnailPreSignedUrl: string } };

export type GetMyQuestionCardCursorPageQueryVariables = Exact<{
  request: MyQuestionCardCursorPageRequestInput;
}>;


export type GetMyQuestionCardCursorPageQuery = { myQuestionCardCursorPage: { pivot?: string | null, elements: Array<{ answeredStatus: QuestionAnsweredStatus, answererCount: number, answererProfileImageUrls: Array<string>, paymentTotal?: { currentAmount: number, payTrackingNumber: string, reason?: string | null, status: PaymentTotalStatus, userPaymentId?: string | null, userPayment?: { cardName: string, cardNumber: string, id: string } | null } | null, question: { status?: QuestionStatus | null, accessibleType: QuestionAccessibleType, content: string, createdAt: number, isBlockedByMe: boolean, isLikedByMe: boolean, isMine: boolean, likeCount: number, questionPid: string, title: string, attachments: Array<{ blindType: AttachmentBlindType, questionAttachmentId: string }>, category: { name: string, iconImageUrl: string, questionCategoryId: string }, tags: Array<{ name: string }>, user: { name: string, userId: string } } }> } };

export type MakeQuestionPrivateMutationVariables = Exact<{
  questionPid: Scalars['ID'];
}>;


export type MakeQuestionPrivateMutation = { makeQuestionPrivate: boolean };

export type NearSimpleQuestionsQueryVariables = Exact<{
  request: NearSimpleQuestionsRequestInput;
}>;


export type NearSimpleQuestionsQuery = { nearSimpleQuestions: Array<{ questionPid: string, title: string }> };

export type QuestionCategoryQueryVariables = Exact<{
  request: QuestionCategoryRequestInput;
}>;


export type QuestionCategoryQuery = { questionCategory: { name: string, type: string } };

export type GetBestOfQuestionCategoryQueryVariables = Exact<{
  request: CategoryBestSimpleQuestionsRequestInput;
}>;


export type GetBestOfQuestionCategoryQuery = { categoryBestSimpleQuestions: Array<{ questionPid: string, title: string }> };

export type GetquestionTitleGeneratedQueryVariables = Exact<{
  questionPid: Scalars['ID'];
}>;


export type GetquestionTitleGeneratedQuery = { questionTitleGenerated: boolean };

export type GetAgreementsForQuestionCategoryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgreementsForQuestionCategoryQuery = { getAgreementsByCategory: Array<{ id: string, required: boolean, title: string, url?: string | null, type: AgreementType }> };

export type GetCheckApprovedByCategoryQueryVariables = Exact<{
  category: AgreementCategory;
}>;


export type GetCheckApprovedByCategoryQuery = { checkApproved: boolean };

export type GetCheckApprovedByTypeQueryVariables = Exact<{
  request: AgreementsApprovedCheckApiRequestInput;
}>;


export type GetCheckApprovedByTypeQuery = { checkApprovedByType: { result: boolean } };

export type QuestionOrderSheetByUserQueryVariables = Exact<{
  request: QuestionOrderSheetRequestInput;
}>;


export type QuestionOrderSheetByUserQuery = { questionOrderSheetByUser: { expectedAmountToPay: number, questionPid: string, totalDiscountAmount: number, totalPrice: number } };

export type PayQuestionMutationVariables = Exact<{
  request: PayQuestionRequestInput;
}>;


export type PayQuestionMutation = { payQuestion: boolean };

export type RepayQuestionMutationVariables = Exact<{
  request: RepayQuestionRequestInput;
}>;


export type RepayQuestionMutation = { repayQuestion: boolean };

export type BeDissatisfiedWithAiAnswerMutationVariables = Exact<{
  request: BeDissatisfiedWithAiAnswerRequestInput;
}>;


export type BeDissatisfiedWithAiAnswerMutation = { beDissatisfiedWithAiAnswer: boolean };

export type BeSatisfiedWithAiAnswerMutationVariables = Exact<{
  request: BeSatisfiedWithAiAnswerRequestInput;
}>;


export type BeSatisfiedWithAiAnswerMutation = { beSatisfiedWithAiAnswer: boolean };

export type CreateQnaAnswerReviewMutationVariables = Exact<{
  request: QnaAnswerReviewCreateRequestInput;
}>;


export type CreateQnaAnswerReviewMutation = { createQnaAnswerReview: boolean };

export type QnaAnswerReviewTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type QnaAnswerReviewTagsQuery = { qnaAnswerReviewTags: Array<{ exposureType: QnaAnswerReviewTagExposureType, id: string, text: string }> };

export type QnaAnswerReviewsQueryVariables = Exact<{
  answerPid: Scalars['ID'];
}>;


export type QnaAnswerReviewsQuery = { qnaAnswerReviews: Array<{ id: string, answerPid: string, rating: number, content?: string | null, reviewTags: Array<{ id: string, text: string }> }> };

export type QnaExpectedAnswerLeadTimeQueryVariables = Exact<{ [key: string]: never; }>;


export type QnaExpectedAnswerLeadTimeQuery = { qnaExpectedAnswerLeadTime: { expectedAnswerMinutes: number, exposureType: QuestionDelayExposureType } };

export type UpsertBlockingAccountMutationVariables = Exact<{
  blockingAccountMutationRequest: BlockingAccountMutationRequestInput;
}>;


export type UpsertBlockingAccountMutation = { upsertBlockingAccount: boolean };

export type GetMyReviewCountQueryVariables = Exact<{
  reviewTargetType: ReviewTargetType;
}>;


export type GetMyReviewCountQuery = { myReviewCount: number };

export type ReportReviewMutationVariables = Exact<{ [key: string]: never; }>;


export type ReportReviewMutation = { reportReview: boolean };

export type GetMyReviewsQueryVariables = Exact<{
  pagingRequest: PagingRequestInput;
  reviewTargetType: ReviewTargetType;
}>;


export type GetMyReviewsQuery = { myReviews: Array<{ id: string, rating: number, title: string, content: string, isPrivate: boolean, isLiked: boolean, likeCount: number, targetPrice?: number | null, createdAt: number, targetCategoryName: string, reviewContext: { reviewTargetType: ReviewTargetType, reviewReceiver: { name: string } }, comments: Array<{ createdAt: number, content: string, isBlocked: boolean, reviewCommentHolder: { id: string, name: string, profileImageUrl?: string | null, reviewHolderType: ReviewCommentHolderType } }>, tags: Array<{ tag: { text: string } }> }> };

export type DeleteReviewMutationVariables = Exact<{
  reviewId: Scalars['ID'];
}>;


export type DeleteReviewMutation = { deleteReview: boolean };

export type GetSearchResultFeedbackCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSearchResultFeedbackCategoriesQuery = { searchResultFeedbackCategories: Array<{ id: string, name: string, isNeedToUserDirectInput: boolean }> };

export type GetSearchResultFeedbackSubCategoriesByCategoryIdQueryVariables = Exact<{
  categoryId: Scalars['ID'];
}>;


export type GetSearchResultFeedbackSubCategoriesByCategoryIdQuery = { searchResultFeedbackSubCategoriesByCategoryId: Array<{ id: string, name: string, isNeedToUserDirectInput: boolean }> };

export type SubmitSearchResultFeedbackMutationVariables = Exact<{
  request: SearchResultFeedbackSubmitRequestInput;
}>;


export type SubmitSearchResultFeedbackMutation = { submitSearchResultFeedback: boolean };

export type GetPopularKeywordsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPopularKeywordsQuery = { getPopularSymptoms: Array<{ name: string, publicId: string }> };

export type GetkeywordSearchQnaQueryVariables = Exact<{
  request: KeywordSearchQuestionCardCursorPageRequestInput;
}>;


export type GetkeywordSearchQnaQuery = { keywordSearchQuestionCardCursorPage: { elements: Array<{ answererCount: number, answeredStatus: QuestionAnsweredStatus, answererProfileImageUrls: Array<string>, question: { status?: QuestionStatus | null, questionPid: string, title: string, content: string, createdAt: number, viewCount: number, likeCount: number, isLikedByMe: boolean, isMine: boolean, isBlockedByMe: boolean, accessibleType: QuestionAccessibleType, aiAnswerStatus: AiAnswerStatus, category: { questionCategoryId: string, name: string, type: string, iconImageUrl: string, aiAnswerAvailable: boolean }, user: { userId: string, name: string, gender: GenderType, birth?: string | null }, tags: Array<{ questionTagId: string, name: string }>, attachments: Array<{ questionAttachmentId: string, blindType: AttachmentBlindType }> } }> } };

export type GetKeywordSearchMagazineQueryVariables = Exact<{
  request: KeywordSearchMagazineCursorPageRequestInput;
}>;


export type GetKeywordSearchMagazineQuery = { keywordSearchMagazineCursorPage: { elements: Array<{ magazineId: string, magazinePid: string, title: string, mobileTitle: string, titleImageUrl: string, description: string, mobileDescription: string, content: string, mobileContent: string, footnote: string, tagNames: Array<string>, likeCount: number, questionCategoryId: string, bottomButtonType: string, isLikedByMe: boolean, createdAt: number, author?: { authorType: AuthorType, authorId: string, name: string, profileImageUrl: string, affiliatedInstitutionName: string, externalLinkUrl?: string | null, professionalFields: Array<{ professionalFieldId: string, professionalFieldType: ProfessionalFieldType, name: string }> } | null }> } };

export type GetDoctorsByKeywordQueryVariables = Exact<{
  request: NonFaceToFaceDoctorCursorPageRequestInput;
}>;


export type GetDoctorsByKeywordQuery = { getDoctorsByKeyword: { pivot?: string | null, elements: Array<{ id: string, doctorName: string, hospitalName: string, profileUrl: string, publicId: string, reviewAverageRating: number, readyForVideoCall: boolean, reviewCount: number, isAbsent: boolean, isBookable: boolean, maxWaitingCount: number, medicineType: MedicineType, diagnosisCount?: { doctorId: string, count?: number | null } | null, professionalDepartment: { doctorId: string, professionalDepartmentName?: string | null, professionalDepartmentId?: string | null } }> } };

export type GetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageQueryVariables = Exact<{
  request: DiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageRequestInput;
}>;


export type GetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageQuery = { diseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPage: { pivot?: number | null, pivotScore?: number | null, totalCount: number, elements: Array<{ hospitalAddress: string, hospitalBadges: Array<string>, hospitalDistance?: number | null, hospitalId: string, hospitalName: string, hospitalOperationStatus: HospitalOperatingStatus, hospitalPublicId: string, hospitalRepresentativeImageUrl?: string | null, hospitalRepresentativeDepartmentName?: string | null, isBookable: boolean, reviewAverageRating: number, reviewTotalCount: number, doctors: Array<{ contractType: ContractType }> }> } };

export type SearchNonF2fDoctorsQueryVariables = Exact<{
  request: NonF2fDoctorSearchRequestInput;
}>;


export type SearchNonF2fDoctorsQuery = { searchNonF2fDoctors: { medicalCategoryGraph?: { category: MedicalCategoryType, id: string } | null, items: Array<{ createdAt: number, distance?: number | null, id: string, publicId: string, isAffiliated: boolean, isNew: boolean, maxWaitingCount: number, medicineType: string, name: string, profileUrl?: string | null, readyForVideoCall: boolean, reviewAverageRating: number, reviewCount: number, departments: Array<{ id: string, description?: string | null, isProfessional: boolean, name: string }>, nonBenefitMedicinePricing?: { doctorId: string, doctorTreatmentMedicineUnitPricingId: string, originalPrice: number, priceOnUsingPoint: number, treatmentMedicineName: string, unitDisplayName: string, unitTypeDisplayName: string, usablePoint: number } | null, professionalDepartment?: { description?: string | null, id: string, isProfessional: boolean, name: string } | null, diagnosisCount?: { count?: number | null, doctorId: string } | null, hospitalV2: { doctorHospitalId: string, doctorId: string, hospitalName: string }, bookingInfo: { bookingAvailability: BookingAvailability, isBookable: boolean, todayBookable: boolean, todayCutoffTime: string, todayKickoffTime: string, todaySchedule: string, tomorrowBookable: boolean, tomorrowCutoffTime: string, tomorrowKickoffTime: string, tomorrowSchedule: string } }> } };

export type GeneralSearchMetaByKeywordQueryVariables = Exact<{
  keyword: Scalars['String'];
}>;


export type GeneralSearchMetaByKeywordQuery = { generalSearchMetaByKeyword?: { features?: Array<GeneralSearchFeatureType> | null, snippet?: GeneralSearchSnippetType | null } | null };

export type GetSearchMedicineDictionaryByCursorScorePageQueryVariables = Exact<{
  request: MedicineDictionarySearchByCursorRequestInput;
}>;


export type GetSearchMedicineDictionaryByCursorScorePageQuery = { searchMedicineDictionaryByCursorScorePage: { totalCount: number, pivotScore?: number | null, pivotId?: string | null, items: Array<{ id: string, publicId: string, basicInfo: { name: string, simplifiedName: string, pharmaceuticalEffectLiteracy: string, medicineImage?: string | null }, medicineGuide: { wholeSummary: Array<string> }, packagingInfo: { image?: string | null } }> } };

export type SearchMedicineDictionaryQueryVariables = Exact<{
  request: MedicineDictionarySearchRequestInput;
}>;


export type SearchMedicineDictionaryQuery = { searchMedicineDictionary: { totalCount: number, totalPage: number, items: Array<{ id: string, publicId: string, basicInfo: { name: string, pharmaceuticalEffectLiteracy: string, medicineImage?: string | null, simplifiedName: string }, medicineGuide: { wholeSummary: Array<string> }, packagingInfo: { image?: string | null } }> } };

export type SearchDiseaseEncyclopediaQueryVariables = Exact<{
  request: DiseaseEncyclopediaSearchRequestInput;
}>;


export type SearchDiseaseEncyclopediaQuery = { searchDiseaseEncyclopedia: { totalCount: number, totalPageCount: number, items: Array<{ content: string, title: string, titleImageUrl?: string | null, publicId: string }> } };

export type SearchDiseaseEncyclopediaByCursorScorePageQueryVariables = Exact<{
  request: DiseaseEncyclopediaSearchByCursorRequestInput;
}>;


export type SearchDiseaseEncyclopediaByCursorScorePageQuery = { searchDiseaseEncyclopediaByCursorScorePage: { pivotId?: string | null, pivotScore?: number | null, totalCount: number, items: Array<{ content: string, title: string, titleImageUrl?: string | null, publicId: string }> } };

export type GetHospitalSitemapsQueryVariables = Exact<{
  page: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type GetHospitalSitemapsQuery = { getHospitalSitemaps: { totalCount: number, totalPage: number, elements: Array<{ id: string, sitemapUrl: string }> } };

export type GetNonBenefitSeoSitemapsV2QueryVariables = Exact<{
  page: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type GetNonBenefitSeoSitemapsV2Query = { getNonBenefitSeoSitemapsV2: { totalCount: number, totalPage: number, elements: Array<{ id: string, sitemapUrl: string }> } };

export type GetDiseaseEncyclopediaSitemapsQueryVariables = Exact<{
  page: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type GetDiseaseEncyclopediaSitemapsQuery = { getDiseaseEncyclopediaSitemaps: { totalCount: number, totalPage: number, elements: Array<{ id: string, sitemapUrl: string }> } };

export type GetMedicineDictionarySitemapsQueryVariables = Exact<{
  page: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type GetMedicineDictionarySitemapsQuery = { getMedicineDictionarySitemaps: { totalCount: number, totalPage: number, elements: Array<{ id: string, sitemapUrl: string }> } };

export type SearchDoctorsByUserQueryVariables = Exact<{
  request: DoctorSearchByUserRequestInput;
}>;


export type SearchDoctorsByUserQuery = { searchDoctorsByUser: { totalCount: number, items: Array<{ createdAt: number, hospitalName: string, id: string, publicId: string, isAffiliated: boolean, medicineType: string, name: string, profileUrl?: string | null, readyForVideoCall: boolean, reviewAverageRating: number, reviewCount: number, professionalDepartment?: { name: string } | null, bookingInfo: { bookingAvailability: BookingAvailability, isBookable: boolean, todayBookable: boolean, todayCutoffTime: string, todayKickoffTime: string, todaySchedule: string, tomorrowBookable: boolean, tomorrowCutoffTime: string, tomorrowKickoffTime: string, tomorrowSchedule: string } }> } };

export type SearchDoctorsByTimeSlotQueryVariables = Exact<{
  request: TimeSlotBasedDoctorSearchMutationRequestInput;
}>;


export type SearchDoctorsByTimeSlotQuery = { searchDoctorsByTimeSlot: { totalCount: number, items: Array<{ createdAt: number, hospitalName: string, id: string, publicId: string, isAffiliated: boolean, medicineType: string, name: string, profileUrl?: string | null, readyForVideoCall: boolean, reviewAverageRating: number, reviewCount: number, professionalDepartment?: { name: string } | null }> } };

export type GetDiagnosisCategoriesV2QueryVariables = Exact<{
  contactType: DiagnosisContactType;
}>;


export type GetDiagnosisCategoriesV2Query = { getDiagnosisCategoriesV2: { popularDepartmentCategories: Array<{ id: string, name: string }>, departmentCategories: Array<{ id: string, name: string, iconUrl: string, description?: string | null }>, popularTreatmentCategories: Array<{ id: string, name: string }>, treatmentCategories: Array<{ id: string, name: string, iconUrl: string, items: Array<{ id: string, name: string }> }> } };

export type GetPopularDiseaseEncyclopediasQueryVariables = Exact<{
  limit: Scalars['Int'];
}>;


export type GetPopularDiseaseEncyclopediasQuery = { popularDiseaseEncyclopedias: Array<{ content: string, title: string, titleImageUrl?: string | null, publicId: string }> };
